import './index.css';var _E = Object.defineProperty;
var gE = (e, n, t) => n in e ? _E(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var k = (e, n, t) => gE(e, typeof n != "symbol" ? n + "" : n, t);
import a, { createContext as ko, useContext as Do, useMemo as A, useState as ee, useEffect as te, useCallback as Pe, useRef as Ft, memo as pE, Fragment as Fe, lazy as hE, Suspense as vE } from "react";
import * as yE from "@wh/message-bus";
import { subscribe as or, unsubscribe as cr, publish as lt, publishSticky as Lo } from "@wh/message-bus";
import { useQuery as ye, QueryClient as TE, QueryClientProvider as CE } from "react-query";
import { Spinner as Qm, Bog as RE, FinishingPostColor as Zm, TpgColor as xo, EpicBoostColor as bE, DoubleYourOddsColor as wE, ExtraPlacesColor as Fo, PriceBoostColor as Bt, BogColor as na, BogPadded as AE, ExtraPlacesPadded as Jm, TpgPadded as SE, HorseRacing as Mo, ArrowUpSlim as IE, ArrowDownSlim as NE, Tv as Qt, ArrowRight as ra, VirtualWorldVirtualSports as PE, Promotions as OE, ListItem as kE, Highlights as DE, Greyhounds as LE, CalendarSchedule as xE, InfoCircle as aa, ErrorNotifications as FE, Refresh as ME, Earth as BE, Account as $E, EachWayExtraColor as WE, EachWayExtra as HE, PriceBoostColorInverted as qE, BetBuilder as GE, YourOddsColor as UE } from "@sb/ui/icons";
import { ModalRoot as Bo, ModalPortal as $o, ModalOverlay as Wo, ModalContent as Ho, ModalHeader as qo, ModalMain as Go, ModalDescription as YE, Title as He, Separator as w, Anchor as bn, Alert as jE, ModalFooter as VE, Button as ke, ModalTrigger as zr, Skeleton as U, TabsRoot as It, TabsList as Nt, TabsTrigger as Pt, Text as T, DialogRoot as sa, DialogTrigger as ia, DialogPortal as oa, DialogOverlay as ca, DialogContent as la, DialogHeader as ua, DialogMain as ma, DialogDescription as ar, DialogFooter as da, ButtonClean as $t, BetOfferPill as lr, useCollapsibleState as KE, CollapsibleTrigger as zE, PriceButtonPlaceholder as ed, PriceButton as Uo, Typography as fa, SectionTitle as Gt, CollapsibleSectionRoot as de, CollapsibleSectionTitle as fe, CollapsibleSectionContent as Ee, TabsContent as Zt, List as Jt, LineClamp as XE, ListItem as en, ListItemButton as QE, Switch as ZE, CollapsibleContent as JE, Collapsible as e_, ExpandableList as ur, ListItemLink as Ea } from "@sb/ui/components";
import { SeoBox as t_, PageNavigationProvider as n_, PageTitle as td, PageTitleSkeleton as r_, UnderscoreTabsNavSkeleton as a_, ChevronTabsNavSkeleton as s_, ModalSelect as i_, ModalSelectTriggerPrefixedGhost as o_, ErrorResult as c_, EmptyListResult as Yo } from "@sb/ui/templates";
import { useCarousel as wn, LightTheme as _a, useControllableState as l_, DarkTheme as u_ } from "@sb/ui/lib";
import { useSelectionSubscription as tn, useEventSubscription as nn, useMarketSubscription as An, useSelectionWasPriceSubscription as m_, useEventSubscriptionList as ga, useMarketSubscriptionList as jo, useSelectionSubscriptionList as Sn } from "@sb/push-containers";
import { useOddsFormat as d_, useOddsFormatter as mr } from "@sb/odds-formatter-react";
import { useBetslipSelectionManager as f_ } from "@sb/betslip-react";
import { isSelectionSuspended as dr } from "@sb/sports-utils";
const nd = ko(null);
function V() {
  const e = Do(nd);
  if (e == null)
    throw new Error("NavigationContext is not available.");
  return e;
}
const Uc = (e) => `https://sports.whcdn${e === "prd" ? "" : `-${e}`}.net/ngs-meetings/horse-racing/com`, Le = async (e, n = {}, t) => {
  const r = new URLSearchParams();
  for (const i in n) {
    const o = n[i];
    o != null && r.append(i, String(o));
  }
  return (await fetch(
    r.size ? `${e}?${r.toString()}` : e,
    t
  )).json();
}, E_ = (e, n) => {
  const t = n === "greyhounds" ? "gmp01" : "rmp01", s = `https://sports.williamhill${e.environment === "prd" ? "" : `-${e.environment}`}.${e.jurisdiction}/data/${t}/api/v2/mobile/${n}/${e.locale}`;
  return {
    baseUrl: s,
    getConfig: () => Le(`${s}/config`),
    getAmbassadorContent: () => Le(`${s}/ambassador-content`),
    getEventDetails: (i) => Le(`${s}/events/${i}`),
    getEventPreview: (i) => Le(`${s}/events/${i}?variant=short`),
    getTopRaces: () => Le(`${s}/top-races`),
    getFutureRaces: () => Le(`${s}/future-races`),
    getFutureRacesPromoted: () => Le(`${s}/future-races/promoted`),
    getFeaturedRaces: () => Le(`${s}/featured-races`),
    getPromotions: (i) => Le(`${s}/promos`, {
      promoName: i
    }),
    getSpecials: () => Le(`${s}/specials`),
    getCompetitionNextEvent: (i) => Le(
      `${s}/competitions/${i}/next-event`
    ),
    getRegionCompetitionsDay: (i, o) => Le(
      `${s}/region-competitions/${i}/${o}`
    )
  };
}, __ = (e, n) => {
  const r = `https://sports.williamhill${e.environment === "prd" ? "" : `-${e.environment}`}.${e.jurisdiction}/data/sea01/data/${e.locale}/${n}`;
  return {
    baseUrl: r,
    getMeetingsSeo: () => Le(`${r}/meetings`)
  };
}, g_ = (e) => {
  const t = `https://streaming.williamhill${e.environment === "prd" ? "" : `-${e.environment}`}.${e.jurisdiction}`;
  return {
    baseUrl: t,
    getEventStream: (r, s) => Le(
      `${t}/api/streams/events/${r}${s ? `?type=${s}` : ""}`,
      {},
      {
        credentials: "include",
        headers: { Accept: "*/*" }
      }
    ),
    getQualifiedEvents: (r) => Le(
      `${t}/api/streams/events`,
      {
        geoValidationOnly: !1,
        type: "LIVE",
        sport: r,
        permitted: !0,
        responseFormat: "IDS"
      },
      {
        credentials: "include",
        headers: { Accept: "*/*" }
      }
    )
  };
}, p_ = (e) => {
  const t = `https://results.williamhill${e.environment === "prd" ? "" : `-${e.environment}`}.${e.jurisdiction}/results/api`;
  return {
    baseUrl: t,
    getApiVersion: () => Le(`${t}/version`).then(
      (r) => r.version
    ),
    getResults: (r, s) => Le(`${t}/${r}/races/${s}/racecard`, {
      lang: e.locale.split("-")[0]
    })
  };
};
function _e() {
  const {
    env: e,
    params: { sport: n }
  } = V();
  return A(() => {
    const { environment: t, jurisdiction: r, locale: s } = e;
    return {
      baseUrl: `https://sports.williamhill${t === "prd" ? "" : `-${t}`}.${r}`,
      services: {
        meetings: E_(e, n),
        seo: __(e, n),
        streaming: g_(e),
        results: p_(e)
      },
      queryKey: ["meetings", t, r, s, n]
    };
  }, [e, n]);
}
const h_ = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "config"],
    queryFn: e.services.meetings.getConfig,
    refetchOnMount: !1
  });
}, Je = {
  ALL: "all"
}, sr = {
  TODAY: "today"
}, rt = {
  GOT_LOGIN_STATE: "gotLoginState",
  MEDIAPLAYERS_WHTV_PLAY: "mediaplayers.whtv.play",
  FREE_TV_CHANNEL_CHANGED: "freeTvChannelChanged",
  ANALYTICS_ADAPTER_READY: "wh.analytics.adapter.ready",
  TOPIC_EVENT_PARTIAL: "wh.common.command.dli.tl.eventPartial",
  GET_FEATURE_FLAG: "sb.featureFlag.getFeatureFlag",
  MEDIA_PLAYERS_STATUS: "mediaplayers.whtv.status",
  MEDIA_PLAYERS_FULL_SCREEN: "mediaplayers.whtv.fullscreen",
  MEDIA_PLAYERS_BITRATE: "mediaplayers.whtv.bitrate",
  WIDGET_START: "wh.sb.widget.start",
  WIDGET_STOP: "wh.sb.widget.stop",
  OPEN_BET_BUILDER: "wh.sports.betbuilder.open"
}, Ot = () => {
  const e = h_();
  return {
    config: e.data,
    isLoading: e.isLoading
  };
}, v_ = () => {
  const { config: e } = Ot();
  return {
    streamingUrlsConfig: (e == null ? void 0 : e.streamingUrls) ?? null
  };
}, y_ = () => {
  const { config: e } = Ot();
  return {
    btvStreamingAnalyticsConfig: (e == null ? void 0 : e.btvStreamingAnalytics) ?? !1
  };
}, T_ = () => {
  const { config: e } = Ot();
  return {
    bogConfigStatus: (e == null ? void 0 : e.bog.enabled) ?? !1
  };
}, C_ = () => {
  const { config: e } = Ot();
  return {
    silkUrlConfig: (e == null ? void 0 : e.silkUrl) ?? null
  };
}, R_ = () => {
  const { config: e, isLoading: n } = Ot();
  return {
    iconKeysExplainer: (e == null ? void 0 : e.iconKeysExplainer) ?? [],
    isLoading: n
  };
}, b_ = () => {
  const { config: e, isLoading: n } = Ot();
  return {
    quickLinks: (e == null ? void 0 : e.racingQuickLinks) ?? [],
    isLoading: n
  };
}, w_ = () => {
  const { config: e } = Ot();
  return {
    homeWidgets: (e == null ? void 0 : e.homeWidgets) ?? []
  };
}, rd = () => {
  const { config: e } = Ot();
  return {
    navigationCarousel: (e == null ? void 0 : e.navigationCarousel) ?? []
  };
}, ad = () => {
  const { config: e } = Ot();
  return {
    defaultRegion: (e == null ? void 0 : e.defaultRegion) ?? Je.ALL
  };
}, ce = {
  HORSE_RACING: "horse-racing",
  GREYHOUNDS: "greyhounds"
}, St = {
  [ce.HORSE_RACING]: "Horse Racing",
  [ce.GREYHOUNDS]: "Greyhounds"
}, A_ = {
  [ce.HORSE_RACING]: "OB_SP43",
  [ce.GREYHOUNDS]: "OB_SP42"
}, S_ = (e) => {
  var n;
  return (n = window.AnalyticsTactical) == null ? void 0 : n.Sports.localHelpers.enrichWithCommonInfo(e);
};
function In(e, n) {
  var t;
  try {
    (t = window.AnalyticsTactical) == null || t.Helpers.sendData(
      e,
      S_(n)
    );
  } catch (r) {
    console.error("Tracking event failed with error", { err: r, value: n });
  }
}
const I_ = () => In("link", {
  tealium_event: "hr_bog_widget_started",
  NonInteractionEvent: "0",
  EventCategory: "HR Widget Interactions",
  EventAction: "Best Odds Guaranteed",
  EventLabel: "Start"
}), N_ = () => In("link", {
  tealium_event: "hr_bog_opted_in",
  EventCategory: "HR Widget Interactions",
  EventAction: "Best Odds Guaranteed",
  EventLabel: "Opt In"
}), sd = (e) => In("link", {
  tealium_event: `${e === ce.HORSE_RACING ? "hr" : "gh"}_redesign_impression`,
  NonInteractionEvent: "0",
  ElementType: "Standard",
  EventCategory: `${e === ce.HORSE_RACING ? "Horse Racing" : "Greyhounds"} Interactions`,
  EventAction: "Redesign",
  EventLabel: "Impression"
}), ve = (e, n) => In("link", {
  tealium_event: `${n === ce.HORSE_RACING ? "hr" : "gh"}_events_change`,
  NonInteractionEvent: "0",
  ElementType: "Standard",
  EventCategory: `${n === ce.HORSE_RACING ? "Horse Racing" : "Greyhounds"} Interactions`,
  EventAction: "Page Navigation",
  EventLabel: e
}), P_ = (e) => In("link", {
  tealium_event: "hr_events_whamb",
  NonInteractionEvent: "0",
  ElementType: "Standard",
  EventCategory: "Horse Racing Interactions",
  EventAction: "WH Ambassador",
  EventLabel: e
}), O_ = () => In("link", {
  tealium_event: "hr_rr_interactions",
  NonInteractionEvent: "0",
  ElementType: "Standard",
  EventCategory: "Horse Racing Interactions",
  EventAction: "Racing Replay",
  EventLabel: "Watch Replay"
}), vn = {
  messageBus: {
    status: "wh.sports.account.flags.BOG",
    optIn: "wh.sports.account.flags.set.BOG_OPT_IN"
  },
  optInTimeout: 10 * 1e3,
  hideOptIn: {
    startDate: "2025-04-04T22:00:00+0000",
    endDate: "2025-04-06T08:00:00+0000"
  }
}, Ke = {
  NOT_AVAILABLE: null,
  ELIGIBLE: "ELIGIBLE",
  OPTED_IN: "OPTED_IN"
}, k_ = () => {
  const e = /* @__PURE__ */ new Date();
  return e >= new Date(vn.hideOptIn.startDate) && e <= new Date(vn.hideOptIn.endDate);
};
function rn() {
  const [e, n] = ee(Ke.NOT_AVAILABLE), { bogConfigStatus: t } = T_();
  return te(() => {
    if (!t)
      return;
    const r = or(
      vn.messageBus.status,
      (s, i) => {
        Object.values(Ke).includes(i) && n(i);
      }
    );
    return () => cr(r);
  }, [t]), e;
}
function D_() {
  const [e, n] = ee(
    null
  );
  return te(() => {
    if (e !== "loading")
      return;
    const r = or(
      vn.messageBus.status,
      (i, o) => {
        o === Ke.OPTED_IN && n("success");
      }
    ), s = setTimeout(() => {
      e === "loading" && n("error");
    }, vn.optInTimeout);
    return () => {
      cr(r), clearTimeout(s);
    };
  }, [e]), [Pe(() => {
    e !== "loading" && (N_(), lt(vn.messageBus.optIn, {}), n("loading"));
  }, [e]), e];
}
const L_ = "ngs-meetings__BOGBanner__container__1Ajga", x_ = "ngs-meetings__BOGBanner__icon__1Ajga", F_ = "ngs-meetings__BOGBanner__content__1Ajga", M_ = "ngs-meetings__BOGBanner__subtitle__1Ajga", B_ = "ngs-meetings__BOGBanner__info__1Ajga", $_ = "ngs-meetings__BOGBanner__optedIn__1Ajga", gn = {
  container: L_,
  icon: x_,
  content: F_,
  subtitle: M_,
  info: B_,
  optedIn: $_
}, W_ = "ngs-meetings__BOGDrawer__main__828UY", H_ = "ngs-meetings__BOGDrawer__section__828UY", q_ = "ngs-meetings__BOGDrawer__header__828UY", G_ = "ngs-meetings__BOGDrawer__spinner__828UY", U_ = "ngs-meetings__BOGDrawer__button__828UY", Ct = {
  main: W_,
  section: H_,
  header: q_,
  spinner: G_,
  button: U_
};
function Y_({ children: e }) {
  const [n, t] = D_(), r = rn(), s = V(), [i, o] = ee(!1);
  return te(() => {
    new URLSearchParams(s.location.search).get("bogModalOpen") === "true" && o(!0);
  }, [s.location.search]), /* @__PURE__ */ a.createElement(Bo, { open: i, onOpenChange: o }, e, /* @__PURE__ */ a.createElement($o, null, /* @__PURE__ */ a.createElement(Wo, null, /* @__PURE__ */ a.createElement(Ho, null, /* @__PURE__ */ a.createElement(
    qo,
    {
      title: "Best Odds Guaranteed",
      subtitle: r === Ke.OPTED_IN ? "Status: Opted In" : void 0
    }
  ), /* @__PURE__ */ a.createElement(Go, { className: Ct.main, padding: !1 }, /* @__PURE__ */ a.createElement(YE, { asChild: !0 }, /* @__PURE__ */ a.createElement("section", { className: Ct.section }, /* @__PURE__ */ a.createElement("header", { className: Ct.header }, /* @__PURE__ */ a.createElement(He, { level: 6 }, "What is Best Odds Guaranteed?")), "Once you have taken a price on your selection, if the starting price is bigger, we will pay you at the bigger odds.")), /* @__PURE__ */ a.createElement("section", { className: Ct.section }, /* @__PURE__ */ a.createElement("header", { className: Ct.header }, /* @__PURE__ */ a.createElement(He, { level: 6 }, "How do I use Best Odds Guaranteed?")), "Best Odds Guaranteed will be applied to your account as soon as you opt in."), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("section", { style: { textAlign: "center" } }, /* @__PURE__ */ a.createElement(
    bn,
    {
      href: "https://sports.williamhill.com/betting/en-gb/apps/promotions/offer/William-Hill-Best-Odds-Guaranteed",
      target: "_blank",
      rel: "noreferrer"
    },
    "Full T&Cs apply"
  )), /* @__PURE__ */ a.createElement("section", { className: Ct.section }, /* @__PURE__ */ a.createElement("header", { className: Ct.header }, /* @__PURE__ */ a.createElement(He, { level: 6 }, "Key Terms And Conditions")), "Online only. Opt-in req. Once opted in, BOG applies (unless cancelled/revoked) on UK horse races between", " ", /* @__PURE__ */ a.createElement("em", null, "08:00 on the day of the race & race start"), '. Valid for win/each-way singles & multiples on "win" market. £25k daily cap applies to additional winnings as a result of BOG. UK & Irish customers. Full T&Cs apply.')), t === "error" && /* @__PURE__ */ a.createElement(jE, { variant: "error", title: "Failed to opt in" }, "Sorry, you haven’t been opted in at this time. Please try again."), r !== Ke.OPTED_IN && /* @__PURE__ */ a.createElement(VE, null, /* @__PURE__ */ a.createElement(
    ke,
    {
      className: Ct.button,
      onClick: n,
      disabled: t === "loading" || t === "success"
    },
    t === "loading" && /* @__PURE__ */ a.createElement(Qm, { className: Ct.spinner, size: 20 }),
    (t === "error" || t == null) && "Opt In"
  ))))));
}
function id() {
  const e = rn(), [n, t] = ee(!1);
  return te(() => {
    e === Ke.ELIGIBLE ? t(!0) : e === Ke.NOT_AVAILABLE && t(!1);
  }, [e]), k_() || !n ? null : /* @__PURE__ */ a.createElement("div", { className: gn.container, "data-testid": "bog-banner-container" }, /* @__PURE__ */ a.createElement(Y_, null, /* @__PURE__ */ a.createElement("div", { className: gn.icon, "data-testid": "bog-banner-icon" }, /* @__PURE__ */ a.createElement(RE, { size: 20 })), /* @__PURE__ */ a.createElement("div", { className: gn.content, "data-testid": "bog-banner-content" }, /* @__PURE__ */ a.createElement(He, { level: 3 }, "Best Odds Guaranteed"), /* @__PURE__ */ a.createElement("div", { className: gn.subtitle, "data-testid": "bog-banner-subtitle" }, "If the starting price is bigger, we pay the bigger price. ", /* @__PURE__ */ a.createElement(zr, { asChild: !0 }, /* @__PURE__ */ a.createElement("em", null, "Find out more")))), e === Ke.ELIGIBLE && /* @__PURE__ */ a.createElement(zr, { asChild: !0 }, /* @__PURE__ */ a.createElement(
    ke,
    {
      className: gn.info,
      variant: "primary",
      size: "medium",
      "data-testid": "bog-opt-in-button",
      onClick: () => I_()
    },
    "Opt In"
  ))), e === Ke.OPTED_IN && /* @__PURE__ */ a.createElement("div", { className: gn.optedIn }, "Opted In"));
}
const j_ = "ngs-meetings__SeoSection__container__92dCh", V_ = "ngs-meetings__SeoSection__seoContent__92dCh", ho = {
  container: j_,
  seoContent: V_
}, K_ = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "seo", "meetings"],
    queryFn: e.services.seo.getMeetingsSeo
  });
};
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries: od,
  setPrototypeOf: Yc,
  isFrozen: z_,
  getPrototypeOf: X_,
  getOwnPropertyDescriptor: Q_
} = Object;
let {
  freeze: qe,
  seal: at,
  create: cd
} = Object, {
  apply: vo,
  construct: yo
} = typeof Reflect < "u" && Reflect;
qe || (qe = function(n) {
  return n;
});
at || (at = function(n) {
  return n;
});
vo || (vo = function(n, t, r) {
  return n.apply(t, r);
});
yo || (yo = function(n, t) {
  return new n(...t);
});
const Pr = Ge(Array.prototype.forEach), Z_ = Ge(Array.prototype.lastIndexOf), jc = Ge(Array.prototype.pop), Wn = Ge(Array.prototype.push), J_ = Ge(Array.prototype.splice), jr = Ge(String.prototype.toLowerCase), za = Ge(String.prototype.toString), Vc = Ge(String.prototype.match), Hn = Ge(String.prototype.replace), eg = Ge(String.prototype.indexOf), tg = Ge(String.prototype.trim), ot = Ge(Object.prototype.hasOwnProperty), $e = Ge(RegExp.prototype.test), qn = ng(TypeError);
function Ge(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      r[s - 1] = arguments[s];
    return vo(e, n, r);
  };
}
function ng(e) {
  return function() {
    for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
      t[r] = arguments[r];
    return yo(e, t);
  };
}
function Z(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : jr;
  Yc && Yc(e, null);
  let r = n.length;
  for (; r--; ) {
    let s = n[r];
    if (typeof s == "string") {
      const i = t(s);
      i !== s && (z_(n) || (n[r] = i), s = i);
    }
    e[s] = !0;
  }
  return e;
}
function rg(e) {
  for (let n = 0; n < e.length; n++)
    ot(e, n) || (e[n] = null);
  return e;
}
function At(e) {
  const n = cd(null);
  for (const [t, r] of od(e))
    ot(e, t) && (Array.isArray(r) ? n[t] = rg(r) : r && typeof r == "object" && r.constructor === Object ? n[t] = At(r) : n[t] = r);
  return n;
}
function Gn(e, n) {
  for (; e !== null; ) {
    const r = Q_(e, n);
    if (r) {
      if (r.get)
        return Ge(r.get);
      if (typeof r.value == "function")
        return Ge(r.value);
    }
    e = X_(e);
  }
  function t() {
    return null;
  }
  return t;
}
const Kc = qe(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Xa = qe(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Qa = qe(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), ag = qe(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Za = qe(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), sg = qe(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), zc = qe(["#text"]), Xc = qe(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ja = qe(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Qc = qe(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Or = qe(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ig = at(/\{\{[\w\W]*|[\w\W]*\}\}/gm), og = at(/<%[\w\W]*|[\w\W]*%>/gm), cg = at(/\$\{[\w\W]*/gm), lg = at(/^data-[\-\w.\u00B7-\uFFFF]+$/), ug = at(/^aria-[\-\w]+$/), ld = at(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), mg = at(/^(?:\w+script|data):/i), dg = at(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), ud = at(/^html$/i), fg = at(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Zc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: ug,
  ATTR_WHITESPACE: dg,
  CUSTOM_ELEMENT: fg,
  DATA_ATTR: lg,
  DOCTYPE_NAME: ud,
  ERB_EXPR: og,
  IS_ALLOWED_URI: ld,
  IS_SCRIPT_OR_DATA: mg,
  MUSTACHE_EXPR: ig,
  TMPLIT_EXPR: cg
});
const Un = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Eg = function() {
  return typeof window > "u" ? null : window;
}, _g = function(n, t) {
  if (typeof n != "object" || typeof n.createPolicy != "function")
    return null;
  let r = null;
  const s = "data-tt-policy-suffix";
  t && t.hasAttribute(s) && (r = t.getAttribute(s));
  const i = "dompurify" + (r ? "#" + r : "");
  try {
    return n.createPolicy(i, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, Jc = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function md() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Eg();
  const n = ($) => md($);
  if (n.version = "3.2.6", n.removed = [], !e || !e.document || e.document.nodeType !== Un.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: t
  } = e;
  const r = t, s = r.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: o,
    Node: c,
    Element: m,
    NodeFilter: u,
    NamedNodeMap: l = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: f,
    trustedTypes: E
  } = e, g = m.prototype, p = Gn(g, "cloneNode"), v = Gn(g, "remove"), y = Gn(g, "nextSibling"), C = Gn(g, "childNodes"), b = Gn(g, "parentNode");
  if (typeof o == "function") {
    const $ = t.createElement("template");
    $.content && $.content.ownerDocument && (t = $.content.ownerDocument);
  }
  let R, P = "";
  const {
    implementation: D,
    createNodeIterator: z,
    createDocumentFragment: F,
    getElementsByTagName: ae
  } = t, {
    importNode: Te
  } = r;
  let W = Jc();
  n.isSupported = typeof od == "function" && typeof b == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: se,
    ERB_EXPR: ue,
    TMPLIT_EXPR: N,
    DATA_ATTR: S,
    ARIA_ATTR: L,
    IS_SCRIPT_OR_DATA: O,
    ATTR_WHITESPACE: B,
    CUSTOM_ELEMENT: M
  } = Zc;
  let {
    IS_ALLOWED_URI: G
  } = Zc, H = null;
  const K = Z({}, [...Kc, ...Xa, ...Qa, ...Za, ...zc]);
  let Y = null;
  const Se = Z({}, [...Xc, ...Ja, ...Qc, ...Or]);
  let j = Object.seal(cd(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), st = null, Ba = null, Rc = !0, $a = !0, bc = !1, wc = !0, ln = !1, Rr = !0, Vt = !1, Wa = !1, Ha = !1, un = !1, br = !1, wr = !1, Ac = !0, Sc = !1;
  const oE = "user-content-";
  let qa = !0, Mn = !1, mn = {}, dn = null;
  const Ic = Z({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Nc = null;
  const Pc = Z({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ga = null;
  const Oc = Z({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ar = "http://www.w3.org/1998/Math/MathML", Sr = "http://www.w3.org/2000/svg", vt = "http://www.w3.org/1999/xhtml";
  let fn = vt, Ua = !1, Ya = null;
  const cE = Z({}, [Ar, Sr, vt], za);
  let Ir = Z({}, ["mi", "mo", "mn", "ms", "mtext"]), Nr = Z({}, ["annotation-xml"]);
  const lE = Z({}, ["title", "style", "font", "a", "script"]);
  let Bn = null;
  const uE = ["application/xhtml+xml", "text/html"], mE = "text/html";
  let Ie = null, En = null;
  const dE = t.createElement("form"), kc = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, ja = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(En && En === _)) {
      if ((!_ || typeof _ != "object") && (_ = {}), _ = At(_), Bn = // eslint-disable-next-line unicorn/prefer-includes
      uE.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? mE : _.PARSER_MEDIA_TYPE, Ie = Bn === "application/xhtml+xml" ? za : jr, H = ot(_, "ALLOWED_TAGS") ? Z({}, _.ALLOWED_TAGS, Ie) : K, Y = ot(_, "ALLOWED_ATTR") ? Z({}, _.ALLOWED_ATTR, Ie) : Se, Ya = ot(_, "ALLOWED_NAMESPACES") ? Z({}, _.ALLOWED_NAMESPACES, za) : cE, Ga = ot(_, "ADD_URI_SAFE_ATTR") ? Z(At(Oc), _.ADD_URI_SAFE_ATTR, Ie) : Oc, Nc = ot(_, "ADD_DATA_URI_TAGS") ? Z(At(Pc), _.ADD_DATA_URI_TAGS, Ie) : Pc, dn = ot(_, "FORBID_CONTENTS") ? Z({}, _.FORBID_CONTENTS, Ie) : Ic, st = ot(_, "FORBID_TAGS") ? Z({}, _.FORBID_TAGS, Ie) : At({}), Ba = ot(_, "FORBID_ATTR") ? Z({}, _.FORBID_ATTR, Ie) : At({}), mn = ot(_, "USE_PROFILES") ? _.USE_PROFILES : !1, Rc = _.ALLOW_ARIA_ATTR !== !1, $a = _.ALLOW_DATA_ATTR !== !1, bc = _.ALLOW_UNKNOWN_PROTOCOLS || !1, wc = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ln = _.SAFE_FOR_TEMPLATES || !1, Rr = _.SAFE_FOR_XML !== !1, Vt = _.WHOLE_DOCUMENT || !1, un = _.RETURN_DOM || !1, br = _.RETURN_DOM_FRAGMENT || !1, wr = _.RETURN_TRUSTED_TYPE || !1, Ha = _.FORCE_BODY || !1, Ac = _.SANITIZE_DOM !== !1, Sc = _.SANITIZE_NAMED_PROPS || !1, qa = _.KEEP_CONTENT !== !1, Mn = _.IN_PLACE || !1, G = _.ALLOWED_URI_REGEXP || ld, fn = _.NAMESPACE || vt, Ir = _.MATHML_TEXT_INTEGRATION_POINTS || Ir, Nr = _.HTML_INTEGRATION_POINTS || Nr, j = _.CUSTOM_ELEMENT_HANDLING || {}, _.CUSTOM_ELEMENT_HANDLING && kc(_.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (j.tagNameCheck = _.CUSTOM_ELEMENT_HANDLING.tagNameCheck), _.CUSTOM_ELEMENT_HANDLING && kc(_.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (j.attributeNameCheck = _.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (j.allowCustomizedBuiltInElements = _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ln && ($a = !1), br && (un = !0), mn && (H = Z({}, zc), Y = [], mn.html === !0 && (Z(H, Kc), Z(Y, Xc)), mn.svg === !0 && (Z(H, Xa), Z(Y, Ja), Z(Y, Or)), mn.svgFilters === !0 && (Z(H, Qa), Z(Y, Ja), Z(Y, Or)), mn.mathMl === !0 && (Z(H, Za), Z(Y, Qc), Z(Y, Or))), _.ADD_TAGS && (H === K && (H = At(H)), Z(H, _.ADD_TAGS, Ie)), _.ADD_ATTR && (Y === Se && (Y = At(Y)), Z(Y, _.ADD_ATTR, Ie)), _.ADD_URI_SAFE_ATTR && Z(Ga, _.ADD_URI_SAFE_ATTR, Ie), _.FORBID_CONTENTS && (dn === Ic && (dn = At(dn)), Z(dn, _.FORBID_CONTENTS, Ie)), qa && (H["#text"] = !0), Vt && Z(H, ["html", "head", "body"]), H.table && (Z(H, ["tbody"]), delete st.tbody), _.TRUSTED_TYPES_POLICY) {
        if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw qn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw qn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        R = _.TRUSTED_TYPES_POLICY, P = R.createHTML("");
      } else
        R === void 0 && (R = _g(E, s)), R !== null && typeof P == "string" && (P = R.createHTML(""));
      qe && qe(_), En = _;
    }
  }, Dc = Z({}, [...Xa, ...Qa, ...ag]), Lc = Z({}, [...Za, ...sg]), fE = function(_) {
    let I = b(_);
    (!I || !I.tagName) && (I = {
      namespaceURI: fn,
      tagName: "template"
    });
    const x = jr(_.tagName), ie = jr(I.tagName);
    return Ya[_.namespaceURI] ? _.namespaceURI === Sr ? I.namespaceURI === vt ? x === "svg" : I.namespaceURI === Ar ? x === "svg" && (ie === "annotation-xml" || Ir[ie]) : !!Dc[x] : _.namespaceURI === Ar ? I.namespaceURI === vt ? x === "math" : I.namespaceURI === Sr ? x === "math" && Nr[ie] : !!Lc[x] : _.namespaceURI === vt ? I.namespaceURI === Sr && !Nr[ie] || I.namespaceURI === Ar && !Ir[ie] ? !1 : !Lc[x] && (lE[x] || !Dc[x]) : !!(Bn === "application/xhtml+xml" && Ya[_.namespaceURI]) : !1;
  }, dt = function(_) {
    Wn(n.removed, {
      element: _
    });
    try {
      b(_).removeChild(_);
    } catch {
      v(_);
    }
  }, _n = function(_, I) {
    try {
      Wn(n.removed, {
        attribute: I.getAttributeNode(_),
        from: I
      });
    } catch {
      Wn(n.removed, {
        attribute: null,
        from: I
      });
    }
    if (I.removeAttribute(_), _ === "is")
      if (un || br)
        try {
          dt(I);
        } catch {
        }
      else
        try {
          I.setAttribute(_, "");
        } catch {
        }
  }, xc = function(_) {
    let I = null, x = null;
    if (Ha)
      _ = "<remove></remove>" + _;
    else {
      const be = Vc(_, /^[\r\n\t ]+/);
      x = be && be[0];
    }
    Bn === "application/xhtml+xml" && fn === vt && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const ie = R ? R.createHTML(_) : _;
    if (fn === vt)
      try {
        I = new f().parseFromString(ie, Bn);
      } catch {
      }
    if (!I || !I.documentElement) {
      I = D.createDocument(fn, "template", null);
      try {
        I.documentElement.innerHTML = Ua ? P : ie;
      } catch {
      }
    }
    const Me = I.body || I.documentElement;
    return _ && x && Me.insertBefore(t.createTextNode(x), Me.childNodes[0] || null), fn === vt ? ae.call(I, Vt ? "html" : "body")[0] : Vt ? I.documentElement : Me;
  }, Fc = function(_) {
    return z.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, Va = function(_) {
    return _ instanceof d && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof l) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, Mc = function(_) {
    return typeof c == "function" && _ instanceof c;
  };
  function yt($, _, I) {
    Pr($, (x) => {
      x.call(n, _, I, En);
    });
  }
  const Bc = function(_) {
    let I = null;
    if (yt(W.beforeSanitizeElements, _, null), Va(_))
      return dt(_), !0;
    const x = Ie(_.nodeName);
    if (yt(W.uponSanitizeElement, _, {
      tagName: x,
      allowedTags: H
    }), Rr && _.hasChildNodes() && !Mc(_.firstElementChild) && $e(/<[/\w!]/g, _.innerHTML) && $e(/<[/\w!]/g, _.textContent) || _.nodeType === Un.progressingInstruction || Rr && _.nodeType === Un.comment && $e(/<[/\w]/g, _.data))
      return dt(_), !0;
    if (!H[x] || st[x]) {
      if (!st[x] && Wc(x) && (j.tagNameCheck instanceof RegExp && $e(j.tagNameCheck, x) || j.tagNameCheck instanceof Function && j.tagNameCheck(x)))
        return !1;
      if (qa && !dn[x]) {
        const ie = b(_) || _.parentNode, Me = C(_) || _.childNodes;
        if (Me && ie) {
          const be = Me.length;
          for (let Ye = be - 1; Ye >= 0; --Ye) {
            const Tt = p(Me[Ye], !0);
            Tt.__removalCount = (_.__removalCount || 0) + 1, ie.insertBefore(Tt, y(_));
          }
        }
      }
      return dt(_), !0;
    }
    return _ instanceof m && !fE(_) || (x === "noscript" || x === "noembed" || x === "noframes") && $e(/<\/no(script|embed|frames)/i, _.innerHTML) ? (dt(_), !0) : (ln && _.nodeType === Un.text && (I = _.textContent, Pr([se, ue, N], (ie) => {
      I = Hn(I, ie, " ");
    }), _.textContent !== I && (Wn(n.removed, {
      element: _.cloneNode()
    }), _.textContent = I)), yt(W.afterSanitizeElements, _, null), !1);
  }, $c = function(_, I, x) {
    if (Ac && (I === "id" || I === "name") && (x in t || x in dE))
      return !1;
    if (!($a && !Ba[I] && $e(S, I))) {
      if (!(Rc && $e(L, I))) {
        if (!Y[I] || Ba[I]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Wc(_) && (j.tagNameCheck instanceof RegExp && $e(j.tagNameCheck, _) || j.tagNameCheck instanceof Function && j.tagNameCheck(_)) && (j.attributeNameCheck instanceof RegExp && $e(j.attributeNameCheck, I) || j.attributeNameCheck instanceof Function && j.attributeNameCheck(I)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            I === "is" && j.allowCustomizedBuiltInElements && (j.tagNameCheck instanceof RegExp && $e(j.tagNameCheck, x) || j.tagNameCheck instanceof Function && j.tagNameCheck(x)))
          ) return !1;
        } else if (!Ga[I]) {
          if (!$e(G, Hn(x, B, ""))) {
            if (!((I === "src" || I === "xlink:href" || I === "href") && _ !== "script" && eg(x, "data:") === 0 && Nc[_])) {
              if (!(bc && !$e(O, Hn(x, B, "")))) {
                if (x)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Wc = function(_) {
    return _ !== "annotation-xml" && Vc(_, M);
  }, Hc = function(_) {
    yt(W.beforeSanitizeAttributes, _, null);
    const {
      attributes: I
    } = _;
    if (!I || Va(_))
      return;
    const x = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Y,
      forceKeepAttr: void 0
    };
    let ie = I.length;
    for (; ie--; ) {
      const Me = I[ie], {
        name: be,
        namespaceURI: Ye,
        value: Tt
      } = Me, $n = Ie(be), Ka = Tt;
      let Be = be === "value" ? Ka : tg(Ka);
      if (x.attrName = $n, x.attrValue = Be, x.keepAttr = !0, x.forceKeepAttr = void 0, yt(W.uponSanitizeAttribute, _, x), Be = x.attrValue, Sc && ($n === "id" || $n === "name") && (_n(be, _), Be = oE + Be), Rr && $e(/((--!?|])>)|<\/(style|title)/i, Be)) {
        _n(be, _);
        continue;
      }
      if (x.forceKeepAttr)
        continue;
      if (!x.keepAttr) {
        _n(be, _);
        continue;
      }
      if (!wc && $e(/\/>/i, Be)) {
        _n(be, _);
        continue;
      }
      ln && Pr([se, ue, N], (Gc) => {
        Be = Hn(Be, Gc, " ");
      });
      const qc = Ie(_.nodeName);
      if (!$c(qc, $n, Be)) {
        _n(be, _);
        continue;
      }
      if (R && typeof E == "object" && typeof E.getAttributeType == "function" && !Ye)
        switch (E.getAttributeType(qc, $n)) {
          case "TrustedHTML": {
            Be = R.createHTML(Be);
            break;
          }
          case "TrustedScriptURL": {
            Be = R.createScriptURL(Be);
            break;
          }
        }
      if (Be !== Ka)
        try {
          Ye ? _.setAttributeNS(Ye, be, Be) : _.setAttribute(be, Be), Va(_) ? dt(_) : jc(n.removed);
        } catch {
          _n(be, _);
        }
    }
    yt(W.afterSanitizeAttributes, _, null);
  }, EE = function $(_) {
    let I = null;
    const x = Fc(_);
    for (yt(W.beforeSanitizeShadowDOM, _, null); I = x.nextNode(); )
      yt(W.uponSanitizeShadowNode, I, null), Bc(I), Hc(I), I.content instanceof i && $(I.content);
    yt(W.afterSanitizeShadowDOM, _, null);
  };
  return n.sanitize = function($) {
    let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, I = null, x = null, ie = null, Me = null;
    if (Ua = !$, Ua && ($ = "<!-->"), typeof $ != "string" && !Mc($))
      if (typeof $.toString == "function") {
        if ($ = $.toString(), typeof $ != "string")
          throw qn("dirty is not a string, aborting");
      } else
        throw qn("toString is not a function");
    if (!n.isSupported)
      return $;
    if (Wa || ja(_), n.removed = [], typeof $ == "string" && (Mn = !1), Mn) {
      if ($.nodeName) {
        const Tt = Ie($.nodeName);
        if (!H[Tt] || st[Tt])
          throw qn("root node is forbidden and cannot be sanitized in-place");
      }
    } else if ($ instanceof c)
      I = xc("<!---->"), x = I.ownerDocument.importNode($, !0), x.nodeType === Un.element && x.nodeName === "BODY" || x.nodeName === "HTML" ? I = x : I.appendChild(x);
    else {
      if (!un && !ln && !Vt && // eslint-disable-next-line unicorn/prefer-includes
      $.indexOf("<") === -1)
        return R && wr ? R.createHTML($) : $;
      if (I = xc($), !I)
        return un ? null : wr ? P : "";
    }
    I && Ha && dt(I.firstChild);
    const be = Fc(Mn ? $ : I);
    for (; ie = be.nextNode(); )
      Bc(ie), Hc(ie), ie.content instanceof i && EE(ie.content);
    if (Mn)
      return $;
    if (un) {
      if (br)
        for (Me = F.call(I.ownerDocument); I.firstChild; )
          Me.appendChild(I.firstChild);
      else
        Me = I;
      return (Y.shadowroot || Y.shadowrootmode) && (Me = Te.call(r, Me, !0)), Me;
    }
    let Ye = Vt ? I.outerHTML : I.innerHTML;
    return Vt && H["!doctype"] && I.ownerDocument && I.ownerDocument.doctype && I.ownerDocument.doctype.name && $e(ud, I.ownerDocument.doctype.name) && (Ye = "<!DOCTYPE " + I.ownerDocument.doctype.name + `>
` + Ye), ln && Pr([se, ue, N], (Tt) => {
      Ye = Hn(Ye, Tt, " ");
    }), R && wr ? R.createHTML(Ye) : Ye;
  }, n.setConfig = function() {
    let $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ja($), Wa = !0;
  }, n.clearConfig = function() {
    En = null, Wa = !1;
  }, n.isValidAttribute = function($, _, I) {
    En || ja({});
    const x = Ie($), ie = Ie(_);
    return $c(x, ie, I);
  }, n.addHook = function($, _) {
    typeof _ == "function" && Wn(W[$], _);
  }, n.removeHook = function($, _) {
    if (_ !== void 0) {
      const I = Z_(W[$], _);
      return I === -1 ? void 0 : J_(W[$], I, 1)[0];
    }
    return jc(W[$]);
  }, n.removeHooks = function($) {
    W[$] = [];
  }, n.removeAllHooks = function() {
    W = Jc();
  }, n;
}
var gg = md();
function pg(e) {
  return gg.sanitize(e, {
    ALLOWED_TAGS: [
      "p",
      "a",
      "ul",
      "ol",
      "li",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "strong"
    ]
  });
}
const hg = () => /* @__PURE__ */ a.createElement("div", { className: ho.container }, /* @__PURE__ */ a.createElement(U, { height: 52 }));
function mI() {
  var r;
  const { data: e, isLoading: n, isSuccess: t } = K_();
  return n ? /* @__PURE__ */ a.createElement(hg, null) : !t || !((r = e == null ? void 0 : e.subFeatureData) != null && r.length) ? null : /* @__PURE__ */ a.createElement("div", { className: ho.container, "data-testid": "seo-container" }, e.subFeatureData.map((s) => /* @__PURE__ */ a.createElement(t_, { key: s.sectionTitle, title: s.sectionTitle }, /* @__PURE__ */ a.createElement(
    "div",
    {
      className: ho.seoContent,
      dangerouslySetInnerHTML: { __html: pg(s.text) },
      "data-testid": "seo-content"
    }
  ))));
}
const vg = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "top-races"],
    queryFn: e.services.meetings.getTopRaces
  });
}, pa = (e = Je.ALL) => {
  const n = _e();
  return ye({
    queryKey: [...n.queryKey, "region-competitions", e],
    queryFn: async () => {
      const t = await n.services.meetings.getRegionCompetitionsDay(
        e,
        sr.TODAY
      ), r = Object.values(t.availableDays ?? {}), s = await Promise.all(
        r.map(async (c) => ({
          day: c,
          dto: c.link === sr.TODAY ? t : await n.services.meetings.getRegionCompetitionsDay(
            e,
            c.link
          )
        }))
      ), i = new Map(
        s.flatMap(({ dto: c }) => c.regionFilters ?? []).map((c) => [c.id, c])
      );
      return {
        regionCompetitionsByDays: s.map(({ day: c, dto: m }) => ({
          day: c,
          regionCompetitions: m.regionCompetitions
        })),
        availableRegionFilters: Array.from(i.values())
      };
    },
    refetchOnMount: !1
  });
}, dd = () => {
  const e = _e();
  return ye({
    queryKey: [
      ...e.queryKey,
      "region-competitions",
      Je.ALL,
      sr.TODAY
    ],
    queryFn: () => e.services.meetings.getRegionCompetitionsDay(
      Je.ALL,
      sr.TODAY
    ),
    refetchOnMount: !1,
    refetchInterval: 60 * 1e3
    // 1 minute
  });
}, ha = (e, n) => e.timeString < n.timeString ? -1 : 1, yg = (e, n) => {
  const t = new Set(e), r = {};
  for (const s of n)
    for (const i of s.competitions)
      for (const o of i.events)
        t.has(o.id) && !o.settled && !o.isInPlay && (r[o.id] || (r[o.id] = o));
  return [...Object.values(r)].sort(ha);
}, Tg = () => {
  const { data: e } = dd(), { data: n } = vg();
  return !(n != null && n.length) || !e ? null : yg(n, e.regionCompetitions);
};
function fd(e) {
  var n, t, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (n = 0; n < s; n++) e[n] && (t = fd(e[n])) && (r && (r += " "), r += t);
  } else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function J() {
  for (var e, n, t = 0, r = "", s = arguments.length; t < s; t++) (e = arguments[t]) && (n = fd(e)) && (r && (r += " "), r += n);
  return r;
}
const Ed = ({ event: e }) => e.settled ? /* @__PURE__ */ a.createElement(Zm, { size: 13 }) : e._offers.topPriceGuarantee ? /* @__PURE__ */ a.createElement(xo, { size: 14 }) : e.hasEpicOddsSpecial ? /* @__PURE__ */ a.createElement(bE, { size: 14 }) : e.hasDoubleYourOddsSpecial ? /* @__PURE__ */ a.createElement(wE, { size: 14 }) : e._offers.extraPlaces ? /* @__PURE__ */ a.createElement(Fo, { size: 14 }) : e.hasEnhancedOddsSpecial ? /* @__PURE__ */ a.createElement(Bt, { size: 14 }) : e.hasPriceBoostSpecial ? /* @__PURE__ */ a.createElement(Bt, { size: 14 }) : null, Cg = "ngs-meetings__EventButton__button__OlfHn", Rg = "ngs-meetings__EventButton__buttonSettled__OlfHn", el = {
  button: Cg,
  buttonSettled: Rg
}, bg = ({ event: e, onClick: n }) => {
  const t = V();
  return /* @__PURE__ */ a.createElement(
    ke,
    {
      className: J(el.button, e.settled && el.buttonSettled),
      variant: "ghost",
      size: "medium",
      asChild: !0,
      onClick: (r) => {
        r.preventDefault(), t.navigateToEvent(e.id, e.slug), n == null || n(e);
      },
      "data-testid": e.id
    },
    /* @__PURE__ */ a.createElement("a", { href: t.getLinkForEvent(e.id, e.slug) }, /* @__PURE__ */ a.createElement(Ed, { event: e }), e.timeString)
  );
}, wg = "ngs-meetings__EventButtonCarousel__container__8j0wB", Ag = "ngs-meetings__EventButtonCarousel__carousel__8j0wB", tl = {
  container: wg,
  carousel: Ag
}, Sg = ({
  events: e,
  onClick: n
}) => {
  const [t, r] = wn({});
  return te(() => {
    if (!r)
      return;
    const s = e.map((i) => i.settled).lastIndexOf(!0);
    r.scrollTo(s + 1, !0);
  }, [r, e]), /* @__PURE__ */ a.createElement(
    "div",
    {
      "data-testid": "event-button-carousel-container",
      className: tl.container,
      ref: t
    },
    /* @__PURE__ */ a.createElement("div", { "data-testid": "event-button-carousel", className: tl.carousel }, e.map((s) => /* @__PURE__ */ a.createElement(bg, { key: s.id, event: s, onClick: n })))
  );
};
function nl(e) {
  if (!e.includes("|"))
    return [e];
  const n = /\|\s*([^|]+?)\s*\|/g, t = [];
  let r;
  for (; (r = n.exec(e)) !== null; )
    t.push(r[1]);
  const s = /\|\s*([^|]+?)\s*$/.exec(e);
  return s && t.push(s[1]), t;
}
function va(e) {
  return e.replace(/(D|d)ogs/i, "").replace("()", "").trim();
}
const Ig = "ngs-meetings__EventNavigationButton__container__uAzeB", Ng = "ngs-meetings__EventNavigationButton__eventIcon__uAzeB", Pg = "ngs-meetings__EventNavigationButton__eventContainer__uAzeB", Og = "ngs-meetings__EventNavigationButton__eventTime__uAzeB", kg = "ngs-meetings__EventNavigationButton__eventName__uAzeB", Yn = {
  container: Ig,
  eventIcon: Ng,
  eventContainer: Pg,
  eventTime: Og,
  eventName: kg
}, Dg = ({
  event: e
}) => {
  const n = va(
    e.slug.replace(/^\d+-/, "").replace(/-/g, " ")
  );
  return /* @__PURE__ */ a.createElement("div", { className: Yn.container }, /* @__PURE__ */ a.createElement("div", { className: Yn.eventIcon }, /* @__PURE__ */ a.createElement(Ed, { event: e })), /* @__PURE__ */ a.createElement("div", { className: Yn.eventContainer }, /* @__PURE__ */ a.createElement("span", { className: Yn.eventTime }, e.timeString), /* @__PURE__ */ a.createElement("span", { className: Yn.eventName }, n)));
}, Vo = ({
  events: e,
  value: n,
  defaultValue: t,
  link: r = () => "",
  onClick: s
}) => e.length ? /* @__PURE__ */ a.createElement(It, { value: n, defaultValue: t }, /* @__PURE__ */ a.createElement(
  Nt,
  {
    "data-testid": "event-nav-carousel",
    variant: "standard",
    stretch: !1
  },
  e.map((i) => /* @__PURE__ */ a.createElement(
    Pt,
    {
      variant: "standard",
      value: i.id,
      key: `${i.id}`,
      onClick: () => s(i.id),
      link: r(i.id),
      "data-testid": "event-carousel-tab",
      size: "small"
    },
    /* @__PURE__ */ a.createElement(Dg, { event: i })
  ))
)) : null, Lg = "ngs-meetings__EventSkeleton__row__c89OJ", xg = "ngs-meetings__EventSkeleton__skeletonItem__c89OJ", it = {
  row: Lg,
  skeletonItem: xg
}, Fg = () => /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement("div", { className: it.row }, /* @__PURE__ */ a.createElement(U, { style: { flex: 5 } }), /* @__PURE__ */ a.createElement(U, { style: { flex: 2 } })), /* @__PURE__ */ a.createElement("div", { className: it.row }, /* @__PURE__ */ a.createElement(U, { style: { flex: 6, height: "16px" } }), /* @__PURE__ */ a.createElement(U, { className: it.skeletonItem })), /* @__PURE__ */ a.createElement("div", { className: it.row }, /* @__PURE__ */ a.createElement(U, { style: { flex: 6, height: "16px" } }), /* @__PURE__ */ a.createElement(U, { className: it.skeletonItem })), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("div", { className: it.row }, /* @__PURE__ */ a.createElement(U, { style: { flex: 7 } })), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("div", { className: it.row }, /* @__PURE__ */ a.createElement(U, { style: { flex: 7 } })), /* @__PURE__ */ a.createElement(w, { theme: "light" }), [...Array(3)].map((e, n) => /* @__PURE__ */ a.createElement(a.Fragment, { key: n }, /* @__PURE__ */ a.createElement("div", { className: it.row, style: { height: "70px" } }, /* @__PURE__ */ a.createElement(U, { style: { flex: 5 }, className: it.skeletonItem }), /* @__PURE__ */ a.createElement(U, { style: { flex: 1 }, className: it.skeletonItem })))), /* @__PURE__ */ a.createElement("div", { className: it.row }, /* @__PURE__ */ a.createElement(U, { style: { flex: 7 } })), /* @__PURE__ */ a.createElement(w, { theme: "light" })), Mg = "ngs-meetings__EachWay__container__CDwGK", Bg = "ngs-meetings__EachWay__text__CDwGK", rl = {
  container: Mg,
  text: Bg
}, _d = ({ eachWay: e }) => e ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: rl.container }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", className: rl.text }, e)), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null, Ae = () => {
  const { params: e } = V();
  return e.sport;
}, tt = () => {
  const { params: e } = V();
  return e.sport === ce.GREYHOUNDS;
}, h = {
  ALL_MARKETS: "All markets",
  BET_BUILDER: "Bet Builder",
  YOUR_ODDS: "#YourOdds",
  WIN: "Racecard",
  // Win Market
  WIN_OR_EW: "Win Or E/W",
  // Each Way Extra Market
  PRICE_BOOST: "Price Boost",
  PLACE_MARKETS: "Place Markets",
  MONEY_BACK: "Money Back",
  EACH_WAY_EXTRA: "Each Way Extra",
  // Win Or E/W Market
  LENGTHEN_YOUR_ODDS: "Lengthen Your Odds",
  MATCH_BETS: "Match Bets",
  BETTING_WITHOUT: "Betting Without",
  ODDS_VS_EVENS: "Odds v Evens",
  WIN_IN_PLAY: "Win - In Play",
  FORECAST_TRICAST: "Forecast/Tricast",
  // Win Market
  GH_WIN: "Named Dog"
  // Win Market
}, $g = {
  PLACES: "Place terms"
}, Ko = {
  STARTING_PRICE: "starting-price"
}, Q = {
  [h.ALL_MARKETS]: "All Markets",
  [h.BET_BUILDER]: "Bet Builder",
  [h.YOUR_ODDS]: "#YourOdds",
  [h.WIN]: "Win",
  [h.WIN_OR_EW]: "Win Or E/W",
  [h.PLACE_MARKETS]: "Place Markets",
  [h.MONEY_BACK]: "Money Back",
  [h.EACH_WAY_EXTRA]: "Each Way Extra",
  [h.LENGTHEN_YOUR_ODDS]: "Lengthen Your Odds",
  [h.PRICE_BOOST]: "Price Boost",
  [h.MATCH_BETS]: "Match Bets",
  [h.BETTING_WITHOUT]: "Betting Without",
  [h.ODDS_VS_EVENS]: "Odds v Evens",
  [h.WIN_IN_PLAY]: "Win in-play",
  [h.FORECAST_TRICAST]: "Forecast/Tricast",
  [h.GH_WIN]: "Win Or E/W"
}, X = {
  [h.ALL_MARKETS]: "",
  [h.WIN]: "win",
  [h.BET_BUILDER]: "bet-builder",
  [h.WIN_OR_EW]: "win-or-ew",
  [h.PRICE_BOOST]: "price-boost",
  [h.YOUR_ODDS]: "your-odds",
  [h.PLACE_MARKETS]: "place-markets",
  [h.MONEY_BACK]: "money-back",
  [h.EACH_WAY_EXTRA]: "each-way-extra",
  [h.LENGTHEN_YOUR_ODDS]: "lengthen-your-odds",
  [h.MATCH_BETS]: "match-bets",
  [h.BETTING_WITHOUT]: "betting-without",
  [h.ODDS_VS_EVENS]: "odds-v-evens",
  [h.WIN_IN_PLAY]: "win-in-play",
  [h.FORECAST_TRICAST]: "forecast-tricast"
}, kr = {
  [h.ALL_MARKETS]: {
    name: Q[h.ALL_MARKETS],
    slug: X[h.ALL_MARKETS],
    marketCollection: h.ALL_MARKETS
  },
  [h.BET_BUILDER]: {
    name: Q[h.BET_BUILDER],
    slug: X[h.BET_BUILDER],
    marketCollection: h.BET_BUILDER,
    isNew: !0
  },
  [h.YOUR_ODDS]: {
    name: Q[h.YOUR_ODDS],
    slug: X[h.YOUR_ODDS],
    marketCollection: h.YOUR_ODDS
  },
  [h.PLACE_MARKETS]: {
    name: Q[h.PLACE_MARKETS],
    slug: X[h.PLACE_MARKETS],
    marketCollection: h.PLACE_MARKETS
  },
  [h.EACH_WAY_EXTRA]: {
    name: Q[h.EACH_WAY_EXTRA],
    slug: X[h.EACH_WAY_EXTRA],
    marketCollection: h.EACH_WAY_EXTRA
  },
  [h.MONEY_BACK]: {
    name: Q[h.MONEY_BACK],
    slug: X[h.MONEY_BACK],
    marketCollection: h.MONEY_BACK
  },
  [h.LENGTHEN_YOUR_ODDS]: {
    name: Q[h.LENGTHEN_YOUR_ODDS],
    slug: X[h.LENGTHEN_YOUR_ODDS],
    marketCollection: h.LENGTHEN_YOUR_ODDS
  },
  [h.MATCH_BETS]: {
    name: Q[h.MATCH_BETS],
    slug: X[h.MATCH_BETS],
    marketCollection: h.MATCH_BETS
  },
  [h.BETTING_WITHOUT]: {
    name: Q[h.BETTING_WITHOUT],
    slug: X[h.BETTING_WITHOUT],
    marketCollection: h.BETTING_WITHOUT
  },
  [h.ODDS_VS_EVENS]: {
    name: Q[h.ODDS_VS_EVENS],
    slug: X[h.ODDS_VS_EVENS],
    marketCollection: h.ODDS_VS_EVENS
  },
  [h.WIN]: {
    name: Q[h.FORECAST_TRICAST],
    slug: X[h.FORECAST_TRICAST],
    marketCollection: h.WIN
  },
  [h.GH_WIN]: {
    name: Q[h.FORECAST_TRICAST],
    slug: X[h.FORECAST_TRICAST],
    marketCollection: h.GH_WIN
  }
}, Wg = (e = -1, n = -1, t = -1) => e > 0 || n > 0 || t > 0, Hg = (e = -1, n = -1, t = -1) => {
  const r = e > 0 && e + "m" || "", s = n > 0 && n + "f" || "", i = t > 0 && t + "y" || "";
  return [r, s, i].join(" ");
}, we = (e) => e.runnerId ?? e.runnerNum, ya = (e) => {
  const { raceCardTables: n } = e, [t] = n, { raceCardRows: r } = t;
  return Object.fromEntries(
    r.map((s) => [we(s), s])
  );
}, qg = (e, n) => n.events.map((s) => s.id).findIndex((s) => s === e) + 1, Gg = (e) => ({
  marketBlurb: e,
  placeTerms: null
}), Ug = (e, n) => {
  const t = e == null ? void 0 : e.find(
    ({ marketType: r }) => r === $g.PLACES
  );
  return {
    marketBlurb: n,
    placeTerms: t
  };
}, gd = (e, n) => tt() ? Gg(n) : Ug(e, n), Oe = {
  WATCH_RACE: "Watch race",
  WATCH_FOR_FREE: "Watch preview & race",
  BET_TO_WATCH: "Bet £1.00 or more to watch this race live",
  WATCH_THE_RACE_LIVE: "Watch the race live",
  LOGIN_TO_WATCH_FOR_FREE: "Login to watch for free",
  WATCH_FOR_FREE_BETT_TV: "Watch for free on betting TV",
  WATCH_BETTING_TV: "Watch on betting TV",
  LOADING: "Loading...",
  BALANCE_REQUIRED: "To watch, you must have a funded account or have placed a bet on any horse race within the last 24 hours.",
  GEO_BLOCKED: "Sorry, live streaming is currently unavailable in your country due to broadcaster territory restrictions.",
  PREVIEW_FROM_8PM: "Race preview will be available from 8pm the night before the race",
  LOG_IN: "Please log-in to watch live streaming. Note: Live streaming is free to active logged in users subject to broadcaster territory restrictions",
  COMMON_ERROR: "We’ve encountered a problem with the stream. Please wait and try again.",
  WATCH_RACE_REPLAY: "Watch replay",
  REPLAY_PENDING: "Replay pending",
  REPLAY_NOT_AVAILABLE: "Replay not available"
}, To = {
  IOS: "ios",
  ANDROID: "android"
}, Yg = {
  J: "Jumps",
  F: "Flat"
}, pd = {
  F: "Firm",
  FT: "Fast",
  FZ: "Frozen",
  G: "Good",
  GF: "Good To Firm",
  GS: "Good To Soft",
  GY: "Good To Yielding",
  HD: "Hard",
  HO: "Holding",
  HY: "Heavy",
  MY: "Muddy",
  S: "Soft",
  SD: "Standard",
  SF: "Standard To Fast",
  SH: "Soft To Heavy",
  SN: "Sand",
  SS: "Standard To Slow",
  SW: "Slow",
  SY: "Sloppy",
  VS: "Very Soft",
  Y: "Yielding",
  YS: "Yielding To Soft"
}, hd = {
  FREE_ON_BETTING_TV: "Betting TV",
  RacingTV: "Racing TV"
}, vd = "Channel", jg = "", zo = "SP", Vg = "ngs-meetings__EventExtraInfo__descriptionContainer__OAJiC", Kg = "ngs-meetings__EventExtraInfo__descriptionElement__OAJiC", zg = "ngs-meetings__EventExtraInfo__raceCardTextColor__OAJiC", ft = {
  descriptionContainer: Vg,
  descriptionElement: Kg,
  raceCardTextColor: zg
}, Xg = ({
  event: e,
  raceNumber: n,
  isRacecardPage: t
}) => {
  const { race: r, streaming: s } = e;
  return /* @__PURE__ */ a.createElement("div", { "data-testid": "race-info-container" }, /* @__PURE__ */ a.createElement(
    "div",
    {
      className: J(
        ft.descriptionContainer,
        t && ft.raceCardTextColor
      ),
      "data-testid": "race-info-description"
    },
    tt() && n ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-first-element"
      },
      "Race ",
      n
    ) : null,
    r.class && r.class !== "-" ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-first-element"
      },
      "Class ",
      r.class
    ) : null,
    r.type ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-second-element"
      },
      Yg[r.type]
    ) : null,
    e.numberOfRunners ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-third-element"
      },
      e.numberOfRunners,
      " runners"
    ) : null,
    Wg(r.distM, r.distF, r.distY) ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-fourth-element"
      },
      Hg(r.distM, r.distF, r.distY)
    ) : null,
    r.going ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-fifth-element"
      },
      pd[r.going]
    ) : null,
    r.prize ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-sixth-element"
      },
      "£",
      Math.round(r.prize).toLocaleString()
    ) : null,
    s.channel && s.providers ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: ft.descriptionElement,
        "data-testid": "race-info-seventh-element"
      },
      hd[s.providers[0]]
    ) : null
  ));
}, Qg = "ngs-meetings__EventDetails__container__vHuyv", Zg = "ngs-meetings__EventDetails__eventName__vHuyv", Jg = "ngs-meetings__EventDetails__eventTitleText__vHuyv", Dr = {
  container: Qg,
  eventName: Zg,
  eventTitleText: Jg
}, Ta = ({
  event: e,
  children: n,
  raceNumber: t,
  isRacecardPage: r = !1,
  displayRaceTitle: s = !0
}) => /* @__PURE__ */ a.createElement("div", { className: Dr.container, "data-testid": "event-details" }, /* @__PURE__ */ a.createElement("div", { className: Dr.eventName, "data-testid": "event-name" }, /* @__PURE__ */ a.createElement(
  He,
  {
    level: 3,
    style: {
      maxWidth: "65%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
  va(e.eventName)
), /* @__PURE__ */ a.createElement("div", { className: Dr.statusContainer }, n)), s && e.race.title ? /* @__PURE__ */ a.createElement(
  T,
  {
    className: Dr.eventTitleText,
    variant: "captionSecondary",
    "data-testid": "caption-secondary"
  },
  e.race.title
) : null, /* @__PURE__ */ a.createElement(
  Xg,
  {
    event: e,
    raceNumber: t,
    isRacecardPage: r
  }
));
function e0({ children: e }) {
  return /* @__PURE__ */ a.createElement(sa, null, /* @__PURE__ */ a.createElement(ia, { asChild: !0 }, e), /* @__PURE__ */ a.createElement(oa, null, /* @__PURE__ */ a.createElement(ca, null, /* @__PURE__ */ a.createElement(la, null, /* @__PURE__ */ a.createElement(
    ua,
    {
      title: /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(na, null), "Best Odds Guaranteed")
    }
  ), /* @__PURE__ */ a.createElement(ma, null, /* @__PURE__ */ a.createElement(ar, null, "Available on bets placed after 8am on the day of the race. Take the price on your selection and if the starting price is bigger, we will pay you at the bigger odds.")), /* @__PURE__ */ a.createElement(da, null, /* @__PURE__ */ a.createElement(
    bn,
    {
      href: "https://sports.williamhill.com/betting/en-gb/apps/promotions/offer/William-Hill-Best-Odds-Guaranteed",
      target: "_blank",
      referrerPolicy: "no-referrer"
    },
    "More info and T&C's"
  ))))));
}
function t0() {
  return /* @__PURE__ */ a.createElement(e0, null, /* @__PURE__ */ a.createElement($t, null, /* @__PURE__ */ a.createElement(lr, null, "Best Odds Guaranteed", /* @__PURE__ */ a.createElement(AE, null))));
}
const n0 = "ngs-meetings__ExtraPlaces__mainContainer__hNf7P", r0 = {
  mainContainer: n0
};
function yd({
  children: e,
  extraPlaceTerms: n
}) {
  const { marketBlurb: t, placeTerms: r } = n, s = (r == null ? void 0 : r.name) ?? null;
  return !t && !s ? null : /* @__PURE__ */ a.createElement(sa, null, /* @__PURE__ */ a.createElement(ia, { asChild: !0 }, e), /* @__PURE__ */ a.createElement(oa, null, /* @__PURE__ */ a.createElement(ca, null, /* @__PURE__ */ a.createElement(la, null, /* @__PURE__ */ a.createElement(
    ua,
    {
      title: /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Fo, null), "Extra Places")
    }
  ), /* @__PURE__ */ a.createElement(ma, { className: r0.mainContainer }, s ? /* @__PURE__ */ a.createElement(ar, null, s) : null, t ? /* @__PURE__ */ a.createElement(ar, null, t) : null), /* @__PURE__ */ a.createElement(da, null, /* @__PURE__ */ a.createElement(
    bn,
    {
      href: "https://sports.williamhill.com/betting/en-gb/apps/promotions/offer/Extra-Places-on-Horse-Racing-V2",
      target: "_blank",
      referrerPolicy: "no-referrer"
    },
    "More info and T&C's"
  ))))));
}
function a0({
  extraPlaceTerms: e
}) {
  return /* @__PURE__ */ a.createElement(yd, { extraPlaceTerms: e }, /* @__PURE__ */ a.createElement($t, null, /* @__PURE__ */ a.createElement(lr, null, "Extra Places", /* @__PURE__ */ a.createElement(Jm, null))));
}
function s0({ children: e }) {
  return /* @__PURE__ */ a.createElement(sa, null, /* @__PURE__ */ a.createElement(ia, { asChild: !0 }, e), /* @__PURE__ */ a.createElement(oa, null, /* @__PURE__ */ a.createElement(ca, null, /* @__PURE__ */ a.createElement(la, null, /* @__PURE__ */ a.createElement(
    ua,
    {
      title: /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(xo, null), "Top Price Guarantee")
    }
  ), /* @__PURE__ */ a.createElement(ma, null, /* @__PURE__ */ a.createElement(ar, null, "We are top or joint top price on every runner for this race!")), /* @__PURE__ */ a.createElement(da, null, /* @__PURE__ */ a.createElement(
    bn,
    {
      href: "https://sports.williamhill.com/betting/en-gb/apps/promotions/offer/TPG-on-The-Biggest-Races",
      target: "_blank",
      referrerPolicy: "no-referrer"
    },
    "More info and T&C's"
  ))))));
}
function i0() {
  return /* @__PURE__ */ a.createElement(s0, null, /* @__PURE__ */ a.createElement($t, null, /* @__PURE__ */ a.createElement(lr, null, "Top Price Guarantee", /* @__PURE__ */ a.createElement(SE, null))));
}
const o0 = "ngs-meetings__OffersAvailablePills__carouselContainer__io42v", c0 = "ngs-meetings__OffersAvailablePills__carousel__io42v", al = {
  carouselContainer: o0,
  carousel: c0
}, l0 = (e, n) => ({
  ...e,
  ...n
}), u0 = ({
  event: e,
  racingSpecials: n,
  marketBlurb: t
}) => {
  const r = rn(), [s] = wn({}), i = gd(n, t), { extraPlaces: o, topPriceGuarantee: c, bestOddsGuaranteed: m } = l0(e._competitionOffers, e._offers), u = r === Ke.OPTED_IN && m, l = o || c || u;
  if (e.settled || !l)
    return null;
  const d = [
    {
      display: o,
      Component: () => /* @__PURE__ */ a.createElement(a0, { extraPlaceTerms: i }),
      key: "extra_places"
    },
    {
      display: c,
      Component: i0,
      key: "top_price_guarantee"
    },
    {
      display: u,
      Component: t0,
      key: "best_odds_guaranteed"
    }
  ];
  return /* @__PURE__ */ a.createElement("div", { className: al.carouselContainer, ref: s }, /* @__PURE__ */ a.createElement("div", { className: al.carousel, "data-testid": "offers-available-carousel" }, d.filter(({ display: f }) => f).map(({ Component: f, key: E }) => /* @__PURE__ */ a.createElement(f, { key: E }))));
}, m0 = "ngs-meetings__OffersAvailable__container__0qG0N", d0 = {
  container: m0
}, Td = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "priceBoostsPromos"],
    queryFn: () => e.services.meetings.getPromotions("price-boost"),
    refetchOnMount: !1
  });
}, f0 = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "promos"],
    queryFn: () => e.services.meetings.getPromotions(),
    refetchOnMount: !1
  });
};
function E0() {
  const { data: e, isLoading: n } = f0(), t = e;
  return n || t == null ? [] : t;
}
function Cd() {
  const { data: e, isLoading: n } = Td(), t = e;
  return n || t == null ? [] : t;
}
const _0 = (e) => {
  const n = Cd().find(
    (t) => t.selectionId === e
  );
  if (n == null)
    throw new Error(`Special selection with ID ${e} does not exist`);
  return tn(
    A(
      () => ({
        ...n,
        id: e,
        status: n.selectionStatus,
        currentPriceNum: n.priceNum,
        currentPriceDen: n.priceDen,
        marketId: n.marketId,
        eventId: n.eventId
      }),
      [e, n]
    )
  );
}, g0 = (e) => E0().filter((n) => n.targetEventId === e), Ca = ({
  marketBlurb: e,
  event: n,
  shouldShowOffersAvailablePills: t = !0,
  showSeparator: r = !0
}) => {
  const s = g0(n.id);
  return /* @__PURE__ */ a.createElement("div", { "data-testid": "offer-available" }, /* @__PURE__ */ a.createElement("div", { className: d0.container }, /* @__PURE__ */ a.createElement(T, { variant: "bodySecondary", "data-testid": "offer-available-title" }, "Offers Available"), t ? /* @__PURE__ */ a.createElement(
    u0,
    {
      marketBlurb: e,
      event: n,
      racingSpecials: s
    }
  ) : null), r && /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}, p0 = "ngs-meetings__Silk__silk__scWPF", h0 = "ngs-meetings__Silk__silkImage__scWPF", v0 = "ngs-meetings__Silk__disabled__scWPF", y0 = "ngs-meetings__Silk__silkInfo__scWPF", jn = {
  silk: p0,
  silkImage: h0,
  disabled: v0,
  silkInfo: y0
}, fr = ({ runner: e, runnerNum: n }) => {
  const { silkUrlConfig: t } = C_(), [r, s] = ee(!1);
  if (!t || !e)
    return null;
  const { silkName: i, draw: o, active: c } = e, m = "silkUrl" in e ? e.silkUrl : `${t}${i}`;
  return /* @__PURE__ */ a.createElement("div", { className: jn.silk }, r ? /* @__PURE__ */ a.createElement(Mo, { className: jn.silkImage }) : /* @__PURE__ */ a.createElement(
    "img",
    {
      "aria-hidden": "true",
      role: "presentation",
      alt: "",
      className: J(jn.silkImage, !c && jn.disabled),
      src: m,
      onError: () => s(!0)
    }
  ), /* @__PURE__ */ a.createElement("div", { className: jn.silkInfo }, n ? /* @__PURE__ */ a.createElement(T, null, n) : null, o ? /* @__PURE__ */ a.createElement(T, null, "(", o, ")") : null));
}, T0 = "ngs-meetings__RunnerInfo__additionalInfo__ZCcIu", C0 = "ngs-meetings__RunnerInfo__courseAndDistance__ZCcIu", R0 = "ngs-meetings__RunnerInfo__runnerInfo__ZCcIu", b0 = "ngs-meetings__RunnerInfo__singleDetail__ZCcIu", w0 = "ngs-meetings__RunnerInfo__horseName__ZCcIu", Rt = {
  additionalInfo: T0,
  courseAndDistance: C0,
  runnerInfo: R0,
  singleDetail: b0,
  horseName: w0
}, A0 = "ngs-meetings__Trap__trapContainer__sKDjW", S0 = "ngs-meetings__Trap__trapInactive__sKDjW", I0 = "ngs-meetings__Trap__trap__sKDjW", N0 = "ngs-meetings__Trap__trapNumber__sKDjW", P0 = "ngs-meetings__Trap__trap1Default__sKDjW", O0 = "ngs-meetings__Trap__trap1Usa__sKDjW", k0 = "ngs-meetings__Trap__trap1AustraliaNewZealand__sKDjW", D0 = "ngs-meetings__Trap__trap2Default__sKDjW", L0 = "ngs-meetings__Trap__trap2Usa__sKDjW", x0 = "ngs-meetings__Trap__trap2AustraliaNewZealand__sKDjW", F0 = "ngs-meetings__Trap__trap3Default__sKDjW", M0 = "ngs-meetings__Trap__trap3Usa__sKDjW", B0 = "ngs-meetings__Trap__trap3AustraliaNewZealand__sKDjW", $0 = "ngs-meetings__Trap__trap4Default__sKDjW", W0 = "ngs-meetings__Trap__trap4Usa__sKDjW", H0 = "ngs-meetings__Trap__trap4AustraliaNewZealand__sKDjW", q0 = "ngs-meetings__Trap__trap5Default__sKDjW", G0 = "ngs-meetings__Trap__trap5Usa__sKDjW", U0 = "ngs-meetings__Trap__trap5AustraliaNewZealand__sKDjW", Y0 = "ngs-meetings__Trap__trap6Default__sKDjW", j0 = "ngs-meetings__Trap__trap6Usa__sKDjW", V0 = "ngs-meetings__Trap__trap6AustraliaNewZealand__sKDjW", K0 = "ngs-meetings__Trap__trap7Usa__sKDjW", z0 = "ngs-meetings__Trap__trap7AustraliaNewZealand__sKDjW", X0 = "ngs-meetings__Trap__trap8Usa__sKDjW", Q0 = "ngs-meetings__Trap__trap8AustraliaNewZealand__sKDjW", Z0 = "ngs-meetings__Trap__trap9Usa__sKDjW", J0 = "ngs-meetings__Trap__trap9AustraliaNewZealand__sKDjW", ep = "ngs-meetings__Trap__trap10AustraliaNewZealand__sKDjW", Vn = {
  trapContainer: A0,
  trapInactive: S0,
  trap: I0,
  trapNumber: N0,
  trap1Default: P0,
  trap1Usa: O0,
  trap1AustraliaNewZealand: k0,
  trap2Default: D0,
  trap2Usa: L0,
  trap2AustraliaNewZealand: x0,
  trap3Default: F0,
  trap3Usa: M0,
  trap3AustraliaNewZealand: B0,
  trap4Default: $0,
  trap4Usa: W0,
  trap4AustraliaNewZealand: H0,
  trap5Default: q0,
  trap5Usa: G0,
  trap5AustraliaNewZealand: U0,
  trap6Default: Y0,
  trap6Usa: j0,
  trap6AustraliaNewZealand: V0,
  trap7Usa: K0,
  trap7AustraliaNewZealand: z0,
  trap8Usa: X0,
  trap8AustraliaNewZealand: Q0,
  trap9Usa: Z0,
  trap9AustraliaNewZealand: J0,
  trap10AustraliaNewZealand: ep
}, tp = {
  "australia-new-zealand": "AustraliaNewZealand",
  usa: "Usa",
  default: "Default"
}, Nn = ({
  runnerNum: e,
  greyhoundsRegionType: n = "default",
  active: t
}) => {
  const r = `trap${e}${tp[n]}`;
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      className: J(Vn.trapContainer, !t && Vn.trapInactive)
    },
    /* @__PURE__ */ a.createElement("div", { className: J(Vn.trap, Vn[r]) }, /* @__PURE__ */ a.createElement("span", { className: Vn.trapNumber }, e))
  );
}, Ra = ({
  runner: e,
  title: n,
  active: t,
  runnerNum: r,
  greyhoundsRegionType: s
}) => {
  const i = tt();
  if (!e)
    return /* @__PURE__ */ a.createElement(
      "div",
      {
        className: J(Rt.runnerInfo, Rt.singleDetail),
        "data-testid": "runner-info"
      },
      /* @__PURE__ */ a.createElement(
        "div",
        {
          "data-testid": "horse-details",
          style: {
            paddingLeft: "0.5rem",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "0.5rem"
          }
        },
        i ? /* @__PURE__ */ a.createElement(
          Nn,
          {
            runnerNum: r,
            greyhoundsRegionType: s,
            active: t
          }
        ) : /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary", className: Rt.raceCardNumber }, r),
        /* @__PURE__ */ a.createElement(T, { variant: "bodySecondary", className: Rt.horseName }, n)
      )
    );
  const { jockey: o, trainer: c } = e, m = "formGuide" in e ? e.formGuide : void 0, u = "courseAndDistance" in e ? e.courseAndDistance : void 0;
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      className: J(
        Rt.runnerInfo,
        !o && !c && Rt.singleDetail
      ),
      "data-testid": "runner-info"
    },
    /* @__PURE__ */ a.createElement("div", { "data-testid": "horse-details" }, /* @__PURE__ */ a.createElement(T, { variant: "bodySecondary", className: Rt.horseName }, n)),
    o ? /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", "data-testid": "jockey-info" }, "J: ", o) : null,
    c ? /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", "data-testid": "trainer-info" }, "T: ", c) : null,
    /* @__PURE__ */ a.createElement("div", { className: Rt.additionalInfo, "data-testid": "additional-info" }, m && /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, "F: ", m), u ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "captionSecondary",
        className: Rt.courseAndDistance,
        "data-testid": "course-and-distance"
      },
      u
    ) : null)
  );
}, np = "ngs-meetings__RunnerDetails__runnerDetails__vyuoc", rp = "ngs-meetings__RunnerDetails__silkCol__vyuoc", ap = "ngs-meetings__RunnerDetails__arrow__vyuoc", es = {
  runnerDetails: np,
  silkCol: rp,
  arrow: ap
}, sp = ({
  runner: e,
  runnerNum: n,
  title: t,
  active: r,
  greyhoundsRegionType: s,
  remWidth: i
}) => {
  const o = KE();
  return /* @__PURE__ */ a.createElement(zE, { asChild: !0 }, /* @__PURE__ */ a.createElement(
    $t,
    {
      style: { minWidth: i && `${i}rem` },
      className: es.runnerDetails,
      "data-testid": "runner-details"
    },
    /* @__PURE__ */ a.createElement("div", { className: es.silkCol, "data-testid": "race-card-row-silk" }, tt() ? /* @__PURE__ */ a.createElement(
      Nn,
      {
        active: r,
        runnerNum: n,
        greyhoundsRegionType: s
      }
    ) : /* @__PURE__ */ a.createElement(fr, { runnerNum: n, runner: e }), e.overview ? /* @__PURE__ */ a.createElement("div", { className: es.arrow }, o ? /* @__PURE__ */ a.createElement(IE, { size: 10 }) : /* @__PURE__ */ a.createElement(NE, { size: 10 })) : null),
    /* @__PURE__ */ a.createElement(Ra, { runner: e, title: t })
  ));
};
function Rd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bt = {}, pn = {}, sl;
function bd() {
  if (sl) return pn;
  sl = 1, Object.defineProperty(pn, "__esModule", {
    value: !0
  }), pn.ODDS_FORMAT_CHANGED = "@sb/odds-format-common/ODDS_FORMAT_CHANGED";
  var e = pn.ODDS_FORMATS = {
    FRACTION: "fraction",
    DECIMAL: "decimal",
    AMERICAN: "american"
  };
  return pn.DEFAULT_ODDS_FORMAT = e.FRACTION, pn;
}
var Kt = {}, Lr = {}, il = {}, ts, ol;
function ip() {
  return ol || (ol = 1, ts = function() {
  }), ts;
}
var ns, cl;
function op() {
  return cl || (cl = 1, ns = function(e, n) {
    return { value: n, done: !!e };
  }), ns;
}
var rs, ll;
function Er() {
  return ll || (ll = 1, rs = {}), rs;
}
var as, ul;
function wd() {
  if (ul) return as;
  ul = 1;
  var e = {}.toString;
  return as = function(n) {
    return e.call(n).slice(8, -1);
  }, as;
}
var ss, ml;
function cp() {
  if (ml) return ss;
  ml = 1;
  var e = wd();
  return ss = Object("z").propertyIsEnumerable(0) ? Object : function(n) {
    return e(n) == "String" ? n.split("") : Object(n);
  }, ss;
}
var is, dl;
function Xo() {
  return dl || (dl = 1, is = function(e) {
    if (e == null) throw TypeError("Can't call method on  " + e);
    return e;
  }), is;
}
var os, fl;
function Qo() {
  if (fl) return os;
  fl = 1;
  var e = cp(), n = Xo();
  return os = function(t) {
    return e(n(t));
  }, os;
}
var cs, El;
function Ad() {
  return El || (El = 1, cs = !0), cs;
}
var ls = { exports: {} }, _l;
function Pn() {
  if (_l) return ls.exports;
  _l = 1;
  var e = ls.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  return typeof __g == "number" && (__g = e), ls.exports;
}
var us = { exports: {} }, gl;
function On() {
  if (gl) return us.exports;
  gl = 1;
  var e = us.exports = { version: "2.6.12" };
  return typeof __e == "number" && (__e = e), us.exports;
}
var ms, pl;
function lp() {
  return pl || (pl = 1, ms = function(e) {
    if (typeof e != "function") throw TypeError(e + " is not a function!");
    return e;
  }), ms;
}
var ds, hl;
function up() {
  if (hl) return ds;
  hl = 1;
  var e = lp();
  return ds = function(n, t, r) {
    if (e(n), t === void 0) return n;
    switch (r) {
      case 1:
        return function(s) {
          return n.call(t, s);
        };
      case 2:
        return function(s, i) {
          return n.call(t, s, i);
        };
      case 3:
        return function(s, i, o) {
          return n.call(t, s, i, o);
        };
    }
    return function() {
      return n.apply(t, arguments);
    };
  }, ds;
}
var fs = {}, Es, vl;
function Zo() {
  return vl || (vl = 1, Es = function(e) {
    return typeof e == "object" ? e !== null : typeof e == "function";
  }), Es;
}
var _s, yl;
function ba() {
  if (yl) return _s;
  yl = 1;
  var e = Zo();
  return _s = function(n) {
    if (!e(n)) throw TypeError(n + " is not an object!");
    return n;
  }, _s;
}
var gs, Tl;
function Sd() {
  return Tl || (Tl = 1, gs = function(e) {
    try {
      return !!e();
    } catch {
      return !0;
    }
  }), gs;
}
var ps, Cl;
function _r() {
  return Cl || (Cl = 1, ps = !Sd()(function() {
    return Object.defineProperty({}, "a", { get: function() {
      return 7;
    } }).a != 7;
  })), ps;
}
var hs, Rl;
function Id() {
  if (Rl) return hs;
  Rl = 1;
  var e = Zo(), n = Pn().document, t = e(n) && e(n.createElement);
  return hs = function(r) {
    return t ? n.createElement(r) : {};
  }, hs;
}
var vs, bl;
function mp() {
  return bl || (bl = 1, vs = !_r() && !Sd()(function() {
    return Object.defineProperty(Id()("div"), "a", { get: function() {
      return 7;
    } }).a != 7;
  })), vs;
}
var ys, wl;
function dp() {
  if (wl) return ys;
  wl = 1;
  var e = Zo();
  return ys = function(n, t) {
    if (!e(n)) return n;
    var r, s;
    if (t && typeof (r = n.toString) == "function" && !e(s = r.call(n)) || typeof (r = n.valueOf) == "function" && !e(s = r.call(n)) || !t && typeof (r = n.toString) == "function" && !e(s = r.call(n))) return s;
    throw TypeError("Can't convert object to primitive value");
  }, ys;
}
var Al;
function wa() {
  if (Al) return fs;
  Al = 1;
  var e = ba(), n = mp(), t = dp(), r = Object.defineProperty;
  return fs.f = _r() ? Object.defineProperty : function(i, o, c) {
    if (e(i), o = t(o, !0), e(c), n) try {
      return r(i, o, c);
    } catch {
    }
    if ("get" in c || "set" in c) throw TypeError("Accessors not supported!");
    return "value" in c && (i[o] = c.value), i;
  }, fs;
}
var Ts, Sl;
function Nd() {
  return Sl || (Sl = 1, Ts = function(e, n) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: n
    };
  }), Ts;
}
var Cs, Il;
function gr() {
  if (Il) return Cs;
  Il = 1;
  var e = wa(), n = Nd();
  return Cs = _r() ? function(t, r, s) {
    return e.f(t, r, n(1, s));
  } : function(t, r, s) {
    return t[r] = s, t;
  }, Cs;
}
var Rs, Nl;
function Aa() {
  if (Nl) return Rs;
  Nl = 1;
  var e = {}.hasOwnProperty;
  return Rs = function(n, t) {
    return e.call(n, t);
  }, Rs;
}
var bs, Pl;
function Pd() {
  if (Pl) return bs;
  Pl = 1;
  var e = Pn(), n = On(), t = up(), r = gr(), s = Aa(), i = "prototype", o = function(c, m, u) {
    var l = c & o.F, d = c & o.G, f = c & o.S, E = c & o.P, g = c & o.B, p = c & o.W, v = d ? n : n[m] || (n[m] = {}), y = v[i], C = d ? e : f ? e[m] : (e[m] || {})[i], b, R, P;
    d && (u = m);
    for (b in u)
      R = !l && C && C[b] !== void 0, !(R && s(v, b)) && (P = R ? C[b] : u[b], v[b] = d && typeof C[b] != "function" ? u[b] : g && R ? t(P, e) : p && C[b] == P ? function(D) {
        var z = function(F, ae, Te) {
          if (this instanceof D) {
            switch (arguments.length) {
              case 0:
                return new D();
              case 1:
                return new D(F);
              case 2:
                return new D(F, ae);
            }
            return new D(F, ae, Te);
          }
          return D.apply(this, arguments);
        };
        return z[i] = D[i], z;
      }(P) : E && typeof P == "function" ? t(Function.call, P) : P, E && ((v.virtual || (v.virtual = {}))[b] = P, c & o.R && y && !y[b] && r(y, b, P)));
  };
  return o.F = 1, o.G = 2, o.S = 4, o.P = 8, o.B = 16, o.W = 32, o.U = 64, o.R = 128, bs = o, bs;
}
var ws, Ol;
function fp() {
  return Ol || (Ol = 1, ws = gr()), ws;
}
var As, kl;
function Jo() {
  if (kl) return As;
  kl = 1;
  var e = Math.ceil, n = Math.floor;
  return As = function(t) {
    return isNaN(t = +t) ? 0 : (t > 0 ? n : e)(t);
  }, As;
}
var Ss, Dl;
function Ep() {
  if (Dl) return Ss;
  Dl = 1;
  var e = Jo(), n = Math.min;
  return Ss = function(t) {
    return t > 0 ? n(e(t), 9007199254740991) : 0;
  }, Ss;
}
var Is, Ll;
function _p() {
  if (Ll) return Is;
  Ll = 1;
  var e = Jo(), n = Math.max, t = Math.min;
  return Is = function(r, s) {
    return r = e(r), r < 0 ? n(r + s, 0) : t(r, s);
  }, Is;
}
var Ns, xl;
function gp() {
  if (xl) return Ns;
  xl = 1;
  var e = Qo(), n = Ep(), t = _p();
  return Ns = function(r) {
    return function(s, i, o) {
      var c = e(s), m = n(c.length), u = t(o, m), l;
      if (r && i != i) {
        for (; m > u; )
          if (l = c[u++], l != l) return !0;
      } else for (; m > u; u++) if ((r || u in c) && c[u] === i)
        return r || u || 0;
      return !r && -1;
    };
  }, Ns;
}
var Ps = { exports: {} }, Fl;
function Od() {
  if (Fl) return Ps.exports;
  Fl = 1;
  var e = On(), n = Pn(), t = "__core-js_shared__", r = n[t] || (n[t] = {});
  return (Ps.exports = function(s, i) {
    return r[s] || (r[s] = i !== void 0 ? i : {});
  })("versions", []).push({
    version: e.version,
    mode: Ad() ? "pure" : "global",
    copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
  }), Ps.exports;
}
var Os, Ml;
function kd() {
  if (Ml) return Os;
  Ml = 1;
  var e = 0, n = Math.random();
  return Os = function(t) {
    return "Symbol(".concat(t === void 0 ? "" : t, ")_", (++e + n).toString(36));
  }, Os;
}
var ks, Bl;
function ec() {
  if (Bl) return ks;
  Bl = 1;
  var e = Od()("keys"), n = kd();
  return ks = function(t) {
    return e[t] || (e[t] = n(t));
  }, ks;
}
var Ds, $l;
function pp() {
  if ($l) return Ds;
  $l = 1;
  var e = Aa(), n = Qo(), t = gp()(!1), r = ec()("IE_PROTO");
  return Ds = function(s, i) {
    var o = n(s), c = 0, m = [], u;
    for (u in o) u != r && e(o, u) && m.push(u);
    for (; i.length > c; ) e(o, u = i[c++]) && (~t(m, u) || m.push(u));
    return m;
  }, Ds;
}
var Ls, Wl;
function Dd() {
  return Wl || (Wl = 1, Ls = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")), Ls;
}
var xs, Hl;
function hp() {
  if (Hl) return xs;
  Hl = 1;
  var e = pp(), n = Dd();
  return xs = Object.keys || function(r) {
    return e(r, n);
  }, xs;
}
var Fs, ql;
function vp() {
  if (ql) return Fs;
  ql = 1;
  var e = wa(), n = ba(), t = hp();
  return Fs = _r() ? Object.defineProperties : function(s, i) {
    n(s);
    for (var o = t(i), c = o.length, m = 0, u; c > m; ) e.f(s, u = o[m++], i[u]);
    return s;
  }, Fs;
}
var Ms, Gl;
function yp() {
  if (Gl) return Ms;
  Gl = 1;
  var e = Pn().document;
  return Ms = e && e.documentElement, Ms;
}
var Bs, Ul;
function Tp() {
  if (Ul) return Bs;
  Ul = 1;
  var e = ba(), n = vp(), t = Dd(), r = ec()("IE_PROTO"), s = function() {
  }, i = "prototype", o = function() {
    var c = Id()("iframe"), m = t.length, u = "<", l = ">", d;
    for (c.style.display = "none", yp().appendChild(c), c.src = "javascript:", d = c.contentWindow.document, d.open(), d.write(u + "script" + l + "document.F=Object" + u + "/script" + l), d.close(), o = d.F; m--; ) delete o[i][t[m]];
    return o();
  };
  return Bs = Object.create || function(m, u) {
    var l;
    return m !== null ? (s[i] = e(m), l = new s(), s[i] = null, l[r] = m) : l = o(), u === void 0 ? l : n(l, u);
  }, Bs;
}
var $s = { exports: {} }, Yl;
function an() {
  if (Yl) return $s.exports;
  Yl = 1;
  var e = Od()("wks"), n = kd(), t = Pn().Symbol, r = typeof t == "function", s = $s.exports = function(i) {
    return e[i] || (e[i] = r && t[i] || (r ? t : n)("Symbol." + i));
  };
  return s.store = e, $s.exports;
}
var Ws, jl;
function Ld() {
  if (jl) return Ws;
  jl = 1;
  var e = wa().f, n = Aa(), t = an()("toStringTag");
  return Ws = function(r, s, i) {
    r && !n(r = i ? r : r.prototype, t) && e(r, t, { configurable: !0, value: s });
  }, Ws;
}
var Hs, Vl;
function Cp() {
  if (Vl) return Hs;
  Vl = 1;
  var e = Tp(), n = Nd(), t = Ld(), r = {};
  return gr()(r, an()("iterator"), function() {
    return this;
  }), Hs = function(s, i, o) {
    s.prototype = e(r, { next: n(1, o) }), t(s, i + " Iterator");
  }, Hs;
}
var qs, Kl;
function Rp() {
  if (Kl) return qs;
  Kl = 1;
  var e = Xo();
  return qs = function(n) {
    return Object(e(n));
  }, qs;
}
var Gs, zl;
function bp() {
  if (zl) return Gs;
  zl = 1;
  var e = Aa(), n = Rp(), t = ec()("IE_PROTO"), r = Object.prototype;
  return Gs = Object.getPrototypeOf || function(s) {
    return s = n(s), e(s, t) ? s[t] : typeof s.constructor == "function" && s instanceof s.constructor ? s.constructor.prototype : s instanceof Object ? r : null;
  }, Gs;
}
var Us, Xl;
function xd() {
  if (Xl) return Us;
  Xl = 1;
  var e = Ad(), n = Pd(), t = fp(), r = gr(), s = Er(), i = Cp(), o = Ld(), c = bp(), m = an()("iterator"), u = !([].keys && "next" in [].keys()), l = "@@iterator", d = "keys", f = "values", E = function() {
    return this;
  };
  return Us = function(g, p, v, y, C, b, R) {
    i(v, p, y);
    var P = function(O) {
      if (!u && O in ae) return ae[O];
      switch (O) {
        case d:
          return function() {
            return new v(this, O);
          };
        case f:
          return function() {
            return new v(this, O);
          };
      }
      return function() {
        return new v(this, O);
      };
    }, D = p + " Iterator", z = C == f, F = !1, ae = g.prototype, Te = ae[m] || ae[l] || C && ae[C], W = Te || P(C), se = C ? z ? P("entries") : W : void 0, ue = p == "Array" && ae.entries || Te, N, S, L;
    if (ue && (L = c(ue.call(new g())), L !== Object.prototype && L.next && (o(L, D, !0), !e && typeof L[m] != "function" && r(L, m, E))), z && Te && Te.name !== f && (F = !0, W = function() {
      return Te.call(this);
    }), (!e || R) && (u || F || !ae[m]) && r(ae, m, W), s[p] = W, s[D] = E, C)
      if (N = {
        values: z ? W : P(f),
        keys: b ? W : P(d),
        entries: se
      }, R) for (S in N)
        S in ae || t(ae, S, N[S]);
      else n(n.P + n.F * (u || F), p, N);
    return N;
  }, Us;
}
var Ys, Ql;
function wp() {
  if (Ql) return Ys;
  Ql = 1;
  var e = ip(), n = op(), t = Er(), r = Qo();
  return Ys = xd()(Array, "Array", function(s, i) {
    this._t = r(s), this._i = 0, this._k = i;
  }, function() {
    var s = this._t, i = this._k, o = this._i++;
    return !s || o >= s.length ? (this._t = void 0, n(1)) : i == "keys" ? n(0, o) : i == "values" ? n(0, s[o]) : n(0, [o, s[o]]);
  }, "values"), t.Arguments = t.Array, e("keys"), e("values"), e("entries"), Ys;
}
var Zl;
function Fd() {
  if (Zl) return il;
  Zl = 1, wp();
  for (var e = Pn(), n = gr(), t = Er(), r = an()("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), i = 0; i < s.length; i++) {
    var o = s[i], c = e[o], m = c && c.prototype;
    m && !m[r] && n(m, r, o), t[o] = t.Array;
  }
  return il;
}
var Jl = {}, js, eu;
function Ap() {
  if (eu) return js;
  eu = 1;
  var e = Jo(), n = Xo();
  return js = function(t) {
    return function(r, s) {
      var i = String(n(r)), o = e(s), c = i.length, m, u;
      return o < 0 || o >= c ? t ? "" : void 0 : (m = i.charCodeAt(o), m < 55296 || m > 56319 || o + 1 === c || (u = i.charCodeAt(o + 1)) < 56320 || u > 57343 ? t ? i.charAt(o) : m : t ? i.slice(o, o + 2) : (m - 55296 << 10) + (u - 56320) + 65536);
    };
  }, js;
}
var tu;
function Md() {
  if (tu) return Jl;
  tu = 1;
  var e = Ap()(!0);
  return xd()(String, "String", function(n) {
    this._t = String(n), this._i = 0;
  }, function() {
    var n = this._t, t = this._i, r;
    return t >= n.length ? { value: void 0, done: !0 } : (r = e(n, t), this._i += r.length, { value: r, done: !1 });
  }), Jl;
}
var Vs, nu;
function Bd() {
  if (nu) return Vs;
  nu = 1;
  var e = wd(), n = an()("toStringTag"), t = e(/* @__PURE__ */ function() {
    return arguments;
  }()) == "Arguments", r = function(s, i) {
    try {
      return s[i];
    } catch {
    }
  };
  return Vs = function(s) {
    var i, o, c;
    return s === void 0 ? "Undefined" : s === null ? "Null" : typeof (o = r(i = Object(s), n)) == "string" ? o : t ? e(i) : (c = e(i)) == "Object" && typeof i.callee == "function" ? "Arguments" : c;
  }, Vs;
}
var Ks, ru;
function Sp() {
  if (ru) return Ks;
  ru = 1;
  var e = Bd(), n = an()("iterator"), t = Er();
  return Ks = On().isIterable = function(r) {
    var s = Object(r);
    return s[n] !== void 0 || "@@iterator" in s || t.hasOwnProperty(e(s));
  }, Ks;
}
var zs, au;
function Ip() {
  return au || (au = 1, Fd(), Md(), zs = Sp()), zs;
}
var Xs, su;
function Np() {
  return su || (su = 1, Xs = { default: Ip(), __esModule: !0 }), Xs;
}
var Qs, iu;
function Pp() {
  if (iu) return Qs;
  iu = 1;
  var e = Bd(), n = an()("iterator"), t = Er();
  return Qs = On().getIteratorMethod = function(r) {
    if (r != null) return r[n] || r["@@iterator"] || t[e(r)];
  }, Qs;
}
var Zs, ou;
function Op() {
  if (ou) return Zs;
  ou = 1;
  var e = ba(), n = Pp();
  return Zs = On().getIterator = function(t) {
    var r = n(t);
    if (typeof r != "function") throw TypeError(t + " is not iterable!");
    return e(r.call(t));
  }, Zs;
}
var Js, cu;
function kp() {
  return cu || (cu = 1, Fd(), Md(), Js = Op()), Js;
}
var ei, lu;
function Dp() {
  return lu || (lu = 1, ei = { default: kp(), __esModule: !0 }), ei;
}
var uu;
function Lp() {
  if (uu) return Lr;
  uu = 1, Lr.__esModule = !0;
  var e = Np(), n = s(e), t = Dp(), r = s(t);
  function s(i) {
    return i && i.__esModule ? i : { default: i };
  }
  return Lr.default = /* @__PURE__ */ function() {
    function i(o, c) {
      var m = [], u = !0, l = !1, d = void 0;
      try {
        for (var f = (0, r.default)(o), E; !(u = (E = f.next()).done) && (m.push(E.value), !(c && m.length === c)); u = !0)
          ;
      } catch (g) {
        l = !0, d = g;
      } finally {
        try {
          !u && f.return && f.return();
        } finally {
          if (l) throw d;
        }
      }
      return m;
    }
    return function(o, c) {
      if (Array.isArray(o))
        return o;
      if ((0, n.default)(Object(o)))
        return i(o, c);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(), Lr;
}
var xr = {}, mu = {}, du;
function xp() {
  if (du) return mu;
  du = 1;
  var e = Pd();
  return e(e.S + e.F * !_r(), "Object", { defineProperty: wa().f }), mu;
}
var ti, fu;
function Fp() {
  if (fu) return ti;
  fu = 1, xp();
  var e = On().Object;
  return ti = function(t, r, s) {
    return e.defineProperty(t, r, s);
  }, ti;
}
var ni, Eu;
function Mp() {
  return Eu || (Eu = 1, ni = { default: Fp(), __esModule: !0 }), ni;
}
var _u;
function Bp() {
  if (_u) return xr;
  _u = 1, xr.__esModule = !0;
  var e = Mp(), n = t(e);
  function t(r) {
    return r && r.__esModule ? r : { default: r };
  }
  return xr.default = function(r, s, i) {
    return s in r ? (0, n.default)(r, s, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : r[s] = i, r;
  }, xr;
}
var Fr = {}, gu;
function $p() {
  if (gu) return Fr;
  gu = 1, Object.defineProperty(Fr, "__esModule", {
    value: !0
  });
  var e = {
    "13/8": "2.62",
    "15/8": "2.87",
    "11/8": "2.37",
    "8/13": "1.61",
    "2/7": "1.28",
    "1/8": "1.12",
    "123/200": "1.62"
  };
  return Fr.default = e, Fr;
}
var pu;
function Wp() {
  if (pu) return Kt;
  pu = 1, Object.defineProperty(Kt, "__esModule", {
    value: !0
  }), Kt.formatSingleOdds = Kt.formatOdds = void 0;
  var e = Lp(), n = m(e), t = Bp(), r = m(t), s, i = bd(), o = $p(), c = m(o);
  function m(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var u = function(y, C) {
    var b = y + "/" + C, R = c.default[b];
    return R !== void 0 ? R : (y / C + 1).toFixed(2);
  }, l = function(y, C) {
    if (y >= C) {
      var b = 100 * (y / C);
      return "+" + b.toFixed(0);
    }
    var R = -100 / (y / C);
    return R.toFixed(0);
  }, d = function(y, C) {
    return y === C ? "EVS" : y + "/" + C;
  }, f = (s = {}, (0, r.default)(s, i.ODDS_FORMATS.DECIMAL, u), (0, r.default)(s, i.ODDS_FORMATS.AMERICAN, l), (0, r.default)(s, i.ODDS_FORMATS.FRACTION, d), s), E = function(y) {
    var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return C ? parseFloat(y) : parseInt(y, 10);
  }, g = function(y, C, b) {
    return !!(y && C && b);
  }, p = Kt.formatOdds = function(y, C) {
    var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i.DEFAULT_ODDS_FORMAT, R = arguments[3], P = E(y, R), D = parseInt(C, 10), z = f[b.toLowerCase()];
    return g(z, P, D) ? z(P, D) : "";
  };
  return Kt.formatSingleOdds = function(y, C, b) {
    var R = y.split("/"), P = (0, n.default)(R, 2), D = P[0], z = P[1];
    return p(D, z, C, b);
  }, Kt;
}
var hu;
function Hp() {
  if (hu) return bt;
  hu = 1, Object.defineProperty(bt, "__esModule", {
    value: !0
  }), bt.formatSingleOdds = bt.formatOdds = bt.oddsFormats = void 0;
  var e = bd(), n = Wp();
  return bt.oddsFormats = e.ODDS_FORMATS, bt.formatOdds = n.formatOdds, bt.formatSingleOdds = n.formatSingleOdds, bt;
}
var qp = Hp();
function $d(e) {
  const n = d_();
  return A(() => Array.isArray(e.priceHistory) ? e.priceHistory.reverse().map((t) => qp.formatSingleOdds(t, n)).filter(Boolean).join(", ") : null, [n, e.priceHistory]);
}
const Gp = "ngs-meetings__SelectionButton__container__YUI4a", Up = "ngs-meetings__SelectionButton__label__YUI4a", ri = {
  container: Gp,
  label: Up
};
function sn({
  readonly: e,
  selection: n,
  market: t,
  event: r,
  analytics: s,
  color: i,
  className: o,
  style: c,
  children: m
}) {
  const u = mr(), { isAdded: l, isAdding: d, toggle: f } = f_(
    n.id,
    A(
      () => ({
        analytics: s
      }),
      [s]
    )
  ), E = dr(n, t, r), g = u(
    n.currentPriceNum,
    n.currentPriceDen
  );
  return e ? /* @__PURE__ */ a.createElement(
    ed,
    {
      className: o,
      style: c,
      "data-selection-id": n.id
    },
    m != null ? typeof m == "function" ? m({ selected: l || d, formattedOdds: g }) : m : g
  ) : /* @__PURE__ */ a.createElement(
    Uo,
    {
      color: i,
      className: o,
      style: c,
      onClick: (p) => {
        p.stopPropagation(), f();
      },
      disabled: E,
      selected: l || d,
      "data-event-id": r.id,
      "data-market-id": t.id,
      "data-selection-id": n.id,
      "data-testid": "price-button"
    },
    m != null ? typeof m == "function" ? m({ selected: l || d, formattedOdds: g }) : m : g
  );
}
const Yp = ({
  event: e,
  selection: n,
  readonly: t,
  topLabel: r,
  bettingOpportunities: s,
  bottomLabel: i
}) => {
  var d;
  const o = nn(
    A(
      () => ({
        id: e.id,
        isInPlay: e.isInPlay,
        settled: e.settled,
        startDateTime: e.startDateTime,
        status: "A"
      }),
      [e]
    )
  ), c = An(e.market, e.id), m = tn(
    A(
      () => ({
        ...n,
        marketId: e.market.id,
        eventId: e.id,
        currentPriceNum: n.priceNum,
        currentPriceDen: n.priceDen
      }),
      [n, e.id, e.market.id]
    )
  ), u = $d(m), l = ((d = s == null ? void 0 : s.find(
    (f) => f.marketId === e.market.id
  )) == null ? void 0 : d.type) === Ko.STARTING_PRICE;
  return /* @__PURE__ */ a.createElement("div", { className: ri.container, "data-testid": "selection-button" }, /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: ri.label }, r), /* @__PURE__ */ a.createElement(
    sn,
    {
      selection: m,
      market: c,
      event: o,
      analytics: A(() => ({ BetListName: ["WH Ambassador"] }), []),
      readonly: t
    },
    l ? zo : null
  ), /* @__PURE__ */ a.createElement(
    T,
    {
      variant: "captionSecondary",
      className: ri.label,
      "data-testid": "price-history"
    },
    i === "priceHistory" && !t ? u : null,
    i !== "priceHistory" ? i : null
  ));
}, jp = "ngs-meetings__Row__container__X5Gdu", Vp = "ngs-meetings__Row__selectionDetailsContainer__X5Gdu", vu = {
  container: jp,
  selectionDetailsContainer: Vp
}, Kp = ({
  event: e,
  selection: n,
  bettingOpportunities: t
}) => {
  const r = tt(), { active: s, runner: i, runnerNum: o, name: c } = n;
  return /* @__PURE__ */ a.createElement("div", { className: vu.container }, /* @__PURE__ */ a.createElement("div", { className: vu.selectionDetailsContainer }, i && (r ? /* @__PURE__ */ a.createElement(
    Nn,
    {
      active: s,
      runnerNum: o,
      greyhoundsRegionType: e.greyhoundsRegionType
    }
  ) : /* @__PURE__ */ a.createElement(fr, { runnerNum: o, runner: i })), /* @__PURE__ */ a.createElement(
    Ra,
    {
      active: s,
      greyhoundsRegionType: e.greyhoundsRegionType,
      runnerNum: o,
      runner: i,
      title: c
    }
  )), /* @__PURE__ */ a.createElement(
    Yp,
    {
      event: e,
      selection: n,
      bettingOpportunities: t,
      bottomLabel: "priceHistory"
    }
  ));
}, zp = "ngs-meetings__RaceFooter__viewCardLink__KO0MX", Xp = {
  viewCardLink: zp
}, Qp = ({
  eventId: e,
  eventSlug: n,
  numberOfRunners: t
}) => {
  const r = V(), s = () => {
    r.navigateToEvent(e, n);
  };
  return /* @__PURE__ */ a.createElement("div", { className: Xp.viewCardLink }, /* @__PURE__ */ a.createElement(ke, { variant: "link", size: "medium", onClick: s }, `View Full Card (${t} Runners)`));
}, Wd = ({
  event: e,
  bettingOpportunity: n
}) => {
  var t;
  return e.settled ? null : /* @__PURE__ */ a.createElement(a.Fragment, null, (t = e.topSelections) == null ? void 0 : t.map((r) => /* @__PURE__ */ a.createElement("div", { key: r.id }, /* @__PURE__ */ a.createElement(
    Kp,
    {
      event: e,
      selection: r,
      bettingOpportunities: n ? [n] : []
    }
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), /* @__PURE__ */ a.createElement(
    Qp,
    {
      eventId: e.id,
      eventSlug: e.slug,
      numberOfRunners: e.numberOfRunners
    }
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}, Zp = "ngs-meetings__EventContainer__eventDetails__CPrXT", Jp = {
  eventDetails: Zp
}, eh = "ngs-meetings__RaceStatus__container__9lrsi", th = "ngs-meetings__RaceStatus__inplay__9lrsi", nh = "ngs-meetings__RaceStatus__settled__9lrsi", Xr = {
  container: eh,
  inplay: th,
  settled: nh
}, rh = "ngs-meetings__CountdownTimer__container__NS6SA", ah = "ngs-meetings__CountdownTimer__prematch__NS6SA", yu = {
  container: rh,
  prematch: ah
}, sh = ["m", "s"], ih = 30, Tu = (e) => {
  if (e == null)
    return;
  const n = +new Date(e) - +/* @__PURE__ */ new Date();
  return n <= 1500 ? null : {
    h: Math.floor(n / (1e3 * 60 * 60)),
    m: Math.floor(n / 1e3 / 60 % 60),
    s: Math.floor(n / 1e3 % 60)
  };
}, oh = ({ target: e }) => {
  const [n, t] = ee(Tu(e));
  return te(() => {
    const r = setTimeout(() => {
      t(Tu(e));
    }, 1e3);
    return () => clearTimeout(r);
  }), ((n == null ? void 0 : n.h) ?? 0) > 0 || ((n == null ? void 0 : n.m) ?? 0) >= ih ? null : /* @__PURE__ */ a.createElement(
    T,
    {
      className: J(yu.container, yu.prematch),
      variant: "captionPrimary",
      "data-testid": "race-status"
    },
    n == null ? "Starting soon" : sh.map((r) => /* @__PURE__ */ a.createElement("span", { key: r }, n[r], r))
  );
}, ch = (e) => {
  const n = _e();
  return ye({
    queryKey: [...n.queryKey, "event-details", e],
    queryFn: () => n.services.meetings.getEventDetails(e)
  });
}, tc = () => {
  const {
    params: { eventId: e }
  } = V();
  if (!e)
    throw new Error("Missing event ID");
  return ch(e);
}, Hd = (e) => {
  const n = _e();
  return ye({
    queryKey: [...n.queryKey, "event-preview", e],
    queryFn: () => n.services.meetings.getEventPreview(e)
  });
};
function Xe(e) {
  const { data: n } = tc();
  if (!n)
    throw new Error("No event data available");
  return A(() => e(n), [n, e]);
}
function Qe() {
  return Xe((e) => e.raceCardData);
}
function q() {
  const e = Xe((n) => n.event);
  return nn(
    A(
      () => ({
        ...e,
        status: "A"
      }),
      [e]
    )
  );
}
function lh(e) {
  return nn(
    A(
      () => ({
        ...e,
        eventId: e.id
      }),
      [e]
    )
  );
}
function qd(e, n) {
  return Xe(
    (t) => t[n].marketCollections.find(
      (r) => r.name === e
    )
  );
}
function he(e) {
  return qd(e, "raceCardData");
}
function uh(e) {
  return qd(e, "inPlayRaceCardData");
}
function nc(e, n) {
  const t = Xe(
    (r) => r[n].marketCollections.flatMap((s) => s.markets).find((s) => s.id === e)
  );
  if (!t)
    throw new Error(`Market with ID ${e} does not exist`);
  return t;
}
function mh(e) {
  return nc(e, "inPlayRaceCardData");
}
function kt(e) {
  const n = Xe((r) => r.event.runners), t = e.map(we);
  return t.length ? t.map((r) => {
    var s, i;
    return !((s = n[r]) != null && s.overview) || ((i = n[r]) == null ? void 0 : i.overview) === "-";
  }).includes(!1) : !1;
}
function Gd() {
  var t;
  const e = tt(), n = he(
    e ? h.GH_WIN : h.WIN
  );
  return (t = n == null ? void 0 : n.markets) == null ? void 0 : t.find(
    ({ name: r }) => r === Q[h.WIN]
  );
}
function Ud() {
  const e = Qe();
  return (e == null ? void 0 : e.racingSpecials) ?? [];
}
function rc() {
  const e = Ud(), n = Gd();
  return gd(e, n == null ? void 0 : n.blurb);
}
function dh(e, n) {
  const t = Xe((s) => s.event), r = nc(e, n);
  return An(
    A(() => ({ ...r, eventId: t.id }), [t, r])
  );
}
function fh(e) {
  return dh(e, "raceCardData");
}
function Yd(e, n) {
  const t = Xe((i) => i[n].selections[e]), r = nc(t.marketId, n), s = Xe((i) => i.event);
  if (t == null)
    throw new Error(`Selection with ID ${e} does not exist`);
  return tn(
    A(
      () => ({
        ...t,
        id: e,
        priceHistory: t.priceHistory.map(
          (i) => `${i.priceNum}/${i.priceDen}`
        ),
        currentPriceNum: t.priceNum,
        currentPriceDen: t.priceDen,
        marketId: r.id,
        eventId: s.id
      }),
      [s, r, t, e]
    )
  );
}
function Eh(e) {
  return Yd(e, "raceCardData");
}
function _h(e) {
  return Yd(e, "inPlayRaceCardData");
}
const gh = () => {
  const { services: e, queryKey: n } = _e();
  return ye({
    queryKey: [...n, "results-version"],
    queryFn: e.results.getApiVersion,
    retry: 10,
    refetchOnMount: !1
  });
}, Co = () => {
  const { services: e, queryKey: n } = _e(), { data: t } = gh(), { id: r, settled: s } = q(), i = r.replace("OB_EV", ""), o = () => e.results.getResults(t, i).then((c) => ph(c.data) ? { ...c, status: "full" } : hh(c.data) ? { ...c, status: "partial" } : { ...c, status: "awaiting" });
  return ye({
    queryKey: [...n, "results", i],
    queryFn: o,
    enabled: !!t && s,
    refetchInterval: (c) => (c == null ? void 0 : c.status) === "full" ? !1 : (c == null ? void 0 : c.status) === "partial" ? 120 * 1e3 : 20 * 1e3,
    retry: 10
  });
};
function ph(e) {
  return e.race_runners.every(
    (n) => n.runner_is_runner && typeof n.runner_position == "number"
  );
}
function hh(e) {
  var r;
  const n = ((r = e.race_each_way_terms) == null ? void 0 : r.num_places) || 1;
  return e.race_runners.filter(
    (s) => s.runner_is_runner && typeof s.runner_position == "number" && s.runner_position <= n
  ).length >= n;
}
function pr({
  startDateTime: e,
  isInPlay: n,
  settled: t
}) {
  const r = tt();
  return t ? /* @__PURE__ */ a.createElement(vh, null) : n ? /* @__PURE__ */ a.createElement(
    T,
    {
      className: J(Xr.container, Xr.inplay),
      variant: "captionPrimary"
    },
    r ? "Race Off" : "In-Running"
  ) : /* @__PURE__ */ a.createElement(oh, { target: e });
}
function vh() {
  const { data: e } = Co();
  return /* @__PURE__ */ a.createElement(
    T,
    {
      className: J(Xr.container, Xr.settled),
      variant: "captionPrimary"
    },
    (e == null ? void 0 : e.status) === "partial" || (e == null ? void 0 : e.status) === "full" ? "Result" : "Awaiting Result"
  );
}
const jd = ({ event: e }) => {
  const n = e == null ? void 0 : e.market, t = n == null ? void 0 : n.bettingOpportunity, r = lh(e);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: Jp.eventDetails }, /* @__PURE__ */ a.createElement(Ta, { event: r }, /* @__PURE__ */ a.createElement(
    pr,
    {
      startDateTime: r.startDateTime,
      isInPlay: r.isInPlay,
      settled: r.settled
    }
  ))), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(_d, { eachWay: t == null ? void 0 : t.eachWay }), /* @__PURE__ */ a.createElement(Ca, { marketBlurb: n == null ? void 0 : n.blurb, event: e }), /* @__PURE__ */ a.createElement(
    Wd,
    {
      event: e,
      bettingOpportunity: t
    }
  ));
}, yh = ({ eventId: e }) => {
  const { data: n, isLoading: t } = Hd(e);
  return t ? /* @__PURE__ */ a.createElement(Fg, null) : n ? /* @__PURE__ */ a.createElement(jd, { event: n.event, key: e }) : null;
}, ai = (e, n) => !!e.find((t) => t.id === n), Th = (e) => e.reduce(
  (n, t) => [...n, ...t.events],
  []
).flat().reduce((n, t) => (n.find((r) => r.id === t.id) || n.push(t), n), []).filter((n) => !n.settled && !n.isInPlay).sort((n, t) => +new Date(n.startDateTime) - +new Date(t.startDateTime)), hr = (e, n) => {
  var r;
  if (!e)
    return [];
  const t = n === Je.ALL ? e.filter(({ regionFilter: s }) => s.id !== "virtual-racing").map((s) => s.competitions).flat() : (r = e.find(
    ({ regionFilter: s }) => s.id === n
  )) == null ? void 0 : r.competitions;
  return t ? Th(t) : [];
}, nr = (e, n) => {
  var t;
  return ((t = hr(e, n).find(
    (r) => !r.settled
  )) == null ? void 0 : t.id) || "";
}, Ch = (e, n, t) => hr(e, n).find(
  (r) => r.id === t
), Vd = (e) => {
  if (!e)
    return [];
  const { regionCompetitionsByDays: n } = e;
  return n.map(({ regionCompetitions: t }) => t).flat().reduce((t, r) => {
    const s = t.find(
      ({ regionFilter: i }) => i.id === r.regionFilter.id
    );
    return s ? s.competitions = [
      ...s.competitions,
      ...r.competitions
    ] : t.push({ ...r }), t;
  }, []);
}, Rh = (e) => {
  if (!e)
    return [];
  const n = Vd(e), { availableRegionFilters: t } = e;
  return t.filter(
    (r) => hr(n, r.id).length
  );
}, Kd = ({
  events: e = [],
  regionCompetitions: n,
  regionId: t
}) => {
  const r = A(() => n && t ? hr(n, t) : e, [n, t, e]), [s, i] = ee(() => {
    var c;
    return n && t ? nr(n, t) : ((c = r[0]) == null ? void 0 : c.id) || "";
  });
  te(() => {
    var m;
    if (!r.length) {
      s && i("");
      return;
    }
    const c = r.find((u) => u.id === s);
    if (!c || c.settled) {
      const u = n && t ? nr(n, t) : ((m = r.find((l) => !l.settled)) == null ? void 0 : m.id) || r[0].id;
      u !== s && i(u);
    }
  }, [r, s, n, t]);
  const o = (c) => i(c);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    Vo,
    {
      events: r,
      value: s,
      onClick: o
    }
  ), s && /* @__PURE__ */ a.createElement(yh, { eventId: s, key: s }));
}, dI = () => {
  const e = Tg();
  return e != null && e.length ? /* @__PURE__ */ a.createElement(fa, { "data-testid": "ngs-top-races" }, /* @__PURE__ */ a.createElement(Gt, null, "Top Races"), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(Kd, { events: e })) : null;
}, bh = (e) => {
  const n = [{ id: Je.ALL, name: "All" }], t = {}, r = {};
  for (const s of e)
    for (const i of s.competitions)
      for (const o of i.events)
        !o.settled && !o.isInPlay && (r[s.regionFilter.id] || (r[s.regionFilter.id] = [], n.push(s.regionFilter)), r[s.regionFilter.id].push(o), !t[o.id] && s.regionFilter.id !== "virtual-racing" && (t[o.id] = o));
  return n.length === 1 ? null : {
    regions: n,
    regionEvents: {
      all: Object.values(t).sort(ha),
      ...r
    }
  };
}, wh = () => {
  const { data: e, isSuccess: n } = dd();
  return {
    isSuccess: n,
    data: e && bh(e.regionCompetitions)
  };
}, zd = ({
  regions: e,
  defaultValue: n,
  link: t = () => "",
  onClick: r
}) => /* @__PURE__ */ a.createElement(It, { defaultValue: n }, /* @__PURE__ */ a.createElement(Nt, { variant: "underscore", theme: "dark", "data-testid": "region-carousel" }, e.map((s) => /* @__PURE__ */ a.createElement(
  Pt,
  {
    key: s.id,
    variant: "underscore",
    theme: "dark",
    value: s.id,
    onClick: () => r(s.id),
    link: t(s.id),
    "data-testid": "region-tab"
  },
  s.name
)))), Ah = ({
  title: e,
  regionEvents: n,
  regions: t
}) => {
  const { defaultRegion: r } = ad(), s = t.some((u) => u.id === r) ? r : Je.ALL, [i, o] = ee(s), c = (u) => {
    o(u);
  }, m = A(() => [...n[i] || []].sort(ha), [i, n]);
  return /* @__PURE__ */ a.createElement(fa, { "data-testid": "ngs-next-races" }, e && /* @__PURE__ */ a.createElement(Gt, null, e), /* @__PURE__ */ a.createElement(
    zd,
    {
      regions: t,
      defaultValue: s,
      onClick: c
    }
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(Kd, { events: m, key: i }));
}, Sh = () => {
  const { data: e, isSuccess: n } = wh();
  if (!n || !e)
    return null;
  const { regions: t, regionEvents: r } = e;
  return /* @__PURE__ */ a.createElement(
    Ah,
    {
      title: "Next Races",
      regionEvents: r,
      regions: t
    }
  );
}, Ih = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "featured-races"],
    queryFn: e.services.meetings.getFeaturedRaces
  });
}, Nh = (e, n) => {
  const t = new Set(e), r = {};
  for (const s of n)
    for (const i of s.regionCompetitions)
      for (const o of i.competitions)
        for (const c of o.events)
          t.has(c.id) && !c.settled && !c.isInPlay && (r[c.id] || (r[c.id] = c));
  return [...Object.values(r)].sort(ha);
}, Ph = () => {
  const { data: e } = pa(), { data: n, isSuccess: t } = Ih();
  return {
    displayTitle: n == null ? void 0 : n.displayTitle,
    featuredRaces: n && e && Nh(
      n.featuredRacesIds,
      e.regionCompetitionsByDays
    ),
    isSuccess: t
  };
}, Oh = "ngs-meetings__FeaturedRaces__eventDetails__NWS8u", kh = "ngs-meetings__FeaturedRaces__skeletonRow__NWS8u", Dh = "ngs-meetings__FeaturedRaces__skeletonItem__NWS8u", ct = {
  eventDetails: Oh,
  skeletonRow: kh,
  skeletonItem: Dh
}, Lh = () => /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement("div", { className: ct.skeletonRow }, /* @__PURE__ */ a.createElement(U, { style: { flex: 7 } })), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("div", { className: ct.skeletonRow }, /* @__PURE__ */ a.createElement(U, { style: { flex: 7 } })), /* @__PURE__ */ a.createElement(w, { theme: "light" }), [...Array(3)].map((e, n) => /* @__PURE__ */ a.createElement(a.Fragment, { key: n }, /* @__PURE__ */ a.createElement("div", { className: ct.skeletonRow, style: { height: "70px" } }, /* @__PURE__ */ a.createElement(U, { style: { flex: 5 }, className: ct.skeletonItem }), /* @__PURE__ */ a.createElement(U, { style: { flex: 1 }, className: ct.skeletonItem })))), /* @__PURE__ */ a.createElement("div", { className: ct.skeletonRow }, /* @__PURE__ */ a.createElement(U, { style: { flex: 7 } })), /* @__PURE__ */ a.createElement(w, { theme: "light" })), xh = ({
  data: e,
  isLoading: n,
  isSuccess: t
}) => {
  var r;
  return n ? /* @__PURE__ */ a.createElement(Lh, null) : !e || !e.event || !t || !e.event.market.bettingOpportunity ? null : /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(_d, { eachWay: (r = e.event.market.bettingOpportunity) == null ? void 0 : r.eachWay }), /* @__PURE__ */ a.createElement(
    Ca,
    {
      marketBlurb: e.event.market.blurb,
      event: e.event
    }
  ), /* @__PURE__ */ a.createElement(
    Wd,
    {
      event: e.event,
      bettingOpportunity: e.event.market.bettingOpportunity
    }
  ));
}, Fh = ({
  data: e,
  isLoading: n,
  isSuccess: t
}) => n ? /* @__PURE__ */ a.createElement("div", { style: { height: "100%" } }, /* @__PURE__ */ a.createElement("div", { className: ct.skeletonRow }, /* @__PURE__ */ a.createElement(U, { style: { flex: 5 } }), /* @__PURE__ */ a.createElement(U, { style: { flex: 2 } })), /* @__PURE__ */ a.createElement("div", { className: ct.skeletonRow }, /* @__PURE__ */ a.createElement(U, { style: { flex: 6, height: "16px" } }), /* @__PURE__ */ a.createElement(U, { className: ct.skeletonItem }))) : !e || !e.event || !t ? null : /* @__PURE__ */ a.createElement("div", { className: ct.eventDetails }, /* @__PURE__ */ a.createElement(Ta, { event: e.event }, /* @__PURE__ */ a.createElement(
  pr,
  {
    startDateTime: e.event.startDateTime,
    isInPlay: e.event.isInPlay
  }
))), Mh = ({
  featuredRaces: e,
  displayTitle: n
}) => {
  const [t, r] = ee(e[0].id), { data: s, isSuccess: i, isLoading: o } = Hd(t);
  return /* @__PURE__ */ a.createElement(fa, { "data-testid": "ngs-featured-races" }, /* @__PURE__ */ a.createElement("div", { className: ct.mainContainer }, n ? /* @__PURE__ */ a.createElement(Gt, null, n) : null, e ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    Vo,
    {
      events: e,
      value: t,
      onClick: r
    }
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null, /* @__PURE__ */ a.createElement(
    Fh,
    {
      data: s,
      isLoading: o,
      isSuccess: i
    }
  )), /* @__PURE__ */ a.createElement(
    xh,
    {
      data: s,
      isLoading: o,
      isSuccess: i
    }
  ));
}, Bh = () => {
  const { displayTitle: e, featuredRaces: n, isSuccess: t } = Ph();
  return !t || !(n != null && n.length) ? null : /* @__PURE__ */ a.createElement(
    Mh,
    {
      featuredRaces: n,
      displayTitle: e
    }
  );
}, $h = "ngs-meetings__PriceBoostCard__container__87maD", Wh = "ngs-meetings__PriceBoostCard__content__87maD", Hh = "ngs-meetings__PriceBoostCard__name__87maD", qh = "ngs-meetings__PriceBoostCard__info__87maD", Gh = "ngs-meetings__PriceBoostCard__title__87maD", Uh = "ngs-meetings__PriceBoostCard__footer__87maD", Yh = "ngs-meetings__PriceBoostCard__eventLink__87maD", jh = "ngs-meetings__PriceBoostCard__eventInfo__87maD", Dt = {
  container: $h,
  content: Wh,
  name: Hh,
  info: qh,
  title: Gh,
  footer: Uh,
  eventLink: Yh,
  eventInfo: jh
}, Vh = "ngs-meetings__PriceBoostSelection__selection__NoJaC", Kh = "ngs-meetings__PriceBoostSelection__wasPrice__NoJaC", si = {
  selection: Vh,
  wasPrice: Kh
};
function zh(e, n, t) {
  return e && n ? t(e, n) : null;
}
const ac = (e, n, t, r) => {
  const s = mr(), i = {
    num: (r == null ? void 0 : r.wasPriceNum) != null ? +r.wasPriceNum : null,
    den: (r == null ? void 0 : r.wasPriceDen) != null ? +r.wasPriceDen : null
  }, { num: o, den: c } = m_(
    e,
    n,
    t,
    i
  );
  return zh(o, c, s);
};
function Xh({
  selectionId: e,
  marketId: n,
  eventId: t
}) {
  const r = _0(e), s = An(
    A(
      () => ({
        id: r.marketId,
        eventId: r.eventId,
        status: r.marketStatus
      }),
      [r]
    )
  ), i = nn(
    A(
      () => ({
        id: r.eventId,
        status: "A"
      }),
      [r]
    )
  ), o = ac(
    e,
    n,
    t,
    r
  );
  return /* @__PURE__ */ a.createElement("div", { className: si.selection, "data-testid": "price-boost-selection" }, o ? /* @__PURE__ */ a.createElement(
    "div",
    {
      className: si.wasPrice,
      "data-testid": "price-boost-card-wasPrice"
    },
    "was ",
    o
  ) : /* @__PURE__ */ a.createElement("div", { className: si.wasPrice }), /* @__PURE__ */ a.createElement(
    sn,
    {
      selection: r,
      market: s,
      event: i,
      analytics: A(
        () => ({ BetListName: [`HR ${r.marketType}`] }),
        [r.marketType]
      ),
      color: "yellow"
    }
  ));
}
function Qh({ promo: e }) {
  var t;
  const { navigateToEvent: n } = V();
  return /* @__PURE__ */ a.createElement("div", { className: Dt.container, "data-testid": "price-boost-card-container" }, /* @__PURE__ */ a.createElement("div", { className: Dt.content, "data-testid": "price-boost-card-content" }, /* @__PURE__ */ a.createElement("div", { className: Dt.name, "data-testid": "price-boost-card-name" }, /* @__PURE__ */ a.createElement("div", { className: Dt.info }, /* @__PURE__ */ a.createElement(T, { variant: "labelSecondary", lines: 3 }, (t = e.selectionEventName) == null ? void 0 : t.replace(/\|/g, ""))), /* @__PURE__ */ a.createElement(He, { lines: 2, level: 4, className: Dt.title }, e.displayName)), /* @__PURE__ */ a.createElement(
    Xh,
    {
      selectionId: e.selectionId,
      marketId: e.marketId,
      eventId: e.eventId
    }
  )), /* @__PURE__ */ a.createElement("div", { className: Dt.footer, "data-testid": "price-boost-card-footer" }, /* @__PURE__ */ a.createElement(
    T,
    {
      variant: "labelSecondary",
      "data-testid": "price-boost-card-stake-limit"
    },
    "Stake Limits Apply"
  ), e.targetEventSlug && (e.targetEventId || e.eventId) ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(
    ke,
    {
      variant: "link",
      onClick: () => n(
        e.targetEventId ?? e.eventId ?? "",
        e.targetEventSlug ?? ""
      ),
      className: Dt.eventLink,
      size: "small"
    },
    /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(T, { variant: "bodySecondary" }, e.targetEventName || e.selectionEventName), /* @__PURE__ */ a.createElement("div", { className: Dt.eventInfo }, /* @__PURE__ */ a.createElement(Qt, { color: "#1A9558", size: 14 }), /* @__PURE__ */ a.createElement(pr, { startDateTime: e.targetStartDateTime }), /* @__PURE__ */ a.createElement(ra, { size: 10 })))
  )) : null));
}
const Zh = "ngs-meetings__SkeletonRow__row__stURR", Jh = "ngs-meetings__SkeletonRow__skeletonItem__stURR", Cu = {
  row: Zh,
  skeletonItem: Jh
}, xe = ({
  amount: e = 1,
  height: n = "100%",
  padding: t
}) => /* @__PURE__ */ a.createElement(
  "div",
  {
    className: Cu.row,
    style: { height: n, padding: t ?? "8px" }
  },
  [...Array(e)].map((r, s) => /* @__PURE__ */ a.createElement(U, { key: s, className: Cu.skeletonItem }))
), ev = "ngs-meetings__PriceBoostsCarousel__carouselContainer__ieePS", tv = "ngs-meetings__PriceBoostsCarousel__carousel__ieePS", Ru = {
  carouselContainer: ev,
  carousel: tv
};
function nv() {
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(xe, { height: "45px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(xe, { height: "180px" }));
}
function rv() {
  return Td().isLoading ? /* @__PURE__ */ a.createElement(nv, null) : /* @__PURE__ */ a.createElement(av, null);
}
function av() {
  const [e] = wn({}), n = Cd(), t = ga(
    A(() => n.map((o) => ({
      id: o.eventId,
      status: "A"
    })), [n])
  ), r = jo(
    A(() => n.map((o) => ({
      eventId: o.eventId,
      id: o.marketId,
      status: o.marketStatus
    })), [n])
  ), s = Sn(
    A(() => n.map((o) => ({
      eventId: o.eventId,
      marketId: o.marketId,
      id: o.selectionId,
      status: o.selectionStatus
    })), [n])
  ), i = A(() => n.filter(
    (o, c) => !dr(
      s[c] ?? { status: "S" },
      r[c] ?? { status: "S" },
      t[c] ?? { status: "S" }
    )
  ), [t, r, s, n]);
  return i.length ? /* @__PURE__ */ a.createElement("div", { "data-testid": "price-boosts-container" }, /* @__PURE__ */ a.createElement(Gt, { icons: /* @__PURE__ */ a.createElement(Bt, null) }, "Price Boosts"), /* @__PURE__ */ a.createElement(
    "div",
    {
      className: Ru.carouselContainer,
      ref: e,
      "data-testid": "price-boosts-carousel-container"
    },
    /* @__PURE__ */ a.createElement("div", { className: Ru.carousel, "data-testid": "price-boosts-carousel" }, i.map((o) => /* @__PURE__ */ a.createElement(
      Qh,
      {
        key: `${o.targetEventId}-${o.selectionId}`,
        promo: o
      }
    )))
  )) : null;
}
const Et = {
  HOME: "/",
  NEXT_RACES: "next-races",
  MEETINGS: "meetings",
  SPECIALS: "specials",
  HORSE_RACING: "horse-racing",
  GREYHOUNDS: "greyhounds",
  FUTURE_RACES: "future-races",
  VIRTUAL_HORSES: "virtual-world/horses",
  VIRTUAL_GREYHOUNDS: "virtual-world/greyhounds"
}, rr = {
  [Et.HOME]: "",
  [Et.FUTURE_RACES]: "future-races",
  [Et.MEETINGS]: "meetings",
  [Et.NEXT_RACES]: "next-races",
  [Et.SPECIALS]: "specials",
  [Et.VIRTUAL_HORSES]: "virtual-world/horses/flats",
  [Et.VIRTUAL_GREYHOUNDS]: "virtual-world/greyhounds/flats",
  [Et.HORSE_RACING]: "horse-racing",
  [Et.GREYHOUNDS]: "greyhounds"
}, sv = {
  CalendarSchedule: xE,
  Greyhounds: LE,
  Highlights: DE,
  HorseRacing: Mo,
  ListItem: kE,
  Promotions: OE,
  VirtualWorldVirtualSports: PE
}, fI = () => {
  const e = V(), { navigationCarousel: n } = rd(), { sport: t, page: r } = e.params, s = (o) => {
    var c;
    return (c = n.find(({ name: m }) => rr[m] === o)) == null ? void 0 : c.displayName;
  }, i = {
    breadcrumbs: [
      {
        label: "Home",
        href: e.getLinkForCustomUrl(),
        onClick: () => e.navigateToCustomUrl()
      },
      {
        label: St[t],
        href: e.getLinkForPage(""),
        onClick: () => e.navigateToPage("")
      },
      r && {
        label: s(r),
        href: e.getLinkForPage(rr[r]),
        onClick: () => e.navigateToPage(rr[r])
      }
    ].filter((o) => !!o),
    onBack: () => e.navigateToCustomUrl()
  };
  return /* @__PURE__ */ a.createElement(n_, { value: i }, /* @__PURE__ */ a.createElement(
    td,
    {
      "data-testid": "meetings-page-title",
      title: St[t]
    }
  ));
}, iv = "ngs-meetings__RacingTable__racingTable__39ctE", ov = "ngs-meetings__RacingTable__selectionsBackground__39ctE", cv = "ngs-meetings__RacingTable__swipeLeft__39ctE", lv = "ngs-meetings__RacingTable__swipeRight__39ctE", uv = "ngs-meetings__RacingTable__leftHeader__39ctE", mv = "ngs-meetings__RacingTable__rightHeaderScroller__39ctE", dv = "ngs-meetings__RacingTable__rightHeaderTrack__39ctE", fv = "ngs-meetings__RacingTable__headerCell__39ctE", Ev = "ngs-meetings__RacingTable__selectionHeader__39ctE", _v = "ngs-meetings__RacingTable__rowLines__39ctE", gv = "ngs-meetings__RacingTable__leftColumn__39ctE", pv = "ngs-meetings__RacingTable__rightBodyScroller__39ctE", hv = "ngs-meetings__RacingTable__rightBodyTrack__39ctE", vv = "ngs-meetings__RacingTable__selectionColumn__39ctE", yv = "ngs-meetings__RacingTable__cell__39ctE", Tv = "ngs-meetings__RacingTable__runnerCell__39ctE", Cv = "ngs-meetings__RacingTable__selectionCell__39ctE", Rv = "ngs-meetings__RacingTable__withShadow__39ctE", bv = "ngs-meetings__RacingTable__racingDragArea__39ctE", wv = "ngs-meetings__RacingTable__racingDragActive__39ctE", oe = {
  racingTable: iv,
  selectionsBackground: ov,
  swipeLeft: cv,
  swipeRight: lv,
  leftHeader: uv,
  rightHeaderScroller: mv,
  rightHeaderTrack: dv,
  headerCell: fv,
  selectionHeader: Ev,
  rowLines: _v,
  leftColumn: gv,
  rightBodyScroller: pv,
  rightBodyTrack: hv,
  selectionColumn: vv,
  cell: yv,
  runnerCell: Tv,
  selectionCell: Cv,
  withShadow: Rv,
  racingDragArea: bv,
  racingDragActive: wv
}, Av = "ngs-meetings__SelectionCell__selectionCell__2DPEc", Sv = "ngs-meetings__SelectionCell__priceButton__2DPEc", Iv = "ngs-meetings__SelectionCell__marketName__2DPEc", ii = {
  selectionCell: Av,
  priceButton: Sv,
  marketName: Iv
}, Nv = ({
  selection: e,
  onToggleSelection: n,
  isSelected: t,
  isDisabled: r
}) => {
  const { marketName: s, priceNum: i, priceDen: o } = e, c = mr();
  return /* @__PURE__ */ a.createElement(
    Uo,
    {
      className: ii.selectionCell,
      disabled: r(e.id),
      selected: t(e.id),
      onClick: () => n(e.id)
    },
    /* @__PURE__ */ a.createElement("div", { className: ii.priceButton }, s && /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "labelSecondary",
        className: J(!t(e.id) && ii.marketName)
      },
      e.marketName
    ), /* @__PURE__ */ a.createElement("div", null, i != null && o != null ? c(i, o) : "N/A"))
  );
}, Pv = "ngs-meetings__Silk__silk__UlPeb", Ov = "ngs-meetings__Silk__silkImage__UlPeb", kv = "ngs-meetings__Silk__silkInfo__UlPeb", Mr = {
  silk: Pv,
  silkImage: Ov,
  silkInfo: kv
}, Dv = ({ runner: e }) => {
  const [n, t] = ee(!1), { silkName: r, draw: s, runnerNum: i } = e;
  return /* @__PURE__ */ a.createElement("div", { className: Mr.silk }, !n && r ? /* @__PURE__ */ a.createElement(
    "img",
    {
      "aria-hidden": "true",
      role: "presentation",
      alt: "",
      className: Mr.silkImage,
      src: `https://secdn.staticcache.org/sportsbook/silks/${r}`,
      onError: () => t(!0)
    }
  ) : /* @__PURE__ */ a.createElement(Mo, { className: Mr.silkImage }), (i || s) && /* @__PURE__ */ a.createElement("div", { className: Mr.silkInfo }, i ? /* @__PURE__ */ a.createElement(T, null, i) : null, s ? /* @__PURE__ */ a.createElement(T, null, "(", s, ")") : null));
}, Lv = "ngs-meetings__RunnerInfo__runnerInfo__z2rbm", xv = "ngs-meetings__RunnerInfo__additionalInfo__z2rbm", Fv = "ngs-meetings__RunnerInfo__courseAndDistance__z2rbm", Mv = "ngs-meetings__RunnerInfo__horseName__z2rbm", Br = {
  runnerInfo: Lv,
  additionalInfo: xv,
  courseAndDistance: Fv,
  horseName: Mv
}, Bv = ({ runner: e }) => {
  const { jockey: n, trainer: t, name: r, formGuide: s, courseAndDistance: i } = e;
  return /* @__PURE__ */ a.createElement("div", { className: J(Br.runnerInfo), "data-testid": "runner-info" }, /* @__PURE__ */ a.createElement(He, { level: 4, className: Br.horseName, "data-testid": "horse-info" }, r), n && /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", "data-testid": "jockey-info" }, "J: ", n), t && /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", "data-testid": "trainer-info" }, "T: ", t), (s || i) && /* @__PURE__ */ a.createElement("div", { className: Br.additionalInfo, "data-testid": "additional-info" }, s && /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, "F: ", s), i && /* @__PURE__ */ a.createElement(
    T,
    {
      variant: "captionSecondary",
      className: Br.courseAndDistance,
      "data-testid": "course-and-distance"
    },
    i
  )));
}, $v = "ngs-meetings__RunnerCell__runnerCell__6dF0z", Wv = "ngs-meetings__RunnerCell__runnerDetails__6dF0z", bu = {
  runnerCell: $v,
  runnerDetails: Wv
}, Hv = ({ runner: e }) => /* @__PURE__ */ a.createElement("div", { className: bu.runnerCell }, /* @__PURE__ */ a.createElement("div", { className: bu.runnerDetails }, /* @__PURE__ */ a.createElement(Dv, { runner: e }), /* @__PURE__ */ a.createElement(Bv, { runner: e }))), qv = "ngs-meetings__Swipe__swipeBar__1FM7R", Gv = "ngs-meetings__Swipe__swipeBtn__1FM7R", Uv = "ngs-meetings__Swipe__disabled__1FM7R", Kn = {
  swipeBar: qv,
  swipeBtn: Gv,
  disabled: Uv
}, Yv = 80, wu = 0.5, jv = 3;
function Vv(e) {
  const n = e.scrollWidth > e.clientWidth + 1, t = e.scrollLeft <= wu, r = e.scrollLeft + e.clientWidth >= e.scrollWidth - wu;
  return { canSwipe: n, atStart: t, atEnd: r };
}
function Kv(e, n, t) {
  e && (e.scrollLeft = t), n && (n.scrollLeft = t);
}
const zv = ({
  headerRef: e,
  bodyRef: n,
  onStateChange: t
}) => {
  const [r, s] = ee(!1), [i, o] = ee(!0), [c, m] = ee(!1), u = Pe(() => {
    const f = n.current;
    if (!f)
      return;
    const E = Vv(f);
    s(E.canSwipe), o(E.atStart), m(E.atEnd), t && t(E);
  }, [n, t]), l = Pe(() => {
    const f = n.current, E = e.current;
    if (!f || !E)
      return;
    const g = Math.round(f.scrollLeft);
    Math.round(E.scrollLeft) !== g && (E.scrollLeft = g);
  }, [n, e]), d = Pe(
    (f) => {
      const E = n.current;
      if (!E)
        return;
      const g = E.scrollWidth - E.clientWidth, p = Math.max(
        0,
        Math.min(Math.round(E.scrollLeft) + f * Yv, g)
      );
      E.scrollTo({ left: p, behavior: "smooth" });
    },
    [n]
  );
  return te(() => {
    const f = e.current, E = n.current;
    if (!f || !E)
      return;
    l(), u();
    const g = () => {
      l(), u();
    };
    E.addEventListener("scroll", g, { passive: !0 });
    const p = () => {
      l(), u();
    };
    window.addEventListener("resize", p);
    let v = null;
    return typeof ResizeObserver < "u" && (v = new ResizeObserver(() => {
      l(), u();
    }), v.observe(E)), () => {
      E.removeEventListener("scroll", g), window.removeEventListener("resize", p), v && v.disconnect();
    };
  }, [e, n, l, u]), r ? /* @__PURE__ */ a.createElement("div", { className: Kn.swipeBar }, /* @__PURE__ */ a.createElement(
    $t,
    {
      className: J(Kn.swipeBtn, i && Kn.disabled),
      onClick: () => d(-1),
      disabled: i,
      "aria-label": "Scroll left"
    },
    "❮"
  ), /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, "Swipe"), /* @__PURE__ */ a.createElement(
    $t,
    {
      className: J(Kn.swipeBtn, c && Kn.disabled),
      onClick: () => d(1),
      disabled: c,
      "aria-label": "Scroll right"
    },
    "❯"
  )) : null;
};
function Xv(e) {
  const { primaryRef: n, syncRef: t } = e, [r, s] = ee(!1), i = Ft(0), o = Ft(0), c = Ft(!1), m = Ft(null), u = Pe(
    (v) => {
      if (m.current === null || v.pointerType !== "mouse" || m.current !== v.pointerId)
        return;
      const y = n.current;
      if (!y)
        return;
      const C = v.clientX - i.current;
      Math.abs(C) > jv && (c.current = !0);
      const b = o.current - C;
      Kv(y, (t == null ? void 0 : t.current) ?? null, b);
    },
    [n, t]
  ), l = Pe(
    (v) => {
      v.pointerType === "mouse" && m.current === v.pointerId && (m.current = null, s(!1), window.removeEventListener("pointermove", u), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l));
    },
    [u]
  ), d = Pe(
    (v) => {
      if (v.pointerType !== "mouse" || v.button !== 0)
        return;
      const y = n.current;
      y && (y.scrollWidth <= y.clientWidth || (i.current = v.clientX, o.current = y.scrollLeft, c.current = !1, m.current = v.pointerId, s(!0), window.addEventListener("pointermove", u, {
        passive: !0
      }), window.addEventListener("pointerup", l, {
        passive: !0
      }), window.addEventListener("pointercancel", l, {
        passive: !0
      })));
    },
    [n, u, l]
  ), f = Pe(() => {
  }, []), E = Pe(() => {
  }, []), g = Pe(() => {
  }, []), p = Pe((v) => {
    c.current && (v.preventDefault(), v.stopPropagation(), c.current = !1);
  }, []);
  return te(() => () => {
    m.current = null, window.removeEventListener("pointermove", u), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l);
  }, [u, l]), {
    onPointerDown: d,
    onPointerMove: f,
    onPointerUp: E,
    onPointerCancel: g,
    onClickCapture: p,
    isDragging: r
  };
}
const Qv = (e) => e.map((n) => {
  const t = /* @__PURE__ */ new Map();
  for (const r of n.selections)
    t.set(r.marketId, r);
  return t;
}), EI = ({
  rows: e,
  columns: n,
  onToggleSelection: t,
  isSelected: r,
  isDisabled: s,
  showDivider: i = !0,
  showHeader: o = !0
}) => {
  const [c, m] = a.useState({
    atStart: !0,
    atEnd: !1,
    canSwipe: !1
  }), u = Ft(null), l = Ft(null), d = Xv({
    primaryRef: l,
    syncRef: u
  }), f = A(() => Qv(e), [e]);
  return /* @__PURE__ */ a.createElement("div", { className: oe.racingTable }, c.canSwipe && i && /* @__PURE__ */ a.createElement(
    "div",
    {
      className: J(oe.selectionsBackground, oe.withShadow),
      "aria-hidden": !0
    }
  ), o && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: oe.swipeLeft, "aria-hidden": !0 }), /* @__PURE__ */ a.createElement("div", { className: oe.swipeRight }, /* @__PURE__ */ a.createElement(
    zv,
    {
      headerRef: u,
      bodyRef: l,
      onStateChange: m
    }
  )), /* @__PURE__ */ a.createElement("div", { className: oe.leftHeader, "aria-hidden": !0 }), /* @__PURE__ */ a.createElement(
    "div",
    {
      className: oe.rightHeaderScroller,
      ref: u,
      role: "presentation"
    },
    /* @__PURE__ */ a.createElement("div", { className: oe.rightHeaderTrack }, n.map((E) => /* @__PURE__ */ a.createElement(
      "div",
      {
        key: E.id,
        className: J(
          oe.headerCell,
          oe.selectionHeader,
          E.showShadow && oe.withShadow
        ),
        title: E.name
      },
      E.name
    )))
  )), /* @__PURE__ */ a.createElement("div", { className: oe.rowLines, "aria-hidden": !0 }), /* @__PURE__ */ a.createElement("div", { className: oe.leftColumn }, e.map((E) => /* @__PURE__ */ a.createElement(
    "div",
    {
      key: E.runner.name,
      className: J(oe.cell, oe.runnerCell)
    },
    /* @__PURE__ */ a.createElement(Hv, { runner: E.runner })
  ))), /* @__PURE__ */ a.createElement(
    "div",
    {
      className: J(
        oe.rightBodyScroller,
        c.canSwipe && (d.isDragging ? oe.racingDragActive : oe.racingDragArea)
      ),
      ref: l,
      role: "presentation",
      onPointerDown: d.onPointerDown,
      onPointerMove: d.onPointerMove,
      onPointerUp: d.onPointerUp,
      onPointerCancel: d.onPointerCancel,
      onClickCapture: d.onClickCapture
    },
    /* @__PURE__ */ a.createElement("div", { className: oe.rightBodyTrack }, n.map((E) => /* @__PURE__ */ a.createElement(
      "div",
      {
        key: E.id,
        className: J(
          oe.selectionColumn,
          E.showShadow && oe.withShadow
        )
      },
      e.map((g, p) => {
        const v = f[p].get(E.id);
        return v ? /* @__PURE__ */ a.createElement(
          "div",
          {
            key: `${g.runner.name}-${E.id}`,
            className: J(oe.cell, oe.selectionCell)
          },
          /* @__PURE__ */ a.createElement(
            Nv,
            {
              selection: v,
              onToggleSelection: t,
              isSelected: r,
              isDisabled: s
            }
          )
        ) : /* @__PURE__ */ a.createElement(
          "div",
          {
            key: `${g.runner.name}-${E.id}`,
            className: oe.cell
          }
        );
      })
    )))
  ));
}, Zv = "ngs-meetings__CompetitionTitle__row__RgNUg", Jv = "ngs-meetings__CompetitionTitle__rowTitle__RgNUg", e1 = "ngs-meetings__CompetitionTitle__rowSpecials__RgNUg", t1 = "ngs-meetings__CompetitionTitle__rowSubtitle__RgNUg", n1 = "ngs-meetings__CompetitionTitle__rowInfo__RgNUg", r1 = "ngs-meetings__CompetitionTitle__rowInfoItem__RgNUg", a1 = "ngs-meetings__CompetitionTitle__rowConcessions__RgNUg", s1 = "ngs-meetings__CompetitionTitle__concessionStreaming__RgNUg", i1 = "ngs-meetings__CompetitionTitle__concessionTvFree__RgNUg", o1 = "ngs-meetings__CompetitionTitle__concessionTv__RgNUg", c1 = "ngs-meetings__CompetitionTitle__concessionAbandoned__RgNUg", je = {
  row: Zv,
  rowTitle: Jv,
  rowSpecials: e1,
  rowSubtitle: t1,
  rowInfo: n1,
  rowInfoItem: r1,
  rowConcessions: a1,
  concessionStreaming: s1,
  concessionTvFree: i1,
  concessionTv: o1,
  concessionAbandoned: c1
}, l1 = (e) => {
  const n = V(), t = rn(), { competition: r, events: s, meetingMarkets: i } = e.competition, { name: o, _going: c, streaming: m, _abandoned: u, _offers: l } = r, d = A(
    () => Array.isArray(s) && s.length > 0 && s.every(
      (g) => !!g.hasEnhancedOddsSpecial || !!g.hasPriceBoostSpecial
    ),
    [s]
  ), f = () => {
    if (!i || i.settled)
      return null;
    {
      const g = `${n.params.sport}/meetings/markets/${i.id}/${i.slug}`;
      return /* @__PURE__ */ a.createElement(
        ke,
        {
          className: je.rowSpecials,
          "data-testid": "competition-row-specials",
          variant: "ghost",
          asChild: !0,
          onClick: (p) => {
            p.preventDefault(), n.navigateToCustomUrl(g);
          }
        },
        /* @__PURE__ */ a.createElement("a", { href: n.getLinkForCustomUrl(g) }, "Meeting Specials")
      );
    }
  }, E = () => u ? /* @__PURE__ */ a.createElement(
    "span",
    {
      className: je.concessionAbandoned,
      "data-testid": "abandoned-competition"
    },
    "Abandoned"
  ) : m.available && m.providers && /* @__PURE__ */ a.createElement("span", { className: je.concessionStreaming }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary" }, hd[m.providers[0]]), /* @__PURE__ */ a.createElement(
    Qt,
    {
      className: m.free ? je.concessionTvFree : je.concessionTv,
      size: 16
    }
  ));
  return /* @__PURE__ */ a.createElement("div", { "data-testid": "competition-title-row", className: je.row }, /* @__PURE__ */ a.createElement(
    "div",
    {
      "data-testid": "competition-title-rowTitle",
      className: je.rowTitle
    },
    /* @__PURE__ */ a.createElement(He, { level: 3 }, va(o)),
    f()
  ), /* @__PURE__ */ a.createElement(
    "div",
    {
      "data-testid": "competition-title-subtitle",
      className: je.rowSubtitle
    },
    /* @__PURE__ */ a.createElement(
      "div",
      {
        "data-testid": "competition-title-row-info",
        className: je.rowInfo
      },
      /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: je.rowInfoItem }, s.length, " ", s.length > 1 ? "races" : "race"),
      c && /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: je.rowInfoItem }, "Going: ", c.map((g) => pd[g]).join("/")),
      t === Ke.OPTED_IN && l.bestOddsGuaranteed && /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: je.rowInfoItem }, /* @__PURE__ */ a.createElement(na, { size: 13 })),
      d && /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: je.rowInfoItem }, /* @__PURE__ */ a.createElement(Bt, { size: 13 }))
    ),
    /* @__PURE__ */ a.createElement(
      "div",
      {
        "data-testid": "competition-title-row-concessions",
        className: je.rowConcessions
      },
      E()
    )
  ));
}, u1 = "ngs-meetings__CompetitionRow__container__4gwLI", m1 = {
  container: u1
}, Au = ({
  competition: e,
  onNavigation: n
}) => {
  const { events: t } = e;
  return /* @__PURE__ */ a.createElement("div", { "data-testid": "competition-row-container", className: m1.container }, /* @__PURE__ */ a.createElement(l1, { competition: e }), /* @__PURE__ */ a.createElement(Sg, { events: t, onClick: n }), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}, d1 = ({
  region: e,
  defaultOpen: n,
  onNavigation: t,
  collapsible: r
}) => r ? /* @__PURE__ */ a.createElement(
  de,
  {
    key: e.regionFilter.id,
    defaultOpen: n,
    "data-testid": "change-race-modal-section"
  },
  /* @__PURE__ */ a.createElement(fe, null, e.regionFilter.name),
  /* @__PURE__ */ a.createElement(Ee, { "data-testid": "change-race-modal-section-content" }, e.competitions.map((s) => /* @__PURE__ */ a.createElement(
    Au,
    {
      key: s.competition.id,
      competition: s,
      onNavigation: t
    }
  )))
) : /* @__PURE__ */ a.createElement("div", { key: e.regionFilter.id }, e.competitions.map((s) => /* @__PURE__ */ a.createElement(
  Au,
  {
    key: s.competition.id,
    competition: s,
    onNavigation: t
  }
))), f1 = "ngs-meetings__IconKey__button__e3ZfZ", E1 = {
  button: f1
}, _1 = {
  extraPlaces: {
    name: "Extra Places",
    desc: "We are paying more than standard places on each way bets.",
    link: "https://sports.williamhill.com/betting/en-gb/apps/promotions/offer/Extra-Places-on-Horse-Racing-V2",
    icon: Fo,
    iconProps: { size: 13 }
  },
  topPriceGuarantee: {
    name: "Top Price Guarantee",
    desc: "We are top or joint top price on every runner for this race!",
    link: "https://sports.williamhill.com/betting/en-gb/apps/promotions/offer/TPG-on-The-Biggest-Races",
    icon: xo,
    iconProps: { size: 13 }
  },
  qualified: {
    name: "Watch",
    desc: "You can watch races for free.",
    link: "",
    icon: Qt,
    iconProps: { size: 15, color: "#0aab4e" }
  },
  settled: {
    name: "Resulted",
    desc: "Race is over and the results are displayed.",
    link: "",
    icon: Zm,
    iconProps: { size: 13 }
  },
  bestOddsGuaranteed: {
    name: "Best Odds Guaranteed",
    desc: "Available on bets placed after 8am on the day of the race. Take the price on your selection and if the starting price is bigger, we will pay you at the bigger odds.",
    link: "https://sports.williamhill.com/betting/en-gb/apps/promotions/offer/William-Hill-Best-Odds-Guaranteed",
    icon: na,
    iconProps: { size: 13 }
  },
  priceBoost: {
    name: "Price Boost",
    desc: "We have boosted the price of a selection for you!",
    link: "",
    icon: Bt,
    iconProps: { size: 13 }
  }
}, g1 = ({ type: e }) => {
  var s;
  const n = _1[e];
  if (!n)
    return null;
  const t = n.icon, r = /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(t, { size: 19, color: (s = n.iconProps) == null ? void 0 : s.color }), n.name);
  return /* @__PURE__ */ a.createElement(sa, null, /* @__PURE__ */ a.createElement(ia, { asChild: !0 }, /* @__PURE__ */ a.createElement($t, { className: E1.button }, /* @__PURE__ */ a.createElement(t, { ...n.iconProps }), n.name)), /* @__PURE__ */ a.createElement(oa, null, /* @__PURE__ */ a.createElement(ca, null, /* @__PURE__ */ a.createElement(la, null, /* @__PURE__ */ a.createElement(ua, { title: r }), /* @__PURE__ */ a.createElement(ma, null, /* @__PURE__ */ a.createElement(ar, null, n.desc)), n.link && /* @__PURE__ */ a.createElement(da, null, /* @__PURE__ */ a.createElement(bn, { href: n.link, target: "_blank", rel: "noreferrer" }, "More info and T&C's"))))));
}, p1 = "ngs-meetings__IconKeyRow__container__WspbE", h1 = "ngs-meetings__IconKeyRow__carousel__WspbE", oi = {
  container: p1,
  carousel: h1
}, v1 = ({ bogStatus: e }) => {
  const [n, t] = wn({}), { iconKeysExplainer: r, isLoading: s } = R_(), i = [
    ...e ? ["bestOddsGuaranteed"] : [],
    ...r
  ];
  return te(() => {
    i.length && (t == null || t.reInit());
  }, [i.length, t]), i.length === 0 ? s ? /* @__PURE__ */ a.createElement("div", { className: oi.container }) : null : /* @__PURE__ */ a.createElement(
    "div",
    {
      "data-testid": "icon-key-container",
      className: oi.container,
      ref: n
    },
    /* @__PURE__ */ a.createElement("div", { className: oi.carousel }, i.map((o, c) => /* @__PURE__ */ a.createElement(g1, { type: o, key: `${o}_${c}` })))
  );
}, Xd = ({
  defaultDay: e,
  regionCompetitions: n,
  onDayNavigation: t,
  onNavigation: r,
  region: s,
  bogStatus: i
}) => /* @__PURE__ */ a.createElement(It, { defaultValue: e }, /* @__PURE__ */ a.createElement(
  Nt,
  {
    "data-testid": "day-filter",
    stretch: !0,
    carousel: !1,
    variant: "standard"
  },
  n.map((o) => /* @__PURE__ */ a.createElement(
    Pt,
    {
      variant: "standard",
      key: o.day.link,
      value: o.day.link,
      onClick: () => t == null ? void 0 : t(o.day.link)
    },
    o.day.name
  ))
), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(v1, { bogStatus: i }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), n.map((o) => /* @__PURE__ */ a.createElement(Zt, { key: o.day.link, value: o.day.link }, o.regionCompetitions.map((c, m) => /* @__PURE__ */ a.createElement(
  d1,
  {
    key: c.regionFilter.id,
    region: c,
    collapsible: o.regionCompetitions.length > 1 || s === Je.ALL,
    defaultOpen: m === 0,
    onNavigation: r
  }
))))), y1 = ({
  regionCompetitions: e
}) => {
  const [n, t] = ee(!1), r = Ae(), s = rn(), i = (o) => {
    o && ve("Change", r), t(o);
  };
  return /* @__PURE__ */ a.createElement(Bo, { open: n, onOpenChange: i }, /* @__PURE__ */ a.createElement(zr, { asChild: !0 }, /* @__PURE__ */ a.createElement(ke, { variant: "ghost", size: "small", "data-testid": "change-button" }, "Change")), /* @__PURE__ */ a.createElement($o, null, /* @__PURE__ */ a.createElement(Wo, null, /* @__PURE__ */ a.createElement(Ho, { "data-testid": "change-race-modal" }, /* @__PURE__ */ a.createElement(
    qo,
    {
      title: "All Races",
      "data-testid": "change-race-modal-title"
    }
  ), /* @__PURE__ */ a.createElement(Go, { padding: !1, "data-testid": "change-race-modal-content" }, /* @__PURE__ */ a.createElement(
    Xd,
    {
      defaultDay: e[0].day.link,
      regionCompetitions: e,
      onNavigation: () => t(!1),
      region: Je.ALL,
      bogStatus: s === Ke.OPTED_IN
    }
  ))))));
}, T1 = ({ data: e }) => {
  const n = V(), { eventId: t, sport: r } = n.params, s = e.regionCompetitionsByDays.flatMap((o) => o.regionCompetitions).flatMap((o) => o.competitions).find(
    (o) => o.events.some((c) => c.id === t)
  ), i = (o) => {
    const { timeString: c, id: m, slug: u } = o;
    ve(c, r), n.navigateToEvent(m, u);
  };
  return /* @__PURE__ */ a.createElement(
    td,
    {
      "data-testid": "page-title-container",
      title: va(
        s ? s.competition.name : "Event Unavailable"
      ),
      actions: /* @__PURE__ */ a.createElement(
        y1,
        {
          regionCompetitions: e == null ? void 0 : e.regionCompetitionsByDays
        }
      )
    },
    s && /* @__PURE__ */ a.createElement(It, { value: n.params.eventId }, /* @__PURE__ */ a.createElement(
      Nt,
      {
        variant: "underscore",
        theme: "light",
        "data-testid": "races-carousel"
      },
      s.events.map((o) => /* @__PURE__ */ a.createElement(
        Pt,
        {
          variant: "underscore",
          theme: "light",
          value: o.id,
          key: o.id,
          link: n.getLinkForEvent(o.id, o.slug),
          onClick: () => i(o),
          "data-testid": "carousel-race-button"
        },
        o.timeString
      ))
    ))
  );
}, C1 = () => /* @__PURE__ */ a.createElement(r_, { breadcrumbs: !0, actions: !0 }, /* @__PURE__ */ a.createElement(a_, { count: 8 })), _I = () => {
  const { data: e, isError: n, isLoading: t } = pa();
  return n ? null : t || !e ? /* @__PURE__ */ a.createElement(C1, null) : /* @__PURE__ */ a.createElement(T1, { data: e });
}, R1 = "ngs-meetings__RaceHeader__container__mMVHT", Qd = {
  container: R1
};
function Zd() {
  return /* @__PURE__ */ a.createElement(_a, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      className: Qd.container,
      style: { padding: "1rem 0.75rem 0.5rem 0.75rem" }
    },
    /* @__PURE__ */ a.createElement(U, { height: 20 }),
    /* @__PURE__ */ a.createElement(U, { height: 12 }),
    /* @__PURE__ */ a.createElement(U, { height: 12 }),
    /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.75rem",
          height: "44px",
          padding: "0.25rem"
        }
      },
      /* @__PURE__ */ a.createElement(U, { width: "10rem", height: "100%" }),
      /* @__PURE__ */ a.createElement(U, { width: "10rem", height: "100%" })
    )
  ));
}
function Jd(e) {
  return (n) => {
    const { params: t } = V(), { eventId: r } = t;
    return r ? /* @__PURE__ */ a.createElement(e, { ...n, key: r }) : null;
  };
}
const b1 = (e, n) => (t) => {
  const r = n.queries.map((o) => o()), s = r.some((o) => o.isLoading), i = r.some((o) => o.isError);
  return s ? n.Loader ? /* @__PURE__ */ a.createElement(n.Loader, null) : null : i ? n.ErrorRenderer ? /* @__PURE__ */ a.createElement(n.ErrorRenderer, null) : null : /* @__PURE__ */ a.createElement(e, { ...t });
}, Ut = (e, n = {}) => Jd(
  b1(e, {
    queries: [tc, ...n.queries || []],
    Loader: n.Loader,
    ErrorRenderer: n.ErrorRenderer
  })
), w1 = "ngs-meetings__RaceHeaderStreaming__playerContainer__wH0XZ", A1 = "ngs-meetings__RaceHeaderStreaming__buttonsContainer__wH0XZ", S1 = "ngs-meetings__RaceHeaderStreaming__button__wH0XZ", $r = {
  playerContainer: w1,
  buttonsContainer: A1,
  button: S1
}, I1 = "ngs-meetings__RaceOverviewModal__container__4gwLI", N1 = {
  container: I1
}, P1 = "ngs-meetings__AmbassadorModalContent__ambassadorNotes__6cPBF", O1 = "ngs-meetings__AmbassadorModalContent__selection__6cPBF", k1 = "ngs-meetings__AmbassadorModalContent__otherPicksText__6cPBF", ci = {
  ambassadorNotes: P1,
  selection: O1,
  otherPicksText: k1
}, D1 = "ngs-meetings__AmbassadorCollapsibleTitle__ambassadorTitleContainer__gdKtb", L1 = "ngs-meetings__AmbassadorCollapsibleTitle__ambassadorTitleText__gdKtb", x1 = "ngs-meetings__AmbassadorCollapsibleTitle__ambassadorPicture__gdKtb", li = {
  ambassadorTitleContainer: D1,
  ambassadorTitleText: L1,
  ambassadorPicture: x1
}, F1 = "ngs-meetings__AmbassadorCard__container__MKjpI", M1 = "ngs-meetings__AmbassadorCard__otherPicksText__MKjpI", B1 = "ngs-meetings__AmbassadorCard__selection__MKjpI", $1 = "ngs-meetings__AmbassadorCard__eventLink__MKjpI", W1 = "ngs-meetings__AmbassadorCard__eventLinkIcons__MKjpI", yn = {
  container: F1,
  otherPicksText: M1,
  selection: B1,
  eventLink: $1,
  eventLinkIcons: W1
}, H1 = ({ ambassadorContent: e }) => {
  const { navigateToEvent: n } = V(), { eventId: t, eventName: r, eventStreaming: s } = e;
  return /* @__PURE__ */ a.createElement(
    ke,
    {
      "data-testid": "ambassador-event-link",
      variant: "ghost",
      onClick: () => n(t ?? "", ""),
      className: yn.eventLink,
      size: "small"
    },
    /* @__PURE__ */ a.createElement(He, { level: 6, className: yn.eventLinkText }, r),
    /* @__PURE__ */ a.createElement("div", { className: yn.eventLinkIcons }, s != null && s.available ? /* @__PURE__ */ a.createElement(Qt, { size: "14", color: "#23985D" }) : null, /* @__PURE__ */ a.createElement(ra, { size: "10" }))
  );
}, ef = ({
  ambassadorContent: e,
  withEventLink: n = !1
}) => {
  const [t, r] = ee(!1), { displayTitle: s, ambassadorPickData: i, otherPicks: o } = e, c = s.replace("Pick", ""), m = (u) => {
    P_(
      `${s} - ${u ? "Show more" : "Show less"}`
    ), r(u);
  };
  return /* @__PURE__ */ a.createElement("div", { className: yn.container, "data-testid": "ambassador-container" }, /* @__PURE__ */ a.createElement(
    ey,
    {
      ambassadorContent: e,
      isOverviewVisible: t,
      onOverviewToggle: m
    }
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), n ? /* @__PURE__ */ a.createElement(H1, { ambassadorContent: e }) : null, /* @__PURE__ */ a.createElement("div", { "data-testid": "ambassador-runner" }, /* @__PURE__ */ a.createElement(
    nf,
    {
      title: i.runnerName,
      runnerNum: i.runner.runnerNum,
      runner: i.runner
    },
    /* @__PURE__ */ a.createElement("div", { className: yn.selection, "data-testid": "ambassador-selection" }, /* @__PURE__ */ a.createElement(Ro, { selection: i }))
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" })), t && (o == null ? void 0 : o.length) > 0 ? /* @__PURE__ */ a.createElement("div", { "data-testid": "ambassador-other-pick" }, /* @__PURE__ */ a.createElement(He, { level: 6, className: yn.otherPicksText }, "See ", c, " other Picks"), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(Jt, null, o.map((u) => /* @__PURE__ */ a.createElement(
    rf,
    {
      key: u.selection.selectionId,
      runner: u.selection.runner,
      eventId: u.eventId,
      eventName: u.eventName,
      runnerName: u.selection.runnerName
    },
    /* @__PURE__ */ a.createElement(Ro, { selection: u.selection })
  )))) : null);
}, q1 = "ngs-meetings__AmbassadorHeader__ambassadorContent__WyUcI", G1 = "ngs-meetings__AmbassadorHeader__ambassadorImage__WyUcI", U1 = "ngs-meetings__AmbassadorHeader__ambassadorText__WyUcI", Y1 = "ngs-meetings__AmbassadorHeader__ambassadorTextHeader__WyUcI", j1 = "ngs-meetings__AmbassadorHeader__clampedNotes__WyUcI", V1 = "ngs-meetings__AmbassadorHeader__expandedNotes__WyUcI", K1 = "ngs-meetings__AmbassadorHeader__notesText__WyUcI", z1 = "ngs-meetings__AmbassadorHeader__showMoreButton__WyUcI", X1 = "ngs-meetings__AmbassadorHeader__showLessButton__WyUcI", _t = {
  ambassadorContent: q1,
  ambassadorImage: G1,
  ambassadorText: U1,
  ambassadorTextHeader: Y1,
  clampedNotes: j1,
  expandedNotes: V1,
  notesText: K1,
  showMoreButton: z1,
  showLessButton: X1
}, Q1 = "ngs-meetings__AmbassadorImage__image__h0ZBe", Z1 = {
  image: Q1
}, tf = ({ url: e }) => /* @__PURE__ */ a.createElement("img", { src: e, alt: "", className: Z1.image }), J1 = ({
  ambassadorContent: e,
  isOverviewVisible: n,
  toggleOverview: t
}) => {
  const { ambassadorNotes: r } = e, s = () => {
    t(!n);
  };
  return n ? /* @__PURE__ */ a.createElement("div", { className: _t.clampedNotes, "data-testid": "ambassador-notes" }, /* @__PURE__ */ a.createElement(T, { className: _t.notesText, variant: "labelSecondary" }, r), /* @__PURE__ */ a.createElement(
    ke,
    {
      className: _t.showLessButton,
      variant: "link",
      onClick: s
    },
    "Show less"
  )) : /* @__PURE__ */ a.createElement("div", { className: _t.expandedNotes, "data-testid": "ambassador-notes" }, /* @__PURE__ */ a.createElement(XE, { lines: 1 }, /* @__PURE__ */ a.createElement(T, { className: _t.notesText, variant: "labelSecondary" }, r)), /* @__PURE__ */ a.createElement(
    ke,
    {
      className: _t.showMoreButton,
      variant: "link",
      onClick: s
    },
    "Show more"
  ));
}, ey = ({
  ambassadorContent: e,
  isOverviewVisible: n,
  onOverviewToggle: t
}) => {
  const { ambassadorImageUrl: r, displayTitle: s } = e, [i, o] = l_({
    prop: n,
    defaultProp: !1,
    onChange: t
  });
  return /* @__PURE__ */ a.createElement("div", { className: _t.ambassadorContent, "data-testid": "ambassador-content" }, r ? /* @__PURE__ */ a.createElement("div", { className: _t.ambassadorImage, "data-testid": "ambassador-image" }, /* @__PURE__ */ a.createElement(tf, { url: r })) : null, /* @__PURE__ */ a.createElement("div", { className: _t.ambassadorText }, /* @__PURE__ */ a.createElement(
    "div",
    {
      className: _t.ambassadorTextHeader,
      "data-testid": "ambassador-text-header"
    },
    /* @__PURE__ */ a.createElement(He, { level: 4 }, s),
    /* @__PURE__ */ a.createElement(T, { variant: "labelSecondary", "data-testid": "ambassador-text" }, "WH Ambassador")
  ), /* @__PURE__ */ a.createElement(
    J1,
    {
      ambassadorContent: e,
      isOverviewVisible: i,
      toggleOverview: o
    }
  )));
}, ty = "ngs-meetings__AmbassadorRunnerRow__runnerRow__pHYSO", ny = "ngs-meetings__AmbassadorRunnerRow__runnerDetails__pHYSO", ry = "ngs-meetings__AmbassadorRunnerRow__silkCol__pHYSO", ui = {
  runnerRow: ty,
  runnerDetails: ny,
  silkCol: ry
}, nf = ({
  title: e,
  runnerNum: n,
  children: t,
  runner: r
}) => /* @__PURE__ */ a.createElement("div", { className: ui.runnerRow }, /* @__PURE__ */ a.createElement("div", { className: ui.runnerDetails }, /* @__PURE__ */ a.createElement("div", { className: ui.silkCol }, /* @__PURE__ */ a.createElement(
  fr,
  {
    runnerNum: n,
    runner: { ...r, active: !0, silkName: "" }
  }
)), /* @__PURE__ */ a.createElement(Ra, { runner: r, title: e })), t), Ro = ({
  selection: e
}) => {
  const n = nn(
    A(
      () => ({
        id: e.eventId,
        isInPlay: e.eventIsInPlay,
        startDateTime: e.eventStartTime,
        status: "A"
      }),
      [e]
    )
  ), t = An(
    A(
      () => ({
        id: e.marketId,
        eventId: e.eventId,
        status: e.marketStatus,
        hasInPlay: e.marketHasInPlay
      }),
      [e]
    )
  ), r = tn(
    A(
      () => ({
        id: e.selectionId,
        marketId: e.marketId,
        eventId: e.eventId,
        currentPriceNum: e.priceNum,
        currentPriceDen: e.priceDen,
        status: e.selectionStatus
      }),
      [e]
    )
  );
  return /* @__PURE__ */ a.createElement(
    sn,
    {
      event: n,
      market: t,
      selection: r,
      analytics: A(() => ({ BetListName: ["WH Ambassador"] }), [])
    }
  );
}, ay = "ngs-meetings__OtherEventRaceCardRow__container__f7jOK", sy = "ngs-meetings__OtherEventRaceCardRow__details__f7jOK", iy = "ngs-meetings__OtherEventRaceCardRow__selection__f7jOK", oy = "ngs-meetings__OtherEventRaceCardRow__arrow__f7jOK", Wr = {
  container: ay,
  details: sy,
  selection: iy,
  arrow: oy
}, cy = /[^\w-\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/g, ly = (e) => e.toLowerCase().trim().replace(/\s+/g, "-").replace(cy, "").replace(/-+/g, "-"), rf = ({
  runner: e,
  children: n,
  eventId: t,
  eventName: r,
  runnerName: s
}) => {
  const i = V();
  return /* @__PURE__ */ a.createElement(en, { className: Wr.container, disablePadding: !0 }, /* @__PURE__ */ a.createElement(
    QE,
    {
      asChild: !0,
      onClick: () => i.navigateToEvent(t, ly(r))
    },
    /* @__PURE__ */ a.createElement("div", { role: "button", tabIndex: 0 }, /* @__PURE__ */ a.createElement(
      fr,
      {
        runner: { ...e, active: !0, silkName: "" },
        "data-testid": "other-pick-silk"
      }
    ), /* @__PURE__ */ a.createElement("div", { className: Wr.details, "data-testid": "other-pick-details" }, /* @__PURE__ */ a.createElement(T, { variant: "labelSecondary" }, r), /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary" }, s)), n && /* @__PURE__ */ a.createElement(
      "div",
      {
        className: Wr.selection,
        "data-testid": "other-pick-selection"
      },
      n
    ), /* @__PURE__ */ a.createElement(
      ra,
      {
        size: 10,
        className: Wr.arrow,
        "data-testid": "other-pick-arrow"
      }
    ))
  ));
}, af = ({
  ambassadorImageUrl: e,
  displayTitle: n
}) => /* @__PURE__ */ a.createElement("div", { className: li.ambassadorTitleContainer }, e && /* @__PURE__ */ a.createElement("div", { className: li.ambassadorPicture }, /* @__PURE__ */ a.createElement(tf, { url: e })), /* @__PURE__ */ a.createElement(
  He,
  {
    level: 3,
    className: li.ambassadorTitleText,
    "data-testid": "ambassador-title"
  },
  n
)), uy = "ngs-meetings__SelectionContainer__container__12g3Q", my = "ngs-meetings__SelectionContainer__label__12g3Q", Tn = {
  container: uy,
  label: my
}, vr = ({
  selectionId: e,
  readonly: n,
  topLabel: t,
  children: r,
  bottomLabel: s
}) => {
  const i = Eh(e), o = fh(i.marketId), c = q(), m = $d(i);
  return /* @__PURE__ */ a.createElement("div", { className: Tn.container, "data-testid": "selection-container" }, /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: Tn.label }, t), /* @__PURE__ */ a.createElement(
    sn,
    {
      selection: i,
      market: o,
      event: c,
      analytics: A(
        () => ({
          BetListName: [o.name]
        }),
        [o.name]
      ),
      readonly: n
    },
    typeof r == "function" ? r(i) : r
  ), /* @__PURE__ */ a.createElement(
    T,
    {
      variant: "captionSecondary",
      className: Tn.label,
      "data-testid": "price-history"
    },
    s === "priceHistory" && !n ? m : null,
    s !== "priceHistory" ? s : null
  ));
}, dy = ({
  selectionId: e,
  readonly: n,
  topLabel: t,
  bottomLabel: r,
  children: s
}) => {
  const i = _h(e), o = mh(i.marketId), c = q();
  return /* @__PURE__ */ a.createElement("div", { className: Tn.container, "data-testid": "in-play-selection" }, /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: Tn.label }, t), /* @__PURE__ */ a.createElement(
    sn,
    {
      selection: i,
      market: o,
      event: c,
      analytics: A(
        () => ({
          BetListName: [o.name]
        }),
        [o.name]
      ),
      readonly: n
    },
    typeof s == "function" ? s(i) : s
  ), /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: Tn.label }, r));
}, fy = ({
  ambassadorContent: e
}) => {
  const {
    ambassadorImageUrl: n,
    displayTitle: t,
    ambassadorPickData: r,
    ambassadorNotes: s,
    otherPicks: i
  } = e, o = t.replace("Pick", "");
  return /* @__PURE__ */ a.createElement(de, { defaultOpen: !1 }, /* @__PURE__ */ a.createElement(fe, null, /* @__PURE__ */ a.createElement(
    af,
    {
      ambassadorImageUrl: n,
      displayTitle: t
    }
  )), /* @__PURE__ */ a.createElement(Ee, null, /* @__PURE__ */ a.createElement("div", { className: ci.ambassadorNotes }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary" }, s)), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement(
    nf,
    {
      title: r.runnerName,
      runnerNum: r.runner.runnerNum,
      runner: r.runner
    },
    /* @__PURE__ */ a.createElement("div", { className: ci.selection }, /* @__PURE__ */ a.createElement(
      vr,
      {
        key: r.selectionId,
        selectionId: r.selectionId
      }
    ))
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" })), i.length > 0 ? /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement(He, { level: 6, className: ci.otherPicksText }, "See ", o, " other Picks"), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(Jt, null, i.map((c) => /* @__PURE__ */ a.createElement(
    rf,
    {
      runner: c.selection.runner,
      eventId: c.eventId,
      eventName: c.eventName,
      runnerName: c.selection.runnerName,
      key: c.selection.selectionId
    },
    /* @__PURE__ */ a.createElement(Ro, { selection: c.selection })
  )))) : null, /* @__PURE__ */ a.createElement(w, { theme: "light" })));
}, Ey = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    width: e.width ?? 78,
    viewBox: "0 0 78 10",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ a.createElement("g", null, /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55.1999 7.29994C55.6999 8.69994 56.8999 9.29994 58.2999 9.49994C60.4999 9.49994 62.3999 8.59994 63.1999 6.59994C64.2999 4.09994 63.4999 0.899943 60.4999 0.599943C58.4999 0.399943 56.5999 1.39994 55.5999 3.19994C54.9999 4.39994 54.6999 5.99994 55.1999 7.29994ZM59.6999 7.69994C58.2999 8.39994 57.2999 7.19994 57.2999 5.89994C57.3999 4.49994 57.8999 2.59994 59.3999 2.29994C60.6999 1.99994 61.3999 2.99994 61.3999 4.19994C61.3999 5.39994 60.8999 7.09994 59.6999 7.69994Z",
      fill: "#D9252A"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M42.4 0.5C42.9 0.7 44.2 0.5 44.5 0.9C44.7 1.1 44.2 2.4 44.1 2.7C42.7 2 40.7 1.9 39.5 3C38.4 3.9 38.1 5.7 38.8 6.9C39.1 7.4 39.7 7.7 40.3 7.8C41.3 7.9 41.5 7.7 41.7 6.8C41.7 6.6 42 6 41.9 5.9C41.8 5.7 41.1 6 40.8 5.9C40.4 5.8 40.6 5.9 40.6 5.4C40.6 5.2 40.7 4.4 40.9 4.3C41.1 4.2 41.9 4.3 42.1 4.3C42.5 4.3 43 4.3 43.4 4.3C43.6 4.3 44.3 4.2 44.4 4.3C44.5 4.4 44.2 5.3 44.2 5.5C44 6.4 43.8 7.3 43.6 8.1C43.5 8.6 43.5 8.8 43.2 9C42.8 9.2 42.1 9.2 41.7 9.3C40.2 9.5 38.5 9.4 37.3 8.3C36.1 7.2 35.9 5.4 36.3 3.9C37.1 1.2 39.8 0.5 42.4 0.5Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.818824 5.4189C0.604886 6.59721 0.384634 7.81029 0 8.90008C0 9.00008 0 9.20008 0.1 9.20008C0.246606 9.20008 0.470589 9.22587 0.72153 9.25477C1.32642 9.32443 2.08796 9.41212 2.3 9.20008C2.52153 9.05239 2.634 8.19584 2.71795 7.55652C2.74769 7.33006 2.77384 7.13086 2.8 7.00008C2.81492 6.89563 2.82539 6.7934 2.83539 6.69573C2.89242 6.13883 2.9343 5.72993 3.7 5.90008C4.43598 6.08408 4.49488 6.52198 4.57745 7.13592C4.58463 7.18933 4.592 7.24406 4.6 7.30008C4.62808 7.41239 4.64827 7.59565 4.67165 7.80781C4.73153 8.35126 4.81231 9.08431 5.1 9.30008C5.2 9.40008 7.2 9.40008 7.2 9.30008C7.3771 9.03443 6.92692 7.74947 6.75207 7.25038C6.72946 7.18583 6.71145 7.13443 6.7 7.10008C6.67901 7.01611 6.65911 6.93324 6.63952 6.85158C6.4724 6.15533 6.32652 5.5476 5.7 5.10008C7.2 4.90008 8.4 4.00008 8 2.40008C7.71551 0.788 5.90232 0.794552 4.52171 0.799542C4.44641 0.799814 4.3724 0.800081 4.3 0.800081C4.19597 0.800081 3.99726 0.779791 3.75487 0.755042C3.06522 0.684623 2.02198 0.578101 1.8 0.800081C1.6733 0.926781 1.62686 1.25414 1.58442 1.55335C1.55987 1.72645 1.53665 1.89013 1.5 2.00008L1.2 3.50008C1.05642 4.11029 0.938613 4.75914 0.818824 5.4189ZM3.50514 4.30522C3.39749 4.30259 3.29499 4.30008 3.2 4.30008C3.2 3.90008 3.3 2.60008 3.6 2.40008C3.9 2.20008 5.1 2.30008 5.4 2.60008C5.9 3.00008 5.7 3.60008 5.3 4.00008C4.79499 4.33676 4.07744 4.31921 3.50514 4.30522Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M67.7999 0.5C68.3999 0.5 69.0999 0.6 69.6999 0.7C69.8999 0.7 70.3999 0.8 70.4999 0.9C70.5999 1.1 70.1999 1.9 70.1999 2.1C69.9999 2.6 70.1999 2.5 69.7999 2.5C69.3999 2.5 68.9999 2.3 68.5999 2.2C68.0999 2.1 67.0999 2.1 66.6999 2.6C65.7999 3.7 68.4999 4.3 69.0999 4.8C70.0999 5.6 70.0999 7 69.3999 8C68.6999 9 67.3999 9.4 66.1999 9.5C65.8999 9.5 65.5999 9.5 65.2999 9.5C64.7999 9.5 63.3999 9.5 63.0999 9.1C62.9999 9 63.2999 7.4 63.4999 7.3C63.5999 7.2 64.0999 7.5 64.1999 7.6C64.5999 7.7 64.9999 7.8 65.3999 7.8C65.9999 7.8 66.8999 7.7 67.1999 7.2C67.5999 6.6 67.0999 6.1 66.5999 5.9C65.1999 5.2 63.5999 4.7 64.1999 2.7C64.6999 1.1 66.2999 0.5 67.7999 0.5Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M20.2001 9.49997C19.6001 9.29997 18.9001 9.29997 18.3001 8.99997C17.7001 8.69997 17.2001 8.19997 16.9001 7.69997C16.2001 6.49997 16.2001 4.89997 16.7001 3.69997C17.8001 0.89997 20.8001 0.29997 23.5001 0.79997C23.6001 0.79997 24.4001 0.89997 24.5001 1.09997C24.6001 1.29997 24.4001 1.59997 24.4001 1.79997C24.4001 1.89997 24.2001 2.69997 24.1001 2.69997C23.9001 2.79997 23.6001 2.49997 23.3001 2.49997C22.0001 1.99997 20.2001 2.29997 19.4001 3.39997C18.7001 4.39997 18.4001 6.09997 19.4001 7.09997C20.4001 8.19997 22.1001 7.79997 23.3001 7.19997C23.2001 7.69997 23.3001 8.29997 23.1001 8.79997C22.9001 9.39997 22.5001 9.29997 21.9001 9.39997C21.3001 9.49997 20.8001 9.49997 20.2001 9.49997Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M77.6 0.800119C77.5 1.10012 77.5 2.00012 77.3 2.30012C77.1 2.50012 76.5 2.40012 76.2 2.40012C75.9 2.40012 75.3 2.30012 75.1 2.50012C74.9 2.70012 74.8 3.70012 74.8 4.10012C74.6 5.20012 74.3 6.20012 74.1 7.30012C74 7.80012 73.9 8.30012 73.8 8.70012C73.7 9.30012 73.8 9.30012 73.2 9.30012C72.8 9.30012 72.3 9.30012 71.8 9.30012C71.3 9.30012 71.3 9.30012 71.4 8.80012C71.6 7.70012 71.8 6.70012 72.1 5.60012C72.2 5.00012 72.3 4.50012 72.5 3.90012C72.6 3.70012 72.9 2.60012 72.8 2.40012C72.6 2.10012 71.1 2.30012 70.7 2.30012C70.8 1.90012 70.8 0.900119 71.1 0.600119C71.4 0.400119 73.1 0.600119 73.5 0.600119C74 0.700119 77.5 0.500119 77.6 0.800119Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M29.8999 0.699973C30.2999 0.699973 30.9999 0.599973 31.2999 0.799973C31.5999 0.999973 31.8999 2.69997 31.9999 3.09997C32.0999 3.39997 32.9999 6.89997 33.0999 6.89997C33.1999 6.89997 33.5999 4.09997 33.6999 3.79997C33.7999 3.19997 33.9999 2.59997 34.0999 1.89997C34.0999 1.69997 34.1999 0.899973 34.3999 0.699973C34.5999 0.499973 35.3999 0.699973 35.6999 0.699973C36.3999 0.699973 36.4999 0.499973 36.3999 1.19997C36.1999 2.49997 35.8999 3.79997 35.5999 5.09997C35.2999 6.29997 35.1999 7.69997 34.7999 8.89997C34.5999 9.49997 34.4999 9.29997 33.8999 9.29997C33.3999 9.29997 32.6999 9.39997 32.1999 9.29997C31.6999 9.19997 31.7999 8.79997 31.5999 8.29997C31.3999 7.69997 31.1999 6.99997 30.9999 6.39997C30.8999 6.09997 30.1999 3.19997 30.0999 3.19997C30.0999 3.19997 29.2999 7.39997 29.1999 7.79997C29.0999 8.19997 29.0999 8.59997 28.9999 8.89997C28.7999 9.49997 28.9999 9.29997 28.3999 9.39997C28.0999 9.39997 27.5999 9.39997 27.2999 9.39997C26.6999 9.29997 26.8999 9.49997 26.8999 9.09997C26.7999 8.39997 27.2999 7.39997 27.3999 6.69997C27.5999 5.79997 27.7999 4.99997 27.9999 4.09997C28.1999 3.19997 28.3999 2.29997 28.5999 1.39997C28.5999 0.499973 29.0999 0.699973 29.8999 0.699973Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M50.8611 0.698116C50.7391 0.699105 50.6185 0.700082 50.4999 0.700082C50.4524 0.700082 50.3849 0.697577 50.3033 0.69455C49.8693 0.678449 49.0366 0.647559 48.6999 0.900082C48.5999 1.00008 48.4999 1.80008 48.4999 2.00008C48.4999 2.33145 48.4313 2.59419 48.3509 2.90202C48.3342 2.96577 48.3171 3.03145 48.2999 3.10008L47.3999 7.30008C47.2999 7.60008 46.7999 9.10008 46.9999 9.30008C47.076 9.45238 47.848 9.37273 48.3003 9.32607C48.4419 9.31146 48.5522 9.30008 48.5999 9.30008C48.9672 9.30008 49.1418 9.30008 49.2392 9.21339C49.3274 9.13487 49.3524 8.98523 49.3999 8.70008C49.4553 8.31244 49.5413 7.95546 49.6241 7.61217C49.6907 7.33555 49.7553 7.06782 49.7999 6.80008C49.9046 6.4335 49.9271 6.28632 50.0109 6.22927C50.0871 6.1774 50.2141 6.20008 50.4999 6.20008C51.1999 6.30008 51.7999 6.30008 52.4999 6.10008C53.4999 5.80008 54.2999 5.20008 54.6999 4.20008C54.9999 3.30008 54.8999 2.00008 54.0999 1.40008C53.1988 0.67917 51.9728 0.689106 50.8611 0.698116ZM52.5999 3.80008C52.1999 4.50008 51.3999 4.60008 50.7999 4.60008C50.5082 4.60008 50.4056 4.60008 50.3772 4.55414C50.3471 4.50557 50.3999 4.40565 50.3999 4.20008C50.4499 4.00008 50.4999 3.77508 50.5499 3.55009C50.5999 3.32508 50.6499 3.10008 50.6999 2.90008C50.7309 2.80715 50.7427 2.72382 50.7531 2.65008C50.7763 2.48577 50.7928 2.36911 50.9999 2.30008C51.1999 2.20008 51.7999 2.30008 51.9999 2.40008C52.5999 2.60008 52.8999 3.20008 52.5999 3.80008Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M27.8001 0.700072C27.4001 2.70007 27.0001 4.60007 26.6001 6.60007C26.5001 7.10007 26.4001 7.60007 26.3001 8.10007C26.2001 8.30007 26.2001 9.20007 26.0001 9.30007C25.8001 9.40007 23.8001 9.40007 23.7001 9.30007C23.6001 9.10007 23.9001 8.10007 24.0001 7.90007C24.1001 7.40007 24.2001 6.90007 24.3001 6.40007C24.5001 5.40007 24.7001 4.40007 25.0001 3.30007C25.1001 2.80007 25.2001 1.10007 25.6001 0.800072C25.9001 0.500072 27.3001 0.700072 27.8001 0.700072Z",
      fill: e.color ?? "#1D1D1C"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.50005 5.20003C8.70005 6.60003 8.00005 7.90003 7.30005 9.30003C7.42303 9.30003 7.60045 9.31213 7.80257 9.32591C8.42219 9.36817 9.27384 9.42624 9.50005 9.20003C9.75005 9.05003 9.85005 8.70003 9.95005 8.35003C10.05 8.00003 10.15 7.65003 10.4 7.50003C10.625 7.27503 11.2438 7.33128 11.7079 7.37347C11.8625 7.38753 12 7.40003 12.1 7.40003C12.2346 7.40003 12.3982 7.38554 12.5712 7.37021C13.0411 7.32859 13.5808 7.28078 13.8 7.50003C13.9401 7.68677 13.9276 8.00428 13.9151 8.32028C13.9009 8.68116 13.8868 9.04008 14.1 9.20003C14.2473 9.34728 14.9908 9.27771 15.4925 9.23076C15.6722 9.21394 15.8209 9.20003 15.9 9.20003C16.2187 9.20003 16.2937 9.24065 16.332 9.21834C16.3538 9.20564 16.3638 9.17257 16.4 9.10003C16.4685 9.03154 16.3494 8.58778 16.2675 8.28279C16.2298 8.14248 16.2 8.03154 16.2 8.00003C16.1 7.65003 16.025 7.27503 15.95 6.90003C15.875 6.52503 15.8 6.15003 15.7 5.80003C15.6575 5.58718 15.6149 5.37231 15.5721 5.156C15.3129 3.84795 15.0433 2.48718 14.7 1.20003C14.5409 0.64287 14.3183 0.655883 13.8307 0.684393C13.7057 0.691702 13.5633 0.70003 13.4 0.70003C13.2799 0.70003 13.1628 0.697087 13.0491 0.694229C12.5 0.680434 12.0314 0.668659 11.7 1.00003C11.3452 1.35483 11.0912 1.96141 10.8663 2.49817C10.7743 2.71783 10.6872 2.92579 10.6 3.10003C10.4 3.45003 10.225 3.80003 10.05 4.15003C9.87505 4.50003 9.70005 4.85003 9.50005 5.20003ZM12.2 4.10003C12.3 3.80003 12.7 2.60003 13 2.50003C13.1 3.00003 13.2 3.60003 13.3 4.20003C13.311 4.233 13.3244 4.27201 13.3395 4.31573C13.4612 4.66984 13.6891 5.333 13.6 5.60003C13.5282 5.88733 13.3532 5.8651 13.075 5.82977C12.9659 5.81591 12.8409 5.80003 12.7 5.80003H11.4C11.5 5.30003 11.9 4.60003 12.2 4.10003Z",
      fill: e.color ?? "#1D1D1C"
    }
  ))
), sf = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e.width ?? 65,
    height: e.height ?? 7,
    viewBox: "0 0 65 7",
    fill: "none"
  },
  /* @__PURE__ */ a.createElement("g", { clipPath: "url(#clip0_2821_33835)" }, /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M49.2845 5.99236C50.6405 5.99236 51.7398 4.89305 51.7398 3.53699C51.7398 2.18094 50.6405 1.08163 49.2845 1.08163C47.9284 1.08163 46.8291 2.18094 46.8291 3.53699C46.8291 4.89305 47.9284 5.99236 49.2845 5.99236Z",
      fill: "#FFF"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M4.02475 6.90827L2.92541 4.69142L1.99073 4.67296V6.89011H0.25V0.165413H3.62158C5.1241 0.165413 5.96707 1.15488 5.96707 2.41919C5.96707 3.57362 5.3626 4.25163 4.66584 4.52646L5.98553 6.90857H4.02475V6.90827ZM4.22634 2.41919C4.22634 1.96093 3.84163 1.66793 3.38367 1.66793H2.00889V3.18861H3.38307C3.89612 3.18861 4.22574 2.89561 4.22574 2.41919H4.22634ZM11.5376 6.90827L11.0975 5.58918L8.64218 5.57072L8.22054 6.89011H6.2416L8.78897 0.146952H10.9695L13.5166 6.89011H11.5376V6.90857V6.90827ZM9.87015 1.86952L9.1189 4.08666H10.6214L9.87015 1.86952ZM20.0581 6.90827V0.165711H21.7989V6.90827H20.0581ZM27.4061 6.90827L24.5475 3.00548V6.90857H22.8068V0.165413H24.6023L27.3328 3.88508V0.165413H29.0735V6.90827H27.4061ZM29.7882 3.51853C29.7515 1.37463 31.4556 0.0186157 33.398 0.0186157C34.6441 0.0186157 35.4502 0.458413 36.0915 1.15488L34.9371 2.23576C34.4241 1.68609 34.1311 1.59468 33.4712 1.57622C32.4817 1.53959 31.584 2.41889 31.584 3.48191C31.584 4.58125 32.39 5.42422 33.453 5.42422C34.0027 5.42422 34.3326 5.27772 34.6441 5.03951V4.52616H33.6362V2.98673H36.3845V5.47901C35.5969 6.54173 34.589 6.96306 33.453 6.98152C31.7489 6.99969 29.8248 5.86372 29.7882 3.51853ZM39.6281 6.90827V0.165711H42.9997C44.5206 0.165711 45.3451 1.22843 45.3451 2.45611C45.3451 3.66533 44.5203 4.69172 42.9997 4.69172H41.3688V6.90887H39.6281V6.90827ZM43.5859 2.43735C43.5859 1.97939 43.2379 1.66793 42.7799 1.66793H41.3688V3.20707H42.7799C43.2379 3.20707 43.5859 2.89561 43.5859 2.43735ZM60.7741 6.90827V1.66763H58.8865V0.14725H64.402V1.66823H62.5148V6.89041L60.7741 6.90827Z",
      fill: e.color ?? "#FFF"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M49.2852 0.0371094C47.361 0.0371094 45.8037 1.59441 45.8037 3.51856C45.8037 5.44271 47.361 7.00002 49.2852 7.00002C51.209 7.00002 52.7666 5.44271 52.7666 3.51856C52.7666 1.59471 51.2093 0.0371094 49.2852 0.0371094ZM49.2852 5.36946C48.8087 5.36946 48.3874 5.2045 48.0575 4.9112C47.6728 4.56282 47.4161 4.06853 47.4161 3.51856C47.4161 2.52909 48.204 1.70459 49.1753 1.66796H49.2667C49.3769 1.66796 49.4683 1.66796 49.5785 1.68613C49.6333 1.70459 49.7065 1.70459 49.7616 1.72275C49.8315 1.73908 49.8992 1.76377 49.9632 1.7963C49.9813 1.7963 49.9813 1.7963 49.9998 1.81446C50.3381 1.95724 50.6266 2.19705 50.8288 2.50363C51.0309 2.8102 51.1378 3.1698 51.1358 3.53702C51.1542 4.54466 50.3113 5.36946 49.2852 5.36946Z",
      fill: "#ED1C24"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M19.4538 5.84587C19.1057 5.51595 18.3178 4.76469 18.3178 4.76469C17.9879 5.16786 17.4751 5.4427 16.8334 5.4427C15.7341 5.4427 14.9462 4.45323 14.9462 3.48192C14.9462 2.2727 15.9723 1.48452 16.9436 1.55807C17.6031 1.61286 17.9879 1.86953 18.2993 2.21762C18.2993 2.21762 19.4356 1.13673 19.4538 1.11827C19.1974 0.8616 18.4646 0.000169045 16.8701 0.000169045C14.7446 -0.0179945 13.1504 1.42944 13.1504 3.4453C13.1504 5.53411 14.7997 6.98184 16.8153 6.98184C18.2812 6.98184 19.014 6.32229 19.4538 5.84587ZM52.9683 5.84587L54.1227 4.76469C54.6908 5.27773 55.3504 5.49748 56.1016 5.49748C56.7064 5.49748 57.0363 5.27773 57.0363 4.94781C57.0363 4.03159 53.2065 4.78285 53.2065 2.19945C53.2065 1.06319 54.1778 0.0186304 55.9 0.0186304C57.3111 0.0186304 58.1907 0.696638 58.3006 0.751725L57.1277 1.85107C56.6897 1.63229 56.2065 1.51929 55.7169 1.52115C55.2039 1.52115 55.0023 1.72273 55.0023 2.01603C55.0023 2.8587 58.8137 2.18099 58.8137 4.74652C58.8137 6.10224 57.7506 6.98184 55.9918 6.98184C54.6542 6.98184 53.7014 6.50541 52.9683 5.84587Z",
      fill: e.color ?? "#FFF"
    }
  )),
  /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", { id: "clip0_2821_33835" }, /* @__PURE__ */ a.createElement(
    "rect",
    {
      width: "64.152",
      height: "7",
      fill: e.color ?? "#FFF",
      transform: "translate(0.25)"
    }
  )))
), _y = "ngs-meetings__RacingPostModalContent__container__12KLQ", gy = "ngs-meetings__RacingPostModalContent__racingPostIcon__12KLQ", py = "ngs-meetings__RacingPostModalContent__racingPostText__12KLQ", mi = {
  container: _y,
  racingPostIcon: gy,
  racingPostText: py
}, hy = ({
  racingPostOverview: e
}) => /* @__PURE__ */ a.createElement("div", { className: mi.container, "data-testid": "racing-post-modal-content" }, /* @__PURE__ */ a.createElement(de, null, /* @__PURE__ */ a.createElement(fe, null, /* @__PURE__ */ a.createElement("div", { className: mi.racingPostIcon, "data-testid": "racing-post-icon" }, /* @__PURE__ */ a.createElement(sf, { height: "16", width: "144", color: "#000" }))), /* @__PURE__ */ a.createElement(Ee, null, /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("div", { className: mi.racingPostText, "data-testid": "racing-post-text" }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary" }, e))))), vy = ({
  racingPostOverview: e,
  children: n,
  ambassadorContent: t
}) => {
  const r = Ae();
  return /* @__PURE__ */ a.createElement(
    Bo,
    {
      onOpenChange: (s) => !s && ve("Overview Close", r)
    },
    /* @__PURE__ */ a.createElement(zr, { asChild: !0 }, n),
    /* @__PURE__ */ a.createElement($o, null, /* @__PURE__ */ a.createElement(Wo, null, /* @__PURE__ */ a.createElement(Ho, { "data-testid": "racing-post-modal" }, /* @__PURE__ */ a.createElement(
      qo,
      {
        title: "Overview & Tips",
        "data-testid": "racing-post-modal-header"
      }
    ), /* @__PURE__ */ a.createElement(Go, { padding: !1 }, /* @__PURE__ */ a.createElement(
      "div",
      {
        className: N1.container,
        "data-testid": "racing-post-modal"
      },
      e ? /* @__PURE__ */ a.createElement(
        hy,
        {
          racingPostOverview: e
        }
      ) : null,
      t ? /* @__PURE__ */ a.createElement(
        fy,
        {
          ambassadorContent: t
        }
      ) : null
    )))))
  );
}, yy = "ngs-meetings__RacingPostLabel__container__p9KYn", Ty = "ngs-meetings__RacingPostLabel__text__p9KYn", Su = {
  container: yy,
  text: Ty
}, Cy = ({ color: e }) => /* @__PURE__ */ a.createElement("div", { className: Su.container }, /* @__PURE__ */ a.createElement(aa, { size: 16, color: "#99ACCC" }), /* @__PURE__ */ a.createElement("div", { className: Su.text }, /* @__PURE__ */ a.createElement(sf, { color: e }), /* @__PURE__ */ a.createElement(T, null, "& more"))), Ry = "ngs-meetings__StreamingPlayerToggle__button__YLvWw", by = "ngs-meetings__StreamingPlayerToggle__active__YLvWw", wy = "ngs-meetings__StreamingPlayerToggle__container__YLvWw", Hr = {
  button: Ry,
  active: by,
  container: wy
};
var of = /* @__PURE__ */ ((e) => (e.PERFORM_RMG = "PERFORM_RMG", e))(of || {}), Qr = /* @__PURE__ */ ((e) => (e.NOT_STARTED = "NOT_STARTED", e.STARTED = "STARTED", e.PENDING = "PENDING", e.AVAILABLE = "AVAILABLE", e))(Qr || {}), bo = /* @__PURE__ */ ((e) => (e.PERMITTED = "PERMITTED", e.PERMISSION_DENIED = "PERMISSION_DENIED", e))(bo || {}), Vr = /* @__PURE__ */ ((e) => (e.BALANCE_REQUIRED = "BALANCE_REQUIRED", e.GEO_BLOCKED = "GEO_BLOCKED", e.NOT_LOGGED_IN = "NOT_LOGGED_IN", e))(Vr || {});
const Ay = {
  BETTING_TV: "bstv",
  BETTING_TV2: "bstv2",
  BETTING_TV3: "bstv3"
}, Sy = {
  ...Ay
}, ze = {
  ...Sy,
  SAS_STREAMING: "sas"
}, Iy = (e) => {
  const n = or(rt.ANALYTICS_ADAPTER_READY, () => {
    cr(n), e();
  });
}, Sa = (e) => Iy(() => {
  lt(rt.TOPIC_EVENT_PARTIAL, e);
}), sc = ({
  free: e,
  channel: n
}) => {
  switch (n) {
    case ze.BETTING_TV:
      return "Betting TV 1";
    case ze.BETTING_TV2:
      return "Betting TV 2";
    case ze.BETTING_TV3:
      return "Betting TV 3";
    case ze.SAS_STREAMING:
      return e ? "Free Streaming" : "B&W";
    default:
      return "Unknown";
  }
}, Ny = ({
  streaming: e,
  source: n
}) => {
  Sa({
    event: "menu_interaction",
    payload: {
      NonInteractionEvent: "0",
      EventCategory: "Menu Interactions",
      EventAction: "In-Page Nav",
      EventLabel: `Video Streaming - ${n}`,
      ElementType: sc(e)
    }
  });
}, Py = (e, n, t) => {
  Sa({
    event: "video_streaming_watched",
    payload: {
      EventCategory: "Video Streaming Interactions",
      EventAction: "Video Streaming watched",
      EventLabel: `Racecard - ${e} min`,
      ElementType: sc(n),
      Bitrate: t !== void 0 ? t.toString() : "null"
    }
  });
}, Oy = (e) => Sa({
  event: "video_streaming_successful",
  payload: {
    EventCategory: "Video Streaming Interactions",
    EventAction: "Video Streaming Launch",
    EventLabel: "Video Streaming Successful",
    ElementType: sc(e)
  }
}), ky = (e) => Sa({
  event: "video_streaming_unsuccessful",
  payload: {
    EventCategory: "Video Streaming Interactions",
    EventAction: "Video Streaming Launch",
    EventLabel: "Video Streaming Unsuccessful",
    ElementType: "Standard",
    ErrorFields: "Video Streaming",
    ErrorFieldsAmount: "1",
    ErrorMessages: e,
    ErrorCode: e
  }
}), cf = () => {
  var n, t;
  let e = "";
  return (t = (n = window == null ? void 0 : window.WH) == null ? void 0 : n.sportsbook) != null && t.page && ({ page: e } = window.WH.sportsbook), e;
}, ic = (e) => Lo(rt.MEDIA_PLAYERS_STATUS, e), Dy = ({ fullscreen: e }) => {
  const n = e ? "on" : "off";
  lt(`whtv.fullscreen.${n}`, {}), Lo(rt.MEDIA_PLAYERS_FULL_SCREEN, n);
}, Ly = (e) => {
  lt("whtv.play", { page: cf() }), Oy(e), ic("play");
}, xy = () => {
  lt("whtv.pause", { page: cf() }), ic("pause");
}, lf = (e) => {
  ky(e), ic("error");
}, Fy = (e) => {
  Lo(rt.MEDIA_PLAYERS_BITRATE, e);
}, My = (e, n) => {
  let t, r;
  const s = () => {
    let m = 0;
    r = setInterval(() => {
      Py(m += 1, e, t);
    }, n);
  }, i = (m) => {
    t = m;
  }, o = () => {
    clearInterval(r);
  };
  return { startSending: () => {
    o(), s();
  }, stopSending: o, setBitrate: i };
};
var di = { exports: {} }, fi = { exports: {} }, Iu;
function By() {
  return Iu || (Iu = 1, function() {
    var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = {
      // Bit-wise rotation left
      rotl: function(t, r) {
        return t << r | t >>> 32 - r;
      },
      // Bit-wise rotation right
      rotr: function(t, r) {
        return t << 32 - r | t >>> r;
      },
      // Swap big-endian to little-endian and vice versa
      endian: function(t) {
        if (t.constructor == Number)
          return n.rotl(t, 8) & 16711935 | n.rotl(t, 24) & 4278255360;
        for (var r = 0; r < t.length; r++)
          t[r] = n.endian(t[r]);
        return t;
      },
      // Generate an array of any length of random bytes
      randomBytes: function(t) {
        for (var r = []; t > 0; t--)
          r.push(Math.floor(Math.random() * 256));
        return r;
      },
      // Convert a byte array to big-endian 32-bit words
      bytesToWords: function(t) {
        for (var r = [], s = 0, i = 0; s < t.length; s++, i += 8)
          r[i >>> 5] |= t[s] << 24 - i % 32;
        return r;
      },
      // Convert big-endian 32-bit words to a byte array
      wordsToBytes: function(t) {
        for (var r = [], s = 0; s < t.length * 32; s += 8)
          r.push(t[s >>> 5] >>> 24 - s % 32 & 255);
        return r;
      },
      // Convert a byte array to a hex string
      bytesToHex: function(t) {
        for (var r = [], s = 0; s < t.length; s++)
          r.push((t[s] >>> 4).toString(16)), r.push((t[s] & 15).toString(16));
        return r.join("");
      },
      // Convert a hex string to a byte array
      hexToBytes: function(t) {
        for (var r = [], s = 0; s < t.length; s += 2)
          r.push(parseInt(t.substr(s, 2), 16));
        return r;
      },
      // Convert a byte array to a base-64 string
      bytesToBase64: function(t) {
        for (var r = [], s = 0; s < t.length; s += 3)
          for (var i = t[s] << 16 | t[s + 1] << 8 | t[s + 2], o = 0; o < 4; o++)
            s * 8 + o * 6 <= t.length * 8 ? r.push(e.charAt(i >>> 6 * (3 - o) & 63)) : r.push("=");
        return r.join("");
      },
      // Convert a base-64 string to a byte array
      base64ToBytes: function(t) {
        t = t.replace(/[^A-Z0-9+\/]/ig, "");
        for (var r = [], s = 0, i = 0; s < t.length; i = ++s % 4)
          i != 0 && r.push((e.indexOf(t.charAt(s - 1)) & Math.pow(2, -2 * i + 8) - 1) << i * 2 | e.indexOf(t.charAt(s)) >>> 6 - i * 2);
        return r;
      }
    };
    fi.exports = n;
  }()), fi.exports;
}
var Ei, Nu;
function Pu() {
  if (Nu) return Ei;
  Nu = 1;
  var e = {
    // UTF-8 encoding
    utf8: {
      // Convert a string to a byte array
      stringToBytes: function(n) {
        return e.bin.stringToBytes(unescape(encodeURIComponent(n)));
      },
      // Convert a byte array to a string
      bytesToString: function(n) {
        return decodeURIComponent(escape(e.bin.bytesToString(n)));
      }
    },
    // Binary encoding
    bin: {
      // Convert a string to a byte array
      stringToBytes: function(n) {
        for (var t = [], r = 0; r < n.length; r++)
          t.push(n.charCodeAt(r) & 255);
        return t;
      },
      // Convert a byte array to a string
      bytesToString: function(n) {
        for (var t = [], r = 0; r < n.length; r++)
          t.push(String.fromCharCode(n[r]));
        return t.join("");
      }
    }
  };
  return Ei = e, Ei;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var _i, Ou;
function $y() {
  if (Ou) return _i;
  Ou = 1, _i = function(t) {
    return t != null && (e(t) || n(t) || !!t._isBuffer);
  };
  function e(t) {
    return !!t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
  }
  function n(t) {
    return typeof t.readFloatLE == "function" && typeof t.slice == "function" && e(t.slice(0, 0));
  }
  return _i;
}
var ku;
function Wy() {
  return ku || (ku = 1, function() {
    var e = By(), n = Pu().utf8, t = $y(), r = Pu().bin, s = function(i, o) {
      i.constructor == String ? o && o.encoding === "binary" ? i = r.stringToBytes(i) : i = n.stringToBytes(i) : t(i) ? i = Array.prototype.slice.call(i, 0) : !Array.isArray(i) && i.constructor !== Uint8Array && (i = i.toString());
      for (var c = e.bytesToWords(i), m = i.length * 8, u = 1732584193, l = -271733879, d = -1732584194, f = 271733878, E = 0; E < c.length; E++)
        c[E] = (c[E] << 8 | c[E] >>> 24) & 16711935 | (c[E] << 24 | c[E] >>> 8) & 4278255360;
      c[m >>> 5] |= 128 << m % 32, c[(m + 64 >>> 9 << 4) + 14] = m;
      for (var g = s._ff, p = s._gg, v = s._hh, y = s._ii, E = 0; E < c.length; E += 16) {
        var C = u, b = l, R = d, P = f;
        u = g(u, l, d, f, c[E + 0], 7, -680876936), f = g(f, u, l, d, c[E + 1], 12, -389564586), d = g(d, f, u, l, c[E + 2], 17, 606105819), l = g(l, d, f, u, c[E + 3], 22, -1044525330), u = g(u, l, d, f, c[E + 4], 7, -176418897), f = g(f, u, l, d, c[E + 5], 12, 1200080426), d = g(d, f, u, l, c[E + 6], 17, -1473231341), l = g(l, d, f, u, c[E + 7], 22, -45705983), u = g(u, l, d, f, c[E + 8], 7, 1770035416), f = g(f, u, l, d, c[E + 9], 12, -1958414417), d = g(d, f, u, l, c[E + 10], 17, -42063), l = g(l, d, f, u, c[E + 11], 22, -1990404162), u = g(u, l, d, f, c[E + 12], 7, 1804603682), f = g(f, u, l, d, c[E + 13], 12, -40341101), d = g(d, f, u, l, c[E + 14], 17, -1502002290), l = g(l, d, f, u, c[E + 15], 22, 1236535329), u = p(u, l, d, f, c[E + 1], 5, -165796510), f = p(f, u, l, d, c[E + 6], 9, -1069501632), d = p(d, f, u, l, c[E + 11], 14, 643717713), l = p(l, d, f, u, c[E + 0], 20, -373897302), u = p(u, l, d, f, c[E + 5], 5, -701558691), f = p(f, u, l, d, c[E + 10], 9, 38016083), d = p(d, f, u, l, c[E + 15], 14, -660478335), l = p(l, d, f, u, c[E + 4], 20, -405537848), u = p(u, l, d, f, c[E + 9], 5, 568446438), f = p(f, u, l, d, c[E + 14], 9, -1019803690), d = p(d, f, u, l, c[E + 3], 14, -187363961), l = p(l, d, f, u, c[E + 8], 20, 1163531501), u = p(u, l, d, f, c[E + 13], 5, -1444681467), f = p(f, u, l, d, c[E + 2], 9, -51403784), d = p(d, f, u, l, c[E + 7], 14, 1735328473), l = p(l, d, f, u, c[E + 12], 20, -1926607734), u = v(u, l, d, f, c[E + 5], 4, -378558), f = v(f, u, l, d, c[E + 8], 11, -2022574463), d = v(d, f, u, l, c[E + 11], 16, 1839030562), l = v(l, d, f, u, c[E + 14], 23, -35309556), u = v(u, l, d, f, c[E + 1], 4, -1530992060), f = v(f, u, l, d, c[E + 4], 11, 1272893353), d = v(d, f, u, l, c[E + 7], 16, -155497632), l = v(l, d, f, u, c[E + 10], 23, -1094730640), u = v(u, l, d, f, c[E + 13], 4, 681279174), f = v(f, u, l, d, c[E + 0], 11, -358537222), d = v(d, f, u, l, c[E + 3], 16, -722521979), l = v(l, d, f, u, c[E + 6], 23, 76029189), u = v(u, l, d, f, c[E + 9], 4, -640364487), f = v(f, u, l, d, c[E + 12], 11, -421815835), d = v(d, f, u, l, c[E + 15], 16, 530742520), l = v(l, d, f, u, c[E + 2], 23, -995338651), u = y(u, l, d, f, c[E + 0], 6, -198630844), f = y(f, u, l, d, c[E + 7], 10, 1126891415), d = y(d, f, u, l, c[E + 14], 15, -1416354905), l = y(l, d, f, u, c[E + 5], 21, -57434055), u = y(u, l, d, f, c[E + 12], 6, 1700485571), f = y(f, u, l, d, c[E + 3], 10, -1894986606), d = y(d, f, u, l, c[E + 10], 15, -1051523), l = y(l, d, f, u, c[E + 1], 21, -2054922799), u = y(u, l, d, f, c[E + 8], 6, 1873313359), f = y(f, u, l, d, c[E + 15], 10, -30611744), d = y(d, f, u, l, c[E + 6], 15, -1560198380), l = y(l, d, f, u, c[E + 13], 21, 1309151649), u = y(u, l, d, f, c[E + 4], 6, -145523070), f = y(f, u, l, d, c[E + 11], 10, -1120210379), d = y(d, f, u, l, c[E + 2], 15, 718787259), l = y(l, d, f, u, c[E + 9], 21, -343485551), u = u + C >>> 0, l = l + b >>> 0, d = d + R >>> 0, f = f + P >>> 0;
      }
      return e.endian([u, l, d, f]);
    };
    s._ff = function(i, o, c, m, u, l, d) {
      var f = i + (o & c | ~o & m) + (u >>> 0) + d;
      return (f << l | f >>> 32 - l) + o;
    }, s._gg = function(i, o, c, m, u, l, d) {
      var f = i + (o & m | c & ~m) + (u >>> 0) + d;
      return (f << l | f >>> 32 - l) + o;
    }, s._hh = function(i, o, c, m, u, l, d) {
      var f = i + (o ^ c ^ m) + (u >>> 0) + d;
      return (f << l | f >>> 32 - l) + o;
    }, s._ii = function(i, o, c, m, u, l, d) {
      var f = i + (c ^ (o | ~m)) + (u >>> 0) + d;
      return (f << l | f >>> 32 - l) + o;
    }, s._blocksize = 16, s._digestsize = 16, di.exports = function(i, o) {
      if (i == null)
        throw new Error("Illegal argument " + i);
      var c = e.wordsToBytes(s(i, o));
      return o && o.asBytes ? c : o && o.asString ? r.bytesToString(c) : e.bytesToHex(c);
    };
  }()), di.exports;
}
var Hy = Wy();
const qy = /* @__PURE__ */ Rd(Hy), uf = (e) => e === "desktop", Gy = (e) => e !== "desktop", Ia = (e) => ["native_ios", "native_android"].includes(e), mf = (e) => {
  var n;
  return ((n = e.split("_")) == null ? void 0 : n[1]) || e;
}, Uy = 60 * 1e3, Yy = (e, n, t, r, s) => {
  uf(e) && n.isChannelFree ? lt(rt.MEDIAPLAYERS_WHTV_PLAY, {
    channel: n.channel,
    clickSource: r
  }) : (!Ia(e) && !n.rmg && n.channel !== ze.SAS_STREAMING && (wo() && s ? Vy() : lt(rt.FREE_TV_CHANNEL_CHANGED, n.channel)), t());
}, jy = () => localStorage.getItem(vd), df = (e) => !!(e && Object.values(ze).includes(e)), wo = (e) => {
  const n = (e == null ? void 0 : e.streaming.rmg) ?? !1, t = (e == null ? void 0 : e.streaming.channel) === ze.SAS_STREAMING;
  if (n || t)
    return !1;
  const r = jy();
  return df(r);
}, Vy = () => {
  localStorage.removeItem(vd), lt(rt.FREE_TV_CHANNEL_CHANGED, jg);
}, Ky = (e, n = !1) => !n && e.available, ff = ({ streaming: e, id: n }, t) => e.available && (e.free || t.includes(n)), zy = (e, n, t) => {
  const r = document.createElement("script");
  return r.src = e.playerUrl, r.async = !0, r.setAttribute("data-uuid", e.fixtureId), r.setAttribute("data-outletkey", e.outletKey), r.setAttribute("data-streamuuid", e.streamId), r.setAttribute("data-oauthtoken", e.accessToken), r.setAttribute("data-rmg", "true"), r.setAttribute("data-apptype", "csb"), r.setAttribute("data-env", "betting"), r.setAttribute("data-flyaway-draggable", "true"), r.setAttribute("data-left", "5px"), r.setAttribute("data-mode", "mini"), r.setAttribute("data-width", window.innerWidth.toString()), r.setAttribute("data-user", n), r.setAttribute(
    "data-streamuser",
    qy(`${e.salt}${n}`)
  ), t && r.setAttribute("data-flyaway", "true"), r;
}, Ef = "rmg-streaming-player", Na = "btv-streaming-player", Xy = (e, n, t) => {
  if (!n || !t)
    return !1;
  const r = document.getElementById(Ef);
  if (!r)
    return !1;
  const { data: s } = n, { properties: i } = s, o = zy(i, t, e);
  return r.appendChild(o), !0;
}, Qy = (e, n, t, r, s) => {
  var o, c, m;
  if (!((o = window.WH) != null && o.StreamPlayer))
    return null;
  const i = My(n, Uy);
  return new window.WH.StreamPlayer({
    streamType: n.channel === ze.SAS_STREAMING ? "LIVE" : "BROADCAST",
    eventId: n.channel === ze.SAS_STREAMING ? e.replace("OB_EV", "") : n.channel,
    container: Na,
    locale: (m = (c = window.WH) == null ? void 0 : c.sportsbook) == null ? void 0 : m.lang.toLowerCase(),
    backendUrl: s,
    self: `TRAF_MEET_${t}_${e.toUpperCase()}_${n.channel}`,
    errorHandler: (u) => lf(u),
    playerConf: {
      // config for underlying video-player (doing the actual video reproduction)
      withCredentials: !1,
      allowFullscreen: !0,
      autostart: !0,
      mute: !0,
      eventHandlers: {
        play: () => {
          r && i.startSending(), Ly(n);
        },
        pause: () => {
          r && i.stopSending(), xy();
        },
        remove: () => {
          r && i.stopSending();
        },
        fullscreen: Dy,
        visualQuality: (u) => {
          if (r) {
            const l = u && u.level && u.level.bitrate;
            i.setBitrate(l), Fy(l);
          }
        }
      }
    }
  });
}, Zy = (e, n, t) => {
  var r, s, i;
  return (r = window.WH) != null && r.StreamPlayer ? new window.WH.StreamPlayer({
    eventId: e.replace("OB_EV", ""),
    container: Na,
    locale: (i = (s = window.WH) == null ? void 0 : s.sportsbook) == null ? void 0 : i.lang.toLowerCase(),
    backendUrl: t,
    streamType: n,
    errorHandler: (o) => lf(o),
    playerConf: {
      autoplay: !0,
      muted: !0,
      pipEnabled: !0,
      closeButton: {
        isEnabled: !1,
        onCloseButtonCallback: () => {
        }
      }
    }
  }) : null;
}, Jy = (e, n = !0) => {
  switch (e) {
    case ze.BETTING_TV:
    case ze.BETTING_TV2:
    case ze.BETTING_TV3:
      return n ? Oe.WATCH_BETTING_TV : Oe.WATCH_FOR_FREE_BETT_TV;
    default:
      return "";
  }
}, _f = (e, n, t) => {
  var i, o, c, m, u, l, d, f, E, g;
  const r = n === "es-es", s = t === To.ANDROID;
  return e && ((i = window == null ? void 0 : window.WH) != null && i.bootstrapper) && r && s ? (u = (m = (c = (o = window.WH) == null ? void 0 : o.bootstrapper) == null ? void 0 : c.features) == null ? void 0 : m["login-flow"]) == null || u.start() : e && window ? window.location.href = "nw-showlogin://" : (l = window == null ? void 0 : window.WH) != null && l.bootstrapper && ((g = (E = (f = (d = window.WH) == null ? void 0 : d.bootstrapper) == null ? void 0 : f.features) == null ? void 0 : E["login-flow"]) == null || g.start()), null;
};
function yr() {
  const [e, n] = ee(null);
  return te(() => {
    const t = or(
      rt.GOT_LOGIN_STATE,
      (r, s) => {
        n((s == null ? void 0 : s.isLoggedIn) === !0 ? (s == null ? void 0 : s.data) ?? null : null);
      }
    );
    return () => cr(t);
  }, []), e;
}
const e9 = () => {
  const { services: e, queryKey: n } = _e(), { id: t } = q(), r = yr(), s = t.replace("OB_EV", "");
  return ye({
    queryKey: [...n, "streaming", s, r == null ? void 0 : r.obAccountNumber],
    queryFn: () => e.streaming.getEventStream(s)
  });
}, t9 = () => {
  const { services: e, queryKey: n } = _e(), { id: t } = q();
  return ye({
    queryKey: [...n, "settled-event-stream-data", t],
    queryFn: () => e.streaming.getEventStream(t, "VOD"),
    retry: !1,
    refetchInterval: (r) => {
      var i, o;
      return ((o = (i = r == null ? void 0 : r.streamsDetails) == null ? void 0 : i[0]) == null ? void 0 : o.status) === "PENDING" ? 3e4 : !1;
    }
  });
}, n9 = () => {
  const { services: e, queryKey: n } = _e(), {
    params: { sport: t }
  } = V();
  return ye({
    queryKey: [...n, "qualified-events"],
    queryFn: () => e.streaming.getQualifiedEvents(t)
  });
}, oc = () => {
  var t, r;
  const e = e9(), n = ((r = (t = e.data) == null ? void 0 : t.streamsDetails) == null ? void 0 : r.find(
    (s) => s.provider === of.PERFORM_RMG
  )) ?? null;
  return {
    ...e,
    data: n
  };
}, Ve = {
  // from query
  isLoading: !1,
  isError: !1,
  // based on auth result
  isBlocked: !1,
  isBalanceRequired: !1,
  isGeoBlocked: !1,
  isNotLoggedIn: !1,
  // based on streaming status
  isNotStarted: !1,
  isStarted: !1
}, gf = () => {
  const { data: e, isLoading: n, isError: t } = oc();
  if (Ve.isLoading = n, Ve.isError = t, !e)
    return Ve;
  const { authorization: r, status: s } = e;
  return r.result === bo.PERMISSION_DENIED ? (Ve.isBlocked = !0, Ve.isBalanceRequired = r.declineReason === Vr.BALANCE_REQUIRED, Ve.isGeoBlocked = r.declineReason === Vr.GEO_BLOCKED, Ve.isNotLoggedIn = r.declineReason === Vr.NOT_LOGGED_IN) : r.result === bo.PERMITTED && (Ve.isBlocked = !1, Ve.isBalanceRequired = !1, Ve.isGeoBlocked = !1, Ve.isNotLoggedIn = !1), Ve.isNotStarted = s === Qr.NOT_STARTED, Ve.isStarted = s === Qr.STARTED, Ve;
}, pf = () => {
  const e = n9();
  return {
    ...e,
    data: e.data ?? []
  };
}, cc = () => {
  const e = q(), { data: n } = pf();
  return ff(e, n);
}, r9 = () => {
  var i, o;
  const { isError: e, isLoading: n, data: t } = t9(), s = (((o = (i = t == null ? void 0 : t.streamsDetails) == null ? void 0 : i[0]) == null ? void 0 : o.status) ?? null) === Qr.AVAILABLE;
  return {
    isError: e,
    isLoading: n,
    hasNoData: !n && !(t != null && t.streamsDetails),
    isAvailable: s
  };
}, a9 = "ngs-meetings__StreamingAnchor__btvNativeAnchor__kazbN", s9 = {
  btvNativeAnchor: a9
};
var qr = { exports: {} }, gi, Du;
function Pa() {
  if (Du) return gi;
  Du = 1;
  const e = "2.0.0", n = 256, t = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, r = 16, s = n - 6;
  return gi = {
    MAX_LENGTH: n,
    MAX_SAFE_COMPONENT_LENGTH: r,
    MAX_SAFE_BUILD_LENGTH: s,
    MAX_SAFE_INTEGER: t,
    RELEASE_TYPES: [
      "major",
      "premajor",
      "minor",
      "preminor",
      "patch",
      "prepatch",
      "prerelease"
    ],
    SEMVER_SPEC_VERSION: e,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
  }, gi;
}
var pi, Lu;
function Oa() {
  return Lu || (Lu = 1, pi = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...n) => console.error("SEMVER", ...n) : () => {
  }), pi;
}
var xu;
function Tr() {
  return xu || (xu = 1, function(e, n) {
    const {
      MAX_SAFE_COMPONENT_LENGTH: t,
      MAX_SAFE_BUILD_LENGTH: r,
      MAX_LENGTH: s
    } = Pa(), i = Oa();
    n = e.exports = {};
    const o = n.re = [], c = n.safeRe = [], m = n.src = [], u = n.safeSrc = [], l = n.t = {};
    let d = 0;
    const f = "[a-zA-Z0-9-]", E = [
      ["\\s", 1],
      ["\\d", s],
      [f, r]
    ], g = (v) => {
      for (const [y, C] of E)
        v = v.split(`${y}*`).join(`${y}{0,${C}}`).split(`${y}+`).join(`${y}{1,${C}}`);
      return v;
    }, p = (v, y, C) => {
      const b = g(y), R = d++;
      i(v, R, y), l[v] = R, m[R] = y, u[R] = b, o[R] = new RegExp(y, C ? "g" : void 0), c[R] = new RegExp(b, C ? "g" : void 0);
    };
    p("NUMERICIDENTIFIER", "0|[1-9]\\d*"), p("NUMERICIDENTIFIERLOOSE", "\\d+"), p("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${f}*`), p("MAINVERSION", `(${m[l.NUMERICIDENTIFIER]})\\.(${m[l.NUMERICIDENTIFIER]})\\.(${m[l.NUMERICIDENTIFIER]})`), p("MAINVERSIONLOOSE", `(${m[l.NUMERICIDENTIFIERLOOSE]})\\.(${m[l.NUMERICIDENTIFIERLOOSE]})\\.(${m[l.NUMERICIDENTIFIERLOOSE]})`), p("PRERELEASEIDENTIFIER", `(?:${m[l.NUMERICIDENTIFIER]}|${m[l.NONNUMERICIDENTIFIER]})`), p("PRERELEASEIDENTIFIERLOOSE", `(?:${m[l.NUMERICIDENTIFIERLOOSE]}|${m[l.NONNUMERICIDENTIFIER]})`), p("PRERELEASE", `(?:-(${m[l.PRERELEASEIDENTIFIER]}(?:\\.${m[l.PRERELEASEIDENTIFIER]})*))`), p("PRERELEASELOOSE", `(?:-?(${m[l.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${m[l.PRERELEASEIDENTIFIERLOOSE]})*))`), p("BUILDIDENTIFIER", `${f}+`), p("BUILD", `(?:\\+(${m[l.BUILDIDENTIFIER]}(?:\\.${m[l.BUILDIDENTIFIER]})*))`), p("FULLPLAIN", `v?${m[l.MAINVERSION]}${m[l.PRERELEASE]}?${m[l.BUILD]}?`), p("FULL", `^${m[l.FULLPLAIN]}$`), p("LOOSEPLAIN", `[v=\\s]*${m[l.MAINVERSIONLOOSE]}${m[l.PRERELEASELOOSE]}?${m[l.BUILD]}?`), p("LOOSE", `^${m[l.LOOSEPLAIN]}$`), p("GTLT", "((?:<|>)?=?)"), p("XRANGEIDENTIFIERLOOSE", `${m[l.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), p("XRANGEIDENTIFIER", `${m[l.NUMERICIDENTIFIER]}|x|X|\\*`), p("XRANGEPLAIN", `[v=\\s]*(${m[l.XRANGEIDENTIFIER]})(?:\\.(${m[l.XRANGEIDENTIFIER]})(?:\\.(${m[l.XRANGEIDENTIFIER]})(?:${m[l.PRERELEASE]})?${m[l.BUILD]}?)?)?`), p("XRANGEPLAINLOOSE", `[v=\\s]*(${m[l.XRANGEIDENTIFIERLOOSE]})(?:\\.(${m[l.XRANGEIDENTIFIERLOOSE]})(?:\\.(${m[l.XRANGEIDENTIFIERLOOSE]})(?:${m[l.PRERELEASELOOSE]})?${m[l.BUILD]}?)?)?`), p("XRANGE", `^${m[l.GTLT]}\\s*${m[l.XRANGEPLAIN]}$`), p("XRANGELOOSE", `^${m[l.GTLT]}\\s*${m[l.XRANGEPLAINLOOSE]}$`), p("COERCEPLAIN", `(^|[^\\d])(\\d{1,${t}})(?:\\.(\\d{1,${t}}))?(?:\\.(\\d{1,${t}}))?`), p("COERCE", `${m[l.COERCEPLAIN]}(?:$|[^\\d])`), p("COERCEFULL", m[l.COERCEPLAIN] + `(?:${m[l.PRERELEASE]})?(?:${m[l.BUILD]})?(?:$|[^\\d])`), p("COERCERTL", m[l.COERCE], !0), p("COERCERTLFULL", m[l.COERCEFULL], !0), p("LONETILDE", "(?:~>?)"), p("TILDETRIM", `(\\s*)${m[l.LONETILDE]}\\s+`, !0), n.tildeTrimReplace = "$1~", p("TILDE", `^${m[l.LONETILDE]}${m[l.XRANGEPLAIN]}$`), p("TILDELOOSE", `^${m[l.LONETILDE]}${m[l.XRANGEPLAINLOOSE]}$`), p("LONECARET", "(?:\\^)"), p("CARETTRIM", `(\\s*)${m[l.LONECARET]}\\s+`, !0), n.caretTrimReplace = "$1^", p("CARET", `^${m[l.LONECARET]}${m[l.XRANGEPLAIN]}$`), p("CARETLOOSE", `^${m[l.LONECARET]}${m[l.XRANGEPLAINLOOSE]}$`), p("COMPARATORLOOSE", `^${m[l.GTLT]}\\s*(${m[l.LOOSEPLAIN]})$|^$`), p("COMPARATOR", `^${m[l.GTLT]}\\s*(${m[l.FULLPLAIN]})$|^$`), p("COMPARATORTRIM", `(\\s*)${m[l.GTLT]}\\s*(${m[l.LOOSEPLAIN]}|${m[l.XRANGEPLAIN]})`, !0), n.comparatorTrimReplace = "$1$2$3", p("HYPHENRANGE", `^\\s*(${m[l.XRANGEPLAIN]})\\s+-\\s+(${m[l.XRANGEPLAIN]})\\s*$`), p("HYPHENRANGELOOSE", `^\\s*(${m[l.XRANGEPLAINLOOSE]})\\s+-\\s+(${m[l.XRANGEPLAINLOOSE]})\\s*$`), p("STAR", "(<|>)?=?\\s*\\*"), p("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), p("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  }(qr, qr.exports)), qr.exports;
}
var hi, Fu;
function lc() {
  if (Fu) return hi;
  Fu = 1;
  const e = Object.freeze({ loose: !0 }), n = Object.freeze({});
  return hi = (r) => r ? typeof r != "object" ? e : r : n, hi;
}
var vi, Mu;
function hf() {
  if (Mu) return vi;
  Mu = 1;
  const e = /^[0-9]+$/, n = (r, s) => {
    const i = e.test(r), o = e.test(s);
    return i && o && (r = +r, s = +s), r === s ? 0 : i && !o ? -1 : o && !i ? 1 : r < s ? -1 : 1;
  };
  return vi = {
    compareIdentifiers: n,
    rcompareIdentifiers: (r, s) => n(s, r)
  }, vi;
}
var yi, Bu;
function Ue() {
  if (Bu) return yi;
  Bu = 1;
  const e = Oa(), { MAX_LENGTH: n, MAX_SAFE_INTEGER: t } = Pa(), { safeRe: r, safeSrc: s, t: i } = Tr(), o = lc(), { compareIdentifiers: c } = hf();
  class m {
    constructor(l, d) {
      if (d = o(d), l instanceof m) {
        if (l.loose === !!d.loose && l.includePrerelease === !!d.includePrerelease)
          return l;
        l = l.version;
      } else if (typeof l != "string")
        throw new TypeError(`Invalid version. Must be a string. Got type "${typeof l}".`);
      if (l.length > n)
        throw new TypeError(
          `version is longer than ${n} characters`
        );
      e("SemVer", l, d), this.options = d, this.loose = !!d.loose, this.includePrerelease = !!d.includePrerelease;
      const f = l.trim().match(d.loose ? r[i.LOOSE] : r[i.FULL]);
      if (!f)
        throw new TypeError(`Invalid Version: ${l}`);
      if (this.raw = l, this.major = +f[1], this.minor = +f[2], this.patch = +f[3], this.major > t || this.major < 0)
        throw new TypeError("Invalid major version");
      if (this.minor > t || this.minor < 0)
        throw new TypeError("Invalid minor version");
      if (this.patch > t || this.patch < 0)
        throw new TypeError("Invalid patch version");
      f[4] ? this.prerelease = f[4].split(".").map((E) => {
        if (/^[0-9]+$/.test(E)) {
          const g = +E;
          if (g >= 0 && g < t)
            return g;
        }
        return E;
      }) : this.prerelease = [], this.build = f[5] ? f[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(l) {
      if (e("SemVer.compare", this.version, this.options, l), !(l instanceof m)) {
        if (typeof l == "string" && l === this.version)
          return 0;
        l = new m(l, this.options);
      }
      return l.version === this.version ? 0 : this.compareMain(l) || this.comparePre(l);
    }
    compareMain(l) {
      return l instanceof m || (l = new m(l, this.options)), c(this.major, l.major) || c(this.minor, l.minor) || c(this.patch, l.patch);
    }
    comparePre(l) {
      if (l instanceof m || (l = new m(l, this.options)), this.prerelease.length && !l.prerelease.length)
        return -1;
      if (!this.prerelease.length && l.prerelease.length)
        return 1;
      if (!this.prerelease.length && !l.prerelease.length)
        return 0;
      let d = 0;
      do {
        const f = this.prerelease[d], E = l.prerelease[d];
        if (e("prerelease compare", d, f, E), f === void 0 && E === void 0)
          return 0;
        if (E === void 0)
          return 1;
        if (f === void 0)
          return -1;
        if (f === E)
          continue;
        return c(f, E);
      } while (++d);
    }
    compareBuild(l) {
      l instanceof m || (l = new m(l, this.options));
      let d = 0;
      do {
        const f = this.build[d], E = l.build[d];
        if (e("build compare", d, f, E), f === void 0 && E === void 0)
          return 0;
        if (E === void 0)
          return 1;
        if (f === void 0)
          return -1;
        if (f === E)
          continue;
        return c(f, E);
      } while (++d);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(l, d, f) {
      if (l.startsWith("pre")) {
        if (!d && f === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (d) {
          const E = new RegExp(`^${this.options.loose ? s[i.PRERELEASELOOSE] : s[i.PRERELEASE]}$`), g = `-${d}`.match(E);
          if (!g || g[1] !== d)
            throw new Error(`invalid identifier: ${d}`);
        }
      }
      switch (l) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", d, f);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", d, f);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", d, f), this.inc("pre", d, f);
          break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", d, f), this.inc("pre", d, f);
          break;
        case "release":
          if (this.prerelease.length === 0)
            throw new Error(`version ${this.raw} is not a prerelease`);
          this.prerelease.length = 0;
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        // This probably shouldn't be used publicly.
        // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
        case "pre": {
          const E = Number(f) ? 1 : 0;
          if (this.prerelease.length === 0)
            this.prerelease = [E];
          else {
            let g = this.prerelease.length;
            for (; --g >= 0; )
              typeof this.prerelease[g] == "number" && (this.prerelease[g]++, g = -2);
            if (g === -1) {
              if (d === this.prerelease.join(".") && f === !1)
                throw new Error("invalid increment argument: identifier already exists");
              this.prerelease.push(E);
            }
          }
          if (d) {
            let g = [d, E];
            f === !1 && (g = [d]), c(this.prerelease[0], d) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = g) : this.prerelease = g;
          }
          break;
        }
        default:
          throw new Error(`invalid increment argument: ${l}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  }
  return yi = m, yi;
}
var Ti, $u;
function kn() {
  if ($u) return Ti;
  $u = 1;
  const e = Ue();
  return Ti = (t, r, s = !1) => {
    if (t instanceof e)
      return t;
    try {
      return new e(t, r);
    } catch (i) {
      if (!s)
        return null;
      throw i;
    }
  }, Ti;
}
var Ci, Wu;
function i9() {
  if (Wu) return Ci;
  Wu = 1;
  const e = kn();
  return Ci = (t, r) => {
    const s = e(t, r);
    return s ? s.version : null;
  }, Ci;
}
var Ri, Hu;
function o9() {
  if (Hu) return Ri;
  Hu = 1;
  const e = kn();
  return Ri = (t, r) => {
    const s = e(t.trim().replace(/^[=v]+/, ""), r);
    return s ? s.version : null;
  }, Ri;
}
var bi, qu;
function c9() {
  if (qu) return bi;
  qu = 1;
  const e = Ue();
  return bi = (t, r, s, i, o) => {
    typeof s == "string" && (o = i, i = s, s = void 0);
    try {
      return new e(
        t instanceof e ? t.version : t,
        s
      ).inc(r, i, o).version;
    } catch {
      return null;
    }
  }, bi;
}
var wi, Gu;
function l9() {
  if (Gu) return wi;
  Gu = 1;
  const e = kn();
  return wi = (t, r) => {
    const s = e(t, null, !0), i = e(r, null, !0), o = s.compare(i);
    if (o === 0)
      return null;
    const c = o > 0, m = c ? s : i, u = c ? i : s, l = !!m.prerelease.length;
    if (!!u.prerelease.length && !l) {
      if (!u.patch && !u.minor)
        return "major";
      if (u.compareMain(m) === 0)
        return u.minor && !u.patch ? "minor" : "patch";
    }
    const f = l ? "pre" : "";
    return s.major !== i.major ? f + "major" : s.minor !== i.minor ? f + "minor" : s.patch !== i.patch ? f + "patch" : "prerelease";
  }, wi;
}
var Ai, Uu;
function u9() {
  if (Uu) return Ai;
  Uu = 1;
  const e = Ue();
  return Ai = (t, r) => new e(t, r).major, Ai;
}
var Si, Yu;
function m9() {
  if (Yu) return Si;
  Yu = 1;
  const e = Ue();
  return Si = (t, r) => new e(t, r).minor, Si;
}
var Ii, ju;
function d9() {
  if (ju) return Ii;
  ju = 1;
  const e = Ue();
  return Ii = (t, r) => new e(t, r).patch, Ii;
}
var Ni, Vu;
function f9() {
  if (Vu) return Ni;
  Vu = 1;
  const e = kn();
  return Ni = (t, r) => {
    const s = e(t, r);
    return s && s.prerelease.length ? s.prerelease : null;
  }, Ni;
}
var Pi, Ku;
function ut() {
  if (Ku) return Pi;
  Ku = 1;
  const e = Ue();
  return Pi = (t, r, s) => new e(t, s).compare(new e(r, s)), Pi;
}
var Oi, zu;
function E9() {
  if (zu) return Oi;
  zu = 1;
  const e = ut();
  return Oi = (t, r, s) => e(r, t, s), Oi;
}
var ki, Xu;
function _9() {
  if (Xu) return ki;
  Xu = 1;
  const e = ut();
  return ki = (t, r) => e(t, r, !0), ki;
}
var Di, Qu;
function uc() {
  if (Qu) return Di;
  Qu = 1;
  const e = Ue();
  return Di = (t, r, s) => {
    const i = new e(t, s), o = new e(r, s);
    return i.compare(o) || i.compareBuild(o);
  }, Di;
}
var Li, Zu;
function g9() {
  if (Zu) return Li;
  Zu = 1;
  const e = uc();
  return Li = (t, r) => t.sort((s, i) => e(s, i, r)), Li;
}
var xi, Ju;
function p9() {
  if (Ju) return xi;
  Ju = 1;
  const e = uc();
  return xi = (t, r) => t.sort((s, i) => e(i, s, r)), xi;
}
var Fi, em;
function ka() {
  if (em) return Fi;
  em = 1;
  const e = ut();
  return Fi = (t, r, s) => e(t, r, s) > 0, Fi;
}
var Mi, tm;
function mc() {
  if (tm) return Mi;
  tm = 1;
  const e = ut();
  return Mi = (t, r, s) => e(t, r, s) < 0, Mi;
}
var Bi, nm;
function vf() {
  if (nm) return Bi;
  nm = 1;
  const e = ut();
  return Bi = (t, r, s) => e(t, r, s) === 0, Bi;
}
var $i, rm;
function yf() {
  if (rm) return $i;
  rm = 1;
  const e = ut();
  return $i = (t, r, s) => e(t, r, s) !== 0, $i;
}
var Wi, am;
function dc() {
  if (am) return Wi;
  am = 1;
  const e = ut();
  return Wi = (t, r, s) => e(t, r, s) >= 0, Wi;
}
var Hi, sm;
function fc() {
  if (sm) return Hi;
  sm = 1;
  const e = ut();
  return Hi = (t, r, s) => e(t, r, s) <= 0, Hi;
}
var qi, im;
function Tf() {
  if (im) return qi;
  im = 1;
  const e = vf(), n = yf(), t = ka(), r = dc(), s = mc(), i = fc();
  return qi = (c, m, u, l) => {
    switch (m) {
      case "===":
        return typeof c == "object" && (c = c.version), typeof u == "object" && (u = u.version), c === u;
      case "!==":
        return typeof c == "object" && (c = c.version), typeof u == "object" && (u = u.version), c !== u;
      case "":
      case "=":
      case "==":
        return e(c, u, l);
      case "!=":
        return n(c, u, l);
      case ">":
        return t(c, u, l);
      case ">=":
        return r(c, u, l);
      case "<":
        return s(c, u, l);
      case "<=":
        return i(c, u, l);
      default:
        throw new TypeError(`Invalid operator: ${m}`);
    }
  }, qi;
}
var Gi, om;
function h9() {
  if (om) return Gi;
  om = 1;
  const e = Ue(), n = kn(), { safeRe: t, t: r } = Tr();
  return Gi = (i, o) => {
    if (i instanceof e)
      return i;
    if (typeof i == "number" && (i = String(i)), typeof i != "string")
      return null;
    o = o || {};
    let c = null;
    if (!o.rtl)
      c = i.match(o.includePrerelease ? t[r.COERCEFULL] : t[r.COERCE]);
    else {
      const E = o.includePrerelease ? t[r.COERCERTLFULL] : t[r.COERCERTL];
      let g;
      for (; (g = E.exec(i)) && (!c || c.index + c[0].length !== i.length); )
        (!c || g.index + g[0].length !== c.index + c[0].length) && (c = g), E.lastIndex = g.index + g[1].length + g[2].length;
      E.lastIndex = -1;
    }
    if (c === null)
      return null;
    const m = c[2], u = c[3] || "0", l = c[4] || "0", d = o.includePrerelease && c[5] ? `-${c[5]}` : "", f = o.includePrerelease && c[6] ? `+${c[6]}` : "";
    return n(`${m}.${u}.${l}${d}${f}`, o);
  }, Gi;
}
var Ui, cm;
function v9() {
  if (cm) return Ui;
  cm = 1;
  class e {
    constructor() {
      this.max = 1e3, this.map = /* @__PURE__ */ new Map();
    }
    get(t) {
      const r = this.map.get(t);
      if (r !== void 0)
        return this.map.delete(t), this.map.set(t, r), r;
    }
    delete(t) {
      return this.map.delete(t);
    }
    set(t, r) {
      if (!this.delete(t) && r !== void 0) {
        if (this.map.size >= this.max) {
          const i = this.map.keys().next().value;
          this.delete(i);
        }
        this.map.set(t, r);
      }
      return this;
    }
  }
  return Ui = e, Ui;
}
var Yi, lm;
function mt() {
  if (lm) return Yi;
  lm = 1;
  const e = /\s+/g;
  class n {
    constructor(S, L) {
      if (L = s(L), S instanceof n)
        return S.loose === !!L.loose && S.includePrerelease === !!L.includePrerelease ? S : new n(S.raw, L);
      if (S instanceof i)
        return this.raw = S.value, this.set = [[S]], this.formatted = void 0, this;
      if (this.options = L, this.loose = !!L.loose, this.includePrerelease = !!L.includePrerelease, this.raw = S.trim().replace(e, " "), this.set = this.raw.split("||").map((O) => this.parseRange(O.trim())).filter((O) => O.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const O = this.set[0];
        if (this.set = this.set.filter((B) => !p(B[0])), this.set.length === 0)
          this.set = [O];
        else if (this.set.length > 1) {
          for (const B of this.set)
            if (B.length === 1 && v(B[0])) {
              this.set = [B];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let S = 0; S < this.set.length; S++) {
          S > 0 && (this.formatted += "||");
          const L = this.set[S];
          for (let O = 0; O < L.length; O++)
            O > 0 && (this.formatted += " "), this.formatted += L[O].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(S) {
      const O = ((this.options.includePrerelease && E) | (this.options.loose && g)) + ":" + S, B = r.get(O);
      if (B)
        return B;
      const M = this.options.loose, G = M ? m[u.HYPHENRANGELOOSE] : m[u.HYPHENRANGE];
      S = S.replace(G, se(this.options.includePrerelease)), o("hyphen replace", S), S = S.replace(m[u.COMPARATORTRIM], l), o("comparator trim", S), S = S.replace(m[u.TILDETRIM], d), o("tilde trim", S), S = S.replace(m[u.CARETTRIM], f), o("caret trim", S);
      let H = S.split(" ").map((j) => C(j, this.options)).join(" ").split(/\s+/).map((j) => W(j, this.options));
      M && (H = H.filter((j) => (o("loose invalid filter", j, this.options), !!j.match(m[u.COMPARATORLOOSE])))), o("range list", H);
      const K = /* @__PURE__ */ new Map(), Y = H.map((j) => new i(j, this.options));
      for (const j of Y) {
        if (p(j))
          return [j];
        K.set(j.value, j);
      }
      K.size > 1 && K.has("") && K.delete("");
      const Se = [...K.values()];
      return r.set(O, Se), Se;
    }
    intersects(S, L) {
      if (!(S instanceof n))
        throw new TypeError("a Range is required");
      return this.set.some((O) => y(O, L) && S.set.some((B) => y(B, L) && O.every((M) => B.every((G) => M.intersects(G, L)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(S) {
      if (!S)
        return !1;
      if (typeof S == "string")
        try {
          S = new c(S, this.options);
        } catch {
          return !1;
        }
      for (let L = 0; L < this.set.length; L++)
        if (ue(this.set[L], S, this.options))
          return !0;
      return !1;
    }
  }
  Yi = n;
  const t = v9(), r = new t(), s = lc(), i = Da(), o = Oa(), c = Ue(), {
    safeRe: m,
    t: u,
    comparatorTrimReplace: l,
    tildeTrimReplace: d,
    caretTrimReplace: f
  } = Tr(), { FLAG_INCLUDE_PRERELEASE: E, FLAG_LOOSE: g } = Pa(), p = (N) => N.value === "<0.0.0-0", v = (N) => N.value === "", y = (N, S) => {
    let L = !0;
    const O = N.slice();
    let B = O.pop();
    for (; L && O.length; )
      L = O.every((M) => B.intersects(M, S)), B = O.pop();
    return L;
  }, C = (N, S) => (o("comp", N, S), N = D(N, S), o("caret", N), N = R(N, S), o("tildes", N), N = F(N, S), o("xrange", N), N = Te(N, S), o("stars", N), N), b = (N) => !N || N.toLowerCase() === "x" || N === "*", R = (N, S) => N.trim().split(/\s+/).map((L) => P(L, S)).join(" "), P = (N, S) => {
    const L = S.loose ? m[u.TILDELOOSE] : m[u.TILDE];
    return N.replace(L, (O, B, M, G, H) => {
      o("tilde", N, O, B, M, G, H);
      let K;
      return b(B) ? K = "" : b(M) ? K = `>=${B}.0.0 <${+B + 1}.0.0-0` : b(G) ? K = `>=${B}.${M}.0 <${B}.${+M + 1}.0-0` : H ? (o("replaceTilde pr", H), K = `>=${B}.${M}.${G}-${H} <${B}.${+M + 1}.0-0`) : K = `>=${B}.${M}.${G} <${B}.${+M + 1}.0-0`, o("tilde return", K), K;
    });
  }, D = (N, S) => N.trim().split(/\s+/).map((L) => z(L, S)).join(" "), z = (N, S) => {
    o("caret", N, S);
    const L = S.loose ? m[u.CARETLOOSE] : m[u.CARET], O = S.includePrerelease ? "-0" : "";
    return N.replace(L, (B, M, G, H, K) => {
      o("caret", N, B, M, G, H, K);
      let Y;
      return b(M) ? Y = "" : b(G) ? Y = `>=${M}.0.0${O} <${+M + 1}.0.0-0` : b(H) ? M === "0" ? Y = `>=${M}.${G}.0${O} <${M}.${+G + 1}.0-0` : Y = `>=${M}.${G}.0${O} <${+M + 1}.0.0-0` : K ? (o("replaceCaret pr", K), M === "0" ? G === "0" ? Y = `>=${M}.${G}.${H}-${K} <${M}.${G}.${+H + 1}-0` : Y = `>=${M}.${G}.${H}-${K} <${M}.${+G + 1}.0-0` : Y = `>=${M}.${G}.${H}-${K} <${+M + 1}.0.0-0`) : (o("no pr"), M === "0" ? G === "0" ? Y = `>=${M}.${G}.${H}${O} <${M}.${G}.${+H + 1}-0` : Y = `>=${M}.${G}.${H}${O} <${M}.${+G + 1}.0-0` : Y = `>=${M}.${G}.${H} <${+M + 1}.0.0-0`), o("caret return", Y), Y;
    });
  }, F = (N, S) => (o("replaceXRanges", N, S), N.split(/\s+/).map((L) => ae(L, S)).join(" ")), ae = (N, S) => {
    N = N.trim();
    const L = S.loose ? m[u.XRANGELOOSE] : m[u.XRANGE];
    return N.replace(L, (O, B, M, G, H, K) => {
      o("xRange", N, O, B, M, G, H, K);
      const Y = b(M), Se = Y || b(G), j = Se || b(H), st = j;
      return B === "=" && st && (B = ""), K = S.includePrerelease ? "-0" : "", Y ? B === ">" || B === "<" ? O = "<0.0.0-0" : O = "*" : B && st ? (Se && (G = 0), H = 0, B === ">" ? (B = ">=", Se ? (M = +M + 1, G = 0, H = 0) : (G = +G + 1, H = 0)) : B === "<=" && (B = "<", Se ? M = +M + 1 : G = +G + 1), B === "<" && (K = "-0"), O = `${B + M}.${G}.${H}${K}`) : Se ? O = `>=${M}.0.0${K} <${+M + 1}.0.0-0` : j && (O = `>=${M}.${G}.0${K} <${M}.${+G + 1}.0-0`), o("xRange return", O), O;
    });
  }, Te = (N, S) => (o("replaceStars", N, S), N.trim().replace(m[u.STAR], "")), W = (N, S) => (o("replaceGTE0", N, S), N.trim().replace(m[S.includePrerelease ? u.GTE0PRE : u.GTE0], "")), se = (N) => (S, L, O, B, M, G, H, K, Y, Se, j, st) => (b(O) ? L = "" : b(B) ? L = `>=${O}.0.0${N ? "-0" : ""}` : b(M) ? L = `>=${O}.${B}.0${N ? "-0" : ""}` : G ? L = `>=${L}` : L = `>=${L}${N ? "-0" : ""}`, b(Y) ? K = "" : b(Se) ? K = `<${+Y + 1}.0.0-0` : b(j) ? K = `<${Y}.${+Se + 1}.0-0` : st ? K = `<=${Y}.${Se}.${j}-${st}` : N ? K = `<${Y}.${Se}.${+j + 1}-0` : K = `<=${K}`, `${L} ${K}`.trim()), ue = (N, S, L) => {
    for (let O = 0; O < N.length; O++)
      if (!N[O].test(S))
        return !1;
    if (S.prerelease.length && !L.includePrerelease) {
      for (let O = 0; O < N.length; O++)
        if (o(N[O].semver), N[O].semver !== i.ANY && N[O].semver.prerelease.length > 0) {
          const B = N[O].semver;
          if (B.major === S.major && B.minor === S.minor && B.patch === S.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return Yi;
}
var ji, um;
function Da() {
  if (um) return ji;
  um = 1;
  const e = Symbol("SemVer ANY");
  class n {
    static get ANY() {
      return e;
    }
    constructor(l, d) {
      if (d = t(d), l instanceof n) {
        if (l.loose === !!d.loose)
          return l;
        l = l.value;
      }
      l = l.trim().split(/\s+/).join(" "), o("comparator", l, d), this.options = d, this.loose = !!d.loose, this.parse(l), this.semver === e ? this.value = "" : this.value = this.operator + this.semver.version, o("comp", this);
    }
    parse(l) {
      const d = this.options.loose ? r[s.COMPARATORLOOSE] : r[s.COMPARATOR], f = l.match(d);
      if (!f)
        throw new TypeError(`Invalid comparator: ${l}`);
      this.operator = f[1] !== void 0 ? f[1] : "", this.operator === "=" && (this.operator = ""), f[2] ? this.semver = new c(f[2], this.options.loose) : this.semver = e;
    }
    toString() {
      return this.value;
    }
    test(l) {
      if (o("Comparator.test", l, this.options.loose), this.semver === e || l === e)
        return !0;
      if (typeof l == "string")
        try {
          l = new c(l, this.options);
        } catch {
          return !1;
        }
      return i(l, this.operator, this.semver, this.options);
    }
    intersects(l, d) {
      if (!(l instanceof n))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new m(l.value, d).test(this.value) : l.operator === "" ? l.value === "" ? !0 : new m(this.value, d).test(l.semver) : (d = t(d), d.includePrerelease && (this.value === "<0.0.0-0" || l.value === "<0.0.0-0") || !d.includePrerelease && (this.value.startsWith("<0.0.0") || l.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && l.operator.startsWith(">") || this.operator.startsWith("<") && l.operator.startsWith("<") || this.semver.version === l.semver.version && this.operator.includes("=") && l.operator.includes("=") || i(this.semver, "<", l.semver, d) && this.operator.startsWith(">") && l.operator.startsWith("<") || i(this.semver, ">", l.semver, d) && this.operator.startsWith("<") && l.operator.startsWith(">")));
    }
  }
  ji = n;
  const t = lc(), { safeRe: r, t: s } = Tr(), i = Tf(), o = Oa(), c = Ue(), m = mt();
  return ji;
}
var Vi, mm;
function La() {
  if (mm) return Vi;
  mm = 1;
  const e = mt();
  return Vi = (t, r, s) => {
    try {
      r = new e(r, s);
    } catch {
      return !1;
    }
    return r.test(t);
  }, Vi;
}
var Ki, dm;
function y9() {
  if (dm) return Ki;
  dm = 1;
  const e = mt();
  return Ki = (t, r) => new e(t, r).set.map((s) => s.map((i) => i.value).join(" ").trim().split(" ")), Ki;
}
var zi, fm;
function T9() {
  if (fm) return zi;
  fm = 1;
  const e = Ue(), n = mt();
  return zi = (r, s, i) => {
    let o = null, c = null, m = null;
    try {
      m = new n(s, i);
    } catch {
      return null;
    }
    return r.forEach((u) => {
      m.test(u) && (!o || c.compare(u) === -1) && (o = u, c = new e(o, i));
    }), o;
  }, zi;
}
var Xi, Em;
function C9() {
  if (Em) return Xi;
  Em = 1;
  const e = Ue(), n = mt();
  return Xi = (r, s, i) => {
    let o = null, c = null, m = null;
    try {
      m = new n(s, i);
    } catch {
      return null;
    }
    return r.forEach((u) => {
      m.test(u) && (!o || c.compare(u) === 1) && (o = u, c = new e(o, i));
    }), o;
  }, Xi;
}
var Qi, _m;
function R9() {
  if (_m) return Qi;
  _m = 1;
  const e = Ue(), n = mt(), t = ka();
  return Qi = (s, i) => {
    s = new n(s, i);
    let o = new e("0.0.0");
    if (s.test(o) || (o = new e("0.0.0-0"), s.test(o)))
      return o;
    o = null;
    for (let c = 0; c < s.set.length; ++c) {
      const m = s.set[c];
      let u = null;
      m.forEach((l) => {
        const d = new e(l.semver.version);
        switch (l.operator) {
          case ">":
            d.prerelease.length === 0 ? d.patch++ : d.prerelease.push(0), d.raw = d.format();
          /* fallthrough */
          case "":
          case ">=":
            (!u || t(d, u)) && (u = d);
            break;
          case "<":
          case "<=":
            break;
          /* istanbul ignore next */
          default:
            throw new Error(`Unexpected operation: ${l.operator}`);
        }
      }), u && (!o || t(o, u)) && (o = u);
    }
    return o && s.test(o) ? o : null;
  }, Qi;
}
var Zi, gm;
function b9() {
  if (gm) return Zi;
  gm = 1;
  const e = mt();
  return Zi = (t, r) => {
    try {
      return new e(t, r).range || "*";
    } catch {
      return null;
    }
  }, Zi;
}
var Ji, pm;
function Ec() {
  if (pm) return Ji;
  pm = 1;
  const e = Ue(), n = Da(), { ANY: t } = n, r = mt(), s = La(), i = ka(), o = mc(), c = fc(), m = dc();
  return Ji = (l, d, f, E) => {
    l = new e(l, E), d = new r(d, E);
    let g, p, v, y, C;
    switch (f) {
      case ">":
        g = i, p = c, v = o, y = ">", C = ">=";
        break;
      case "<":
        g = o, p = m, v = i, y = "<", C = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (s(l, d, E))
      return !1;
    for (let b = 0; b < d.set.length; ++b) {
      const R = d.set[b];
      let P = null, D = null;
      if (R.forEach((z) => {
        z.semver === t && (z = new n(">=0.0.0")), P = P || z, D = D || z, g(z.semver, P.semver, E) ? P = z : v(z.semver, D.semver, E) && (D = z);
      }), P.operator === y || P.operator === C || (!D.operator || D.operator === y) && p(l, D.semver))
        return !1;
      if (D.operator === C && v(l, D.semver))
        return !1;
    }
    return !0;
  }, Ji;
}
var eo, hm;
function w9() {
  if (hm) return eo;
  hm = 1;
  const e = Ec();
  return eo = (t, r, s) => e(t, r, ">", s), eo;
}
var to, vm;
function A9() {
  if (vm) return to;
  vm = 1;
  const e = Ec();
  return to = (t, r, s) => e(t, r, "<", s), to;
}
var no, ym;
function S9() {
  if (ym) return no;
  ym = 1;
  const e = mt();
  return no = (t, r, s) => (t = new e(t, s), r = new e(r, s), t.intersects(r, s)), no;
}
var ro, Tm;
function I9() {
  if (Tm) return ro;
  Tm = 1;
  const e = La(), n = ut();
  return ro = (t, r, s) => {
    const i = [];
    let o = null, c = null;
    const m = t.sort((f, E) => n(f, E, s));
    for (const f of m)
      e(f, r, s) ? (c = f, o || (o = f)) : (c && i.push([o, c]), c = null, o = null);
    o && i.push([o, null]);
    const u = [];
    for (const [f, E] of i)
      f === E ? u.push(f) : !E && f === m[0] ? u.push("*") : E ? f === m[0] ? u.push(`<=${E}`) : u.push(`${f} - ${E}`) : u.push(`>=${f}`);
    const l = u.join(" || "), d = typeof r.raw == "string" ? r.raw : String(r);
    return l.length < d.length ? l : r;
  }, ro;
}
var ao, Cm;
function N9() {
  if (Cm) return ao;
  Cm = 1;
  const e = mt(), n = Da(), { ANY: t } = n, r = La(), s = ut(), i = (d, f, E = {}) => {
    if (d === f)
      return !0;
    d = new e(d, E), f = new e(f, E);
    let g = !1;
    e: for (const p of d.set) {
      for (const v of f.set) {
        const y = m(p, v, E);
        if (g = g || y !== null, y)
          continue e;
      }
      if (g)
        return !1;
    }
    return !0;
  }, o = [new n(">=0.0.0-0")], c = [new n(">=0.0.0")], m = (d, f, E) => {
    if (d === f)
      return !0;
    if (d.length === 1 && d[0].semver === t) {
      if (f.length === 1 && f[0].semver === t)
        return !0;
      E.includePrerelease ? d = o : d = c;
    }
    if (f.length === 1 && f[0].semver === t) {
      if (E.includePrerelease)
        return !0;
      f = c;
    }
    const g = /* @__PURE__ */ new Set();
    let p, v;
    for (const F of d)
      F.operator === ">" || F.operator === ">=" ? p = u(p, F, E) : F.operator === "<" || F.operator === "<=" ? v = l(v, F, E) : g.add(F.semver);
    if (g.size > 1)
      return null;
    let y;
    if (p && v) {
      if (y = s(p.semver, v.semver, E), y > 0)
        return null;
      if (y === 0 && (p.operator !== ">=" || v.operator !== "<="))
        return null;
    }
    for (const F of g) {
      if (p && !r(F, String(p), E) || v && !r(F, String(v), E))
        return null;
      for (const ae of f)
        if (!r(F, String(ae), E))
          return !1;
      return !0;
    }
    let C, b, R, P, D = v && !E.includePrerelease && v.semver.prerelease.length ? v.semver : !1, z = p && !E.includePrerelease && p.semver.prerelease.length ? p.semver : !1;
    D && D.prerelease.length === 1 && v.operator === "<" && D.prerelease[0] === 0 && (D = !1);
    for (const F of f) {
      if (P = P || F.operator === ">" || F.operator === ">=", R = R || F.operator === "<" || F.operator === "<=", p) {
        if (z && F.semver.prerelease && F.semver.prerelease.length && F.semver.major === z.major && F.semver.minor === z.minor && F.semver.patch === z.patch && (z = !1), F.operator === ">" || F.operator === ">=") {
          if (C = u(p, F, E), C === F && C !== p)
            return !1;
        } else if (p.operator === ">=" && !r(p.semver, String(F), E))
          return !1;
      }
      if (v) {
        if (D && F.semver.prerelease && F.semver.prerelease.length && F.semver.major === D.major && F.semver.minor === D.minor && F.semver.patch === D.patch && (D = !1), F.operator === "<" || F.operator === "<=") {
          if (b = l(v, F, E), b === F && b !== v)
            return !1;
        } else if (v.operator === "<=" && !r(v.semver, String(F), E))
          return !1;
      }
      if (!F.operator && (v || p) && y !== 0)
        return !1;
    }
    return !(p && R && !v && y !== 0 || v && P && !p && y !== 0 || z || D);
  }, u = (d, f, E) => {
    if (!d)
      return f;
    const g = s(d.semver, f.semver, E);
    return g > 0 ? d : g < 0 || f.operator === ">" && d.operator === ">=" ? f : d;
  }, l = (d, f, E) => {
    if (!d)
      return f;
    const g = s(d.semver, f.semver, E);
    return g < 0 ? d : g > 0 || f.operator === "<" && d.operator === "<=" ? f : d;
  };
  return ao = i, ao;
}
var so, Rm;
function P9() {
  if (Rm) return so;
  Rm = 1;
  const e = Tr(), n = Pa(), t = Ue(), r = hf(), s = kn(), i = i9(), o = o9(), c = c9(), m = l9(), u = u9(), l = m9(), d = d9(), f = f9(), E = ut(), g = E9(), p = _9(), v = uc(), y = g9(), C = p9(), b = ka(), R = mc(), P = vf(), D = yf(), z = dc(), F = fc(), ae = Tf(), Te = h9(), W = Da(), se = mt(), ue = La(), N = y9(), S = T9(), L = C9(), O = R9(), B = b9(), M = Ec(), G = w9(), H = A9(), K = S9(), Y = I9(), Se = N9();
  return so = {
    parse: s,
    valid: i,
    clean: o,
    inc: c,
    diff: m,
    major: u,
    minor: l,
    patch: d,
    prerelease: f,
    compare: E,
    rcompare: g,
    compareLoose: p,
    compareBuild: v,
    sort: y,
    rsort: C,
    gt: b,
    lt: R,
    eq: P,
    neq: D,
    gte: z,
    lte: F,
    cmp: ae,
    coerce: Te,
    Comparator: W,
    Range: se,
    satisfies: ue,
    toComparators: N,
    maxSatisfying: S,
    minSatisfying: L,
    minVersion: O,
    validRange: B,
    outside: M,
    gtr: G,
    ltr: H,
    intersects: K,
    simplifyRange: Y,
    subset: Se,
    SemVer: t,
    re: e.re,
    src: e.src,
    tokens: e.t,
    SEMVER_SPEC_VERSION: n.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: n.RELEASE_TYPES,
    compareIdentifiers: r.compareIdentifiers,
    rcompareIdentifiers: r.rcompareIdentifiers
  }, so;
}
var O9 = P9();
const Gr = /* @__PURE__ */ Rd(O9), k9 = "13.9.0", D9 = "5.4.0", L9 = () => (document.cookie || "").split(";").map((e) => e.split("=").map((n) => n.trim())).reduce(
  (e, [n, t]) => (e[n] = t, e),
  {}
), x9 = () => {
  const n = L9().wh_device || "{}", { app_version: t, device_os: r } = JSON.parse(
    n.replace('"false"', "false").replace('"true"', "true")
  );
  return { appVersion: t, deviceOs: r };
}, bm = (e, n) => {
  const { min: t, max: r } = n, s = Gr.coerce(e), i = Gr.valid(s) || "", o = Gr.validRange(`${t || "*"} - ${r || "*"}`) || "";
  return Gr.satisfies(i, o);
}, F9 = (e, n) => e === To.IOS ? bm(n, {
  min: k9,
  max: "*"
}) : e === To.ANDROID ? bm(n, {
  min: D9,
  max: "*"
}) : !1, M9 = ({ channel: e }, n) => {
  if (!e)
    return "";
  const { appVersion: t, deviceOs: r } = x9();
  return F9(r, t) ? `whsbkh://?action=openTV&channelId=${e}` : `whsbkh://?action=openTV&streamUrl=${encodeURIComponent(n[e])}`;
}, B9 = (e, n, t) => !e || !n.isChannelFree ? "" : n.channel ? M9(n, t) : "", $9 = () => {
  if (typeof document == "object") {
    const e = document.querySelector("#main-container");
    e == null || e.scrollIntoView(!0), e == null || e.scrollTo(0, 0);
  }
}, W9 = ({
  children: e,
  withScrollTop: n,
  onStreamingToggled: t,
  source: r,
  clickSource: s
}) => {
  const {
    env: { platform: i }
  } = V(), { streamingUrlsConfig: o } = v_(), c = q(), { streaming: m } = c, u = cc(), l = yr();
  if (!o)
    return null;
  const d = () => {
    Ny({ streaming: m, source: r }), u && (Yy(
      i,
      m,
      t,
      s,
      !!(l != null && l.obAccountNumber)
    ), n && $9());
  }, f = B9(
    Ia(i),
    m,
    o
  );
  return /* @__PURE__ */ a.createElement("span", { className: "compnent-streaming-anchor", "data-testid": "streaming-anchor" }, f ? /* @__PURE__ */ a.createElement(
    "a",
    {
      href: f,
      className: J(
        "non-route",
        "streaming-anchor",
        s9.btvNativeAnchor
      )
    },
    e
  ) : /* @__PURE__ */ a.createElement(
    "span",
    {
      className: "streaming-anchor",
      onClick: d,
      role: "presentation"
    },
    e
  ));
}, H9 = "ngs-meetings__StreamingPlayerButton__streamingOpen__a2EPk", q9 = "ngs-meetings__StreamingPlayerButton__streamingClosed__a2EPk", G9 = "ngs-meetings__StreamingPlayerButton__nextRaceStreaming__a2EPk", io = {
  streamingOpen: H9,
  streamingClosed: q9,
  nextRaceStreaming: G9
}, U9 = ({
  isPlayerOpened: e,
  isRacecardPage: n
}) => {
  const t = tt(), r = () => n ? e ? "#FFF" : "#23985D" : e ? "#000" : "#23985D", s = () => n ? e ? io.streamingOpen : io.streamingClosed : io.nextRaceStreaming;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Qt, { size: 16, color: r() }), /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: s() }, t ? Oe.WATCH_RACE : Oe.WATCH_FOR_FREE));
}, Y9 = (e, n) => e.streaming.free ? Oe.WATCH_FOR_FREE : ff(e, n) ? Oe.WATCH_THE_RACE_LIVE : Oe.BET_TO_WATCH, j9 = (e, n, t, r = !1) => {
  const s = Jy(
    n.streaming.channel,
    e
  );
  return s || (r ? Y9(n, t) : n.streaming.free ? Oe.LOGIN_TO_WATCH_FOR_FREE : Oe.BET_TO_WATCH);
}, oo = (e) => !!(e != null && e.obAccountNumber), V9 = ({
  onStreamingToggled: e,
  isRacecardPage: n = !1,
  className: t
}) => {
  const r = q(), {
    env: { locale: s, platform: i }
  } = V(), o = yr(), c = pf().data, m = cc(), [u, l] = ee(
    oo(o) && wo(r)
  ), [d, f] = ee(null);
  te(() => {
    const g = or(
      rt.FREE_TV_CHANNEL_CHANGED,
      (p, v) => {
        f(v);
      }
    );
    return () => cr(g);
  }, []), te(() => {
    if (!(r.streaming.rmg ?? !1)) {
      const p = wo(r);
      l(oo(o) && p);
    }
  }, [u, o, r]), te(() => {
    (r.streaming.rmg ?? !1) || l(df(d));
  }, [d, r]);
  const E = () => {
    l((g) => !g), !(o != null && o.obAccountNumber) && r.streaming.channel === ze.SAS_STREAMING && _f(Ia(i), s, mf(i));
  };
  return m ? /* @__PURE__ */ a.createElement(
    ke,
    {
      variant: "ghost",
      className: J(
        Hr.button,
        t,
        u && Hr.active
      ),
      size: "large",
      onClick: E,
      "data-testid": "streaming-button"
    },
    /* @__PURE__ */ a.createElement(
      W9,
      {
        onStreamingToggled: e,
        source: "Racecard",
        clickSource: "Racecard"
      },
      /* @__PURE__ */ a.createElement("div", { className: Hr.container }, /* @__PURE__ */ a.createElement(
        U9,
        {
          isPlayerOpened: u,
          isRacecardPage: n
        }
      ))
    )
  ) : /* @__PURE__ */ a.createElement(
    ke,
    {
      variant: "ghost",
      className: J(Hr.button, t),
      size: "large",
      onClick: E
    },
    /* @__PURE__ */ a.createElement(Qt, { size: 16, color: u ? "#FFF" : "#23985D" }),
    /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, j9(
      Gy(i),
      r,
      c,
      oo(o)
    ))
  );
}, K9 = {}, z9 = () => {
  const e = q(), { services: n } = _e(), { btvStreamingAnalyticsConfig: t } = y_(), {
    params: { sport: r }
  } = V();
  return te(() => {
    const s = Qy(
      e.id,
      { channel: e.streaming.channel, free: e.streaming.free },
      r,
      t,
      n.streaming.baseUrl
    );
    return s == null || s.play(), () => {
      s == null || s.destroy();
    };
  }, [
    e.id,
    e.streaming.channel,
    e.streaming.free,
    r,
    n.streaming.baseUrl,
    t
  ]), /* @__PURE__ */ a.createElement("div", { className: K9.container, id: Na });
}, X9 = "ngs-meetings__RMGStreamingPlayer__playerStatus__0X6BF", Q9 = "ngs-meetings__RMGStreamingPlayer__spinner__0X6BF", ht = {
  playerStatus: X9,
  spinner: Q9
}, Z9 = () => /* @__PURE__ */ a.createElement("div", { className: J(ht.playerStatus, ht.playerLoading) }, /* @__PURE__ */ a.createElement(Qm, { className: ht.spinner, size: 26 }), Oe.LOADING), J9 = () => {
  const { refetch: e } = oc();
  return /* @__PURE__ */ a.createElement("div", { className: J(ht.playerStatus, ht.playerError) }, /* @__PURE__ */ a.createElement(FE, { size: 32 }), /* @__PURE__ */ a.createElement("span", null, Oe.COMMON_ERROR), /* @__PURE__ */ a.createElement(ke, { onClick: () => e() }, /* @__PURE__ */ a.createElement(ME, { size: 14 }), " Reload"));
}, eT = () => /* @__PURE__ */ a.createElement("div", { className: J(ht.playerStatus, ht.playerNotStarted) }, /* @__PURE__ */ a.createElement(aa, { size: 32 }), /* @__PURE__ */ a.createElement("span", null, Oe.PREVIEW_FROM_8PM)), tT = () => {
  const { isBalanceRequired: e, isGeoBlocked: n, isNotLoggedIn: t } = gf();
  return /* @__PURE__ */ a.createElement("div", { className: J(ht.playerStatus, ht.playerBlocked) }, e && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(aa, { size: 32 }), /* @__PURE__ */ a.createElement("span", null, Oe.BALANCE_REQUIRED)), n && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(BE, { size: 32 }), /* @__PURE__ */ a.createElement("span", null, Oe.GEO_BLOCKED)), t && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement($E, { size: 32 }), /* @__PURE__ */ a.createElement("span", null, Oe.LOG_IN)));
}, nT = () => {
  const e = Ft(!1), {
    env: { platform: n }
  } = V(), t = yr(), { data: r } = oc();
  return te(() => {
    e.current || (e.current = Xy(
      uf(n),
      r,
      t == null ? void 0 : t.obAccountNumber
    ));
  }, [n, r, t]), /* @__PURE__ */ a.createElement("div", { className: ht.rmgStreamingPlayer, id: Ef });
}, rT = () => {
  const { isStarted: e, isLoading: n, isError: t, isBlocked: r, isNotStarted: s } = gf();
  return t ? /* @__PURE__ */ a.createElement(J9, null) : n ? /* @__PURE__ */ a.createElement(Z9, null) : r ? /* @__PURE__ */ a.createElement(tT, null) : s ? /* @__PURE__ */ a.createElement(eT, null) : e ? /* @__PURE__ */ a.createElement(nT, null) : null;
}, aT = pE(() => {
  const { streaming: e } = q(), { rmg: n } = e;
  return n ? /* @__PURE__ */ a.createElement(rT, null) : /* @__PURE__ */ a.createElement(z9, null);
}), sT = () => {
  const [e, n] = ee(!1), t = cc();
  return [e, () => {
    e ? n(!1) : t && n(!e);
  }];
}, iT = ({
  eventId: e,
  streamType: n
}) => {
  const { services: t } = _e();
  return te(() => {
    const r = Zy(
      e,
      n,
      t.streaming.baseUrl
    );
    return r == null || r.play(), () => {
      r == null || r.destroy();
    };
  }, [e, n, t.streaming]), /* @__PURE__ */ a.createElement("div", { id: Na });
}, oT = "ngs-meetings__WatchRacingReplayButton__button__6Nmxr", cT = "ngs-meetings__WatchRacingReplayButton__active__6Nmxr", lT = "ngs-meetings__WatchRacingReplayButton__container__6Nmxr", uT = "ngs-meetings__WatchRacingReplayButton__replayOpen__6Nmxr", mT = "ngs-meetings__WatchRacingReplayButton__replayClosed__6Nmxr", dT = "ngs-meetings__WatchRacingReplayButton__replayPending__6Nmxr", fT = "ngs-meetings__WatchRacingReplayButton__replayIconOpen__6Nmxr", ET = "ngs-meetings__WatchRacingReplayButton__replayIconClosed__6Nmxr", _T = "ngs-meetings__WatchRacingReplayButton__replayIconPending__6Nmxr", wt = {
  button: oT,
  active: cT,
  container: lT,
  replayOpen: uT,
  replayClosed: mT,
  replayPending: dT,
  replayIconOpen: fT,
  replayIconClosed: ET,
  replayIconPending: _T
}, gT = ({
  isPlayerOpened: e,
  onReplayToggleHandler: n
}) => {
  const {
    env: { locale: t, platform: r }
  } = V(), {
    isAvailable: s,
    isError: i,
    hasNoData: o
  } = r9(), c = yr(), m = () => {
    _f(Ia(r), t, mf(r));
  }, u = () => s ? e ? wt.replayIconOpen : wt.replayIconClosed : wt.replayIconPending, l = () => s ? e ? wt.replayOpen : wt.replayClosed : wt.replayPending, d = () => i || o ? Oe.REPLAY_NOT_AVAILABLE : s ? Oe.WATCH_RACE_REPLAY : Oe.REPLAY_PENDING;
  return /* @__PURE__ */ a.createElement(
    ke,
    {
      variant: "ghost",
      className: J(wt.button, e && wt.active),
      disabled: !s || i || o,
      size: "large",
      onClick: c != null && c.obAccountNumber ? n : m
    },
    /* @__PURE__ */ a.createElement("div", { className: wt.container }, /* @__PURE__ */ a.createElement(Qt, { size: 16, className: u() }), /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary", className: l() }, d()))
  );
}, Cf = ({
  event: e,
  racingPostColor: n,
  isRacecardPage: t
}) => {
  var g;
  const r = Ae(), s = e.streaming.rmg, i = tt(), [o, c] = sT(), [m, u] = ee(!1), l = Ky(
    e.streaming,
    e.settled
  ), { ambassadorContent: d } = q(), f = () => {
    o || ve("Watch preview & race", r), c();
  }, E = () => {
    m || O_(), u((p) => !p);
  };
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: $r.buttonsContainer }, (((g = e.race) == null ? void 0 : g.overview) || !!d) && /* @__PURE__ */ a.createElement(
    vy,
    {
      racingPostOverview: e.race.overview,
      ambassadorContent: d || null
    },
    /* @__PURE__ */ a.createElement(
      ke,
      {
        size: "large",
        variant: "ghost",
        onClick: () => ve("Racing Post & More", r),
        className: $r.button,
        "data-testid": "race-overview-button"
      },
      /* @__PURE__ */ a.createElement(Cy, { color: n })
    )
  ), l && /* @__PURE__ */ a.createElement(
    V9,
    {
      className: $r.button,
      onStreamingToggled: f,
      isRacecardPage: t
    }
  ), !i && e.settled && /* @__PURE__ */ a.createElement(
    gT,
    {
      isPlayerOpened: m,
      onReplayToggleHandler: E
    }
  )), m && /* @__PURE__ */ a.createElement(iT, { eventId: e.id, streamType: "FULL_RACE" }), o && (s || e.streaming.channel === ze.SAS_STREAMING) && /* @__PURE__ */ a.createElement("div", { className: $r.playerContainer }, /* @__PURE__ */ a.createElement(aT, null)));
}, gI = Ut(pT, {
  Loader: Zd
});
function pT() {
  const e = Ae();
  te(() => {
    sd(e);
  }, [e]);
  const n = q(), t = Xe((s) => s.activeCompetition), r = qg(n.id, t);
  return /* @__PURE__ */ a.createElement("div", { className: Qd.container, "data-testid": "race-event-header" }, /* @__PURE__ */ a.createElement(_a, null, /* @__PURE__ */ a.createElement(Ta, { event: n, raceNumber: r, isRacecardPage: !0 }, /* @__PURE__ */ a.createElement(
    pr,
    {
      startDateTime: n.startDateTime,
      isInPlay: n.isInPlay,
      settled: n.settled
    }
  )), /* @__PURE__ */ a.createElement(
    Cf,
    {
      event: n,
      racingPostColor: "#FFF",
      isRacecardPage: !0
    }
  )));
}
const hT = (e) => {
  const [n, t] = ee({
    isEnabled: !1,
    variables: {}
  });
  return te(() => {
    lt(rt.GET_FEATURE_FLAG, {
      featureKey: e,
      callback: t
    });
  }, [e]), n;
}, wm = [
  h.WIN,
  h.GH_WIN
], Rf = (e, n) => {
  const { isEnabled: t } = hT("hr_bet_builder"), { byoFreedomEnabled: r } = n, s = t && r;
  return A(() => [
    kr[h.ALL_MARKETS],
    ...s ? [kr[h.BET_BUILDER]] : [],
    ...e.filter((i) => !wm.includes(i.name)).map((i) => kr[i.name] ?? null).filter((i) => !!i),
    ...e.filter((i) => wm.includes(i.name)).map((i) => kr[i.name] ?? null).filter((i) => !!i)
  ], [s, e]);
}, vT = "ngs-meetings__TabLabel__tabLabel__ejtpY", yT = {
  tabLabel: vT
}, bf = ({ children: e }) => /* @__PURE__ */ a.createElement("span", { className: yT.tabLabel }, e), pI = Ut(TT, {
  Loader: () => /* @__PURE__ */ a.createElement(
    s_,
    {
      count: 5,
      height: "1.75rem",
      minWidth: "6rem",
      maxWidth: "9rem"
    }
  )
});
function TT() {
  const { params: e, navigateToEvent: n, getLinkForEvent: t } = V(), r = q(), { marketCollections: s } = Qe(), i = Rf(s, r);
  if (r.isInPlay || r.settled)
    return e.marketSlug != null && n(r.id, r.slug), null;
  const o = (c) => {
    ve(c, e.sport), n(r.id, r.slug, X[c]);
  };
  return /* @__PURE__ */ a.createElement(
    It,
    {
      value: e.marketSlug ?? X[h.ALL_MARKETS]
    },
    /* @__PURE__ */ a.createElement(Nt, { variant: "chevron" }, i.map(({ name: c, slug: m, isNew: u }) => /* @__PURE__ */ a.createElement(
      Pt,
      {
        variant: "chevron",
        value: m,
        key: c,
        link: t(r.id, r.slug, m),
        onClick: () => o(c),
        style: {}
      },
      u ? /* @__PURE__ */ a.createElement("span", null, c, " ", /* @__PURE__ */ a.createElement(bf, null, "New")) : c
    )))
  );
}
function CT(e, n, t, r) {
  const s = `collapsibleOpenState:${n}:${t}:${e}`, [i, o] = ee(() => {
    try {
      const m = localStorage.getItem(
        `collapsibleOpenState:${n}:${t}:${e}`
      );
      return m !== null ? m === "true" : r;
    } catch {
      return r;
    }
  });
  te(() => {
    try {
      const m = localStorage.getItem(s);
      m !== null && o(m === "true");
    } catch {
    }
  }, [s]);
  const c = Pe(
    (m) => {
      o(m);
      try {
        localStorage.setItem(s, String(m));
      } catch {
      }
    },
    [s]
  );
  return {
    defaultOpen: i,
    onOpenChange: c
  };
}
const Ze = ({
  Component: e,
  name: n,
  defaultOpen: t,
  collapsible: r = !0
}) => {
  const s = V(), { sport: i } = s.params, { defaultOpen: o, onOpenChange: c } = CT(
    n,
    i,
    "raceAllMarkets",
    t
  );
  return /* @__PURE__ */ a.createElement(
    e,
    {
      collapsible: r,
      defaultOpen: o,
      onOpenChange: c
    }
  );
}, RT = "ngs-meetings__RaceCardRowBasic__raceCardRow__P6D1V", bT = "ngs-meetings__RaceCardRowBasic__raceCardInfo__P6D1V", wT = "ngs-meetings__RaceCardRowBasic__raceCardNumber__P6D1V", AT = "ngs-meetings__RaceCardRowBasic__raceCardTitle__P6D1V", Ur = {
  raceCardRow: RT,
  raceCardInfo: bT,
  raceCardNumber: wT,
  raceCardTitle: AT
}, ST = ({
  runnerNum: e,
  title: n,
  active: t,
  children: r,
  greyhoundsRegionType: s,
  remWidth: i
}) => /* @__PURE__ */ a.createElement("div", { className: Ur.raceCardRow }, /* @__PURE__ */ a.createElement(
  "div",
  {
    className: Ur.raceCardInfo,
    style: { minWidth: i && `${i}rem` }
  },
  tt() ? /* @__PURE__ */ a.createElement(
    Nn,
    {
      runnerNum: e,
      greyhoundsRegionType: s,
      active: t
    }
  ) : /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary", className: Ur.raceCardNumber }, e),
  /* @__PURE__ */ a.createElement(T, { variant: "captionPrimary", className: Ur.raceCardTitle }, n)
), r), wf = ko(
  {}
), Af = () => {
  const e = Do(wf);
  if (!e)
    throw new Error(
      "useExpandAllItems must be used within a ExpandAllItemsProvider"
    );
  return e;
}, _c = () => {
  const { allExpanded: e, toggleAll: n } = Af(), t = Ae(), r = (s) => {
    ve(`Show form for all runners ${s ? "On" : "Off"}`, t), n(s);
  };
  return /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        padding: "0.75rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ a.createElement(T, { "data-testid": "expand-all-items-text" }, "Show form for all runners"),
    /* @__PURE__ */ a.createElement(
      ZE,
      {
        checked: e,
        onCheckedChange: r,
        "data-testid": "expand-all-items-toggle"
      }
    )
  );
}, IT = () => {
  const [e, n] = ee({}), t = A(() => {
    const o = Object.values(e), c = o.length, m = o.filter(Boolean).length;
    return c > 0 && m === c;
  }, [e]), r = Pe((o) => {
    n((c) => ({
      ...c,
      [o]: c[o] ?? !1
    }));
  }, []), s = Pe((o) => {
    n(
      (c) => o in c ? { ...c, [o]: !c[o] } : c
    );
  }, []), i = Pe((o) => {
    n(
      (c) => Object.entries(c).reduce(
        (m, [u]) => ({ ...m, [u]: o }),
        {}
      )
    );
  }, []);
  return A(
    () => ({
      expandedItems: e,
      toggleItem: s,
      registerItem: r,
      allExpanded: t,
      toggleAll: i
    }),
    [e, s, r, t, i]
  );
}, NT = ({
  children: e
}) => /* @__PURE__ */ a.createElement(wf.Provider, { value: IT() }, e);
function PT(e) {
  return (n) => /* @__PURE__ */ a.createElement(NT, null, /* @__PURE__ */ a.createElement(e, { ...n }));
}
const OT = "ngs-meetings__RacingPostOverview__stats__5F54z", kT = "ngs-meetings__RacingPostOverview__rating__5F54z", DT = "ngs-meetings__RacingPostOverview__maxRating__5F54z", LT = "ngs-meetings__RacingPostOverview__racingPost__5F54z", xT = "ngs-meetings__RacingPostOverview__overview__5F54z", zn = {
  stats: OT,
  rating: kT,
  maxRating: DT,
  racingPost: LT,
  overview: xT
}, FT = ({ runner: e }) => {
  const {
    overview: n,
    weightS: t,
    weightP: r,
    daysSinceRun: s,
    age: i,
    rpRating: o,
    maxRpRating: c
  } = e;
  return /* @__PURE__ */ a.createElement(JE, null, /* @__PURE__ */ a.createElement("div", { className: zn.overview, "data-testid": "racing-post-overview" }, /* @__PURE__ */ a.createElement("div", { className: zn.stats, "data-testid": "racing-post-stats" }, s && /* @__PURE__ */ a.createElement(T, { variant: "captionPrimary", "data-testid": "last-race" }, "Last race:", " ", /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, s, " ", s === 1 ? "day" : "days")), t && r ? /* @__PURE__ */ a.createElement(T, { variant: "captionPrimary", "data-testid": "weight" }, "Weight:", " ", /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, t, "st ", r, "lb")) : null, i ? /* @__PURE__ */ a.createElement(T, { variant: "captionPrimary", "data-testid": "age" }, "Age: ", /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, i)) : null, o ? /* @__PURE__ */ a.createElement(T, { variant: "captionPrimary" }, "Rating: ", /* @__PURE__ */ a.createElement(
    T,
    {
      className: J(
        zn.rating,
        c && zn.maxRating
      ),
      variant: "captionSecondary"
    },
    o
  )) : null), n != "-" ? /* @__PURE__ */ a.createElement("div", { className: zn.racingPost }, /* @__PURE__ */ a.createElement(Ey, null), /* @__PURE__ */ a.createElement(T, { variant: "captionSecondary" }, n)) : null));
}, MT = "ngs-meetings__RaceCardRowEnhanced__raceCardRow__mTukI", BT = {
  raceCardRow: MT
}, $T = ({
  id: e,
  active: n,
  title: t,
  runnerNum: r,
  runner: s,
  greyhoundsRegionType: i,
  children: o,
  remWidth: c
}) => {
  const { expandedItems: m, toggleItem: u, registerItem: l } = Af(), d = m[e];
  return te(() => {
    l(e);
  }, [l, e]), /* @__PURE__ */ a.createElement(e_, { onOpenChange: () => u(e), open: d }, /* @__PURE__ */ a.createElement("div", { className: BT.raceCardRow, "data-testid": "race-card-row" }, /* @__PURE__ */ a.createElement(
    sp,
    {
      runner: s,
      title: t,
      active: n,
      runnerNum: r,
      greyhoundsRegionType: i,
      remWidth: c
    }
  ), o), s.overview ? /* @__PURE__ */ a.createElement(FT, { runner: s }) : null);
}, et = ({
  row: e,
  children: n,
  remWidth: t
}) => {
  const { runnerNum: r, title: s, selections: i, active: o } = e, { greyhoundsRegionType: c } = q(), m = Xe((u) => u.event.runners[we(e)]);
  return m ? /* @__PURE__ */ a.createElement(
    $T,
    {
      id: `${we(e)}_${i[0]}`,
      title: s,
      active: o,
      runnerNum: r,
      runner: m,
      greyhoundsRegionType: c,
      remWidth: t,
      children: n
    }
  ) : /* @__PURE__ */ a.createElement(
    ST,
    {
      runnerNum: r,
      title: s,
      active: o,
      greyhoundsRegionType: c,
      children: n,
      remWidth: t
    }
  );
}, WT = (e, n) => A(() => e ? [...n].sort((t, r) => {
  const s = t[e], i = r[e], o = s == null, c = i == null;
  return o && c ? 0 : o ? 1 : c ? -1 : s > i ? 1 : s < i ? -1 : 0;
}) : n, [e, n]);
var Ao = /* @__PURE__ */ ((e) => (e.Price = "_price", e.Card = "runnerNum", e.Draw = "_draw", e))(Ao || {});
function Yt(e, n, t) {
  const { sortableRaceCardRows: r } = qT(
    e,
    n,
    t
  ), { sortedRows: s, sortingState: i } = GT(r);
  return {
    sortedRows: s,
    sortingState: i
  };
}
function jt(e = 0, n = []) {
  return A(() => {
    const t = {};
    for (const r of n) {
      const s = we(r);
      s != null && (t[s] = r.selections[e]);
    }
    return t;
  }, [e, n]);
}
const HT = (e) => e ? Am[e] : Am.J, Am = {
  J: [
    {
      label: "Price",
      value: "_price"
      /* Price */
    },
    {
      label: "Card",
      value: "runnerNum"
      /* Card */
    }
  ],
  F: [
    {
      label: "Price",
      value: "_price"
      /* Price */
    },
    {
      label: "Card",
      value: "runnerNum"
      /* Card */
    },
    {
      label: "Draw",
      value: "_draw"
      /* Draw */
    }
  ]
}, qT = (e, n, t) => {
  const r = Sn(
    A(
      () => t.map((o) => ({
        id: o.id,
        marketId: o.marketId,
        eventId: o.eventId,
        currentPriceNum: o.currentPriceNum,
        currentPriceDen: o.currentPriceDen
      })),
      [t]
    )
  ), s = Xe((o) => o.event.runners);
  return {
    sortableRaceCardRows: A(() => {
      var c;
      const o = [];
      for (const m of e) {
        const u = we(m);
        if (u == null)
          continue;
        const l = r.find((E) => E.id === n[u]);
        let d = null;
        (l == null ? void 0 : l.currentPriceNum) != null && (l == null ? void 0 : l.currentPriceDen) != null && (l == null ? void 0 : l.currentPriceDen) !== 0 && (d = l.currentPriceNum / l.currentPriceDen);
        const f = (c = s[u]) == null ? void 0 : c.draw;
        o.push({ ...m, _price: d, _draw: f });
      }
      return o;
    }, [n, r, e, s])
  };
};
function GT(e) {
  const n = tt() ? "runnerNum" : "_price", t = ee(n), [r] = t;
  return {
    sortedRows: WT(r, e),
    sortingState: t
  };
}
const UT = "ngs-meetings__SortingSelector__container__cMH7J", YT = {
  container: UT
}, jT = (e, n, t, r) => {
  const s = `sortingPreferences_${e}`, [i, o] = r;
  return te(() => {
    const c = localStorage.getItem(
      s
    ), m = n.some((u) => u.value === c);
    o(c && m ? c : t);
  }, [n, t, s, o]), [
    i,
    (c) => {
      o(c), localStorage.setItem(s, c);
    }
  ];
}, on = ({
  sortingState: e,
  defaultValue: n,
  style: t
}) => {
  const r = Xe((d) => d.event.race), s = Ae(), i = tt(), o = HT(r.type), c = n ?? (i ? Ao.Card : Ao.Price), [m, u] = jT(
    s,
    o,
    c,
    e
  ), l = (d) => {
    var f;
    ve(
      `Sort by: ${(f = o.find((E) => E.value === d)) == null ? void 0 : f.label}`,
      s
    ), u(d);
  };
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      className: YT.container,
      style: t,
      "data-testid": "sorting-selector"
    },
    /* @__PURE__ */ a.createElement(
      i_,
      {
        value: m,
        defaultValue: c,
        onValueChange: (d) => l(d),
        title: "Sort by",
        trigger: o_,
        options: o
      }
    )
  );
}, VT = "ngs-meetings__MultipleOdds__multipleOdds__LtDK6", KT = {
  multipleOdds: VT
}, xa = ({
  row: e,
  bettingOpportunities: n
}) => {
  const { selections: t } = e;
  return t.length === 0 ? null : /* @__PURE__ */ a.createElement("div", { className: KT.multipleOdds, "data-testid": "multiple-odds" }, t.map((r) => /* @__PURE__ */ a.createElement(vr, { key: r, selectionId: r }, (s) => {
    var o;
    return ((o = n == null ? void 0 : n.find(
      (c) => c.marketId === s.marketId
    )) == null ? void 0 : o.type) === Ko.STARTING_PRICE ? zo : void 0;
  })));
}, zT = "ngs-meetings__SyncScrollable__scrollable__LS0Io", Sf = {
  scrollable: zT
}, Kr = "scrollable-id", co = {}, XT = (e = 8, n = 500) => {
  let t = 0, r = 0, s = [], i = 0;
  return ({ target: o }) => {
    const c = o;
    if (co[c.getAttribute(Kr)]) {
      delete co[c.getAttribute(Kr)];
      return;
    }
    t = c.scrollLeft;
    const m = (/* @__PURE__ */ new Date()).getTime();
    m - r < e || (r = m, m - i > n && (s = Array.from(
      document.getElementsByClassName(Sf.scrollable)
    ), i = m), s.forEach((u) => {
      u !== c && (co[u.getAttribute(Kr)] = !0, u.scrollLeft = t);
    }));
  };
};
let QT = 0;
const Wt = ({ children: e }) => {
  const n = Ft(null);
  return te(() => {
    if (!n.current)
      return;
    n.current.setAttribute(Kr, `${QT++}`);
    const t = n.current, r = XT();
    return t.addEventListener("scroll", r, { passive: !0 }), () => t.removeEventListener("scroll", r);
  }, []), /* @__PURE__ */ a.createElement("div", { ref: n, className: Sf.scrollable }, e);
}, ZT = "ngs-meetings__EWAndSortingWrapper__container__F9Z8S", Sm = {
  container: ZT
}, Dn = ({
  children: e,
  scrollable: n
}) => /* @__PURE__ */ a.createElement("div", { className: J(Sm.container, n && Sm.scrollable) }, e), JT = "ngs-meetings__SelectionWinPriceCaption__absolute__C7H9Z", eC = {
  absolute: JT
}, Fa = ({
  selectionId: e,
  className: n
}) => /* @__PURE__ */ a.createElement(
  tC,
  {
    selectionId: e,
    className: J(n, eC.absolute)
  }
), tC = ({
  selectionId: e,
  className: n
}) => {
  const t = q(), r = Qe(), s = tn(
    A(
      () => {
        var o, c, m;
        return {
          currentPriceNum: (o = r.selections[e]) == null ? void 0 : o.priceNum,
          currentPriceDen: (c = r.selections[e]) == null ? void 0 : c.priceDen,
          id: e,
          marketId: (m = r.selections[e]) == null ? void 0 : m.marketId,
          eventId: t.id
        };
      },
      [t.id, r.selections, e]
    )
  ), i = mr();
  return /* @__PURE__ */ a.createElement(
    T,
    {
      variant: "captionSecondary",
      className: n,
      "data-testid": "selection-win-price-caption"
    },
    "Win price ",
    i(s.currentPriceNum, s.currentPriceDen)
  );
}, nC = "ngs-meetings__MarketDescription__container__NLM4p", rC = "ngs-meetings__MarketDescription__icon__NLM4p", Im = {
  container: nC,
  icon: rC
}, gc = ({ children: e }) => e ? /* @__PURE__ */ a.createElement("div", { className: Im.container, "data-testid": "market-description" }, /* @__PURE__ */ a.createElement(aa, { size: 12, className: Im.icon }), /* @__PURE__ */ a.createElement(T, null, e)) : null, cn = ({
  renderToggle: e,
  children: n
}) => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(gc, null, n), /* @__PURE__ */ a.createElement(w, { theme: "light" }), e ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(_c, null), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null), aC = (e, n) => n.map(
  ({ name: t, reduction: r, from: s, to: i }) => `${e ?? t} - ${r}p reductions on bets placed between ${s} and ${i}`
), sC = "ngs-meetings__Rule4__header__As6ER", iC = "ngs-meetings__Rule4__rowsContainer__As6ER", Nm = {
  header: sC,
  rowsContainer: iC
};
function Ln({ markets: e }) {
  return !e.length || e.every((n) => {
    var t;
    return !((t = n.rule4) != null && t.length);
  }) ? null : /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("label", { className: Nm.header }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary" }, "Rule 4 Deductions")), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("div", { className: Nm.rowsContainer }, e.map((n, t) => /* @__PURE__ */ a.createElement(oC, { key: t, market: n }))));
}
function oC({ market: e }) {
  const { rule4: n, name: t } = e;
  if (!(n != null && n.length))
    return null;
  const r = aC(t, n);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, r.map((s, i) => /* @__PURE__ */ a.createElement(T, { key: i, variant: "bodyPrimary" }, s)));
}
function cC({
  marketCollection: e,
  winMarketCollection: n
}) {
  var C;
  const { raceCardTables: t, description: r, markets: s } = e, [i] = t, { raceCardRows: o } = i, { bettingOpportunities: c } = i, m = ya(n), u = A(
    () => c.slice(1),
    [c]
  ), l = jt(
    0,
    (C = n.raceCardTables[0]) == null ? void 0 : C.raceCardRows
  ), d = q(), f = Qe(), { sortedRows: E, sortingState: g } = Yt(
    o,
    l,
    A(
      () => Object.values(l).map((b) => {
        const R = f.selections[b];
        return {
          id: b,
          marketId: R.marketId,
          eventId: d.id,
          currentPriceNum: R.priceNum,
          currentPriceDen: R.priceDen
        };
      }),
      [l, d, f]
    )
  ), p = A(
    () => E.filter((b) => b.active),
    [E]
  ), v = A(
    () => E.filter((b) => !b.active),
    [E]
  ), y = kt(p);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(cn, { renderToggle: y }, r.description), /* @__PURE__ */ a.createElement(Dn, { scrollable: !0 }, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        minWidth: "13rem",
        paddingLeft: "0.25rem",
        flex: "1 0 13rem"
      }
    },
    /* @__PURE__ */ a.createElement(on, { sortingState: g })
  ), /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        gap: "0.5rem",
        paddingRight: "1rem"
      }
    },
    u.map((b) => /* @__PURE__ */ a.createElement(
      T,
      {
        key: b.marketId,
        variant: "bodyPrimary",
        style: { width: "60px", textAlign: "center" }
      },
      b.name
    ))
  ))), /* @__PURE__ */ a.createElement(w, { theme: "light" }), p.map((b) => {
    const R = we(b);
    return /* @__PURE__ */ a.createElement(Fe, { key: R }, /* @__PURE__ */ a.createElement(et, { row: b }, /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          position: "relative",
          overflow: "hidden",
          display: "flex"
        }
      },
      R && m[R] ? /* @__PURE__ */ a.createElement(
        Fa,
        {
          selectionId: m[R].selections[0]
        }
      ) : null,
      /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
        xa,
        {
          row: { ...b, selections: b.selections.slice(1) },
          bettingOpportunities: u
        }
      ))
    )), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
  }), v.length ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ln, { markets: s.slice(0, 1) }), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null);
}
function lC(...e) {
  return function(n) {
    return e.reduceRight(
      (t, r) => r(t),
      n
    );
  };
}
const uC = "ngs-meetings__MarketLoader__container__a5brH", mC = "ngs-meetings__MarketLoader__flexRow__a5brH", lo = {
  container: uC,
  flexRow: mC
};
function pc({
  collapsible: e,
  defaultOpen: n
}) {
  return /* @__PURE__ */ a.createElement("div", { className: lo.container }, e && /* @__PURE__ */ a.createElement("div", { className: lo.flexRow }, /* @__PURE__ */ a.createElement(U, { height: "1.75rem", style: { flex: 6 } }), /* @__PURE__ */ a.createElement(U, { height: "1.75rem", style: { flex: 1 } })), (!e || e && n) && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(U, { height: "3rem" }), new Array(e ? 4 : 10).fill(null).map((t, r) => /* @__PURE__ */ a.createElement("div", { key: r, className: lo.flexRow }, /* @__PURE__ */ a.createElement(U, { height: "2.5rem", style: { flex: 5 } }), /* @__PURE__ */ a.createElement(U, { height: "2.5rem", style: { flex: 2 } })))));
}
function dC(e) {
  return (n) => tc().isLoading ? /* @__PURE__ */ a.createElement(
    pc,
    {
      collapsible: n.collapsible,
      defaultOpen: n.defaultOpen
    }
  ) : /* @__PURE__ */ a.createElement(e, { ...n });
}
const nt = lC(
  Jd,
  dC,
  PT
), If = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.EACH_WAY_EXTRA
    ), s = he(
      h.WIN
    ), i = q(), o = Ae();
    return i.isInPlay || i.settled || !s || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "each-way-extra-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (c) => {
          t == null || t(c), ve(
            `${Q[h.EACH_WAY_EXTRA]} ${c ? "Expand" : "Collapse"}`,
            o
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, { icons: /* @__PURE__ */ a.createElement(WE, null) }, Q[h.EACH_WAY_EXTRA]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "each-way-extra-content" }, /* @__PURE__ */ a.createElement(
        cC,
        {
          marketCollection: r,
          winMarketCollection: s
        }
      ))
    );
  }
), fC = "ngs-meetings__AmbassadorContent__container__ewsYF", EC = "ngs-meetings__AmbassadorContent__title__ewsYF", Pm = {
  container: fC,
  title: EC
};
function _C() {
  return /* @__PURE__ */ a.createElement("div", { className: Pm.container }, /* @__PURE__ */ a.createElement(_a, null, /* @__PURE__ */ a.createElement("div", { className: Pm.title }, /* @__PURE__ */ a.createElement(U, { height: "1.75rem", style: { flex: 6 } }), /* @__PURE__ */ a.createElement(U, { height: "1.75rem", style: { flex: 1 } })), /* @__PURE__ */ a.createElement(U, { height: "8rem" })));
}
const gC = Ut(
  () => {
    const e = q();
    return e.isInPlay || e.settled || !e.ambassadorContent ? null : /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement(de, null, /* @__PURE__ */ a.createElement(fe, null, /* @__PURE__ */ a.createElement(
      af,
      {
        displayTitle: e.ambassadorContent.displayTitle
      }
    )), /* @__PURE__ */ a.createElement(Ee, { style: { margin: " 0.625rem" } }, /* @__PURE__ */ a.createElement(ef, { ambassadorContent: e.ambassadorContent }))), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
  },
  {
    Loader: _C
  }
);
function pC({
  marketCollection: e,
  winMarketCollection: n
}) {
  var y;
  const { raceCardTables: t, description: r, markets: s } = e, [i] = t, { raceCardRows: o, bettingOpportunities: c } = i, m = ya(n), u = jt(
    0,
    (y = n.raceCardTables[0]) == null ? void 0 : y.raceCardRows
  ), l = q(), d = Qe(), { sortedRows: f, sortingState: E } = Yt(
    o,
    u,
    A(
      () => Object.values(u).map((C) => {
        const b = d.selections[C];
        return {
          id: C,
          marketId: b.marketId,
          eventId: l.id,
          currentPriceNum: b.priceNum,
          currentPriceDen: b.priceDen
        };
      }),
      [u, l, d]
    )
  ), g = A(
    () => f.filter((C) => C.active),
    [f]
  ), p = A(
    () => f.filter((C) => !C.active),
    [f]
  ), v = kt(g);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(cn, { renderToggle: v }, r.description), /* @__PURE__ */ a.createElement(Dn, { scrollable: !0 }, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        minWidth: "13rem",
        paddingLeft: "0.25rem",
        flex: "1 0 13rem"
      }
    },
    /* @__PURE__ */ a.createElement(on, { sortingState: E })
  ), /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        gap: "0.5rem",
        paddingRight: "1rem"
      }
    },
    c.map((C) => /* @__PURE__ */ a.createElement(
      T,
      {
        key: C.marketId,
        variant: "bodyPrimary",
        style: { width: "60px", textAlign: "center" }
      },
      C.name
    ))
  ))), /* @__PURE__ */ a.createElement(w, { theme: "light" }), g.map((C) => {
    const b = we(C);
    return /* @__PURE__ */ a.createElement(Fe, { key: b }, /* @__PURE__ */ a.createElement(et, { row: C }, /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          position: "relative",
          overflow: "hidden",
          display: "flex"
        }
      },
      b && m[b] ? /* @__PURE__ */ a.createElement(
        Fa,
        {
          selectionId: m[b].selections[0]
        }
      ) : null,
      /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
        xa,
        {
          row: C,
          bettingOpportunities: c
        }
      ))
    )), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
  }), p.length ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ln, { markets: s.slice(0, 1) }), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null);
}
const Nf = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(h.PLACE_MARKETS), s = he(
      h.WIN
    ), i = q(), o = Ae();
    return i.isInPlay || i.settled || !s || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "place-markets-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (c) => {
          t == null || t(c), ve(
            `${Q[h.PLACE_MARKETS]} ${c ? "Expand" : "Collapse"}`,
            o
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.PLACE_MARKETS]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "place-markets-content" }, /* @__PURE__ */ a.createElement(
        pC,
        {
          marketCollection: r,
          winMarketCollection: s
        }
      ))
    );
  }
), hC = "ngs-meetings__SingleOdds__singleOdds__qzJ5D", vC = {
  singleOdds: hC
}, Ht = ({
  row: e,
  selectionIndex: n = 0,
  readonly: t,
  inPlay: r = !1,
  topLabel: s,
  bottomLabel: i,
  bettingOpportunities: o
}) => {
  const c = e.selections[n];
  if (c == null)
    return null;
  const m = r ? dy : vr;
  return /* @__PURE__ */ a.createElement("div", { className: vC.singleOdds, "data-testid": "single-odds" }, /* @__PURE__ */ a.createElement(
    m,
    {
      key: c,
      selectionId: c,
      readonly: t,
      topLabel: s,
      bottomLabel: i
    },
    (u) => {
      var d;
      return ((d = o == null ? void 0 : o.find(
        (f) => f.marketId === u.marketId
      )) == null ? void 0 : d.type) === Ko.STARTING_PRICE ? zo : void 0;
    }
  ));
};
function yC({
  marketCollection: e
}) {
  const { raceCardTables: n } = e, [t] = n, { raceCardRows: r, bettingOpportunities: s } = t, i = q(), o = Qe(), c = Sn(
    A(
      () => r.map((u) => u.selections[0]).map((u) => {
        const l = o.selections[u];
        return {
          id: u,
          marketId: l.marketId,
          eventId: i.id,
          currentPriceNum: l.priceNum,
          currentPriceDen: l.priceDen
        };
      }),
      [r, i, o]
    )
  ), m = A(() => r.slice().sort((u, l) => {
    const d = c.find(
      (p) => p.id === u.selections[0]
    ), f = c.find(
      (p) => p.id === l.selections[0]
    );
    let E = 0;
    (d == null ? void 0 : d.currentPriceNum) != null && (d == null ? void 0 : d.currentPriceDen) != null && (d == null ? void 0 : d.currentPriceDen) !== 0 && (E = d.currentPriceNum / d.currentPriceDen);
    let g = 0;
    return (f == null ? void 0 : f.currentPriceNum) != null && (f == null ? void 0 : f.currentPriceDen) != null && (f == null ? void 0 : f.currentPriceDen) !== 0 && (g = f.currentPriceNum / f.currentPriceDen), E - g;
  }), [r, c]);
  return /* @__PURE__ */ a.createElement(Jt, null, m.map((u) => /* @__PURE__ */ a.createElement(
    en,
    {
      style: { justifyContent: "space-between", paddingRight: 0 },
      key: u.selections[0]
    },
    /* @__PURE__ */ a.createElement(T, null, u.title),
    /* @__PURE__ */ a.createElement(Ht, { row: u, bettingOpportunities: s })
  )));
}
const Pf = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.YOUR_ODDS
    ), s = q(), i = Ae();
    return s.isInPlay || s.settled || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "your-odds-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (o) => {
          t == null || t(o), ve(
            `${Q[h.YOUR_ODDS]} ${o ? "Expand" : "Collapse"}`,
            i
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.YOUR_ODDS]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "your-odds-content" }, /* @__PURE__ */ a.createElement(yC, { marketCollection: r }))
    );
  }
), TC = "ngs-meetings__EachWay__container__MjoRq", CC = {
  container: TC
}, RC = ({ eachWay: e }) => {
  const [n, t] = ee(""), [r, s] = ee(""), i = rc(), { placeTerms: o } = i;
  return te(() => {
    if (o && e) {
      const [c, m] = e.match(/(^EW:.*Odds)|(\d{1}\sPlaces)/g) || [];
      if (!c || !m) {
        s(e);
        return;
      }
      s(c), t(m);
    } else
      s(e);
  }, [e, o]), /* @__PURE__ */ a.createElement("div", { className: CC.container }, /* @__PURE__ */ a.createElement(T, { "data-testid": "each-way", variant: "bodySecondary" }, r), n && /* @__PURE__ */ a.createElement("div", { "data-testid": "each-way-extra-places" }, o ? /* @__PURE__ */ a.createElement(yd, { extraPlaceTerms: i }, /* @__PURE__ */ a.createElement($t, null, /* @__PURE__ */ a.createElement(lr, null, n, /* @__PURE__ */ a.createElement(Jm, null)))) : n));
};
function bC({
  marketCollection: e
}) {
  const { raceCardTables: n, eachWay: t, markets: r } = e, [s] = n, { bettingOpportunities: i, raceCardRows: o } = s, c = jt(0, o), m = q(), u = Qe(), { sortedRows: l, sortingState: d } = Yt(
    o,
    c,
    A(
      () => Object.values(c).map((v) => {
        const y = u.selections[v];
        return {
          id: v,
          marketId: y.marketId,
          eventId: m.id,
          currentPriceNum: y.priceNum,
          currentPriceDen: y.priceDen
        };
      }),
      [c, m, u]
    )
  ), f = Gd(), E = A(
    () => l.filter((v) => v.active),
    [l]
  ), g = A(
    () => l.filter((v) => !v.active),
    [l]
  ), p = kt(E);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ca, { event: m, marketBlurb: f == null ? void 0 : f.blurb }), p ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(_c, null), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null, /* @__PURE__ */ a.createElement(Dn, null, /* @__PURE__ */ a.createElement(RC, { eachWay: t }), /* @__PURE__ */ a.createElement(
    on,
    {
      sortingState: d,
      style: { paddingRight: "0.25rem" }
    }
  )), /* @__PURE__ */ a.createElement(w, { theme: "light" }), E.map((v) => /* @__PURE__ */ a.createElement(Fe, { key: we(v) }, /* @__PURE__ */ a.createElement(et, { row: v }, /* @__PURE__ */ a.createElement(
    Ht,
    {
      row: v,
      bettingOpportunities: i,
      bottomLabel: "priceHistory"
    }
  )), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), g.length ? /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        display: "flex",
        padding: "0.75rem 0.75rem 0.5625rem 0.75rem",
        alignSelf: "stretch"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary" }, "Non-runners")
  ) : null, /* @__PURE__ */ a.createElement(w, { theme: "light" }), g.map((v) => /* @__PURE__ */ a.createElement(Fe, { key: we(v) }, /* @__PURE__ */ a.createElement(et, { row: v }, /* @__PURE__ */ a.createElement(
    Ht,
    {
      row: v,
      readonly: !0,
      bettingOpportunities: i,
      bottomLabel: "priceHistory"
    }
  )), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), g.length ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ln, { markets: r.slice(0, 1) }), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null);
}
function wC({
  marketCollection: e
}) {
  const { raceCardTables: n, eachWay: t } = e, [r] = n, { raceCardRows: s } = r, i = A(
    () => s.filter((o) => o.active),
    [s]
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0.75rem 1rem 0.5625rem 0.75rem",
        alignSelf: "stretch"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", style: { alignSelf: "start" } }, t),
    /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", style: { alignSelf: "end" } }, "Last Price")
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), i.map((o) => /* @__PURE__ */ a.createElement(Fe, { key: we(o) }, /* @__PURE__ */ a.createElement(et, { row: o }, /* @__PURE__ */ a.createElement(Ht, { row: o, readonly: !0 })), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
const AC = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = Xe(
      (g) => g.raceCardData.displayWinOrEachWayExtra
    ), s = he(
      h.WIN
    ), i = he(h.GH_WIN), o = he(
      h.EACH_WAY_EXTRA
    ), c = s ?? i, { isInPlay: m, hasInPlayMarket: u, settled: l } = q(), d = Ae(), f = (!r || !o) && !l, E = m && !u && !l;
    return f && c ? /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "win-market-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (g) => {
          t == null || t(g), ve(
            `${Q[h.WIN]} ${g ? "Expand" : "Collapse"}`,
            d
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.WIN_OR_EW]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "win-market-content" }, /* @__PURE__ */ a.createElement(
        bC,
        {
          marketCollection: c
        }
      ))
    ) : E && s ? /* @__PURE__ */ a.createElement(wC, { marketCollection: s }) : null;
  }
), SC = "ngs-meetings__ExtraPlacesTerms__header__As6ER", IC = "ngs-meetings__ExtraPlacesTerms__rowsContainer__As6ER", uo = {
  header: SC,
  rowsContainer: IC
};
function NC() {
  const { marketBlurb: e, placeTerms: n } = rc(), t = (n == null ? void 0 : n.name) ?? null;
  return !e && !t ? null : /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("label", { className: uo.header }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary" }, "Extra Places Terms")), /* @__PURE__ */ a.createElement(w, { theme: "light" }), t ? /* @__PURE__ */ a.createElement("div", { className: uo.rowsContainer }, t) : null, e ? /* @__PURE__ */ a.createElement("div", { className: uo.rowsContainer }, e) : null, /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
const PC = "ngs-meetings__WinOrEWExtraColumns__extraColumnsContainer__1UAlZ", OC = "ngs-meetings__WinOrEWExtraColumns__selectionWrapper__1UAlZ", kC = "ngs-meetings__WinOrEWExtraColumns__extraColumn__1UAlZ", mo = {
  extraColumnsContainer: PC,
  selectionWrapper: OC,
  extraColumn: kC
}, Om = ({
  row: e,
  bettingOpportunities: n,
  bottomLabel: t
}) => /* @__PURE__ */ a.createElement(
  "div",
  {
    className: mo.extraColumnsContainer,
    "data-testid": "win-or-ew-extra"
  },
  n.map((r, s) => {
    const i = e.selections[s];
    return /* @__PURE__ */ a.createElement(
      "div",
      {
        key: i || `extra-column-${s}`,
        className: J(
          mo.selectionWrapper,
          s === 1 && mo.extraColumn
        )
      },
      i ? /* @__PURE__ */ a.createElement(
        vr,
        {
          selectionId: i,
          bottomLabel: s === 0 ? "priceHistory" : /* @__PURE__ */ a.createElement("div", { style: { width: "60px", textAlign: "center" } }, t)
        }
      ) : /* @__PURE__ */ a.createElement("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ a.createElement(Uo, null))
    );
  })
), DC = "ngs-meetings__WinOrEWExtraMarketTemplate__extraMarketOffers__1kHkR", LC = "ngs-meetings__WinOrEWExtraMarketTemplate__extraMarketOffersCarousel__1kHkR", xC = "ngs-meetings__WinOrEWExtraMarketTemplate__extraMarketSorting__1kHkR", FC = "ngs-meetings__WinOrEWExtraMarketTemplate__columnsHeaders__1kHkR", MC = "ngs-meetings__WinOrEWExtraMarketTemplate__columnHeader__1kHkR", BC = "ngs-meetings__WinOrEWExtraMarketTemplate__columnHeaderContent__1kHkR", $C = "ngs-meetings__WinOrEWExtraMarketTemplate__nonRunnersLabel__1kHkR", WC = "ngs-meetings__WinOrEWExtraMarketTemplate__eachWayExtraPill__1kHkR", HC = "ngs-meetings__WinOrEWExtraMarketTemplate__columnHeaderContentText__1kHkR", qC = "ngs-meetings__WinOrEWExtraMarketTemplate__placesLine__1kHkR", GC = "ngs-meetings__WinOrEWExtraMarketTemplate__promoPlaces__1kHkR", UC = "ngs-meetings__WinOrEWExtraMarketTemplate__promoArrow__1kHkR", YC = "ngs-meetings__WinOrEWExtraMarketTemplate__oddsLine__1kHkR", jC = "ngs-meetings__WinOrEWExtraMarketTemplate__promoActive__1kHkR", We = {
  extraMarketOffers: DC,
  extraMarketOffersCarousel: LC,
  extraMarketSorting: xC,
  columnsHeaders: FC,
  columnHeader: MC,
  columnHeaderContent: BC,
  nonRunnersLabel: $C,
  eachWayExtraPill: WC,
  columnHeaderContentText: HC,
  placesLine: qC,
  promoPlaces: GC,
  promoArrow: UC,
  oddsLine: YC,
  promoActive: jC
};
function VC({ className: e }) {
  return /* @__PURE__ */ a.createElement(lr, { className: e }, "E/W Extra", /* @__PURE__ */ a.createElement(HE, { size: 10 }));
}
const KC = (e, n) => {
  if (!e || !n) return;
  const t = e.match(
    /Paying\s+(\d+)\s+Places?\s+Instead\s+of\s+(\d+)/i
  );
  if (t) {
    const r = parseInt(t[1], 10), s = parseInt(t[2], 10);
    if (r === n && s < r)
      return s;
  }
  return n > 1 ? n - 1 : void 0;
}, zC = (e, n, t, r) => {
  var m;
  const s = n === 0;
  if (!s)
    return {
      isFirst: s,
      currentPlaces: void 0,
      previousPlaces: void 0,
      promoActive: !1
    };
  const i = parseInt(((m = e.match(/(\d+)/)) == null ? void 0 : m[1]) || "", 10), o = t ? KC(r, i) : void 0;
  return {
    isFirst: s,
    currentPlaces: i,
    previousPlaces: o,
    promoActive: t && o !== void 0
  };
};
function XC({
  eweMarketCollection: e,
  winMarketCollection: n
}) {
  var ae, Te;
  const t = rn(), { placeTerms: r } = rc(), s = (r == null ? void 0 : r.name) ?? null, { raceCardTables: i, markets: o } = e, [c] = i, { raceCardRows: m, bettingOpportunities: u } = c, { eachWay: l, markets: d } = n, f = q(), E = Qe(), { _offers: g, _competitionOffers: p } = f, v = !!(f._offers.extraPlaces || f._competitionOffers.extraPlaces), y = !!(g.bestOddsGuaranteed || p.bestOddsGuaranteed), C = A(() => {
    var N;
    const [W, se] = u.slice(0, 2), ue = [];
    if (W) {
      const S = l == null ? void 0 : l.match(/(\d+\/\d+) Odds (\d+) Places/), L = (S == null ? void 0 : S[1]) || "", O = (S == null ? void 0 : S[2]) || "";
      ue.push({
        ...W,
        oddsLabel: `${L} Odds`,
        placesLabel: `${O} Places`
      });
    }
    if (se) {
      const S = se.name.match(/EW (\d+) Places/), L = (S == null ? void 0 : S[1]) || "", O = ((N = se.eachWay) == null ? void 0 : N.replace(/\s*Odds$/, "")) || "";
      ue.push({
        ...se,
        oddsLabel: `${O} Odds`,
        placesLabel: `${L} Places`
      });
    }
    return ue;
  }, [l, u]), b = jt(
    0,
    (ae = n.raceCardTables[0]) == null ? void 0 : ae.raceCardRows
  ), { sortedRows: R, sortingState: P } = Yt(
    m,
    b,
    A(
      () => Object.values(b).map((W) => {
        const se = E.selections[W];
        return {
          id: W,
          marketId: se.marketId,
          eventId: f.id,
          currentPriceNum: se.priceNum,
          currentPriceDen: se.priceDen
        };
      }),
      [b, f, E]
    )
  ), D = A(
    () => R.filter((W) => W.active),
    [R]
  ), z = A(
    () => R.filter((W) => !W.active),
    [R]
  ), F = kt(D);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, F && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(_c, null), /* @__PURE__ */ a.createElement(w, { theme: "light" })), /* @__PURE__ */ a.createElement("div", { className: We.extraMarketOffers }, /* @__PURE__ */ a.createElement("div", { className: We.extraMarketOffersCarousel }, /* @__PURE__ */ a.createElement(
    Ca,
    {
      event: f,
      marketBlurb: (Te = d[0]) == null ? void 0 : Te.blurb,
      showSeparator: !1
    }
  ))), /* @__PURE__ */ a.createElement("div", { className: We.extraMarketSorting }, /* @__PURE__ */ a.createElement(on, { sortingState: P }), /* @__PURE__ */ a.createElement("div", { className: We.columnsHeaders }, C.map((W, se) => {
    const { isFirst: ue, currentPlaces: N, previousPlaces: S, promoActive: L } = zC(
      W.placesLabel,
      se,
      v,
      s
    );
    return /* @__PURE__ */ a.createElement("div", { key: W.marketId, className: We.columnHeader }, se === 1 && /* @__PURE__ */ a.createElement(VC, { className: We.eachWayExtraPill }), /* @__PURE__ */ a.createElement("div", { className: We.columnHeaderContent }, t === Ke.OPTED_IN && y && ue && /* @__PURE__ */ a.createElement(na, { size: 12 }), /* @__PURE__ */ a.createElement(
      "div",
      {
        className: J(
          We.columnHeaderContentText,
          L && We.promoActive
        )
      },
      L ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("p", { className: We.promoPlaces }, /* @__PURE__ */ a.createElement("del", null, S), /* @__PURE__ */ a.createElement("span", { className: We.promoArrow }, ">"), N, " Places"), /* @__PURE__ */ a.createElement("p", { className: We.oddsLine }, W.oddsLabel)) : /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("p", { className: We.placesLine }, W.placesLabel), /* @__PURE__ */ a.createElement("p", { className: We.oddsLine }, W.oddsLabel))
    )));
  }))), /* @__PURE__ */ a.createElement(w, { theme: "light" }), D.map((W) => {
    var ue;
    const se = we(W);
    return /* @__PURE__ */ a.createElement(Fe, { key: se }, /* @__PURE__ */ a.createElement(et, { row: W, remWidth: 1 }, /* @__PURE__ */ a.createElement(
      Om,
      {
        row: W,
        bettingOpportunities: C,
        bottomLabel: (ue = C[1]) == null ? void 0 : ue.placesLabel
      }
    )), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
  }), z.length > 0 && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("label", { className: We.nonRunnersLabel }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary" }, "Non-runners")), /* @__PURE__ */ a.createElement(w, { theme: "light" }), z.map((W) => {
    var ue;
    const se = we(W);
    return /* @__PURE__ */ a.createElement(Fe, { key: se }, /* @__PURE__ */ a.createElement(et, { row: W, remWidth: 1 }, /* @__PURE__ */ a.createElement(
      Om,
      {
        row: W,
        bettingOpportunities: C,
        bottomLabel: (ue = C[1]) == null ? void 0 : ue.placesLabel
      }
    )), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
  })), /* @__PURE__ */ a.createElement(NC, null), z.length > 0 && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ln, { markets: o.slice(0, 2) }), /* @__PURE__ */ a.createElement(w, { theme: "light" })));
}
const QC = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = Xe(
      (m) => m.raceCardData.displayWinOrEachWayExtra
    ), s = he(
      h.EACH_WAY_EXTRA
    ), i = he(
      h.WIN
    ), o = q(), c = Ae();
    return o.isInPlay || o.settled || !i || !s || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "win-or-ew-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (m) => {
          t == null || t(m), ve(
            `${Q[h.WIN_OR_EW]} ${m ? "Expand" : "Collapse"}`,
            c
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.WIN_OR_EW]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "win-or-ew-content" }, /* @__PURE__ */ a.createElement(
        XC,
        {
          eweMarketCollection: s,
          winMarketCollection: i
        }
      ))
    );
  }
);
function ZC({
  marketCollection: e
}) {
  const { raceCardTables: n, eachWay: t } = e, [r] = n, { raceCardRows: s } = r, i = A(
    () => s.filter((o) => o.active).sort((o, c) => (o.runnerNum ?? 0) - (c.runnerNum ?? 0)),
    [s]
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0.75rem 1rem 0.5625rem 0.75rem",
        alignSelf: "stretch"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", style: { alignSelf: "start" } }, t),
    /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", style: { alignSelf: "end" } }, "Bet in-running")
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), i.map((o) => /* @__PURE__ */ a.createElement(Fe, { key: we(o) }, /* @__PURE__ */ a.createElement(et, { row: o }, /* @__PURE__ */ a.createElement(Ht, { row: o, inPlay: !0 })), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
const JC = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = uh(
      h.WIN_IN_PLAY
    ), s = q(), i = Ae();
    return !s.hasInPlayMarket || !s.isInPlay || s.settled ? null : r ? /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "win-in-play-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (o) => {
          t == null || t(o), ve(
            `${Q[h.WIN_IN_PLAY]} ${o ? "Expand" : "Collapse"}`,
            i
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.WIN_IN_PLAY]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "win-in-play-content" }, /* @__PURE__ */ a.createElement(
        ZC,
        {
          marketCollection: r
        }
      ))
    ) : null;
  }
);
function eR(e, n) {
  const t = q(), r = Qe();
  return A(() => {
    const s = [];
    for (const i of (e == null ? void 0 : e.marketCollection.raceCardTables) ?? [])
      for (const o of i.raceCardRows) {
        const c = o.selections[0], m = r.selections[c], u = e == null ? void 0 : e.marketCollection.markets.find(
          (d) => d.id === e.marketId
        );
        if (m == null || u == null)
          continue;
        const l = nl(o.originalTitle ?? o.title);
        s.push({
          title: l[0],
          subtitle: l.slice(1).join(" "),
          isSpecials: !1,
          selection: {
            id: c,
            eventId: t.id,
            marketId: m.marketId,
            status: m.status,
            currentPriceNum: m.priceNum,
            currentPriceDen: m.priceDen,
            wasPriceNum: m.wasPriceNum,
            wasPriceDen: m.wasPriceDen
          },
          market: {
            id: m.marketId,
            eventId: t.id,
            status: u.status,
            eachWay: u.eachWay
          },
          event: {
            id: t.id,
            status: "A"
            // we can assume the initial value
          },
          analytics: {
            BetListName: [`HR ${u.name}`]
          }
        });
      }
    for (const i of n ?? []) {
      if (s.findIndex(
        (c) => c.selection.id === i.selectionId
      ) >= 0)
        continue;
      const o = nl(
        i.originalDisplayName ?? i.displayName
      );
      s.push({
        title: o[0],
        subtitle: o.slice(1).join(" "),
        isSpecials: !0,
        selection: {
          id: i.selectionId,
          eventId: i.eventId,
          marketId: i.marketId,
          status: i.selectionStatus,
          currentPriceNum: i.priceNum,
          currentPriceDen: i.priceDen,
          wasPriceNum: i.wasPriceNum,
          wasPriceDen: i.wasPriceDen
        },
        market: {
          id: i.marketId,
          eventId: i.eventId,
          status: i.marketStatus
        },
        event: {
          id: i.eventId,
          status: "A"
          // we can assume the initial value
        },
        analytics: { BetListName: [`HR ${i.marketType}`] }
      });
    }
    return s;
  }, [e, t, n, r]);
}
const tR = "ngs-meetings__PriceBoostMarketTemplate__container__xtlSB", nR = "ngs-meetings__PriceBoostMarketTemplate__row__xtlSB", rR = "ngs-meetings__PriceBoostMarketTemplate__title__xtlSB", aR = "ngs-meetings__PriceBoostMarketTemplate__selection__xtlSB", sR = "ngs-meetings__PriceBoostMarketTemplate__wasPrice__xtlSB", Cn = {
  container: tR,
  row: nR,
  title: rR,
  selection: aR,
  wasPrice: sR
};
function iR({
  marketCollection: e,
  racingSpecials: n
}) {
  const { id: t } = q(), r = A(
    () => e != null ? {
      eventId: t,
      marketId: e.markets[0].id,
      marketCollection: e
    } : void 0,
    [e, t]
  ), s = eR(r, n), i = Sn(
    A(() => s.map((c) => c.selection), [s])
  ), o = A(() => s.filter(
    (m) => {
      var u;
      return ((u = i.find((l) => m.selection.id === l.id)) == null ? void 0 : u.status) === "A";
    }
  ).sort((m, u) => {
    const l = i.find((g) => g.id === m.selection.id), d = i.find((g) => g.id === u.selection.id);
    let f = 0;
    (l == null ? void 0 : l.currentPriceNum) != null && (l == null ? void 0 : l.currentPriceDen) != null && (l == null ? void 0 : l.currentPriceDen) !== 0 && (f = l.currentPriceNum / l.currentPriceDen);
    let E = 0;
    return (d == null ? void 0 : d.currentPriceNum) != null && (d == null ? void 0 : d.currentPriceDen) != null && (d == null ? void 0 : d.currentPriceDen) !== 0 && (E = d.currentPriceNum / d.currentPriceDen), f - E;
  }), [s, i]);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, (e == null ? void 0 : e.description.description) != null && /* @__PURE__ */ a.createElement(gc, null, e.description.description), /* @__PURE__ */ a.createElement(
    ur,
    {
      className: Cn.expandableList,
      collapsedLimit: 2,
      showLessText: "Show less",
      showMoreText: "Show more"
    },
    o.map((c) => /* @__PURE__ */ a.createElement(oR, { key: c.selection.id, ...c }))
  ));
}
function oR({
  title: e,
  subtitle: n,
  selection: t,
  market: r,
  event: s,
  analytics: i,
  tracking: o,
  className: c,
  style: m
}) {
  return /* @__PURE__ */ a.createElement(
    en,
    {
      className: J(Cn.container, c),
      style: m,
      "data-testid": "price-boost-selection"
    },
    /* @__PURE__ */ a.createElement("div", { className: Cn.row, "data-testid": "price-boost-row" }, /* @__PURE__ */ a.createElement(
      He,
      {
        level: 5,
        lines: 2,
        "data-testid": "price-boost-title",
        className: Cn.title
      },
      e
    ), n && /* @__PURE__ */ a.createElement(T, { "data-testid": "price-boost-sub-title" }, n)),
    /* @__PURE__ */ a.createElement(
      cR,
      {
        selection: t,
        market: r,
        event: s,
        tracking: o,
        analytics: i
      }
    )
  );
}
function cR({
  selection: e,
  market: n,
  event: t,
  ...r
}) {
  const s = nn(t), i = An(n), o = tn(e), c = ac(
    o.id,
    i.id,
    s.id,
    o
  );
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      className: Cn.selection,
      "data-testid": "price-boost-selection-button"
    },
    c && /* @__PURE__ */ a.createElement("div", { className: Cn.wasPrice, "data-testid": "price-boost-was-price" }, c),
    /* @__PURE__ */ a.createElement(
      sn,
      {
        ...r,
        selection: o,
        market: i,
        event: s,
        color: "yellow"
      },
      ({ selected: m, formattedOdds: u }) => /* @__PURE__ */ a.createElement(a.Fragment, null, m ? /* @__PURE__ */ a.createElement(Bt, null) : /* @__PURE__ */ a.createElement(qE, null), " ", u)
    )
  );
}
const lR = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.PRICE_BOOST
    ), s = Ud(), i = A(
      () => s.filter(
        (m) => m.marketType === "Price Boost"
      ) ?? [],
      [s]
    ), o = q(), c = Ae();
    return o.isInPlay || o.settled || !(r || i.length > 0) ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "price-boost-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (m) => {
          t == null || t(m), ve(
            `${Q[h.PRICE_BOOST]} ${m ? "Expand" : "Collapse"}`,
            c
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, { icons: /* @__PURE__ */ a.createElement(Bt, null) }, Q[h.PRICE_BOOST]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "price-boost-content" }, /* @__PURE__ */ a.createElement(
        iR,
        {
          marketCollection: r,
          racingSpecials: i
        }
      ))
    );
  }
);
function uR({
  marketCollection: e
}) {
  const { description: n, raceCardTables: t } = e, [r] = t, { raceCardRows: s } = r, i = kt(s);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(cn, { renderToggle: i }, n.description), t.map((o) => /* @__PURE__ */ a.createElement(mR, { key: o.key, raceCardTable: o })));
}
function mR({ raceCardTable: e }) {
  const { header: n, raceCardRows: t, bettingOpportunities: r } = e, s = A(
    () => t.filter((i) => i.active),
    [t]
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        gap: "0.625rem",
        padding: "0.5rem 0.75rem",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "bodySecondary" }, n)
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), s.map((i) => /* @__PURE__ */ a.createElement(Fe, { key: we(i) }, /* @__PURE__ */ a.createElement(et, { row: i }, /* @__PURE__ */ a.createElement(Ht, { row: i, bettingOpportunities: r })), /* @__PURE__ */ a.createElement(w, { theme: "light" }))));
}
const Of = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.MATCH_BETS
    ), s = q(), i = Ae();
    return s.isInPlay || s.settled || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "match-bets-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (o) => {
          t == null || t(o), ve(
            `${Q[h.MATCH_BETS]} ${o ? "Expand" : "Collapse"}`,
            i
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.MATCH_BETS]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "match-bets-content" }, /* @__PURE__ */ a.createElement(
        uR,
        {
          marketCollection: r
        }
      ))
    );
  }
);
function dR({
  marketCollection: e,
  winMarketCollection: n
}) {
  var v;
  const { raceCardTables: t, description: r } = e, [s] = t, { raceCardRows: i } = s, { bettingOpportunities: o } = s, c = ya(n), m = A(
    () => o.slice(1),
    [o]
  ), u = jt(
    0,
    (v = n.raceCardTables[0]) == null ? void 0 : v.raceCardRows
  ), l = q(), d = Qe(), { sortedRows: f, sortingState: E } = Yt(
    i,
    u,
    A(
      () => Object.values(u).map((y) => {
        const C = d.selections[y];
        return {
          id: y,
          marketId: C.marketId,
          eventId: l.id,
          currentPriceNum: C.priceNum,
          currentPriceDen: C.priceDen
        };
      }),
      [u, l, d]
    )
  ), g = A(
    () => f.filter((y) => y.active),
    [f]
  ), p = kt(g);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(cn, { renderToggle: p }, r.description), /* @__PURE__ */ a.createElement(Dn, { scrollable: !0 }, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        minWidth: "13rem",
        paddingLeft: "0.25rem",
        flex: "1 0 13rem"
      }
    },
    /* @__PURE__ */ a.createElement(on, { sortingState: E })
  ), /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        gap: "0.5rem",
        paddingRight: "1rem"
      }
    },
    m.map((y) => /* @__PURE__ */ a.createElement(
      T,
      {
        key: y.marketId,
        variant: "bodyPrimary",
        style: { width: "60px", textAlign: "center" }
      },
      y.name
    ))
  ))), /* @__PURE__ */ a.createElement(w, { theme: "light" }), g.map((y) => {
    const C = we(y);
    return /* @__PURE__ */ a.createElement(Fe, { key: C }, /* @__PURE__ */ a.createElement(et, { row: y }, /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          position: "relative",
          overflow: "hidden",
          display: "flex"
        }
      },
      C && c[C] ? /* @__PURE__ */ a.createElement(
        Fa,
        {
          selectionId: c[C].selections[0]
        }
      ) : null,
      /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
        xa,
        {
          row: { ...y, selections: y.selections.slice(1) },
          bettingOpportunities: m
        }
      ))
    )), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
  }));
}
const kf = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.LENGTHEN_YOUR_ODDS
    ), s = he(
      h.WIN
    ), i = q(), o = Ae();
    return i.isInPlay || i.settled || !s || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "lengthen-your-odds-content",
        defaultOpen: n ? e : !0,
        onOpenChange: (c) => {
          t == null || t(c), ve(
            `${Q[h.LENGTHEN_YOUR_ODDS]} ${c ? "Expand" : "Collapse"}`,
            o
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.LENGTHEN_YOUR_ODDS]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "lengthen-your-odds-section" }, /* @__PURE__ */ a.createElement(
        dR,
        {
          marketCollection: r,
          winMarketCollection: s
        }
      ))
    );
  }
);
function fR({
  marketCollection: e,
  winMarketCollection: n
}) {
  var y;
  const { raceCardTables: t, description: r, markets: s } = e, [i] = t, { raceCardRows: o } = i, { bettingOpportunities: c } = i, m = ya(n), u = jt(
    0,
    (y = n.raceCardTables[0]) == null ? void 0 : y.raceCardRows
  ), l = q(), d = Qe(), { sortedRows: f, sortingState: E } = Yt(
    o,
    u,
    A(
      () => Object.values(u).map((C) => {
        const b = d.selections[C];
        return {
          id: C,
          marketId: b.marketId,
          eventId: l.id,
          currentPriceNum: b.priceNum,
          currentPriceDen: b.priceDen
        };
      }),
      [u, l, d]
    )
  ), g = A(
    () => f.filter((C) => C.active),
    [f]
  ), p = A(
    () => f.filter((C) => !C.active),
    [f]
  ), v = kt(g);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(cn, { renderToggle: v }, r.description), /* @__PURE__ */ a.createElement(Dn, { scrollable: !0 }, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        minWidth: "13rem",
        paddingLeft: "0.25rem",
        flex: "1 0 13rem"
      }
    },
    /* @__PURE__ */ a.createElement(on, { sortingState: E })
  ), /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        gap: "0.5rem",
        paddingRight: "1rem"
      }
    },
    c.map((C) => /* @__PURE__ */ a.createElement(
      T,
      {
        key: C.marketId,
        variant: "bodyPrimary",
        style: { width: "60px", textAlign: "center" }
      },
      C.name
    ))
  ))), /* @__PURE__ */ a.createElement(w, { theme: "light" }), g.map((C) => {
    const b = we(C);
    return /* @__PURE__ */ a.createElement(Fe, { key: b }, /* @__PURE__ */ a.createElement(et, { row: C }, /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          position: "relative",
          overflow: "hidden",
          display: "flex"
        }
      },
      b && m[b] ? /* @__PURE__ */ a.createElement(
        Fa,
        {
          selectionId: m[b].selections[0]
        }
      ) : null,
      /* @__PURE__ */ a.createElement(Wt, null, /* @__PURE__ */ a.createElement(
        xa,
        {
          row: C,
          bettingOpportunities: c
        }
      ))
    )), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
  }), p.length ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ln, { markets: s.slice(0, 1) }), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null);
}
const Df = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.MONEY_BACK
    ), s = he(
      h.WIN
    ), i = q(), o = Ae();
    return i.isInPlay || i.settled || !r || !s ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "money-back-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (c) => {
          t == null || t(c), ve(
            `${Q[h.MONEY_BACK]} ${c ? "Expand" : "Collapse"}`,
            o
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.MONEY_BACK]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "money-back-content" }, /* @__PURE__ */ a.createElement(
        fR,
        {
          marketCollection: r,
          winMarketCollection: s
        }
      ))
    );
  }
);
function ER({
  marketCollection: e
}) {
  const { description: n, raceCardTables: t } = e, [r] = t, { raceCardRows: s } = r, i = kt(s);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(cn, { renderToggle: i }, n.description), t.map((o) => /* @__PURE__ */ a.createElement(_R, { key: o.key, raceCardTable: o })));
}
function _R({ raceCardTable: e }) {
  const { header: n, raceCardRows: t, bettingOpportunities: r } = e, s = jt(0, t), i = q(), o = Qe(), { sortedRows: c } = Yt(
    t,
    s,
    A(
      () => Object.values(s).map((u) => {
        const l = o.selections[u];
        return {
          id: u,
          marketId: l.marketId,
          eventId: i.id,
          currentPriceNum: l.priceNum,
          currentPriceDen: l.priceDen
        };
      }),
      [s, o.selections, i.id]
    )
  ), m = A(
    () => c.filter((u) => u.active),
    [c]
  );
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        gap: "0.625rem",
        padding: "0.5rem 0.75rem",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "bodySecondary" }, n)
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), m.map((u) => /* @__PURE__ */ a.createElement(Fe, { key: we(u) }, /* @__PURE__ */ a.createElement(et, { row: u }, /* @__PURE__ */ a.createElement(Ht, { row: u, bettingOpportunities: r })), /* @__PURE__ */ a.createElement(w, { theme: "light" }))));
}
const Lf = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.BETTING_WITHOUT
    ), s = q(), i = Ae();
    return s.isInPlay || s.settled || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "betting-without-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (o) => {
          t == null || t(o), ve(
            `${Q[h.BETTING_WITHOUT]} ${o ? "Expand" : "Collapse"}`,
            i
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.BETTING_WITHOUT]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "betting-without-content" }, /* @__PURE__ */ a.createElement(
        ER,
        {
          marketCollection: r
        }
      ))
    );
  }
), gR = "ngs-meetings__OddsEvensMarketTemplate__oddsEvensTable__A2DeH", pR = "ngs-meetings__OddsEvensMarketTemplate__oddsEvensRow__A2DeH", xf = {
  oddsEvensTable: gR,
  oddsEvensRow: pR
};
function hR({
  marketCollection: e
}) {
  const { description: n, raceCardTables: t } = e, [r] = t, { raceCardRows: s } = r;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(gc, null, n.description), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("div", { className: xf.oddsEvensTable }, s.filter((i) => i.active).map((i) => /* @__PURE__ */ a.createElement(vR, { key: i.runnerNum, row: i }))), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
function vR({
  row: e,
  selectionIndex: n = 0
}) {
  const { title: t } = e, r = e.selections[n];
  return r == null ? null : /* @__PURE__ */ a.createElement("div", { className: xf.oddsEvensRow }, /* @__PURE__ */ a.createElement(T, null, t.slice(0, -1)), /* @__PURE__ */ a.createElement(vr, { key: r, selectionId: r }));
}
const Ff = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(
      h.ODDS_VS_EVENS
    ), s = q(), i = Ae();
    return s.isInPlay || s.settled || !r ? null : /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "odds-evens-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (o) => {
          t == null || t(o), ve(
            `${Q[h.ODDS_VS_EVENS]} ${o ? "Expand" : "Collapse"}`,
            i
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.ODDS_VS_EVENS]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "odds-evens-content" }, /* @__PURE__ */ a.createElement(
        hR,
        {
          marketCollection: r
        }
      ))
    );
  }
);
function yR({
  marketCollection: e
}) {
  const { raceCardTables: n } = e, [t] = n, { raceCardRows: r, bettingOpportunities: s } = t, i = jt(0, r), o = q(), c = Qe(), { sortedRows: m, sortingState: u } = Yt(
    r,
    i,
    A(
      () => Object.values(i).map((f) => {
        const E = c.selections[f];
        return {
          id: f,
          marketId: E.marketId,
          eventId: o.id,
          currentPriceNum: E.priceNum,
          currentPriceDen: E.priceDen
        };
      }),
      [i, o, c]
    )
  ), l = A(
    () => m.filter((f) => f.active),
    [m]
  ), d = kt(l);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(cn, { renderToggle: d }, "Add 2 selections for forecast, or 3 for tricast"), /* @__PURE__ */ a.createElement(Dn, null, /* @__PURE__ */ a.createElement(
    on,
    {
      sortingState: u,
      style: { paddingRight: "0.25rem" }
    }
  )), /* @__PURE__ */ a.createElement(w, { theme: "light" }), l.map((f) => /* @__PURE__ */ a.createElement(Fe, { key: we(f) }, /* @__PURE__ */ a.createElement(et, { row: f }, /* @__PURE__ */ a.createElement(
    Ht,
    {
      row: f,
      bettingOpportunities: s,
      bottomLabel: "priceHistory"
    }
  )), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
const Mf = nt(
  ({
    defaultOpen: e = !1,
    collapsible: n = !1,
    onOpenChange: t
  }) => {
    const r = he(h.WIN), s = he(h.GH_WIN), i = q(), o = Ae();
    if (i.isInPlay || i.settled)
      return null;
    const c = r ?? s;
    return c ? /* @__PURE__ */ a.createElement(
      de,
      {
        "data-testid": "forecast-tricast-section",
        defaultOpen: n ? e : !0,
        onOpenChange: (m) => {
          t == null || t(m), ve(
            `${Q[h.FORECAST_TRICAST]} ${m ? "Expand" : "Collapse"}`,
            o
          );
        }
      },
      n && /* @__PURE__ */ a.createElement(fe, null, Q[h.FORECAST_TRICAST]),
      /* @__PURE__ */ a.createElement(Ee, { "data-testid": "forecast-tricast-content" }, /* @__PURE__ */ a.createElement(yR, { marketCollection: c }))
    ) : null;
  }
), TR = Ut(CR);
function CR() {
  const e = q();
  return e.isInPlay || e.settled ? null : /* @__PURE__ */ a.createElement(id, null);
}
function RR({
  position: e,
  active: n
}) {
  const t = A(() => e === 1 ? "st" : e === 2 ? "nd" : e === 3 ? "rd" : "th", [e]);
  return n ? /* @__PURE__ */ a.createElement(
    T,
    {
      variant: "labelPrimary",
      style: { width: "1.5rem", fontSize: "0.875rem" },
      "data-testid": "results-row-position"
    },
    e ? /* @__PURE__ */ a.createElement(a.Fragment, null, e, /* @__PURE__ */ a.createElement("sup", null, t)) : "-"
  ) : /* @__PURE__ */ a.createElement(
    T,
    {
      variant: "labelPrimary",
      style: { width: "1.5rem", fontSize: "0.875rem" }
    },
    "NR"
  );
}
const km = {
  0: "dht",
  "0.05": "nse",
  "0.1": "shd",
  "0.2": "hd",
  "0.25": "snk",
  "0.3": "nk",
  "0.5": "1/2"
}, bR = (e) => {
  if (e === null)
    return "-";
  const n = Object.keys(km).map(
    (c) => parseFloat(c)
  ), t = n.findIndex(
    (c) => c > e
  );
  if (t !== -1) {
    const c = n[t - 1], m = n[t], u = Number(((c + m) / 2).toFixed(4)), l = e < u ? c : m;
    return km[l.toString()];
  }
  const r = [], s = Math.round(e / 0.25) % 4, i = Math.floor(Math.round(e / 0.25) / 4), o = s !== 0 ? s === 2 ? "1/2" : `${s}/4` : "";
  return i && r.push(i), o && r.push(o), r.join(" ");
};
function Dm({ row: e }) {
  const { greyhoundsRegionType: n } = q(), t = mr(), {
    title: r,
    position: s,
    startingPriceNum: i,
    startingPriceDen: o,
    distance: c,
    active: m
  } = e, u = i && o && t(i, o);
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        alignSelf: "stretch",
        padding: "0.75rem"
      },
      "data-testid": "results-row"
    },
    /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          gap: "0.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          alignSelf: "stretch"
        },
        "data-testid": "results-row-details"
      },
      /* @__PURE__ */ a.createElement(RR, { position: s, active: m }),
      /* @__PURE__ */ a.createElement(wR, { row: e, greyhoundsRegionType: n }),
      /* @__PURE__ */ a.createElement(Ra, { runner: e, title: r })
    ),
    /* @__PURE__ */ a.createElement(
      ed,
      {
        style: { justifySelf: "end" },
        "data-testid": "results-row-price"
      },
      u
    )
  ), c ? /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0.75rem 1rem 0.5625rem 0.75rem",
        alignSelf: "stretch"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", style: { alignSelf: "end" } }, "Dist: ", bR(c))
  ) : null);
}
function wR({
  row: e,
  greyhoundsRegionType: n
}) {
  const { silkName: t, runnerNum: r, active: s } = e;
  return tt() ? /* @__PURE__ */ a.createElement(
    Nn,
    {
      runnerNum: r,
      active: s,
      greyhoundsRegionType: n
    }
  ) : t ? /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0.25rem"
      }
    },
    /* @__PURE__ */ a.createElement(fr, { runnerNum: r, runner: e })
  ) : r && !t ? /* @__PURE__ */ a.createElement(T, { style: { width: "1rem" } }, r) : null;
}
const AR = "ngs-meetings__BetInformation__header__YqYwP", SR = "ngs-meetings__BetInformation__tableHeader__YqYwP", IR = "ngs-meetings__BetInformation__tableRow__YqYwP", NR = "ngs-meetings__BetInformation__caption__YqYwP", PR = "ngs-meetings__BetInformation__cellContainer__YqYwP", OR = "ngs-meetings__BetInformation__cell__YqYwP", Ne = {
  header: AR,
  tableHeader: SR,
  tableRow: IR,
  caption: NR,
  cellContainer: PR,
  cell: OR
};
function kR({ markets: e }) {
  const [n] = e, { betInformation: t } = n, { bets: r, tote: s } = t;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("label", { className: Ne.header }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary" }, "Bet Information")), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement("label", { className: Ne.tableHeader }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary", className: Ne.caption }, "Runner"), /* @__PURE__ */ a.createElement("div", { className: Ne.cellContainer }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary", className: Ne.cell }, "Tote Win"), /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary", className: Ne.cell }, "Tote Place"))), s.map((i) => /* @__PURE__ */ a.createElement(Fe, { key: i.runnerName }, /* @__PURE__ */ a.createElement("label", { className: Ne.tableRow }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", className: Ne.caption }, i.runnerName), /* @__PURE__ */ a.createElement("div", { className: Ne.cellContainer }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", className: Ne.cell }, i.win), /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", className: Ne.cell }, i.place))))), /* @__PURE__ */ a.createElement("label", { className: Ne.tableHeader }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary", className: Ne.caption }, "Bet Type"), /* @__PURE__ */ a.createElement("div", { className: Ne.cellContainer }, /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary", className: Ne.cell }, "Dividend"))), r.map((i) => /* @__PURE__ */ a.createElement(Fe, { key: i.betType }, /* @__PURE__ */ a.createElement("label", { className: Ne.tableRow }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary" }, i.betType), /* @__PURE__ */ a.createElement("div", { className: Ne.cellContainer }, /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", className: Ne.cell }, i.dividend))))), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
function DR({ resultsData: e }) {
  const { marketCollections: n, resultsBasicInfo: t } = e, [r] = n, { raceCardTables: s, markets: i } = r, [o] = s, { raceCardRows: c } = o, m = A(
    () => c.filter((f) => f.active),
    [c]
  ), u = A(
    () => c.filter((f) => !f.active),
    [c]
  ), { eachWayTerms: l, offTime: d } = t;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0.75rem 1rem 0.5625rem 0.75rem",
        alignSelf: "stretch"
      },
      "data-testid": "results-header"
    },
    m.length ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "bodyPrimary",
        style: { alignSelf: "end" },
        "data-testid": "results-header-runners"
      },
      m.length,
      " Ran"
    ) : null,
    d ? /* @__PURE__ */ a.createElement(
      T,
      {
        variant: "bodyPrimary",
        style: { alignSelf: "end" },
        "data-testid": "results-header-off-time"
      },
      "Off Time: ",
      d
    ) : null
  ), /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0.75rem 1rem 0.5625rem 0.75rem",
        alignSelf: "stretch"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary" }, l.eachWayAvailable ? `${l.eachWayFactorNum}/${l.eachWayFactorDen} Odds ${l.eachWayPlaces} Places` : null)
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), m.map((f) => /* @__PURE__ */ a.createElement(Fe, { key: f.resultsId }, /* @__PURE__ */ a.createElement(Dm, { row: f }), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), u.length ? /* @__PURE__ */ a.createElement(
    "label",
    {
      style: {
        display: "flex",
        padding: "0.75rem 0.75rem 0.5625rem 0.75rem",
        alignSelf: "stretch"
      }
    },
    /* @__PURE__ */ a.createElement(T, { variant: "labelPrimary" }, "Non-runners")
  ) : null, /* @__PURE__ */ a.createElement(w, { theme: "light" }), u.map((f) => /* @__PURE__ */ a.createElement(Fe, { key: f.resultsId }, /* @__PURE__ */ a.createElement(Dm, { row: f }), /* @__PURE__ */ a.createElement(w, { theme: "light" }))), /* @__PURE__ */ a.createElement(kR, { markets: i }), u.length ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Ln, { markets: i.slice(0, 1) }), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null);
}
const fo = (e, n) => +`${Math.round(+`${e}e+${n}`)}e-${n}`, LR = ({
  runner_starting_price: e,
  runner_live_price: n
}) => e ? {
  startingPriceNum: e.num,
  startingPriceDen: e.den
} : n ? {
  startingPriceNum: n.num,
  startingPriceDen: n.den
} : { startingPriceNum: null, startingPriceDen: null }, xR = ({
  runner_id: e,
  runner_name: n,
  runner_starting_price: t,
  runner_live_price: r,
  runner_position: s,
  runner_beaten_distance: i,
  runner_number: o,
  runner_racing_post_comment: c,
  runner_draw_number: m,
  runner_jockey: u,
  runner_trainer: l,
  runner_silk: d,
  runner_is_runner: f
}, E) => ({
  id: E ? o.toString() : `OB_RN${e}`,
  // it's not OB_RN${runner_id} in the real data
  resultsId: E ? o.toString() : e,
  title: n,
  ...LR({ runner_starting_price: t, runner_live_price: r }),
  position: s,
  distance: i,
  overview: c === "-" ? null : c,
  runnerNum: o,
  draw: m,
  jockey: u,
  trainer: l,
  silkName: E ? `silk_${o}.png` : d,
  active: f
}), Zr = (e) => {
  if (!e || typeof e != "string")
    return (e == null ? void 0 : e.toString()) || null;
  const [n, t] = e.split("T"), r = n.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3"), s = t.replace(/(\d{2})(\d{2})(\d{2})/, "$1:$2:$3");
  return (/* @__PURE__ */ new Date(`${r}T${s}`)).toLocaleTimeString();
}, FR = ({
  rule4_deductions_name: e,
  rule4_deductions_datetime_from: n,
  rule4_deductions_datetime_to: t,
  rule4_deductions_deduction: r
}) => ({
  name: e,
  from: Zr(n) || "",
  to: Zr(t) || "",
  reduction: r
}), MR = (e, n) => e.data.race_runners.reduce(
  (t, r) => {
    const s = xR(r, n);
    return t[s.id] = s, t;
  },
  {}
), BR = (e) => e.data.race_rule4_deductions ? e.data.race_rule4_deductions.map(FR) : [], $R = (e, n) => e.position && !n.position ? -1 : !e.position && n.position ? 1 : (e.position ?? 0) - (n.position ?? 0), WR = (e, n, t) => ({
  marketCollections: [
    {
      name: "Racecard",
      markets: [{ id: "results", rule4: n, ...t }],
      raceCardTables: [
        {
          raceCardRows: Object.values(e).sort($R),
          key: "Racecard"
        }
      ]
    }
  ]
}), Lm = (e, n) => (
  // @ts-expect-error - TS doesn't know that the runner_is_[position]_fav property exists
  (e.find((t) => t[`runner_is_${n}_fav`]) || {}).runner_name
), HR = ({ data: e, request: n }, { type: t, prize: r, title: s }) => {
  const i = e.race_each_way_terms && e.race_each_way_terms.num_places, o = e.race_each_way_terms && e.race_each_way_terms.factor.num, c = e.race_each_way_terms && e.race_each_way_terms.factor.den, u = {
    eachWayAvailable: !!(i && o && c),
    eachWayPlaces: i,
    eachWayFactorNum: o,
    eachWayFactorDen: c
  };
  return {
    resultsBasicInfo: {
      raceTitle: s,
      raceType: t,
      prizeMoney: r && Number(r).toLocaleString(),
      eachWayTerms: u,
      offTime: Zr(n.race.race_off_datetime),
      winningTime: Zr(e.race_winning_time),
      favouriteRunner1: Lm(e.race_runners, 1),
      favouriteRunner2: Lm(e.race_runners, 2)
    }
  };
}, xm = {
  forecast: "Forecast",
  tricast: "Tricast",
  tote_exacta: "Exacta",
  tote_trifecta: "Trifecta"
}, qR = (e) => {
  const { race_dividends: n, race_runners: t } = e.data;
  return {
    betInformation: {
      bets: Object.keys(n).filter((r) => Object.keys(xm).includes(r)).reduce((r, s) => {
        if (n[s] && n[s].length > 0) {
          const i = n[s][0];
          return [
            ...r,
            {
              betType: xm[s] || s,
              dividend: i && fo(i, 2).toFixed(2)
            }
          ];
        }
        return r;
      }, []),
      tote: t.filter(
        (r) => r.runner_dividends.tote_win || r.runner_dividends.tote_place
      ).map((r) => {
        const s = (r.runner_dividends.tote_win || [])[0], i = (r.runner_dividends.tote_place || [])[0];
        return {
          runnerName: r.runner_name,
          win: s && fo(s, 2).toFixed(2),
          place: i && fo(i, 2).toFixed(2)
        };
      })
    }
  };
}, GR = (e, n) => {
  const t = MR(n, e.virtualRacing), r = BR(n), s = qR(n);
  return {
    event: {
      ...e,
      runners: t,
      numberOfRunners: n.data.race_num_runners
    },
    ...WR(t, r, s),
    ...HR(n, e.race)
  };
}, UR = Ut(
  () => {
    const e = q(), { data: n } = Co();
    return !e.settled || !n ? null : /* @__PURE__ */ a.createElement(DR, { resultsData: GR(e, n) });
  },
  {
    queries: [Co],
    Loader: () => /* @__PURE__ */ a.createElement(pc, null)
  }
), YR = ({ sport: e }) => /* @__PURE__ */ a.createElement(a.Fragment, null, e === ce.HORSE_RACING && /* @__PURE__ */ a.createElement(TR, null), /* @__PURE__ */ a.createElement(UR, null), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: JC,
    name: X[h.WIN],
    defaultOpen: !0
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: lR,
    name: X[h.PRICE_BOOST],
    defaultOpen: !0
  }
), /* @__PURE__ */ a.createElement(gC, null), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: AC,
    name: X[h.WIN],
    defaultOpen: !0
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: QC,
    name: X[h.WIN_OR_EW],
    defaultOpen: !0
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: Pf,
    name: X[h.YOUR_ODDS],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: Nf,
    name: X[h.PLACE_MARKETS],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: If,
    name: X[h.EACH_WAY_EXTRA],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: Df,
    name: X[h.MONEY_BACK],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: kf,
    name: X[h.LENGTHEN_YOUR_ODDS],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: Of,
    name: X[h.MATCH_BETS],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: Lf,
    name: X[h.BETTING_WITHOUT],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: Ff,
    name: X[h.ODDS_VS_EVENS],
    defaultOpen: !1
  }
), /* @__PURE__ */ a.createElement(
  Ze,
  {
    Component: Mf,
    name: X[h.FORECAST_TRICAST],
    defaultOpen: !1
  }
)), jR = "ngs-meetings__BetBuilderCTA__wrapper__H5MyJ", VR = "ngs-meetings__BetBuilderCTA__widthWrapper__H5MyJ", KR = "ngs-meetings__BetBuilderCTA__bbIcon__H5MyJ", zR = "ngs-meetings__BetBuilderCTA__content__H5MyJ", XR = "ngs-meetings__BetBuilderCTA__headline__H5MyJ", QR = "ngs-meetings__BetBuilderCTA__secondaryText__H5MyJ", ZR = "ngs-meetings__BetBuilderCTA__runnersList__H5MyJ", JR = "ngs-meetings__BetBuilderCTA__runner__H5MyJ", Lt = {
  wrapper: jR,
  widthWrapper: VR,
  bbIcon: KR,
  content: zR,
  headline: XR,
  secondaryText: QR,
  runnersList: ZR,
  runner: JR
}, eb = [
  {
    silkUrl: "bb-silk-1.gif",
    name: "Ndaawi",
    description: "Top 4 Finish"
  },
  {
    silkUrl: "bb-silk-2.gif",
    name: "Absurde",
    description: "Top 4 Finish"
  },
  {
    silkUrl: "bb-silk-3.gif",
    name: "Ethical Diamond",
    description: "Ethical Diamond vs Our Champ"
  }
], tb = ({
  eventId: e,
  sportId: n,
  environment: t
}) => {
  const r = () => lt(rt.OPEN_BET_BUILDER, {
    eventId: e,
    sportId: n
  });
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      className: Lt.wrapper,
      style: {
        backgroundImage: `url(${Uc(t)}/hr-bb-launchcard-bg.png)`
      }
    },
    /* @__PURE__ */ a.createElement("div", { className: Lt.widthWrapper }, /* @__PURE__ */ a.createElement("div", { className: Lt.content }, /* @__PURE__ */ a.createElement(He, { level: 3, className: Lt.headline }, /* @__PURE__ */ a.createElement(GE, { className: Lt.bbIcon }), "Bet Builder"), /* @__PURE__ */ a.createElement(T, { variant: "bodyPrimary", className: Lt.secondaryText }, "Create your own acca across multiple markets within a race"), /* @__PURE__ */ a.createElement("div", { className: Lt.runnersList }, eb.map((s) => /* @__PURE__ */ a.createElement("div", { key: s.name, className: Lt.runner }, /* @__PURE__ */ a.createElement(
      "img",
      {
        src: `${Uc(t)}/${s.silkUrl}`,
        alt: `${s.name} jockey silk`
      }
    ), /* @__PURE__ */ a.createElement(T, { lines: 2 }, /* @__PURE__ */ a.createElement("b", null, s.name), " ", s.description))))), /* @__PURE__ */ a.createElement(
      ke,
      {
        style: {
          width: "100%"
        },
        onClick: r
      },
      "Build"
    ))
  );
}, nb = () => {
  const { id: e } = q(), { params: n, env: t } = V();
  return /* @__PURE__ */ a.createElement(
    rb,
    {
      eventId: e,
      sportId: A_[n.sport],
      environment: t.environment
    }
  );
}, rb = ({
  eventId: e,
  sportId: n,
  environment: t
}) => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
  tb,
  {
    eventId: e,
    sportId: n,
    environment: t
  }
)), ab = () => {
  const { getLinkForEvent: e, navigateToEvent: n, params: t } = V();
  return /* @__PURE__ */ a.createElement(
    c_,
    {
      title: "Market does not exist (yet)",
      subtitle: "Please choose a different market or return to all markets",
      onActionClick: () => n(
        e(t.sport, t.eventId, t.raceSlug)
      ),
      actionLabel: "Return to all markets"
    }
  );
}, sb = ({ marketSlug: e }) => {
  const n = A(() => {
    switch (e) {
      case X[h.BET_BUILDER]:
        return nb;
      case X[h.YOUR_ODDS]:
        return Pf;
      case X[h.LENGTHEN_YOUR_ODDS]:
        return kf;
      case X[h.PLACE_MARKETS]:
        return Nf;
      case X[h.EACH_WAY_EXTRA]:
        return If;
      case X[h.MONEY_BACK]:
        return Df;
      case X[h.MATCH_BETS]:
        return Of;
      case X[h.BETTING_WITHOUT]:
        return Lf;
      case X[h.ODDS_VS_EVENS]:
        return Ff;
      case X[h.FORECAST_TRICAST]:
        return Mf;
      default:
        return ab;
    }
  }, [e]);
  return /* @__PURE__ */ a.createElement(n, { collapsible: !1 });
}, ib = () => {
  const { params: e, navigateToPage: n } = V();
  return /* @__PURE__ */ a.createElement("div", { "data-testid": "event-unavailable-container" }, /* @__PURE__ */ a.createElement(
    Yo,
    {
      primaryActionLabel: "Meetings",
      onPrimaryActionClick: () => n("meetings"),
      secondaryActionLabel: St[e.sport],
      onSecondaryActionClick: () => n(""),
      title: "This event is currently unavailable",
      subtitle: "We are sorry but something went wrong. For more betting opportunities please select another event."
    }
  ));
}, hI = Ut(
  () => {
    const { params: e } = V(), { marketSlug: n, sport: t } = e;
    return n ? /* @__PURE__ */ a.createElement(sb, { marketSlug: n }) : /* @__PURE__ */ a.createElement(YR, { sport: t });
  },
  {
    Loader: () => /* @__PURE__ */ a.createElement(pc, null),
    ErrorRenderer: ib
  }
), ob = () => {
  const {
    params: { competitionId: e }
  } = V(), n = _e();
  return ye({
    queryKey: [...n.queryKey, "competitions", e],
    queryFn: () => n.services.meetings.getCompetitionNextEvent(e),
    refetchOnMount: !1
  });
};
function vI() {
  const { navigateToEvent: e, navigateToPage: n } = V(), { data: t, isLoading: r } = ob();
  return te(() => {
    r || (t != null && t.id && (t != null && t.slug) ? e(t.id, t.slug) : n("meetings"));
  }, [r, t, e, n]), r ? /* @__PURE__ */ a.createElement(Zd, null) : null;
}
const yI = () => {
  const { params: e, getLinkForNextRaces: n, navigateToNextRaces: t } = V(), { sport: r, regionFilterId: s, eventId: i = "" } = e, { data: o, isSuccess: c } = pa(), { defaultRegion: m } = ad(), [u, l] = ee([]), [d, f] = ee([]), E = A(
    () => Vd(o),
    [o]
  ), g = s || m, p = o ? Rh(o) : [], v = ai(p, g) ? g : ai(p, m) ? m : Je.ALL;
  return te(() => {
    o && (l(p), f(hr(E, g)), (!ai(p, g) || !Ch(E, g, i)) && t(
      v,
      nr(E, v)
    ));
  }, [
    o,
    g,
    i,
    m,
    E
  ]), !c || !d.length || !i ? /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(xe, { amount: 5, height: "44px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(xe, { amount: 4, height: "61.5px" })) : /* @__PURE__ */ a.createElement("div", { "data-testid": `${r}-next-races-region-navigation` }, /* @__PURE__ */ a.createElement(
    zd,
    {
      regions: u,
      defaultValue: v,
      link: (y) => n(
        y,
        nr(E, y)
      ),
      onClick: (y) => t(
        y,
        nr(E, y)
      )
    }
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(
    Vo,
    {
      events: d,
      value: i,
      link: (y) => n(g, y),
      onClick: (y) => t(g, y),
      key: g
    }
  ));
}, cb = "ngs-meetings__NextRacesEventHeaderTemplate__container__gDXGa", lb = "ngs-meetings__NextRacesEventHeaderTemplate__goToMeeting__gDXGa", So = {
  container: cb,
  goToMeeting: lb
};
function ub() {
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    "div",
    {
      className: So.container,
      style: { padding: "1rem 0.75rem 0.5rem 0.75rem" }
    },
    /* @__PURE__ */ a.createElement(U, { height: 20 }),
    /* @__PURE__ */ a.createElement(U, { height: 12 }),
    /* @__PURE__ */ a.createElement(U, { height: 18, width: "50%" }),
    /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.75rem",
          height: "44px",
          padding: "0.25rem"
        }
      },
      /* @__PURE__ */ a.createElement(U, { width: "10rem", height: "100%" }),
      /* @__PURE__ */ a.createElement(U, { width: "10rem", height: "100%" })
    )
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
const mb = () => {
  const { getLinkForEvent: e } = V(), n = q();
  return /* @__PURE__ */ a.createElement("div", { className: So.container, "data-testid": "next-races-event-header" }, /* @__PURE__ */ a.createElement(u_, null, /* @__PURE__ */ a.createElement(Ta, { event: n, displayRaceTitle: !1 }, /* @__PURE__ */ a.createElement(
    pr,
    {
      startDateTime: n.startDateTime,
      isInPlay: n.isInPlay,
      settled: n.settled
    }
  )), /* @__PURE__ */ a.createElement("div", { className: So.goToMeeting }, /* @__PURE__ */ a.createElement(bn, { href: e(n.id, n.slug) }, "Go to Meeting ", /* @__PURE__ */ a.createElement(ra, { size: 12 }))), /* @__PURE__ */ a.createElement(
    Cf,
    {
      event: n,
      racingPostColor: "#000",
      isRacecardPage: !1
    }
  )));
}, TI = Ut(mb, {
  Loader: ub
}), db = () => {
  const { params: e, navigateToNextRaces: n, getLinkForNextRaces: t } = V(), r = q(), { marketCollections: s } = Qe(), i = Rf(s, r);
  if (r.isInPlay || r.settled)
    return e.marketSlug != null && n(e.regionFilterId, r.id), null;
  const o = (c) => {
    n(
      e.regionFilterId,
      r.id,
      X[c]
    );
  };
  return /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(
    It,
    {
      value: e.marketSlug ?? X[h.ALL_MARKETS]
    },
    /* @__PURE__ */ a.createElement(Nt, { variant: "standard" }, i.map(({ name: c, slug: m, isNew: u }) => /* @__PURE__ */ a.createElement(
      Pt,
      {
        variant: "standard",
        value: m,
        key: c,
        link: t(
          e.regionFilterId || Je.ALL,
          r.id,
          X[c]
        ),
        onClick: () => o(c)
      },
      u ? /* @__PURE__ */ a.createElement("span", null, c, " ", /* @__PURE__ */ a.createElement(bf, null, "New")) : c
    )))
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}, fb = () => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(xe, { amount: 3, height: "56px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" })), CI = Ut(
  db,
  {
    Loader: fb
  }
), Eb = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "future-races/promoted"],
    queryFn: e.services.meetings.getFutureRacesPromoted,
    refetchOnMount: !0
  });
}, _b = "ngs-meetings__FutureRacesWidgetUI__futureRacesList__J6wqp", gb = "ngs-meetings__FutureRacesWidgetUI__futureRacesListItem__J6wqp", pb = "ngs-meetings__FutureRacesWidgetUI__contentWrapper__J6wqp", hb = "ngs-meetings__FutureRacesWidgetUI__contentTop__J6wqp", vb = "ngs-meetings__FutureRacesWidgetUI__contentBottom__J6wqp", tr = {
  futureRacesList: _b,
  futureRacesListItem: gb,
  contentWrapper: pb,
  contentTop: hb,
  contentBottom: vb
}, Bf = 6048e5, yb = 864e5, Tb = 6e4, Cb = 36e5, Rb = 1e3, Fm = Symbol.for("constructDateFrom");
function De(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && Fm in e ? e[Fm](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function Re(e, n) {
  return De(n || e, e);
}
function $f(e, n, t) {
  const r = Re(e, t == null ? void 0 : t.in);
  return isNaN(n) ? De((t == null ? void 0 : t.in) || e, NaN) : (n && r.setDate(r.getDate() + n), r);
}
let bb = {};
function xn() {
  return bb;
}
function qt(e, n) {
  var c, m, u, l;
  const t = xn(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : m.weekStartsOn) ?? t.weekStartsOn ?? ((l = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : l.weekStartsOn) ?? 0, s = Re(e, n == null ? void 0 : n.in), i = s.getDay(), o = (i < r ? 7 : 0) + i - r;
  return s.setDate(s.getDate() - o), s.setHours(0, 0, 0, 0), s;
}
function Rn(e, n) {
  return qt(e, { ...n, weekStartsOn: 1 });
}
function Wf(e, n) {
  const t = Re(e, n == null ? void 0 : n.in), r = t.getFullYear(), s = De(t, 0);
  s.setFullYear(r + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const i = Rn(s), o = De(t, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const c = Rn(o);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= c.getTime() ? r : r - 1;
}
function Jr(e) {
  const n = Re(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function wb(e, ...n) {
  const t = De.bind(
    null,
    n.find((r) => typeof r == "object")
  );
  return n.map(t);
}
function Mm(e, n) {
  const t = Re(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Ab(e, n, t) {
  const [r, s] = wb(
    t == null ? void 0 : t.in,
    e,
    n
  ), i = Mm(r), o = Mm(s), c = +i - Jr(i), m = +o - Jr(o);
  return Math.round((c - m) / yb);
}
function Sb(e, n) {
  const t = Wf(e, n), r = De(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), Rn(r);
}
function Ib(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Nb(e) {
  return !(!Ib(e) && typeof e != "number" || isNaN(+Re(e)));
}
function Pb(e, n) {
  const t = Re(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
const Ob = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, kb = (e, n, t) => {
  let r;
  const s = Ob[e];
  return typeof s == "string" ? r = s : n === 1 ? r = s.one : r = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Eo(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Db = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Lb = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xb = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Fb = {
  date: Eo({
    formats: Db,
    defaultWidth: "full"
  }),
  time: Eo({
    formats: Lb,
    defaultWidth: "full"
  }),
  dateTime: Eo({
    formats: xb,
    defaultWidth: "full"
  })
}, Mb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Bb = (e, n, t, r) => Mb[e];
function Xn(e) {
  return (n, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, c = t != null && t.width ? String(t.width) : o;
      s = e.formattingValues[c] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, c = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[c] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[i];
  };
}
const $b = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Wb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Hb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, qb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Gb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ub = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Yb = (e, n) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, jb = {
  ordinalNumber: Yb,
  era: Xn({
    values: $b,
    defaultWidth: "wide"
  }),
  quarter: Xn({
    values: Wb,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Xn({
    values: Hb,
    defaultWidth: "wide"
  }),
  day: Xn({
    values: qb,
    defaultWidth: "wide"
  }),
  dayPeriod: Xn({
    values: Gb,
    defaultWidth: "wide",
    formattingValues: Ub,
    defaultFormattingWidth: "wide"
  })
};
function Qn(e) {
  return (n, t = {}) => {
    const r = t.width, s = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = n.match(s);
    if (!i)
      return null;
    const o = i[0], c = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], m = Array.isArray(c) ? Kb(c, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      Vb(c, (d) => d.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(m) : m, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const l = n.slice(o.length);
    return { value: u, rest: l };
  };
}
function Vb(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Kb(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function zb(e) {
  return (n, t = {}) => {
    const r = n.match(e.matchPattern);
    if (!r) return null;
    const s = r[0], i = n.match(e.parsePattern);
    if (!i) return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const c = n.slice(s.length);
    return { value: o, rest: c };
  };
}
const Xb = /^(\d+)(th|st|nd|rd)?/i, Qb = /\d+/i, Zb = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Jb = {
  any: [/^b/i, /^(a|c)/i]
}, ew = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, tw = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, nw = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, rw = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, aw = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, sw = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, iw = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ow = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, cw = {
  ordinalNumber: zb({
    matchPattern: Xb,
    parsePattern: Qb,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Qn({
    matchPatterns: Zb,
    defaultMatchWidth: "wide",
    parsePatterns: Jb,
    defaultParseWidth: "any"
  }),
  quarter: Qn({
    matchPatterns: ew,
    defaultMatchWidth: "wide",
    parsePatterns: tw,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Qn({
    matchPatterns: nw,
    defaultMatchWidth: "wide",
    parsePatterns: rw,
    defaultParseWidth: "any"
  }),
  day: Qn({
    matchPatterns: aw,
    defaultMatchWidth: "wide",
    parsePatterns: sw,
    defaultParseWidth: "any"
  }),
  dayPeriod: Qn({
    matchPatterns: iw,
    defaultMatchWidth: "any",
    parsePatterns: ow,
    defaultParseWidth: "any"
  })
}, Hf = {
  code: "en-US",
  formatDistance: kb,
  formatLong: Fb,
  formatRelative: Bb,
  localize: jb,
  match: cw,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function lw(e, n) {
  const t = Re(e, n == null ? void 0 : n.in);
  return Ab(t, Pb(t)) + 1;
}
function qf(e, n) {
  const t = Re(e, n == null ? void 0 : n.in), r = +Rn(t) - +Sb(t);
  return Math.round(r / Bf) + 1;
}
function hc(e, n) {
  var l, d, f, E;
  const t = Re(e, n == null ? void 0 : n.in), r = t.getFullYear(), s = xn(), i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (l = n == null ? void 0 : n.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((E = (f = s.locale) == null ? void 0 : f.options) == null ? void 0 : E.firstWeekContainsDate) ?? 1, o = De((n == null ? void 0 : n.in) || e, 0);
  o.setFullYear(r + 1, 0, i), o.setHours(0, 0, 0, 0);
  const c = qt(o, n), m = De((n == null ? void 0 : n.in) || e, 0);
  m.setFullYear(r, 0, i), m.setHours(0, 0, 0, 0);
  const u = qt(m, n);
  return +t >= +c ? r + 1 : +t >= +u ? r : r - 1;
}
function uw(e, n) {
  var c, m, u, l;
  const t = xn(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((m = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : m.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((l = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, s = hc(e, n), i = De((n == null ? void 0 : n.in) || e, 0);
  return i.setFullYear(s, 0, r), i.setHours(0, 0, 0, 0), qt(i, n);
}
function Gf(e, n) {
  const t = Re(e, n == null ? void 0 : n.in), r = +qt(t, n) - +uw(t, n);
  return Math.round(r / Bf) + 1;
}
function re(e, n) {
  const t = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(n, "0");
  return t + r;
}
const xt = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), r = t > 0 ? t : 1 - t;
    return re(n === "yy" ? r % 100 : r, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : re(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return re(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return re(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return re(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return re(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return re(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, r = e.getMilliseconds(), s = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return re(s, n.length);
  }
}, hn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Bm = {
  // Era
  G: function(e, n, t) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const r = e.getFullYear(), s = r > 0 ? r : 1 - r;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return xt.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, r) {
    const s = hc(e, r), i = s > 0 ? s : 1 - s;
    if (n === "YY") {
      const o = i % 100;
      return re(o, 2);
    }
    return n === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : re(i, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = Wf(e);
    return re(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return re(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return re(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return re(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return xt.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return re(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, r) {
    const s = Gf(e, r);
    return n === "wo" ? t.ordinalNumber(s, { unit: "week" }) : re(s, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const r = qf(e);
    return n === "Io" ? t.ordinalNumber(r, { unit: "week" }) : re(r, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : xt.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const r = lw(e);
    return n === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : re(r, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const r = e.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, r) {
    const s = e.getDay(), i = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return re(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, r) {
    const s = e.getDay(), i = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return re(i, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const r = e.getDay(), s = r === 0 ? 7 : r;
    switch (n) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return re(s, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const r = e.getHours();
    let s;
    switch (r === 12 ? s = hn.noon : r === 0 ? s = hn.midnight : s = r / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const r = e.getHours();
    let s;
    switch (r >= 17 ? s = hn.evening : r >= 12 ? s = hn.afternoon : r >= 4 ? s = hn.morning : s = hn.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return xt.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : xt.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const r = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : re(r, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let r = e.getHours();
    return r === 0 && (r = 24), n === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : re(r, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : xt.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : xt.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return xt.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return Wm(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return zt(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return zt(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return Wm(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return zt(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return zt(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + $m(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + zt(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + $m(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + zt(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const r = Math.trunc(+e / 1e3);
    return re(r, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return re(+e, n.length);
  }
};
function $m(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), s = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? t + String(s) : t + String(s) + n + re(i, 2);
}
function Wm(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + re(Math.abs(e) / 60, 2) : zt(e, n);
}
function zt(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), s = re(Math.trunc(r / 60), 2), i = re(r % 60, 2);
  return t + s + n + i;
}
const Hm = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, Uf = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, mw = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], r = t[1], s = t[2];
  if (!s)
    return Hm(e, n);
  let i;
  switch (r) {
    case "P":
      i = n.dateTime({ width: "short" });
      break;
    case "PP":
      i = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = n.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Hm(r, n)).replace("{{time}}", Uf(s, n));
}, Io = {
  p: Uf,
  P: mw
}, dw = /^D+$/, fw = /^Y+$/, Ew = ["D", "DD", "YY", "YYYY"];
function Yf(e) {
  return dw.test(e);
}
function jf(e) {
  return fw.test(e);
}
function No(e, n, t) {
  const r = _w(e, n, t);
  if (console.warn(r), Ew.includes(e)) throw new RangeError(r);
}
function _w(e, n, t) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const gw = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, pw = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hw = /^'([^]*?)'?$/, vw = /''/g, yw = /[a-zA-Z]/;
function Po(e, n, t) {
  var l, d, f, E;
  const r = xn(), s = r.locale ?? Hf, i = r.firstWeekContainsDate ?? ((d = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = r.weekStartsOn ?? ((E = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : E.weekStartsOn) ?? 0, c = Re(e, t == null ? void 0 : t.in);
  if (!Nb(c))
    throw new RangeError("Invalid time value");
  let m = n.match(pw).map((g) => {
    const p = g[0];
    if (p === "p" || p === "P") {
      const v = Io[p];
      return v(g, s.formatLong);
    }
    return g;
  }).join("").match(gw).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const p = g[0];
    if (p === "'")
      return { isToken: !1, value: Tw(g) };
    if (Bm[p])
      return { isToken: !0, value: g };
    if (p.match(yw))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: g };
  });
  s.localize.preprocessor && (m = s.localize.preprocessor(c, m));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: s
  };
  return m.map((g) => {
    if (!g.isToken) return g.value;
    const p = g.value;
    (jf(p) || Yf(p)) && No(p, n, String(e));
    const v = Bm[p[0]];
    return v(c, p, s.localize, u);
  }).join("");
}
function Tw(e) {
  const n = e.match(hw);
  return n ? n[1].replace(vw, "'") : e;
}
function Cw() {
  return Object.assign({}, xn());
}
function Rw(e, n) {
  const t = Re(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function bw(e, n) {
  const t = ww(n) ? new n(0) : De(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function ww(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const Aw = 10;
class Vf {
  constructor() {
    k(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class Sw extends Vf {
  constructor(n, t, r, s, i) {
    super(), this.value = n, this.validateValue = t, this.setValue = r, this.priority = s, i && (this.subPriority = i);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, r) {
    return this.setValue(n, t, this.value, r);
  }
}
class Iw extends Vf {
  constructor(t, r) {
    super();
    k(this, "priority", Aw);
    k(this, "subPriority", -1);
    this.context = t || ((s) => De(r, s));
  }
  set(t, r) {
    return r.timestampIsSet ? t : De(t, bw(t, this.context));
  }
}
class ne {
  run(n, t, r, s) {
    const i = this.parse(n, t, r, s);
    return i ? {
      setter: new Sw(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(n, t, r) {
    return !0;
  }
}
class Nw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 140);
    k(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, r, s) {
    return r.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const ge = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, gt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function pe(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function le(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function pt(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, o = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (s * Cb + i * Tb + o * Rb),
    rest: n.slice(t[0].length)
  };
}
function Kf(e) {
  return le(ge.anyDigitsSigned, e);
}
function me(e, n) {
  switch (e) {
    case 1:
      return le(ge.singleDigit, n);
    case 2:
      return le(ge.twoDigits, n);
    case 3:
      return le(ge.threeDigits, n);
    case 4:
      return le(ge.fourDigits, n);
    default:
      return le(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function ea(e, n) {
  switch (e) {
    case 1:
      return le(ge.singleDigitSigned, n);
    case 2:
      return le(ge.twoDigitsSigned, n);
    case 3:
      return le(ge.threeDigitsSigned, n);
    case 4:
      return le(ge.fourDigitsSigned, n);
    default:
      return le(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function vc(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function zf(e, n) {
  const t = n > 0, r = t ? n : 1 - n;
  let s;
  if (r <= 50)
    s = e || 100;
  else {
    const i = r + 50, o = Math.trunc(i / 100) * 100, c = e >= i % 100;
    s = e + o - (c ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function Xf(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Pw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, s) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return pe(me(4, t), i);
      case "yo":
        return pe(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return pe(me(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, s) {
    const i = t.getFullYear();
    if (s.isTwoDigitYear) {
      const c = zf(
        s.year,
        i
      );
      return t.setFullYear(c, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const o = !("era" in r) || r.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Ow extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return pe(me(4, t), i);
      case "Yo":
        return pe(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return pe(me(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, s, i) {
    const o = hc(t, i);
    if (s.isTwoDigitYear) {
      const m = zf(
        s.year,
        o
      );
      return t.setFullYear(
        m,
        0,
        i.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), qt(t, i);
    }
    const c = !("era" in r) || r.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(c, 0, i.firstWeekContainsDate), t.setHours(0, 0, 0, 0), qt(t, i);
  }
}
class kw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return ea(r === "R" ? 4 : r.length, t);
  }
  set(t, r, s) {
    const i = De(t, 0);
    return i.setFullYear(s, 0, 4), i.setHours(0, 0, 0, 0), Rn(i);
  }
}
class Dw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 130);
    k(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return ea(r === "u" ? 4 : r.length, t);
  }
  set(t, r, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Lw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 120);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return me(r.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class xw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 120);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return me(r.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Fw extends ne {
  constructor() {
    super(...arguments);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    k(this, "priority", 110);
  }
  parse(t, r, s) {
    const i = (o) => o - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return pe(
          le(ge.month, t),
          i
        );
      // 01, 02, ..., 12
      case "MM":
        return pe(me(2, t), i);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return pe(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Mw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 110);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const i = (o) => o - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return pe(
          le(ge.month, t),
          i
        );
      // 01, 02, ..., 12
      case "LL":
        return pe(me(2, t), i);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return pe(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Bw(e, n, t) {
  const r = Re(e, t == null ? void 0 : t.in), s = Gf(r, t) - n;
  return r.setDate(r.getDate() - s * 7), Re(r, t == null ? void 0 : t.in);
}
class $w extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 100);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "w":
        return le(ge.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, s, i) {
    return qt(Bw(t, s, i), i);
  }
}
function Ww(e, n, t) {
  const r = Re(e, t == null ? void 0 : t.in), s = qf(r, t) - n;
  return r.setDate(r.getDate() - s * 7), r;
}
class Hw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 100);
    k(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "I":
        return le(ge.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, s) {
    return Rn(Ww(t, s));
  }
}
const qw = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Gw = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Uw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "subPriority", 1);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "d":
        return le(ge.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    const s = t.getFullYear(), i = Xf(s), o = t.getMonth();
    return i ? r >= 1 && r <= Gw[o] : r >= 1 && r <= qw[o];
  }
  set(t, r, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class Yw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "subpriority", 1);
    k(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "D":
      case "DD":
        return le(ge.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    const s = t.getFullYear();
    return Xf(s) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function yc(e, n, t) {
  var d, f, E, g;
  const r = xn(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((g = (E = r.locale) == null ? void 0 : E.options) == null ? void 0 : g.weekStartsOn) ?? 0, i = Re(e, t == null ? void 0 : t.in), o = i.getDay(), m = (n % 7 + 7) % 7, u = 7 - s, l = n < 0 || n > 6 ? n - (o + u) % 7 : (m + u) % 7 - (o + u) % 7;
  return $f(i, l, t);
}
class jw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, i) {
    return t = yc(t, s, i), t.setHours(0, 0, 0, 0), t;
  }
}
class Vw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s, i) {
    const o = (c) => {
      const m = Math.floor((c - 1) / 7) * 7;
      return (c + i.weekStartsOn + 6) % 7 + m;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return pe(me(r.length, t), o);
      // 3rd
      case "eo":
        return pe(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, i) {
    return t = yc(t, s, i), t.setHours(0, 0, 0, 0), t;
  }
}
class Kw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, s, i) {
    const o = (c) => {
      const m = Math.floor((c - 1) / 7) * 7;
      return (c + i.weekStartsOn + 6) % 7 + m;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return pe(me(r.length, t), o);
      // 3rd
      case "co":
        return pe(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, i) {
    return t = yc(t, s, i), t.setHours(0, 0, 0, 0), t;
  }
}
function zw(e, n, t) {
  const r = Re(e, t == null ? void 0 : t.in), s = Rw(r, t), i = n - s;
  return $f(r, i, t);
}
class Xw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 90);
    k(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const i = (o) => o === 0 ? 7 : o;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return me(r.length, t);
      // 2nd
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return pe(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // T
      case "iiiii":
        return pe(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tu
      case "iiiiii":
        return pe(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tuesday
      case "iiii":
      default:
        return pe(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, s) {
    return t = zw(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class Qw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 80);
    k(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(vc(s), 0, 0, 0), t;
  }
}
class Zw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 80);
    k(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(vc(s), 0, 0, 0), t;
  }
}
class Jw extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 80);
    k(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(vc(s), 0, 0, 0), t;
  }
}
class eA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "h":
        return le(ge.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, s) {
    const i = t.getHours() >= 12;
    return i && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !i && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class tA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "H":
        return le(ge.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class nA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "K":
        return le(ge.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class rA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 70);
    k(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "k":
        return le(ge.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, s) {
    const i = s <= 24 ? s % 24 : s;
    return t.setHours(i, 0, 0, 0), t;
  }
}
class aA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 60);
    k(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "m":
        return le(ge.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class sA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 50);
    k(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "s":
        return le(ge.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return me(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, s) {
    return t.setSeconds(s, 0), t;
  }
}
class iA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 30);
    k(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const s = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return pe(me(r.length, t), s);
  }
  set(t, r, s) {
    return t.setMilliseconds(s), t;
  }
}
class oA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 10);
    k(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return pt(
          gt.basicOptionalMinutes,
          t
        );
      case "XX":
        return pt(gt.basic, t);
      case "XXXX":
        return pt(
          gt.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return pt(
          gt.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return pt(gt.extended, t);
    }
  }
  set(t, r, s) {
    return r.timestampIsSet ? t : De(
      t,
      t.getTime() - Jr(t) - s
    );
  }
}
class cA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 10);
    k(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return pt(
          gt.basicOptionalMinutes,
          t
        );
      case "xx":
        return pt(gt.basic, t);
      case "xxxx":
        return pt(
          gt.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return pt(
          gt.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return pt(gt.extended, t);
    }
  }
  set(t, r, s) {
    return r.timestampIsSet ? t : De(
      t,
      t.getTime() - Jr(t) - s
    );
  }
}
class lA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 40);
    k(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Kf(t);
  }
  set(t, r, s) {
    return [De(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class uA extends ne {
  constructor() {
    super(...arguments);
    k(this, "priority", 20);
    k(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Kf(t);
  }
  set(t, r, s) {
    return [De(t, s), { timestampIsSet: !0 }];
  }
}
const mA = {
  G: new Nw(),
  y: new Pw(),
  Y: new Ow(),
  R: new kw(),
  u: new Dw(),
  Q: new Lw(),
  q: new xw(),
  M: new Fw(),
  L: new Mw(),
  w: new $w(),
  I: new Hw(),
  d: new Uw(),
  D: new Yw(),
  E: new jw(),
  e: new Vw(),
  c: new Kw(),
  i: new Xw(),
  a: new Qw(),
  b: new Zw(),
  B: new Jw(),
  h: new eA(),
  H: new tA(),
  K: new nA(),
  k: new rA(),
  m: new aA(),
  s: new sA(),
  S: new iA(),
  X: new oA(),
  x: new cA(),
  t: new lA(),
  T: new uA()
}, dA = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fA = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, EA = /^'([^]*?)'?$/, _A = /''/g, gA = /\S/, pA = /[a-zA-Z]/;
function qm(e, n, t, r) {
  var v, y, C, b;
  const s = () => De(t, NaN), i = Cw(), o = i.locale ?? Hf, c = i.firstWeekContainsDate ?? ((y = (v = i.locale) == null ? void 0 : v.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, m = i.weekStartsOn ?? ((b = (C = i.locale) == null ? void 0 : C.options) == null ? void 0 : b.weekStartsOn) ?? 0;
  if (!n)
    return e ? s() : Re(t, r == null ? void 0 : r.in);
  const u = {
    firstWeekContainsDate: c,
    weekStartsOn: m,
    locale: o
  }, l = [new Iw(r == null ? void 0 : r.in, t)], d = n.match(fA).map((R) => {
    const P = R[0];
    if (P in Io) {
      const D = Io[P];
      return D(R, o.formatLong);
    }
    return R;
  }).join("").match(dA), f = [];
  for (let R of d) {
    jf(R) && No(R, n, e), Yf(R) && No(R, n, e);
    const P = R[0], D = mA[P];
    if (D) {
      const { incompatibleTokens: z } = D;
      if (Array.isArray(z)) {
        const ae = f.find(
          (Te) => z.includes(Te.token) || Te.token === P
        );
        if (ae)
          throw new RangeError(
            `The format string mustn't contain \`${ae.fullToken}\` and \`${R}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${R}\` and any other token at the same time`
        );
      f.push({ token: P, fullToken: R });
      const F = D.run(
        e,
        R,
        o.match,
        u
      );
      if (!F)
        return s();
      l.push(F.setter), e = F.rest;
    } else {
      if (P.match(pA))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + P + "`"
        );
      if (R === "''" ? R = "'" : P === "'" && (R = hA(R)), e.indexOf(R) === 0)
        e = e.slice(R.length);
      else
        return s();
    }
  }
  if (e.length > 0 && gA.test(e))
    return s();
  const E = l.map((R) => R.priority).sort((R, P) => P - R).filter((R, P, D) => D.indexOf(R) === P).map(
    (R) => l.filter((P) => P.priority === R).sort((P, D) => D.subPriority - P.subPriority)
  ).map((R) => R[0]);
  let g = Re(t, r == null ? void 0 : r.in);
  if (isNaN(+g)) return s();
  const p = {};
  for (const R of E) {
    if (!R.validate(g, u))
      return s();
    const P = R.set(g, p, u);
    Array.isArray(P) ? (g = P[0], Object.assign(p, P[1])) : g = P;
  }
  return g;
}
function hA(e) {
  return e.match(EA)[1].replace(_A, "'");
}
const vA = ({
  futureRace: e
}) => {
  const n = V(), t = `${n.params.sport}/${e.eventId}`;
  return /* @__PURE__ */ a.createElement(en, { className: tr.futureRacesListItem }, /* @__PURE__ */ a.createElement(
    Ea,
    {
      onClick: (r) => {
        r.preventDefault(), n.navigateToCustomUrl(t);
      }
    },
    /* @__PURE__ */ a.createElement(
      "a",
      {
        className: tr.contentWrapper,
        href: n.getLinkForCustomUrl(t)
      },
      /* @__PURE__ */ a.createElement("div", { className: tr.contentTop }, /* @__PURE__ */ a.createElement("span", null, Po(e.raceDate, "EEEE d MMM")), /* @__PURE__ */ a.createElement("span", null, e.competitionName)),
      /* @__PURE__ */ a.createElement("div", { className: tr.contentBottom }, /* @__PURE__ */ a.createElement("span", null, e.raceName))
    )
  ));
}, yA = ({ data: e }) => /* @__PURE__ */ a.createElement(Jt, { className: tr.futureRacesList }, e.map((n) => /* @__PURE__ */ a.createElement(
  vA,
  {
    key: n.eventId,
    futureRace: n
  }
))), TA = "ngs-meetings__FutureRacesWidget__action__uAynQ", Gm = {
  action: TA
};
function CA() {
  const e = V(), { sport: n } = e.params, { data: t, isSuccess: r } = Eb();
  if (!t || (t == null ? void 0 : t.length) === 0)
    return null;
  if (!r)
    return /* @__PURE__ */ a.createElement(U, null);
  const s = `${n}/${rr[Et.FUTURE_RACES]}`, i = /* @__PURE__ */ a.createElement(
    ke,
    {
      className: Gm.action,
      onClick: () => e.navigateToCustomUrl(s),
      variant: "link",
      asChild: !0
    },
    /* @__PURE__ */ a.createElement(
      "a",
      {
        className: Gm.action,
        href: e.getLinkForCustomUrl(s)
      },
      "See all"
    )
  );
  return /* @__PURE__ */ a.createElement("div", { "data-testid": `${n}-future-races` }, /* @__PURE__ */ a.createElement(Gt, { actions: i }, "Future Races"), /* @__PURE__ */ a.createElement(yA, { data: t }));
}
function RI() {
  const e = V(), { navigationCarousel: n } = rd(), { page: t, sport: r } = e.params;
  te(() => {
    sd(r);
  }, [r, t]);
  const s = (i, o) => {
    o ? e.navigateToCustomUrl(i) : e.navigateToPage(i);
  };
  return /* @__PURE__ */ a.createElement(It, { value: t, "data-testid": `${r}-meetings-navigation` }, /* @__PURE__ */ a.createElement(Nt, { variant: "chevron" }, n.map(({ name: i, displayName: o, icon: c, customUrl: m }) => ({
    displayName: o,
    icon: sv[c],
    customUrl: m,
    url: rr[i]
  })).map(({ url: i, displayName: o, icon: c, customUrl: m }) => /* @__PURE__ */ a.createElement(
    Pt,
    {
      size: "small",
      key: i,
      variant: "chevron",
      value: i,
      link: m ? e.getLinkForCustomUrl(i) : e.getLinkForPage(i),
      onClick: () => s(i, m)
    },
    /* @__PURE__ */ a.createElement(c, null),
    o
  ))));
}
const RA = "ngs-meetings__QuickLinksUI__quickLinks__oh3Sp", bA = "ngs-meetings__QuickLinksUI__quickLinksItem__oh3Sp", wA = "ngs-meetings__QuickLinksUI__quickLinksItemFullWidth__oh3Sp", AA = "ngs-meetings__QuickLinksUI__quickLinksItemHref__oh3Sp", Xt = {
  quickLinks: RA,
  quickLinksItem: bA,
  quickLinksItemFullWidth: wA,
  quickLinksItemHref: AA
}, SA = ({ links: e }) => {
  const n = V();
  return /* @__PURE__ */ a.createElement(Jt, { className: Xt.quickLinks, "data-testid": "quick-links-list" }, e.map(({ url: t, fullWidth: r }) => /* @__PURE__ */ a.createElement(
    en,
    {
      key: t.href,
      className: J(
        Xt.quickLinksItem,
        r && Xt.quickLinksItemFullWidth
      ),
      "data-testid": `quick-link-${t.title}`
    },
    /* @__PURE__ */ a.createElement(
      Ea,
      {
        onClick: (s) => {
          s.preventDefault(), n.navigateToCustomUrl(t.href);
        },
        "data-testid": `quick-link-${t.title}-link`
      },
      /* @__PURE__ */ a.createElement(
        "a",
        {
          href: n.getLinkForCustomUrl(t.href),
          className: Xt.quickLinksItemHref
        },
        t.title
      )
    )
  )));
}, IA = () => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(Gt, null, "Quick Links"), /* @__PURE__ */ a.createElement(Jt, { className: Xt.quickLinks, "data-testid": "quick-links-list" }, [...Array(5)].map((e, n) => /* @__PURE__ */ a.createElement(
  en,
  {
    key: n,
    className: J(
      Xt.quickLinksItem,
      n === 0 && Xt.quickLinksItemFullWidth
    )
  },
  /* @__PURE__ */ a.createElement(Ea, null, /* @__PURE__ */ a.createElement(U, { width: "100%", height: "100%" }))
)))), Ce = {
  TOTE: "Tote",
  TOP_BETS: "Top Bets",
  NAPS: "Naps Table",
  FUTURE_RACES: "Future Races",
  SPECIALS: "Specials"
}, Zn = {
  [Ce.TOTE]: "tote",
  [Ce.TOP_BETS]: "top-bets",
  [Ce.NAPS]: "naps",
  [Ce.FUTURE_RACES]: "future-races",
  [Ce.SPECIALS]: "specials"
}, Jn = {
  [Ce.TOTE]: "Tote",
  [Ce.TOP_BETS]: "Top Bets",
  [Ce.NAPS]: "Naps Table",
  [Ce.FUTURE_RACES]: "Future Races",
  [Ce.SPECIALS]: "Specials"
}, NA = {
  [ce.GREYHOUNDS]: [
    {
      url: {
        title: Jn[Ce.FUTURE_RACES],
        href: `${ce.GREYHOUNDS}/${Zn[Ce.FUTURE_RACES]}`
      }
    },
    {
      url: {
        title: Jn[Ce.SPECIALS],
        href: `${ce.GREYHOUNDS}/${Zn[Ce.SPECIALS]}`
      }
    },
    {
      url: {
        title: `Virtual ${St[ce.GREYHOUNDS]}`,
        href: `virtual-world/${ce.GREYHOUNDS}/flats`
      }
    },
    {
      url: {
        title: St[ce.HORSE_RACING],
        href: `${ce.HORSE_RACING}/meetings`
      }
    }
  ],
  [ce.HORSE_RACING]: [
    {
      url: {
        title: St[ce.GREYHOUNDS],
        href: `${ce.GREYHOUNDS}/meetings`
      },
      fullWidth: !0
    },
    {
      url: {
        title: `Virtual ${St[ce.HORSE_RACING]}`,
        href: "virtual-world/horses/flats"
      }
    },
    {
      url: {
        title: Jn[Ce.TOP_BETS],
        href: `${ce.HORSE_RACING}/${Zn[Ce.TOP_BETS]}`
      }
    },
    {
      url: {
        title: Jn[Ce.NAPS],
        href: `${ce.HORSE_RACING}/${Zn[Ce.NAPS]}`
      }
    },
    {
      url: {
        title: Jn[Ce.TOTE],
        href: `${ce.HORSE_RACING}/${Zn[Ce.TOTE]}`
      }
    }
  ]
};
function PA() {
  const e = V(), { sport: n } = e.params, { quickLinks: t, isLoading: r } = b_(), s = NA[n];
  return r ? /* @__PURE__ */ a.createElement(IA, null) : /* @__PURE__ */ a.createElement("div", { "data-testid": `${n}-quick-links` }, /* @__PURE__ */ a.createElement(Gt, null, "Quick Links"), /* @__PURE__ */ a.createElement(
    SA,
    {
      links: t.length > 0 ? t : s
    }
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
const OA = hE(
  () => import("./PopularAccas-Do-cZGXJ.js").then((e) => ({ default: e.PopularAccas }))
), kA = () => /* @__PURE__ */ a.createElement(vE, { fallback: null }, /* @__PURE__ */ a.createElement(OA, null)), DA = "ngs-meetings__RegionNavigationSkeleton__competition__v8y4U", LA = {
  competition: DA
}, xA = () => {
  const e = /* @__PURE__ */ a.createElement("div", { className: LA.competition }, /* @__PURE__ */ a.createElement("div", { style: { width: "75%" } }, /* @__PURE__ */ a.createElement(xe, { height: "26px", padding: "0 8px" })), /* @__PURE__ */ a.createElement("div", { style: { width: "50%" } }, /* @__PURE__ */ a.createElement(xe, { amount: 3, height: "28px" })), /* @__PURE__ */ a.createElement(xe, { amount: 5, height: "38px" }));
  return /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement(xe, { amount: 5, height: "44px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(xe, { amount: 3, height: "56px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(xe, { amount: 5, height: "36px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        height: "47px",
        display: "flex",
        gap: "8px",
        padding: "8px"
      }
    },
    /* @__PURE__ */ a.createElement(U, { height: "100%", style: { flex: 7 } }),
    /* @__PURE__ */ a.createElement(U, { height: "100%", style: { flex: 1 } })
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), [...Array(5)].map((n, t) => /* @__PURE__ */ a.createElement(a.Fragment, { key: t }, e)));
};
function bI() {
  const { params: e, getLinkForRegion: n, navigateToRegion: t } = V(), {
    sport: r,
    regionFilterId: s = Je.ALL,
    dayFilterId: i = sr.TODAY
  } = e, { data: o, isSuccess: c } = pa(), m = rn();
  if (!c)
    return /* @__PURE__ */ a.createElement(xA, null);
  const u = (l) => l === Je.ALL ? o.regionCompetitionsByDays : o.regionCompetitionsByDays.map((d) => ({
    ...d,
    regionCompetitions: d.regionCompetitions.filter(
      (f) => f.regionFilter.id === l
    )
  })).filter((d) => d.regionCompetitions.length > 0);
  return /* @__PURE__ */ a.createElement("div", { "data-testid": `${r}-region-navigation` }, /* @__PURE__ */ a.createElement(It, { value: s }, /* @__PURE__ */ a.createElement(
    Nt,
    {
      carousel: !0,
      variant: "underscore",
      theme: "dark",
      "data-testid": "region-carousel"
    },
    o.availableRegionFilters.map((l) => /* @__PURE__ */ a.createElement(
      Pt,
      {
        variant: "underscore",
        theme: "dark",
        value: l.id,
        key: l.id,
        link: n(l.id, i),
        onClick: () => t(l.id, i)
      },
      l.name
    ))
  ), /* @__PURE__ */ a.createElement(w, { theme: "light" }), o.availableRegionFilters.map((l) => {
    var d, f;
    return /* @__PURE__ */ a.createElement(Zt, { value: l.id, key: l.id }, /* @__PURE__ */ a.createElement(
      Xd,
      {
        defaultDay: ((d = u(l.id).find(
          (E) => E.day.link === i
        )) == null ? void 0 : d.day.link) ?? ((f = u(l.id)[0]) == null ? void 0 : f.day.link),
        regionCompetitions: u(l.id),
        onDayNavigation: (E) => t(l.id, E),
        region: l.id,
        bogStatus: m === Ke.OPTED_IN
      }
    ));
  })), /* @__PURE__ */ a.createElement(w, { theme: "light" }));
}
const Qf = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "ambassador-content"],
    queryFn: e.services.meetings.getAmbassadorContent,
    refetchOnMount: !1
  });
}, FA = "ngs-meetings__TodayPicks__carouselContainer__x86iy", MA = "ngs-meetings__TodayPicks__carousel__x86iy", Um = {
  carouselContainer: FA,
  carousel: MA
}, BA = () => /* @__PURE__ */ a.createElement(_a, null, /* @__PURE__ */ a.createElement(U, { height: "244px" })), $A = () => {
  const { data: e } = Qf(), n = V(), { sport: t } = n.params, [r] = wn({});
  return e != null && e.length ? /* @__PURE__ */ a.createElement("div", { className: "today-picks", "data-testid": `${t}-today-picks` }, /* @__PURE__ */ a.createElement(Gt, null, "Today’s Picks"), /* @__PURE__ */ a.createElement("div", { className: Um.carouselContainer, ref: r }, /* @__PURE__ */ a.createElement("div", { className: Um.carousel }, e.map((s) => /* @__PURE__ */ a.createElement("div", { style: { minWidth: "330px" }, key: s.eventId }, /* @__PURE__ */ a.createElement(ef, { ambassadorContent: s, withEventLink: !0 }))))), /* @__PURE__ */ a.createElement(w, { theme: "light" })) : null;
}, WA = () => {
  const { isLoading: e } = Qf();
  return e ? /* @__PURE__ */ a.createElement(BA, null) : /* @__PURE__ */ a.createElement($A, null);
}, HA = [
  "bog-opt-in",
  "featured-races",
  "price-boosts",
  "next-races",
  "popular-accas",
  "today-picks",
  "quick-links",
  "future-races"
], qA = {
  "bog-opt-in": id,
  "featured-races": Bh,
  "price-boosts": rv,
  "next-races": Sh,
  "popular-accas": kA,
  "today-picks": WA,
  "quick-links": PA,
  "future-races": CA
}, wI = () => {
  const { homeWidgets: e } = w_(), n = e.length > 0 ? e : HA;
  return /* @__PURE__ */ a.createElement(a.Fragment, null, n.map((t) => {
    const r = qA[t];
    return r && /* @__PURE__ */ a.createElement(r, { key: t });
  }));
}, GA = () => {
  const { apiPath: e } = V();
  return ye({
    queryKey: ["nextOffs", e],
    queryFn: () => fetch(e).then((t) => t.json()),
    refetchOnMount: !1,
    staleTime: 120 * 1e3
    // 2 minutes
  });
}, Zf = ko(void 0), UA = () => {
  const e = Do(Zf);
  if (e === void 0)
    throw new Error(
      "useExcludedItems must be used within an ExcludedItemsProvider"
    );
  return e;
}, Ym = 10, Jf = () => {
  const { data: e, refetch: n, isStale: t } = GA(), { exclude: r, isExcluded: s } = UA();
  return te(() => {
    e != null && e.length && e.length < Ym && t && n();
  }, [e == null ? void 0 : e.length, t, n]), {
    nextOffs: A(() => e ? e.filter(({ id: o }) => !s(o)).slice(0, Ym) : [], [e, s]),
    exclude: r
  };
}, YA = ({ children: e }) => {
  const [n] = wn({});
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      style: {
        flex: 1,
        overflow: "hidden",
        padding: "0.75rem"
      },
      ref: n
    },
    /* @__PURE__ */ a.createElement(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "flex-start",
          gap: "0.75rem"
        }
      },
      e
    )
  );
};
var jA = "is-in-play", VA = "wh.push.ready";
function KA(e) {
  return function(t, r) {
    e.subscribe(t, function(s, i) {
      e.unsubscribe(t), r(i);
    });
  };
}
function zA(e) {
  var n = e.messageBus, t = e.readyTopic, r = e.operationSelector, s = new Promise(function(o) {
    KA(n)(t, o);
  }), i = {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    UNSUBSCRIBE_ALL: "unsubscribeAll"
  };
  return {
    subscribe: function(c) {
      return new Promise(function(m) {
        s.then(function() {
          var u;
          (u = r(i.SUBSCRIBE)) === null || u === void 0 || u(c), m();
        });
      });
    },
    unsubscribe: function(c) {
      return new Promise(function(m) {
        s.then(function() {
          var u;
          (u = r(i.UNSUBSCRIBE)) === null || u === void 0 || u(c), m();
        });
      });
    },
    unsubscribeAll: function(c) {
      return new Promise(function(m) {
        s.then(function() {
          var u;
          (u = r(i.UNSUBSCRIBE_ALL)) === null || u === void 0 || u(c), m();
        });
      });
    }
  };
}
function XA(e) {
  return window.subscriptionManager[e];
}
var eE = zA({
  messageBus: yE,
  operationSelector: XA,
  readyTopic: VA
}), QA = eE.subscribe, ZA = eE.unsubscribe;
const jm = "sports", Vm = "next-offs-component", JA = (e, n) => {
  te(() => {
    const t = (r) => {
      r.type === jA && n(r.value);
    };
    return QA({
      type: jm,
      owner: Vm,
      eventId: e,
      callback: t
    }), () => {
      ZA({ type: jm, owner: Vm, eventId: e, callback: t });
    };
  }, [n, e]);
}, eS = ({ event: e }) => {
  const { exclude: n } = Jf(), t = Pe(
    (r) => {
      r && n(e.id);
    },
    [e.id, n]
  );
  return JA(e.id, t), /* @__PURE__ */ a.createElement(
    "div",
    {
      key: e.id,
      style: {
        minWidth: "300px",
        borderRadius: "6px",
        boxShadow: "0 0 1rem 1px rgba(0, 0, 0, 0.1)"
      }
    },
    /* @__PURE__ */ a.createElement(jd, { event: e })
  );
}, tS = () => {
  const { nextOffs: e } = Jf();
  return e ? /* @__PURE__ */ a.createElement(YA, null, e.map((n) => /* @__PURE__ */ a.createElement(eS, { key: n.id, event: n }))) : null;
}, nS = ({
  children: e
}) => {
  const [n, t] = ee(/* @__PURE__ */ new Set()), r = Pe((o) => {
    t((c) => new Set(c).add(o));
  }, []), s = Pe(
    (o) => n.has(o),
    [n]
  );
  te(() => () => t(/* @__PURE__ */ new Set()), []);
  const i = {
    exclude: r,
    isExcluded: s
  };
  return /* @__PURE__ */ a.createElement(Zf.Provider, { value: i }, e);
}, rS = new TE({}), AI = ({ config: e }) => {
  const n = A(
    () => ({
      env: {
        platform: "mobile",
        environment: "prd",
        jurisdiction: "com",
        locale: e.locale
      },
      params: { sport: e.sportId },
      navigateToEvent: (t) => {
        const r = `/betting/${e.locale}/${e.sportId}/racecard/${t}`;
        lt("internalRoute", { url: r });
      },
      apiPath: e.apiPath
      // using 'as Navigation' as all defined properties are enough to satisfy the Navigation type in this case
    }),
    [e.apiPath, e.locale, e.sportId]
  );
  return /* @__PURE__ */ a.createElement(ZS, { value: n }, /* @__PURE__ */ a.createElement(nS, null, /* @__PURE__ */ a.createElement(CE, { client: rS }, /* @__PURE__ */ a.createElement(fa, null, /* @__PURE__ */ a.createElement(tS, null)))));
}, aS = () => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(xe, { height: "47px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(xe, { height: "51px", amount: 3 }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), [...Array(10)].map((e, n) => /* @__PURE__ */ a.createElement(a.Fragment, { key: n }, /* @__PURE__ */ a.createElement(xe, { height: "57px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" })))), sS = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "specials"],
    queryFn: e.services.meetings.getSpecials,
    refetchOnMount: !1
  });
};
var ta = /* @__PURE__ */ ((e) => (e.PRICE = "price", e.TIME = "time", e))(ta || {});
const ir = ta, Mt = {
  PRICE_BOOSTS: "Price Boosts",
  YOUR_ODDS: "#YourOdds",
  JOCKEY_SPECIALS: "Jockey Specials",
  TRAINER_SPECIALS: "Trainer Specials"
}, iS = {
  TODAY: "Today"
}, Fn = () => {
  const { data: e, isLoading: n, isError: t } = sS();
  return {
    data: !e || e.length === 0 ? null : e,
    isLoading: n,
    isError: t
  };
}, oS = () => {
  const { data: e } = Fn(), n = e == null ? void 0 : e.find(
    (t) => t.category === Mt.JOCKEY_SPECIALS
  );
  return {
    category: n == null ? void 0 : n.category,
    data: (n == null ? void 0 : n.data) || null
  };
}, cS = () => {
  const { data: e } = Fn(), n = e == null ? void 0 : e.find(
    (t) => t.category === Mt.TRAINER_SPECIALS
  );
  return {
    category: n == null ? void 0 : n.category,
    data: (n == null ? void 0 : n.data) || null
  };
}, lS = () => {
  const { data: e } = Fn(), n = e == null ? void 0 : e.find(
    (t) => t.category === Mt.PRICE_BOOSTS
  );
  return {
    category: n == null ? void 0 : n.category,
    data: (n == null ? void 0 : n.data) || null
  };
}, uS = () => {
  const { data: e } = Fn(), n = e == null ? void 0 : e.find(
    (t) => t.category === Mt.YOUR_ODDS
  );
  return {
    category: n == null ? void 0 : n.category,
    data: (n == null ? void 0 : n.data) || null
  };
}, mS = (e) => {
  const { data: n } = Fn(), t = n == null ? void 0 : n.find(
    (r) => r.category === e
  );
  return {
    data: (t == null ? void 0 : t.data) || null
  };
}, tE = ({
  special: e,
  color: n
}) => {
  const t = nn(
    A(
      () => ({
        id: e.eventId,
        isInPlay: e.eventIsInPlay,
        startDateTime: e.eventStartTime,
        status: e.eventStatus
      }),
      [e]
    )
  ), r = An(
    A(
      () => ({
        id: e.marketId,
        eventId: e.eventId,
        status: e.marketStatus,
        hasInPlay: e.marketHasInPlay
      }),
      [e]
    )
  ), s = tn(
    A(
      () => ({
        ...e,
        id: e.selectionId,
        status: e.selectionStatus,
        currentPriceNum: e.priceNum,
        currentPriceDen: e.priceDen,
        marketId: e.marketId,
        eventId: e.eventId
      }),
      [e]
    )
  );
  return /* @__PURE__ */ a.createElement(
    sn,
    {
      event: t,
      market: r,
      selection: s,
      color: n
    }
  );
}, nE = (e) => e.map((n) => ({
  id: n.eventId,
  isInPlay: n.eventIsInPlay,
  startDateTime: n.eventStartTime,
  status: n.eventStatus
})), rE = (e) => e.map((n) => ({
  id: n.marketId,
  eventId: n.eventId,
  status: n.marketStatus,
  hasInPlay: n.marketHasInPlay
})), aE = (e) => e.map((n) => ({
  id: n.selectionId,
  marketId: n.marketId,
  eventId: n.eventId,
  status: n.selectionStatus,
  currentPriceNum: n.priceNum,
  currentPriceDen: n.priceDen,
  wasPriceNum: n.wasPriceNum,
  wasPriceDen: n.wasPriceDen
})), dS = (e) => e.eventIsInPlay ? !1 : !dr(
  { status: e.selectionStatus ?? "S" },
  { status: e.marketStatus ?? "S" },
  { status: e.eventStatus ?? "S" }
), fS = (e) => Array.isArray(e) && e.some(dS), _o = (e, n, t, r) => {
  const s = new Map(n.map((c) => [c.id, c])), i = new Map(t.map((c) => [c.id, c])), o = new Map(
    r.map((c) => [c.id, c])
  );
  return e.filter((c) => {
    const m = s.get(c.eventId);
    if (m != null && m.isInPlay)
      return !1;
    const u = i.get(c.marketId), l = o.get(c.selectionId);
    return !dr(
      { status: (l == null ? void 0 : l.status) ?? "S" },
      { status: (u == null ? void 0 : u.status) ?? "S" },
      { status: (m == null ? void 0 : m.status) ?? "S" }
    );
  });
}, ES = (e, n) => {
  const t = (r) => (r == null ? void 0 : r.currentPriceNum) != null && r.currentPriceDen != null && r.currentPriceDen !== 0 ? r.currentPriceNum / r.currentPriceDen : Number.POSITIVE_INFINITY;
  return e.slice().sort((r, s) => {
    const i = n.find((c) => c.id === r.selectionId), o = n.find((c) => c.id === s.selectionId);
    return t(i) - t(o);
  });
}, _S = (e, n) => {
  const t = new Map(n.map((s) => [s.id, s])), r = (s) => {
    var c;
    const i = ((c = t.get(s.eventId)) == null ? void 0 : c.startDateTime) ?? s.eventStartTime, o = Date.parse(i);
    return Number.isFinite(o) ? o : Number.POSITIVE_INFINITY;
  };
  return e.slice().sort((s, i) => {
    const o = r(s), c = r(i);
    return o !== c ? o - c : s.displayName.localeCompare(i.displayName);
  });
}, Tc = (e) => {
  const n = A(
    () => e ? e.map(({ selections: u }) => u).flat() : [],
    [e]
  ), t = ga(
    A(() => nE(n), [n])
  ), r = jo(
    A(() => rE(n), [n])
  ), s = Sn(
    A(() => aE(n), [n])
  ), i = A(
    () => new Map(t.map((u) => [u.id, u])),
    [t]
  ), o = A(
    () => new Map(r.map((u) => [u.id, u])),
    [r]
  ), c = A(
    () => new Map(s.map((u) => [u.id, u])),
    [s]
  ), m = A(() => {
    if (!e)
      return !1;
    for (const u of e.map(({ selections: l }) => l))
      for (const l of u) {
        const d = i.get(l.eventId);
        if (d != null && d.isInPlay)
          continue;
        const f = o.get(l.marketId), E = c.get(l.selectionId);
        if (!dr(
          { status: (E == null ? void 0 : E.status) ?? "S" },
          { status: (f == null ? void 0 : f.status) ?? "S" },
          { status: (d == null ? void 0 : d.status) ?? "S" }
        ))
          return !0;
      }
    return !1;
  }, [e, i, o, c]);
  return {
    updates: { events: t, markets: r, selections: s },
    hasActive: m
  };
}, Ma = (e) => {
  const { specials: n, sort: t, updates: r, getSort: s } = e, o = A(
    () => n.filter(({ selections: R }) => fS(R)),
    [n]
  )[0].filterName ?? n[0].filterName ?? "", [c, m] = ee(o), u = A(
    () => {
      var R;
      return ((R = n.find(({ filterName: P }) => P === c)) == null ? void 0 : R.selections) ?? [];
    },
    [n, c]
  ), l = ga(
    A(() => nE(u), [u])
  ), d = jo(
    A(() => rE(u), [u])
  ), f = Sn(
    A(() => aE(u), [u])
  ), E = (r == null ? void 0 : r.events) ?? l, g = (r == null ? void 0 : r.markets) ?? d, p = (r == null ? void 0 : r.selections) ?? f, v = A(
    () => n.filter(
      ({ selections: R }) => _o(
        R,
        E,
        g,
        p
      ).length > 0
    ),
    [n, E, g, p]
  );
  te(() => {
    var P;
    if (!c)
      return;
    const R = _o(
      ((P = n.find(({ filterName: D }) => D === c)) == null ? void 0 : P.selections) ?? [],
      E,
      g,
      p
    ).length > 0;
    if (!n.find(({ filterName: D }) => D === c) || !R) {
      const D = v[0].filterName ?? "";
      D && D !== c && m(D);
    }
  }, [
    c,
    n,
    v,
    E,
    g,
    p
  ]);
  const y = A(
    () => _o(
      u,
      E,
      g,
      p
    ),
    [u, E, g, p]
  ), C = A(
    () => t ?? (s == null ? void 0 : s(c)),
    [t, s, c]
  ), b = A(() => C === ta.PRICE ? ES(y, p) : C === ta.TIME ? _S(y, E) : y, [y, E, p, C]);
  return {
    selectedFilter: c,
    setSelectedFilter: m,
    filteredSpecials: v,
    list: u,
    eventsWithUpdates: E,
    marketsWithUpdates: g,
    selectionsWithUpdates: p,
    activeSpecials: y,
    sortedSpecials: b
  };
}, gS = "ngs-meetings__JockeyTrainerSpecialSection__collapsibleContent__p9SCX", pS = "ngs-meetings__JockeyTrainerSpecialSection__selection__p9SCX", hS = "ngs-meetings__JockeyTrainerSpecialSection__toggleWrapper__p9SCX", vS = "ngs-meetings__JockeyTrainerSpecialSection__separator__p9SCX", Yr = {
  collapsibleContent: gS,
  selection: pS,
  toggleWrapper: hS,
  separator: vS
}, yS = "ngs-meetings__FiltersCarousel__tabs__iQdHd", TS = {
  tabs: yS
}, Cr = ({
  filters: e,
  value: n,
  defaultValue: t,
  onClick: r,
  children: s,
  carouselName: i
}) => e.length ? /* @__PURE__ */ a.createElement(It, { value: n, defaultValue: t }, /* @__PURE__ */ a.createElement(
  Nt,
  {
    variant: "standard",
    stretch: !1,
    "data-testid": `${i}-nav-carousel`
  },
  e.map((o) => /* @__PURE__ */ a.createElement(
    Pt,
    {
      key: `${o}`,
      value: o,
      variant: "standard",
      size: "small",
      onClick: () => r(o),
      className: TS.tabs,
      "data-testid": `${i}-carousel-tab-${o}`
    },
    o
  ))
), s) : null, sE = ({
  specials: e,
  title: n
}) => {
  const [t, r] = ee(!1), { selectedFilter: s, setSelectedFilter: i, sortedSpecials: o } = Ma({
    specials: e,
    sort: ir.PRICE
  });
  if (o.length === 0)
    return null;
  const c = 9, m = o.length > c, u = t ? o : o.slice(0, c), l = () => /* @__PURE__ */ a.createElement("div", { className: Yr.toggleWrapper }, /* @__PURE__ */ a.createElement(
    ke,
    {
      variant: "link",
      onClick: () => r((d) => !d),
      "data-testid": "showMoreShowLess-button"
    },
    t ? "Show Less" : "Show More"
  ));
  return /* @__PURE__ */ a.createElement(de, { defaultOpen: !0, "data-testid": "jockey-trainer-section" }, /* @__PURE__ */ a.createElement(fe, null, n), /* @__PURE__ */ a.createElement(Ee, null, /* @__PURE__ */ a.createElement(
    Cr,
    {
      filters: e.map(({ filterName: d }) => d),
      value: s,
      defaultValue: s,
      onClick: (d) => {
        i(d), r(!1);
      },
      carouselName: "jockey-trainer-specials"
    },
    /* @__PURE__ */ a.createElement(Zt, { value: s }, /* @__PURE__ */ a.createElement("div", { className: Yr.collapsibleContent }, u.map((d) => /* @__PURE__ */ a.createElement("div", { key: d.selectionId, className: Yr.selection }, d.displayName, /* @__PURE__ */ a.createElement(tE, { special: d }), /* @__PURE__ */ a.createElement(w, { theme: "light", className: Yr.separator })))), m && /* @__PURE__ */ a.createElement(l, null))
  )));
}, CS = () => {
  const { data: e, category: n } = oS();
  return e ? /* @__PURE__ */ a.createElement(
    sE,
    {
      "data-testid": "jockey-specials",
      specials: e,
      title: n
    }
  ) : null;
}, RS = () => {
  const { data: e, category: n } = cS();
  return e ? /* @__PURE__ */ a.createElement(
    sE,
    {
      "data-testid": "trainer-specials",
      specials: e,
      title: n
    }
  ) : null;
}, bS = "ngs-meetings__SpecialsSelectionRow__container__fVl7I", wS = "ngs-meetings__SpecialsSelectionRow__specialInfo__fVl7I", AS = "ngs-meetings__SpecialsSelectionRow__name__fVl7I", SS = "ngs-meetings__SpecialsSelectionRow__wasPrice__fVl7I", IS = "ngs-meetings__SpecialsSelectionRow__selection__fVl7I", er = {
  container: bS,
  specialInfo: wS,
  name: AS,
  wasPrice: SS,
  selection: IS
}, Cc = ({
  special: e
}) => {
  const n = ac(
    (e == null ? void 0 : e.selectionId) || "",
    (e == null ? void 0 : e.marketId) || "",
    (e == null ? void 0 : e.eventId) || "",
    e
  );
  if (!e)
    return null;
  const t = e != null && e.isEnhanced ? "yellow" : "default", r = /^Trap\s+(\d+)$/.exec(e.displayName);
  return /* @__PURE__ */ a.createElement("div", { className: er.container, "data-testid": "specials-card-container" }, /* @__PURE__ */ a.createElement("div", { className: er.specialInfo }, /* @__PURE__ */ a.createElement("div", { className: er.name, "data-testid": "specials-card-name" }, r ? /* @__PURE__ */ a.createElement(Nn, { active: !0, runnerNum: Number(r[1]) }) : null, /* @__PURE__ */ a.createElement(T, { lines: 4 }, e.displayName))), /* @__PURE__ */ a.createElement("div", { className: er.selection }, n ? /* @__PURE__ */ a.createElement("div", { className: er.wasPrice, "data-testid": "specials-was-price" }, n) : null, /* @__PURE__ */ a.createElement(
    tE,
    {
      special: e,
      color: t,
      "data-testid": "specials-selection"
    }
  )));
}, NS = "ngs-meetings__PriceBoostsSpecialsTemplate__marketCollectionHeader__9B6IV", PS = "ngs-meetings__PriceBoostsSpecialsTemplate__text__9B6IV", Km = {
  marketCollectionHeader: NS,
  text: PS
}, OS = ({
  specials: e,
  updates: n
}) => {
  const {
    selectedFilter: t,
    setSelectedFilter: r,
    sortedSpecials: s,
    filteredSpecials: i
  } = Ma({
    specials: e,
    updates: n,
    getSort: (o) => o === iS.TODAY ? ir.TIME : ir.PRICE
  });
  return /* @__PURE__ */ a.createElement(
    Cr,
    {
      value: t,
      filters: i.map(({ filterName: o }) => o),
      onClick: (o) => r(o),
      carouselName: "price-boosts-specials"
    },
    /* @__PURE__ */ a.createElement(Zt, { key: t, value: t }, /* @__PURE__ */ a.createElement("div", { className: Km.marketCollectionHeader }, /* @__PURE__ */ a.createElement(T, { className: Km.text }, "Stake Limits Apply")), /* @__PURE__ */ a.createElement(
      ur,
      {
        collapsedLimit: 4,
        showLessText: "Show Less",
        showMoreText: "Show More"
      },
      s.map((o, c) => /* @__PURE__ */ a.createElement(
        Cc,
        {
          key: `${o.selectionId}-${c}`,
          special: o
        }
      ))
    ))
  );
}, kS = () => {
  const { data: e, category: n } = lS(), { updates: t, hasActive: r } = Tc(e);
  return !e || !r ? null : /* @__PURE__ */ a.createElement(de, { "data-testid": "price-boosts-specials" }, /* @__PURE__ */ a.createElement(fe, { icons: /* @__PURE__ */ a.createElement(Bt, null) }, n), /* @__PURE__ */ a.createElement(Ee, null, /* @__PURE__ */ a.createElement(OS, { specials: e, updates: t })));
}, DS = ({
  specials: e,
  updates: n
}) => {
  const {
    selectedFilter: t,
    setSelectedFilter: r,
    filteredSpecials: s,
    sortedSpecials: i
  } = Ma({
    specials: e,
    sort: ir.TIME,
    updates: n
  });
  return /* @__PURE__ */ a.createElement(
    Cr,
    {
      value: t,
      filters: s.map(({ filterName: o }) => o),
      onClick: (o) => r(o),
      carouselName: "yourd-odds-specials"
    },
    /* @__PURE__ */ a.createElement(Zt, { value: t }, /* @__PURE__ */ a.createElement(
      ur,
      {
        collapsedLimit: 8,
        showLessText: "Show Less",
        showMoreText: "Show More"
      },
      i.map((o, c) => /* @__PURE__ */ a.createElement(
        Cc,
        {
          key: `${o.selectionId}-${c}`,
          special: o
        }
      ))
    ))
  );
}, LS = () => {
  const { data: e, category: n } = uS(), { updates: t, hasActive: r } = Tc(e);
  return !e || !r ? null : /* @__PURE__ */ a.createElement(de, { "data-testid": "your-odds-specials" }, /* @__PURE__ */ a.createElement(fe, { icons: /* @__PURE__ */ a.createElement(UE, null) }, n), /* @__PURE__ */ a.createElement(Ee, null, /* @__PURE__ */ a.createElement(DS, { specials: e, updates: t })));
}, xS = ({
  specials: e,
  updates: n
}) => {
  const {
    selectedFilter: t,
    setSelectedFilter: r,
    filteredSpecials: s,
    sortedSpecials: i
  } = Ma({
    specials: e,
    sort: ir.PRICE,
    updates: n
  });
  return /* @__PURE__ */ a.createElement(
    Cr,
    {
      value: t,
      filters: s.map(({ filterName: o }) => o),
      onClick: (o) => r(o),
      carouselName: "other-racing-specials"
    },
    /* @__PURE__ */ a.createElement(Zt, { value: t }, /* @__PURE__ */ a.createElement(
      ur,
      {
        collapsedLimit: 8,
        showLessText: "Show Less",
        showMoreText: "Show More"
      },
      i.map((o, c) => /* @__PURE__ */ a.createElement(
        Cc,
        {
          key: `${o.selectionId}-${c}`,
          special: o
        }
      ))
    ))
  );
}, FS = ({
  title: e,
  specials: n
}) => {
  const { updates: t, hasActive: r } = Tc(n);
  return r ? /* @__PURE__ */ a.createElement(de, { "data-testid": `others-${e}-specials` }, /* @__PURE__ */ a.createElement(fe, null, e), /* @__PURE__ */ a.createElement(Ee, null, /* @__PURE__ */ a.createElement(xS, { specials: n, updates: t }))) : null;
}, MS = ({
  specialCategoryName: e
}) => {
  const { data: n } = mS(e);
  return n ? /* @__PURE__ */ a.createElement(
    FS,
    {
      key: e,
      title: e,
      specials: n
    }
  ) : null;
}, SI = () => {
  const { navigateToPage: e, params: n } = V(), { data: t, isLoading: r, isError: s } = Fn();
  return r ? /* @__PURE__ */ a.createElement(aS, null) : s || !t ? /* @__PURE__ */ a.createElement("div", { "data-testid": "specials-unavailable-container" }, /* @__PURE__ */ a.createElement(
    Yo,
    {
      primaryActionLabel: "Meetings",
      onPrimaryActionClick: () => e("meetings"),
      secondaryActionLabel: St[n.sport],
      onSecondaryActionClick: () => e(""),
      title: "Special offers are currently unavailable",
      subtitle: "We are sorry but something went wrong. For more betting opportunities please select another event."
    }
  )) : /* @__PURE__ */ a.createElement("div", { "data-testid": "specials-container" }, t.map((i, o) => i.category === Mt.PRICE_BOOSTS ? /* @__PURE__ */ a.createElement(kS, { key: `special-${o}` }) : i.category === Mt.JOCKEY_SPECIALS ? /* @__PURE__ */ a.createElement(CS, { key: `special-${o}` }) : i.category === Mt.YOUR_ODDS ? /* @__PURE__ */ a.createElement(LS, { key: `special-${o}` }) : i.category === Mt.TRAINER_SPECIALS ? /* @__PURE__ */ a.createElement(RS, { key: `special-${o}` }) : /* @__PURE__ */ a.createElement(
    MS,
    {
      specialCategoryName: i.category,
      key: `special-${o}`
    }
  )));
}, BS = () => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(xe, { height: "47px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), /* @__PURE__ */ a.createElement(xe, { height: "51px", amount: 3 }), /* @__PURE__ */ a.createElement(w, { theme: "light" }), [...Array(10)].map((e, n) => /* @__PURE__ */ a.createElement(a.Fragment, { key: n }, /* @__PURE__ */ a.createElement(xe, { height: "57px" }), /* @__PURE__ */ a.createElement(w, { theme: "light" })))), $S = "ngs-meetings__FutureRacesEventList__dateAndCompetitionText__qLdla", WS = "ngs-meetings__FutureRacesEventList__eventText__qLdla", HS = "ngs-meetings__FutureRacesEventList__link__qLdla", go = {
  dateAndCompetitionText: $S,
  eventText: WS,
  link: HS
}, Oo = "All", zm = "Others", po = /\d{1,2}(st|nd|rd|th)\s(January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s*[0-9]{0,4}/gi, qS = /\d{1,2}(st|nd|rd|th)\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s[0-9]{4}/, GS = /\d{1,2}(st|nd|rd|th)\s(January|February|March|April|May|June|July|August|September|October|November|December)$/, iE = (e) => {
  var t, r;
  const n = e.split(" - ").map((s) => s.trim()).filter(Boolean);
  if (n.length >= 3) {
    const s = (t = n[n.length - 1]) == null ? void 0 : t.match(po);
    return {
      competitionName: n[0],
      eventName: n.slice(1, -1).join(" - "),
      eventDate: s ? s[0] : ""
    };
  }
  if (n.length === 2) {
    if (po.test(n[1])) {
      const s = (r = n[n.length - 1]) == null ? void 0 : r.match(po);
      return {
        competitionName: "",
        eventName: n[0],
        eventDate: s ? s[0] : ""
      };
    }
    return { competitionName: n[0], eventName: n[1], eventDate: "" };
  }
  return { competitionName: "", eventName: e, eventDate: "" };
}, US = (e) => qS.test(e) ? Po(qm(e, "do LLL yyyy", /* @__PURE__ */ new Date()), "EEE d MMM") : GS.test(e) ? Po(qm(e, "do MMMM", /* @__PURE__ */ new Date()), "EEE d MMM") : "", YS = (e, n) => {
  const t = new Map(
    n.map((r) => [r.id, r])
  );
  return e.filter((r) => {
    const s = t.get(r.id);
    return !(s != null && s.isInPlay) && (s == null ? void 0 : s.displayed) && !(s != null && s.settled);
  });
}, jS = (e, n) => {
  const { competitionFilters: t = [], events: r } = e, s = YS(r, n);
  let i = {};
  const o = [];
  s.forEach((m) => {
    const { competitionName: u } = iE(m.originalEventName);
    t.includes(u) ? (i[u] || (i[u] = []), i[u].push(m)) : o.push(m);
  });
  let c = t.filter(
    (m) => Object.keys(i).includes(m)
  );
  return c.length === 1 && (i = {}, c = []), o.length && Object.keys(i).length && (c.push(zm), i[zm] = o), c.unshift(Oo), i[Oo] = s, {
    filters: c,
    eventsByFilter: i
  };
}, Xm = ({
  events: e,
  collapsedLimit: n = 4
}) => {
  const t = V();
  return e.length ? /* @__PURE__ */ a.createElement(
    ur,
    {
      collapsedLimit: n,
      showMoreText: "Show More",
      showLessText: "Show Less"
    },
    e.map((r) => {
      const s = `${t.params.sport}/${r.id}`, {
        competitionName: i,
        eventName: o,
        eventDate: c = ""
      } = iE(r.originalEventName), m = US(c);
      return /* @__PURE__ */ a.createElement(en, { key: r.id }, /* @__PURE__ */ a.createElement(
        Ea,
        {
          onClick: (u) => {
            u.preventDefault(), t.navigateToCustomUrl(s);
          }
        },
        /* @__PURE__ */ a.createElement(
          "a",
          {
            href: t.getLinkForCustomUrl(s),
            className: go.link
          },
          /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement("span", { className: go.dateAndCompetitionText }, m, m && i ? ", " : "", i || "")),
          /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement("span", { className: go.eventText }, o))
        )
      ));
    })
  ) : /* @__PURE__ */ a.createElement(Jt, null, /* @__PURE__ */ a.createElement("li", { "data-testid": "future-races-empty" }, "No events"));
}, VS = () => {
  const e = _e();
  return ye({
    queryKey: [...e.queryKey, "future-races"],
    queryFn: e.services.meetings.getFutureRaces,
    refetchOnMount: !0
  });
}, KS = () => {
  const { data: e, isLoading: n, isError: t } = VS();
  return {
    data: !e || typeof e == "object" && Object.keys(e).length === 0 ? null : Object.values(e).filter(
      (i) => {
        var o;
        return (o = i == null ? void 0 : i.events) == null ? void 0 : o.length;
      }
    ),
    isLoading: n,
    isError: t
  };
}, zS = (e) => e.map((n) => ({
  id: n.id,
  isInPlay: n.isInPlay,
  settled: n.settled,
  displayed: !0,
  startDateTime: n.startDateTime,
  status: "A"
})), XS = (e) => {
  const [n, t] = ee(Oo), r = ga(
    A(() => zS(e.events), [e.events])
  ), { filters: s, eventsByFilter: i } = A(
    () => jS(e, r),
    [e, r]
  );
  return {
    filters: s,
    activeFilter: n,
    setActiveFilter: t,
    eventsByFilter: i,
    showCarousel: s.length > 1
  };
}, QS = ({
  competition: e,
  defaultOpen: n
}) => {
  const {
    filters: t,
    activeFilter: r,
    setActiveFilter: s,
    eventsByFilter: i,
    showCarousel: o
  } = XS(e);
  return /* @__PURE__ */ a.createElement(de, { defaultOpen: n }, /* @__PURE__ */ a.createElement(fe, null, e.competitionName), /* @__PURE__ */ a.createElement(Ee, null, o ? /* @__PURE__ */ a.createElement(
    Cr,
    {
      filters: t,
      value: r,
      onClick: (c) => s(c),
      carouselName: "futureRaces"
    },
    /* @__PURE__ */ a.createElement(Zt, { value: r }, /* @__PURE__ */ a.createElement(Xm, { events: i[r] }))
  ) : /* @__PURE__ */ a.createElement(Xm, { events: i[r] })));
}, II = () => {
  const { navigateToPage: e, params: n } = V(), { data: t, isLoading: r, isError: s } = KS();
  return r ? /* @__PURE__ */ a.createElement(BS, null) : s || !t ? /* @__PURE__ */ a.createElement("div", null, /* @__PURE__ */ a.createElement(
    Yo,
    {
      primaryActionLabel: "Meetings",
      onPrimaryActionClick: () => e("meetings"),
      secondaryActionLabel: St[n.sport],
      onSecondaryActionClick: () => e(""),
      title: "Future races offers are currently unavailable",
      subtitle: "We are sorry but something went wrong. For more betting opportunities please select another event."
    }
  )) : /* @__PURE__ */ a.createElement("div", { "data-testid": "future-races-page" }, t.map((i, o) => /* @__PURE__ */ a.createElement(
    QS,
    {
      key: i.competitionId,
      competition: i,
      defaultOpen: o === 0
    }
  )));
}, ZS = nd.Provider;
export {
  hI as A,
  id as B,
  Mh as F,
  wI as H,
  rt as M,
  ZS as N,
  rv as P,
  PA as Q,
  EI as R,
  mI as S,
  dI as T,
  Sh as a,
  Bh as b,
  av as c,
  fI as d,
  _I as e,
  gI as f,
  pI as g,
  UR as h,
  gC as i,
  vI as j,
  TR as k,
  rb as l,
  nb as m,
  yI as n,
  TI as o,
  CI as p,
  CA as q,
  RI as r,
  kA as s,
  bI as t,
  V as u,
  WA as v,
  AI as w,
  SI as x,
  II as y
};
//# sourceMappingURL=index-BiPjnX_S.js.map
